(() => {
    var e = {
            2312: (e) => {
                function t(e) {
                    var i,
                        s,
                        r = "";
                    if ("string" == typeof e || "number" == typeof e) r += e;
                    else if ("object" == typeof e)
                        if (Array.isArray(e)) {
                            var n = e.length;
                            for (i = 0; i < n; i++) e[i] && (s = t(e[i])) && (r && (r += " "), (r += s));
                        } else for (s in e) e[s] && (r && (r += " "), (r += s));
                    return r;
                }
                function i() {
                    for (var e, i, s = 0, r = "", n = arguments.length; s < n; s++) (e = arguments[s]) && (i = t(e)) && (r && (r += " "), (r += i));
                    return r;
                }
                (e.exports = i), (e.exports.clsx = i);
            },
            3008: (e) => {
                function t(e, t) {
                    (e.onload = function () {
                        (this.onerror = this.onload = null), t(null, e);
                    }),
                        (e.onerror = function () {
                            (this.onerror = this.onload = null), t(new Error("Failed to load " + this.src), e);
                        });
                }
                function i(e, t) {
                    e.onreadystatechange = function () {
                        ("complete" != this.readyState && "loaded" != this.readyState) || ((this.onreadystatechange = null), t(null, e));
                    };
                }
                e.exports = function (e, s, r) {
                    var n = document.head || document.getElementsByTagName("head")[0],
                        a = document.createElement("script");
                    "function" == typeof s && ((r = s), (s = {})),
                        (s = s || {}),
                        (r = r || function () {}),
                        (a.type = s.type || "text/javascript"),
                        (a.charset = s.charset || "utf8"),
                        (a.async = !("async" in s) || !!s.async),
                        (a.src = e),
                        s.attrs &&
                            (function (e, t) {
                                for (var i in t) e.setAttribute(i, t[i]);
                            })(a, s.attrs),
                        s.text && (a.text = "" + s.text),
                        ("onload" in a ? t : i)(a, r),
                        a.onload || t(a, r),
                        n.appendChild(a);
                };
            },
            320: (e) => {
                "use strict";
                var t;
                (t = function () {
                    var e = {},
                        t = {};
                    return (
                        (e.on = function (e, i) {
                            var s = { name: e, handler: i };
                            return (t[e] = t[e] || []), t[e].unshift(s), s;
                        }),
                        (e.off = function (e) {
                            var i = t[e.name].indexOf(e);
                            -1 !== i && t[e.name].splice(i, 1);
                        }),
                        (e.trigger = function (e, i) {
                            var s,
                                r = t[e];
                            if (r) for (s = r.length; s--; ) r[s].handler(i);
                        }),
                        e
                    );
                }),
                    (e.exports = t);
            },
            6864: (e, t) => {
                "use strict";
                Object.defineProperty(t, Symbol.toStringTag, { value: "Module" });
                const i = "-";
                function s(e) {
                    const t = (function (e) {
                            const { theme: t, prefix: i } = e,
                                s = { nextPart: new Map(), validators: [] },
                                r = (function (e, t) {
                                    return t ? e.map(([e, i]) => [e, i.map((e) => ("string" == typeof e ? t + e : "object" == typeof e ? Object.fromEntries(Object.entries(e).map(([e, i]) => [t + e, i])) : e))]) : e;
                                })(Object.entries(e.classGroups), i);
                            return (
                                r.forEach(([e, i]) => {
                                    a(i, s, e, t);
                                }),
                                s
                            );
                        })(e),
                        { conflictingClassGroups: s, conflictingClassGroupModifiers: o } = e;
                    return {
                        getClassGroupId: function (e) {
                            const s = e.split(i);
                            return (
                                "" === s[0] && 1 !== s.length && s.shift(),
                                r(s, t) ||
                                    (function (e) {
                                        if (n.test(e)) {
                                            const t = n.exec(e)[1],
                                                i = t?.substring(0, t.indexOf(":"));
                                            if (i) return "arbitrary.." + i;
                                        }
                                    })(e)
                            );
                        },
                        getConflictingClassGroupIds: function (e, t) {
                            const i = s[e] || [];
                            return t && o[e] ? [...i, ...o[e]] : i;
                        },
                    };
                }
                function r(e, t) {
                    if (0 === e.length) return t.classGroupId;
                    const s = e[0],
                        n = t.nextPart.get(s),
                        a = n ? r(e.slice(1), n) : void 0;
                    if (a) return a;
                    if (0 === t.validators.length) return;
                    const o = e.join(i);
                    return t.validators.find(({ validator: e }) => e(o))?.classGroupId;
                }
                const n = /^\[(.+)\]$/;
                function a(e, t, i, s) {
                    e.forEach((e) => {
                        if ("string" != typeof e) {
                            if ("function" == typeof e) return e.isThemeGetter ? void a(e(s), t, i, s) : void t.validators.push({ validator: e, classGroupId: i });
                            Object.entries(e).forEach(([e, r]) => {
                                a(r, o(t, e), i, s);
                            });
                        } else ("" === e ? t : o(t, e)).classGroupId = i;
                    });
                }
                function o(e, t) {
                    let s = e;
                    return (
                        t.split(i).forEach((e) => {
                            s.nextPart.has(e) || s.nextPart.set(e, { nextPart: new Map(), validators: [] }), (s = s.nextPart.get(e));
                        }),
                        s
                    );
                }
                function l(e) {
                    if (e < 1) return { get: () => {}, set: () => {} };
                    let t = 0,
                        i = new Map(),
                        s = new Map();
                    function r(r, n) {
                        i.set(r, n), t++, t > e && ((t = 0), (s = i), (i = new Map()));
                    }
                    return {
                        get(e) {
                            let t = i.get(e);
                            return void 0 !== t ? t : void 0 !== (t = s.get(e)) ? (r(e, t), t) : void 0;
                        },
                        set(e, t) {
                            i.has(e) ? i.set(e, t) : r(e, t);
                        },
                    };
                }
                const d = "!";
                function c(e) {
                    const t = e.separator,
                        i = 1 === t.length,
                        s = t[0],
                        r = t.length;
                    return function (e) {
                        const n = [];
                        let a,
                            o = 0,
                            l = 0;
                        for (let d = 0; d < e.length; d++) {
                            let c = e[d];
                            if (0 === o) {
                                if (c === s && (i || e.slice(d, d + r) === t)) {
                                    n.push(e.slice(l, d)), (l = d + r);
                                    continue;
                                }
                                if ("/" === c) {
                                    a = d;
                                    continue;
                                }
                            }
                            "[" === c ? o++ : "]" === c && o--;
                        }
                        const c = 0 === n.length ? e : e.substring(l),
                            u = c.startsWith(d);
                        return { modifiers: n, hasImportantModifier: u, baseClassName: u ? c.substring(1) : c, maybePostfixModifierPosition: a && a > l ? a - l : void 0 };
                    };
                }
                const u = /\s+/;
                function p() {
                    let e,
                        t,
                        i = 0,
                        s = "";
                    for (; i < arguments.length; ) (e = arguments[i++]) && (t = h(e)) && (s && (s += " "), (s += t));
                    return s;
                }
                function h(e) {
                    if ("string" == typeof e) return e;
                    let t,
                        i = "";
                    for (let s = 0; s < e.length; s++) e[s] && (t = h(e[s])) && (i && (i += " "), (i += t));
                    return i;
                }
                function m(e, ...t) {
                    let i,
                        r,
                        n,
                        a = function (d) {
                            const u = t.reduce((e, t) => t(e), e());
                            return (
                                (i = (function (e) {
                                    return { cache: l(e.cacheSize), splitModifiers: c(e), ...s(e) };
                                })(u)),
                                (r = i.cache.get),
                                (n = i.cache.set),
                                (a = o),
                                o(d)
                            );
                        };
                    function o(e) {
                        const t = r(e);
                        if (t) return t;
                        const s = (function (e, t) {
                            const { splitModifiers: i, getClassGroupId: s, getConflictingClassGroupIds: r } = t,
                                n = new Set();
                            return e
                                .trim()
                                .split(u)
                                .map((e) => {
                                    const { modifiers: t, hasImportantModifier: r, baseClassName: n, maybePostfixModifierPosition: a } = i(e);
                                    let o = s(a ? n.substring(0, a) : n),
                                        l = Boolean(a);
                                    if (!o) {
                                        if (!a) return { isTailwindClass: !1, originalClassName: e };
                                        if (((o = s(n)), !o)) return { isTailwindClass: !1, originalClassName: e };
                                        l = !1;
                                    }
                                    const c = (function (e) {
                                        if (e.length <= 1) return e;
                                        const t = [];
                                        let i = [];
                                        return (
                                            e.forEach((e) => {
                                                "[" === e[0] ? (t.push(...i.sort(), e), (i = [])) : i.push(e);
                                            }),
                                            t.push(...i.sort()),
                                            t
                                        );
                                    })(t).join(":");
                                    return { isTailwindClass: !0, modifierId: r ? c + d : c, classGroupId: o, originalClassName: e, hasPostfixModifier: l };
                                })
                                .reverse()
                                .filter((e) => {
                                    if (!e.isTailwindClass) return !0;
                                    const { modifierId: t, classGroupId: i, hasPostfixModifier: s } = e,
                                        a = t + i;
                                    return !n.has(a) && (n.add(a), r(i, s).forEach((e) => n.add(t + e)), !0);
                                })
                                .reverse()
                                .map((e) => e.originalClassName)
                                .join(" ");
                        })(e, i);
                        return n(e, s), s;
                    }
                    return function () {
                        return a(p.apply(null, arguments));
                    };
                }
                function v(e) {
                    const t = (t) => t[e] || [];
                    return (t.isThemeGetter = !0), t;
                }
                const g = /^\[(?:([a-z-]+):)?(.+)\]$/i,
                    f = /^\d+\/\d+$/,
                    b = new Set(["px", "full", "screen"]),
                    w = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/,
                    y = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/,
                    E = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/,
                    S = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/,
                    x = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
                function C(e) {
                    return M(e) || b.has(e) || f.test(e);
                }
                function T(e) {
                    return F(e, "length", H);
                }
                function M(e) {
                    return Boolean(e) && !Number.isNaN(Number(e));
                }
                function L(e) {
                    return F(e, "number", M);
                }
                function P(e) {
                    return Boolean(e) && Number.isInteger(Number(e));
                }
                function A(e) {
                    return e.endsWith("%") && M(e.slice(0, -1));
                }
                function k(e) {
                    return g.test(e);
                }
                function I(e) {
                    return w.test(e);
                }
                const O = new Set(["length", "size", "percentage"]);
                function D(e) {
                    return F(e, O, R);
                }
                function z(e) {
                    return F(e, "position", R);
                }
                const _ = new Set(["image", "url"]);
                function $(e) {
                    return F(e, _, N);
                }
                function B(e) {
                    return F(e, "", j);
                }
                function q() {
                    return !0;
                }
                function F(e, t, i) {
                    const s = g.exec(e);
                    return !!s && (s[1] ? ("string" == typeof t ? s[1] === t : t.has(s[1])) : i(s[2]));
                }
                function H(e) {
                    return y.test(e) && !E.test(e);
                }
                function R() {
                    return !1;
                }
                function j(e) {
                    return S.test(e);
                }
                function N(e) {
                    return x.test(e);
                }
                const V = Object.defineProperty(
                    {
                        __proto__: null,
                        isAny: q,
                        isArbitraryImage: $,
                        isArbitraryLength: T,
                        isArbitraryNumber: L,
                        isArbitraryPosition: z,
                        isArbitraryShadow: B,
                        isArbitrarySize: D,
                        isArbitraryValue: k,
                        isInteger: P,
                        isLength: C,
                        isNumber: M,
                        isPercent: A,
                        isTshirtSize: I,
                    },
                    Symbol.toStringTag,
                    { value: "Module" }
                );
                function G() {
                    const e = v("colors"),
                        t = v("spacing"),
                        i = v("blur"),
                        s = v("brightness"),
                        r = v("borderColor"),
                        n = v("borderRadius"),
                        a = v("borderSpacing"),
                        o = v("borderWidth"),
                        l = v("contrast"),
                        d = v("grayscale"),
                        c = v("hueRotate"),
                        u = v("invert"),
                        p = v("gap"),
                        h = v("gradientColorStops"),
                        m = v("gradientColorStopPositions"),
                        g = v("inset"),
                        f = v("margin"),
                        b = v("opacity"),
                        w = v("padding"),
                        y = v("saturate"),
                        E = v("scale"),
                        S = v("sepia"),
                        x = v("skew"),
                        O = v("space"),
                        _ = v("translate"),
                        F = () => ["auto", k, t],
                        H = () => [k, t],
                        R = () => ["", C, T],
                        j = () => ["auto", M, k],
                        N = () => ["", "0", k],
                        V = () => [M, L],
                        G = () => [M, k];
                    return {
                        cacheSize: 500,
                        separator: ":",
                        theme: {
                            colors: [q],
                            spacing: [C, T],
                            blur: ["none", "", I, k],
                            brightness: V(),
                            borderColor: [e],
                            borderRadius: ["none", "", "full", I, k],
                            borderSpacing: H(),
                            borderWidth: R(),
                            contrast: V(),
                            grayscale: N(),
                            hueRotate: G(),
                            invert: N(),
                            gap: H(),
                            gradientColorStops: [e],
                            gradientColorStopPositions: [A, T],
                            inset: F(),
                            margin: F(),
                            opacity: V(),
                            padding: H(),
                            saturate: V(),
                            scale: V(),
                            sepia: N(),
                            skew: G(),
                            space: H(),
                            translate: H(),
                        },
                        classGroups: {
                            aspect: [{ aspect: ["auto", "square", "video", k] }],
                            container: ["container"],
                            columns: [{ columns: [I] }],
                            "break-after": [{ "break-after": ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"] }],
                            "break-before": [{ "break-before": ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"] }],
                            "break-inside": [{ "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"] }],
                            "box-decoration": [{ "box-decoration": ["slice", "clone"] }],
                            box: [{ box: ["border", "content"] }],
                            display: [
                                "block",
                                "inline-block",
                                "inline",
                                "flex",
                                "inline-flex",
                                "table",
                                "inline-table",
                                "table-caption",
                                "table-cell",
                                "table-column",
                                "table-column-group",
                                "table-footer-group",
                                "table-header-group",
                                "table-row-group",
                                "table-row",
                                "flow-root",
                                "grid",
                                "inline-grid",
                                "contents",
                                "list-item",
                                "hidden",
                            ],
                            float: [{ float: ["right", "left", "none", "start", "end"] }],
                            clear: [{ clear: ["left", "right", "both", "none", "start", "end"] }],
                            isolation: ["isolate", "isolation-auto"],
                            "object-fit": [{ object: ["contain", "cover", "fill", "none", "scale-down"] }],
                            "object-position": [{ object: ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top", k] }],
                            overflow: [{ overflow: ["auto", "hidden", "clip", "visible", "scroll"] }],
                            "overflow-x": [{ "overflow-x": ["auto", "hidden", "clip", "visible", "scroll"] }],
                            "overflow-y": [{ "overflow-y": ["auto", "hidden", "clip", "visible", "scroll"] }],
                            overscroll: [{ overscroll: ["auto", "contain", "none"] }],
                            "overscroll-x": [{ "overscroll-x": ["auto", "contain", "none"] }],
                            "overscroll-y": [{ "overscroll-y": ["auto", "contain", "none"] }],
                            position: ["static", "fixed", "absolute", "relative", "sticky"],
                            inset: [{ inset: [g] }],
                            "inset-x": [{ "inset-x": [g] }],
                            "inset-y": [{ "inset-y": [g] }],
                            start: [{ start: [g] }],
                            end: [{ end: [g] }],
                            top: [{ top: [g] }],
                            right: [{ right: [g] }],
                            bottom: [{ bottom: [g] }],
                            left: [{ left: [g] }],
                            visibility: ["visible", "invisible", "collapse"],
                            z: [{ z: ["auto", P, k] }],
                            basis: [{ basis: F() }],
                            "flex-direction": [{ flex: ["row", "row-reverse", "col", "col-reverse"] }],
                            "flex-wrap": [{ flex: ["wrap", "wrap-reverse", "nowrap"] }],
                            flex: [{ flex: ["1", "auto", "initial", "none", k] }],
                            grow: [{ grow: N() }],
                            shrink: [{ shrink: N() }],
                            order: [{ order: ["first", "last", "none", P, k] }],
                            "grid-cols": [{ "grid-cols": [q] }],
                            "col-start-end": [{ col: ["auto", { span: ["full", P, k] }, k] }],
                            "col-start": [{ "col-start": j() }],
                            "col-end": [{ "col-end": j() }],
                            "grid-rows": [{ "grid-rows": [q] }],
                            "row-start-end": [{ row: ["auto", { span: [P, k] }, k] }],
                            "row-start": [{ "row-start": j() }],
                            "row-end": [{ "row-end": j() }],
                            "grid-flow": [{ "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"] }],
                            "auto-cols": [{ "auto-cols": ["auto", "min", "max", "fr", k] }],
                            "auto-rows": [{ "auto-rows": ["auto", "min", "max", "fr", k] }],
                            gap: [{ gap: [p] }],
                            "gap-x": [{ "gap-x": [p] }],
                            "gap-y": [{ "gap-y": [p] }],
                            "justify-content": [{ justify: ["normal", "start", "end", "center", "between", "around", "evenly", "stretch"] }],
                            "justify-items": [{ "justify-items": ["start", "end", "center", "stretch"] }],
                            "justify-self": [{ "justify-self": ["auto", "start", "end", "center", "stretch"] }],
                            "align-content": [{ content: ["normal", "start", "end", "center", "between", "around", "evenly", "stretch", "baseline"] }],
                            "align-items": [{ items: ["start", "end", "center", "baseline", "stretch"] }],
                            "align-self": [{ self: ["auto", "start", "end", "center", "stretch", "baseline"] }],
                            "place-content": [{ "place-content": ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline"] }],
                            "place-items": [{ "place-items": ["start", "end", "center", "baseline", "stretch"] }],
                            "place-self": [{ "place-self": ["auto", "start", "end", "center", "stretch"] }],
                            p: [{ p: [w] }],
                            px: [{ px: [w] }],
                            py: [{ py: [w] }],
                            ps: [{ ps: [w] }],
                            pe: [{ pe: [w] }],
                            pt: [{ pt: [w] }],
                            pr: [{ pr: [w] }],
                            pb: [{ pb: [w] }],
                            pl: [{ pl: [w] }],
                            m: [{ m: [f] }],
                            mx: [{ mx: [f] }],
                            my: [{ my: [f] }],
                            ms: [{ ms: [f] }],
                            me: [{ me: [f] }],
                            mt: [{ mt: [f] }],
                            mr: [{ mr: [f] }],
                            mb: [{ mb: [f] }],
                            ml: [{ ml: [f] }],
                            "space-x": [{ "space-x": [O] }],
                            "space-x-reverse": ["space-x-reverse"],
                            "space-y": [{ "space-y": [O] }],
                            "space-y-reverse": ["space-y-reverse"],
                            w: [{ w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", k, t] }],
                            "min-w": [{ "min-w": [k, t, "min", "max", "fit"] }],
                            "max-w": [{ "max-w": [k, t, "none", "full", "min", "max", "fit", "prose", { screen: [I] }, I] }],
                            h: [{ h: [k, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"] }],
                            "min-h": [{ "min-h": [k, t, "min", "max", "fit", "svh", "lvh", "dvh"] }],
                            "max-h": [{ "max-h": [k, t, "min", "max", "fit", "svh", "lvh", "dvh"] }],
                            size: [{ size: [k, t, "auto", "min", "max", "fit"] }],
                            "font-size": [{ text: ["base", I, T] }],
                            "font-smoothing": ["antialiased", "subpixel-antialiased"],
                            "font-style": ["italic", "not-italic"],
                            "font-weight": [{ font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", L] }],
                            "font-family": [{ font: [q] }],
                            "fvn-normal": ["normal-nums"],
                            "fvn-ordinal": ["ordinal"],
                            "fvn-slashed-zero": ["slashed-zero"],
                            "fvn-figure": ["lining-nums", "oldstyle-nums"],
                            "fvn-spacing": ["proportional-nums", "tabular-nums"],
                            "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
                            tracking: [{ tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", k] }],
                            "line-clamp": [{ "line-clamp": ["none", M, L] }],
                            leading: [{ leading: ["none", "tight", "snug", "normal", "relaxed", "loose", C, k] }],
                            "list-image": [{ "list-image": ["none", k] }],
                            "list-style-type": [{ list: ["none", "disc", "decimal", k] }],
                            "list-style-position": [{ list: ["inside", "outside"] }],
                            "placeholder-color": [{ placeholder: [e] }],
                            "placeholder-opacity": [{ "placeholder-opacity": [b] }],
                            "text-alignment": [{ text: ["left", "center", "right", "justify", "start", "end"] }],
                            "text-color": [{ text: [e] }],
                            "text-opacity": [{ "text-opacity": [b] }],
                            "text-decoration": ["underline", "overline", "line-through", "no-underline"],
                            "text-decoration-style": [{ decoration: ["solid", "dashed", "dotted", "double", "none", "wavy"] }],
                            "text-decoration-thickness": [{ decoration: ["auto", "from-font", C, T] }],
                            "underline-offset": [{ "underline-offset": ["auto", C, k] }],
                            "text-decoration-color": [{ decoration: [e] }],
                            "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
                            "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
                            "text-wrap": [{ text: ["wrap", "nowrap", "balance", "pretty"] }],
                            indent: [{ indent: H() }],
                            "vertical-align": [{ align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", k] }],
                            whitespace: [{ whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"] }],
                            break: [{ break: ["normal", "words", "all", "keep"] }],
                            hyphens: [{ hyphens: ["none", "manual", "auto"] }],
                            content: [{ content: ["none", k] }],
                            "bg-attachment": [{ bg: ["fixed", "local", "scroll"] }],
                            "bg-clip": [{ "bg-clip": ["border", "padding", "content", "text"] }],
                            "bg-opacity": [{ "bg-opacity": [b] }],
                            "bg-origin": [{ "bg-origin": ["border", "padding", "content"] }],
                            "bg-position": [{ bg: ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top", z] }],
                            "bg-repeat": [{ bg: ["no-repeat", { repeat: ["", "x", "y", "round", "space"] }] }],
                            "bg-size": [{ bg: ["auto", "cover", "contain", D] }],
                            "bg-image": [{ bg: ["none", { "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"] }, $] }],
                            "bg-color": [{ bg: [e] }],
                            "gradient-from-pos": [{ from: [m] }],
                            "gradient-via-pos": [{ via: [m] }],
                            "gradient-to-pos": [{ to: [m] }],
                            "gradient-from": [{ from: [h] }],
                            "gradient-via": [{ via: [h] }],
                            "gradient-to": [{ to: [h] }],
                            rounded: [{ rounded: [n] }],
                            "rounded-s": [{ "rounded-s": [n] }],
                            "rounded-e": [{ "rounded-e": [n] }],
                            "rounded-t": [{ "rounded-t": [n] }],
                            "rounded-r": [{ "rounded-r": [n] }],
                            "rounded-b": [{ "rounded-b": [n] }],
                            "rounded-l": [{ "rounded-l": [n] }],
                            "rounded-ss": [{ "rounded-ss": [n] }],
                            "rounded-se": [{ "rounded-se": [n] }],
                            "rounded-ee": [{ "rounded-ee": [n] }],
                            "rounded-es": [{ "rounded-es": [n] }],
                            "rounded-tl": [{ "rounded-tl": [n] }],
                            "rounded-tr": [{ "rounded-tr": [n] }],
                            "rounded-br": [{ "rounded-br": [n] }],
                            "rounded-bl": [{ "rounded-bl": [n] }],
                            "border-w": [{ border: [o] }],
                            "border-w-x": [{ "border-x": [o] }],
                            "border-w-y": [{ "border-y": [o] }],
                            "border-w-s": [{ "border-s": [o] }],
                            "border-w-e": [{ "border-e": [o] }],
                            "border-w-t": [{ "border-t": [o] }],
                            "border-w-r": [{ "border-r": [o] }],
                            "border-w-b": [{ "border-b": [o] }],
                            "border-w-l": [{ "border-l": [o] }],
                            "border-opacity": [{ "border-opacity": [b] }],
                            "border-style": [{ border: ["solid", "dashed", "dotted", "double", "none", "hidden"] }],
                            "divide-x": [{ "divide-x": [o] }],
                            "divide-x-reverse": ["divide-x-reverse"],
                            "divide-y": [{ "divide-y": [o] }],
                            "divide-y-reverse": ["divide-y-reverse"],
                            "divide-opacity": [{ "divide-opacity": [b] }],
                            "divide-style": [{ divide: ["solid", "dashed", "dotted", "double", "none"] }],
                            "border-color": [{ border: [r] }],
                            "border-color-x": [{ "border-x": [r] }],
                            "border-color-y": [{ "border-y": [r] }],
                            "border-color-t": [{ "border-t": [r] }],
                            "border-color-r": [{ "border-r": [r] }],
                            "border-color-b": [{ "border-b": [r] }],
                            "border-color-l": [{ "border-l": [r] }],
                            "divide-color": [{ divide: [r] }],
                            "outline-style": [{ outline: ["", "solid", "dashed", "dotted", "double", "none"] }],
                            "outline-offset": [{ "outline-offset": [C, k] }],
                            "outline-w": [{ outline: [C, T] }],
                            "outline-color": [{ outline: [e] }],
                            "ring-w": [{ ring: R() }],
                            "ring-w-inset": ["ring-inset"],
                            "ring-color": [{ ring: [e] }],
                            "ring-opacity": [{ "ring-opacity": [b] }],
                            "ring-offset-w": [{ "ring-offset": [C, T] }],
                            "ring-offset-color": [{ "ring-offset": [e] }],
                            shadow: [{ shadow: ["", "inner", "none", I, B] }],
                            "shadow-color": [{ shadow: [q] }],
                            opacity: [{ opacity: [b] }],
                            "mix-blend": [
                                {
                                    "mix-blend": [
                                        "normal",
                                        "multiply",
                                        "screen",
                                        "overlay",
                                        "darken",
                                        "lighten",
                                        "color-dodge",
                                        "color-burn",
                                        "hard-light",
                                        "soft-light",
                                        "difference",
                                        "exclusion",
                                        "hue",
                                        "saturation",
                                        "color",
                                        "luminosity",
                                        "plus-lighter",
                                    ],
                                },
                            ],
                            "bg-blend": [
                                {
                                    "bg-blend": [
                                        "normal",
                                        "multiply",
                                        "screen",
                                        "overlay",
                                        "darken",
                                        "lighten",
                                        "color-dodge",
                                        "color-burn",
                                        "hard-light",
                                        "soft-light",
                                        "difference",
                                        "exclusion",
                                        "hue",
                                        "saturation",
                                        "color",
                                        "luminosity",
                                        "plus-lighter",
                                    ],
                                },
                            ],
                            filter: [{ filter: ["", "none"] }],
                            blur: [{ blur: [i] }],
                            brightness: [{ brightness: [s] }],
                            contrast: [{ contrast: [l] }],
                            "drop-shadow": [{ "drop-shadow": ["", "none", I, k] }],
                            grayscale: [{ grayscale: [d] }],
                            "hue-rotate": [{ "hue-rotate": [c] }],
                            invert: [{ invert: [u] }],
                            saturate: [{ saturate: [y] }],
                            sepia: [{ sepia: [S] }],
                            "backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
                            "backdrop-blur": [{ "backdrop-blur": [i] }],
                            "backdrop-brightness": [{ "backdrop-brightness": [s] }],
                            "backdrop-contrast": [{ "backdrop-contrast": [l] }],
                            "backdrop-grayscale": [{ "backdrop-grayscale": [d] }],
                            "backdrop-hue-rotate": [{ "backdrop-hue-rotate": [c] }],
                            "backdrop-invert": [{ "backdrop-invert": [u] }],
                            "backdrop-opacity": [{ "backdrop-opacity": [b] }],
                            "backdrop-saturate": [{ "backdrop-saturate": [y] }],
                            "backdrop-sepia": [{ "backdrop-sepia": [S] }],
                            "border-collapse": [{ border: ["collapse", "separate"] }],
                            "border-spacing": [{ "border-spacing": [a] }],
                            "border-spacing-x": [{ "border-spacing-x": [a] }],
                            "border-spacing-y": [{ "border-spacing-y": [a] }],
                            "table-layout": [{ table: ["auto", "fixed"] }],
                            caption: [{ caption: ["top", "bottom"] }],
                            transition: [{ transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", k] }],
                            duration: [{ duration: G() }],
                            ease: [{ ease: ["linear", "in", "out", "in-out", k] }],
                            delay: [{ delay: G() }],
                            animate: [{ animate: ["none", "spin", "ping", "pulse", "bounce", k] }],
                            transform: [{ transform: ["", "gpu", "none"] }],
                            scale: [{ scale: [E] }],
                            "scale-x": [{ "scale-x": [E] }],
                            "scale-y": [{ "scale-y": [E] }],
                            rotate: [{ rotate: [P, k] }],
                            "translate-x": [{ "translate-x": [_] }],
                            "translate-y": [{ "translate-y": [_] }],
                            "skew-x": [{ "skew-x": [x] }],
                            "skew-y": [{ "skew-y": [x] }],
                            "transform-origin": [{ origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", k] }],
                            accent: [{ accent: ["auto", e] }],
                            appearance: [{ appearance: ["none", "auto"] }],
                            cursor: [
                                {
                                    cursor: [
                                        "auto",
                                        "default",
                                        "pointer",
                                        "wait",
                                        "text",
                                        "move",
                                        "help",
                                        "not-allowed",
                                        "none",
                                        "context-menu",
                                        "progress",
                                        "cell",
                                        "crosshair",
                                        "vertical-text",
                                        "alias",
                                        "copy",
                                        "no-drop",
                                        "grab",
                                        "grabbing",
                                        "all-scroll",
                                        "col-resize",
                                        "row-resize",
                                        "n-resize",
                                        "e-resize",
                                        "s-resize",
                                        "w-resize",
                                        "ne-resize",
                                        "nw-resize",
                                        "se-resize",
                                        "sw-resize",
                                        "ew-resize",
                                        "ns-resize",
                                        "nesw-resize",
                                        "nwse-resize",
                                        "zoom-in",
                                        "zoom-out",
                                        k,
                                    ],
                                },
                            ],
                            "caret-color": [{ caret: [e] }],
                            "pointer-events": [{ "pointer-events": ["none", "auto"] }],
                            resize: [{ resize: ["none", "y", "x", ""] }],
                            "scroll-behavior": [{ scroll: ["auto", "smooth"] }],
                            "scroll-m": [{ "scroll-m": H() }],
                            "scroll-mx": [{ "scroll-mx": H() }],
                            "scroll-my": [{ "scroll-my": H() }],
                            "scroll-ms": [{ "scroll-ms": H() }],
                            "scroll-me": [{ "scroll-me": H() }],
                            "scroll-mt": [{ "scroll-mt": H() }],
                            "scroll-mr": [{ "scroll-mr": H() }],
                            "scroll-mb": [{ "scroll-mb": H() }],
                            "scroll-ml": [{ "scroll-ml": H() }],
                            "scroll-p": [{ "scroll-p": H() }],
                            "scroll-px": [{ "scroll-px": H() }],
                            "scroll-py": [{ "scroll-py": H() }],
                            "scroll-ps": [{ "scroll-ps": H() }],
                            "scroll-pe": [{ "scroll-pe": H() }],
                            "scroll-pt": [{ "scroll-pt": H() }],
                            "scroll-pr": [{ "scroll-pr": H() }],
                            "scroll-pb": [{ "scroll-pb": H() }],
                            "scroll-pl": [{ "scroll-pl": H() }],
                            "snap-align": [{ snap: ["start", "end", "center", "align-none"] }],
                            "snap-stop": [{ snap: ["normal", "always"] }],
                            "snap-type": [{ snap: ["none", "x", "y", "both"] }],
                            "snap-strictness": [{ snap: ["mandatory", "proximity"] }],
                            touch: [{ touch: ["auto", "none", "manipulation"] }],
                            "touch-x": [{ "touch-pan": ["x", "left", "right"] }],
                            "touch-y": [{ "touch-pan": ["y", "up", "down"] }],
                            "touch-pz": ["touch-pinch-zoom"],
                            select: [{ select: ["none", "text", "all", "auto"] }],
                            "will-change": [{ "will-change": ["auto", "scroll", "contents", "transform", k] }],
                            fill: [{ fill: [e, "none"] }],
                            "stroke-w": [{ stroke: [C, T, L] }],
                            stroke: [{ stroke: [e, "none"] }],
                            sr: ["sr-only", "not-sr-only"],
                            "forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }],
                        },
                        conflictingClassGroups: {
                            overflow: ["overflow-x", "overflow-y"],
                            overscroll: ["overscroll-x", "overscroll-y"],
                            inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
                            "inset-x": ["right", "left"],
                            "inset-y": ["top", "bottom"],
                            flex: ["basis", "grow", "shrink"],
                            gap: ["gap-x", "gap-y"],
                            p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
                            px: ["pr", "pl"],
                            py: ["pt", "pb"],
                            m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
                            mx: ["mr", "ml"],
                            my: ["mt", "mb"],
                            size: ["w", "h"],
                            "font-size": ["leading"],
                            "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
                            "fvn-ordinal": ["fvn-normal"],
                            "fvn-slashed-zero": ["fvn-normal"],
                            "fvn-figure": ["fvn-normal"],
                            "fvn-spacing": ["fvn-normal"],
                            "fvn-fraction": ["fvn-normal"],
                            "line-clamp": ["display", "overflow"],
                            rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
                            "rounded-s": ["rounded-ss", "rounded-es"],
                            "rounded-e": ["rounded-se", "rounded-ee"],
                            "rounded-t": ["rounded-tl", "rounded-tr"],
                            "rounded-r": ["rounded-tr", "rounded-br"],
                            "rounded-b": ["rounded-br", "rounded-bl"],
                            "rounded-l": ["rounded-tl", "rounded-bl"],
                            "border-spacing": ["border-spacing-x", "border-spacing-y"],
                            "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
                            "border-w-x": ["border-w-r", "border-w-l"],
                            "border-w-y": ["border-w-t", "border-w-b"],
                            "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
                            "border-color-x": ["border-color-r", "border-color-l"],
                            "border-color-y": ["border-color-t", "border-color-b"],
                            "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
                            "scroll-mx": ["scroll-mr", "scroll-ml"],
                            "scroll-my": ["scroll-mt", "scroll-mb"],
                            "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
                            "scroll-px": ["scroll-pr", "scroll-pl"],
                            "scroll-py": ["scroll-pt", "scroll-pb"],
                            touch: ["touch-x", "touch-y", "touch-pz"],
                            "touch-x": ["touch"],
                            "touch-y": ["touch"],
                            "touch-pz": ["touch"],
                        },
                        conflictingClassGroupModifiers: { "font-size": ["leading"] },
                    };
                }
                function W(e, { cacheSize: t, prefix: i, separator: s, extend: r = {}, override: n = {} }) {
                    Y(e, "cacheSize", t), Y(e, "prefix", i), Y(e, "separator", s);
                    for (const t in n) U(e[t], n[t]);
                    for (const t in r) X(e[t], r[t]);
                    return e;
                }
                function Y(e, t, i) {
                    void 0 !== i && (e[t] = i);
                }
                function U(e, t) {
                    if (t) for (const i in t) Y(e, i, t[i]);
                }
                function X(e, t) {
                    if (t)
                        for (const i in t) {
                            const s = t[i];
                            void 0 !== s && (e[i] = (e[i] || []).concat(s));
                        }
                }
                const K = m(G);
                (t.createTailwindMerge = m),
                    (t.extendTailwindMerge = function (e, ...t) {
                        return "function" == typeof e ? m(G, e, ...t) : m(() => W(G(), e), ...t);
                    }),
                    (t.fromTheme = v),
                    (t.getDefaultConfig = G),
                    (t.mergeConfigs = W),
                    (t.twJoin = p),
                    (t.twMerge = K),
                    (t.validators = V);
            },
            9e3: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.AccordionItem = void 0);
                class i extends HTMLElement {
                    constructor() {
                        super(), (this.heading = null), (this.content = null), (this.contentHeight = 0), (this.duration = 0), (this.isAnimating = !1), this.init();
                    }
                    init() {
                        (this.heading = this.querySelector("[data-heading]")), (this.content = this.querySelector("[data-content]")), this.initContentDimensions(), this.initEventListeners(), this.initDataset();
                    }
                    initDataset() {
                        if (!this.content) return this.destroy();
                        const e = this.dataset.duration,
                            t = this.dataset.delay,
                            i = this.dataset.open;
                        e && ((this.duration = parseInt(e)), (this.content.style.transitionDuration = `${e}ms`)), t && (this.content.style.transitionDelay = `${t}ms`), "true" === i && this.open();
                    }
                    initEventListeners() {
                        if (!this.heading) return this.destroy();
                        window.addEventListener("resize", () => this.initContentDimensions()), window.addEventListener("change", () => this.initContentDimensions()), this.heading.addEventListener("click", () => this.toggle());
                    }
                    initContentDimensions() {
                        setTimeout(() => {
                            if (!this.content) return this.destroy();
                            (this.contentHeight = this.content.offsetHeight),
                                this.content.style.removeProperty("height"),
                                (this.contentHeight = this.content.offsetHeight),
                                (this.content.style.height = "0"),
                                (this.content.style.opacity = "1"),
                                this.close();
                        }, 0);
                    }
                    toggle() {
                        this.hasAttribute("open") ? this.close() : this.open();
                    }
                    open() {
                        this.heading &&
                            this.content &&
                            !this.isAnimating &&
                            ((this.isAnimating = !0), (this.content.style.height = `${this.contentHeight}px`), this.setAttribute("open", ""), setTimeout(() => (this.isAnimating = !1), this.duration));
                    }
                    close() {
                        this.heading && this.content && !this.isAnimating && ((this.isAnimating = !0), (this.content.style.height = "0"), this.removeAttribute("open"), setTimeout(() => (this.isAnimating = !1), this.duration));
                    }
                    destroy() {
                        this.heading && this.heading.removeEventListener("click", () => this.toggle),
                            window.removeEventListener("resize", this.initContentDimensions),
                            window.removeEventListener("change", this.initContentDimensions),
                            (this.content = null),
                            (this.heading = null),
                            (this.duration = 0),
                            (this.contentHeight = 0),
                            (this.isAnimating = !1);
                    }
                }
                (t.AccordionItem = i), customElements.define("accordion-item", i);
            },
            3116: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(852),
                    r = i(932),
                    n = i(5056);
                class a extends HTMLElement {
                    constructor() {
                        var e;
                        super(),
                            (this.activeElement = null),
                            (this.productId = null),
                            this.addEventListener("keyup", (e) => "Escape" === e.code && this.close()),
                            null === (e = this.querySelector("#CartDrawer-Overlay")) || void 0 === e || e.addEventListener("click", this.close.bind(this)),
                            this.setHeaderCartIconAccessibility();
                    }
                    setHeaderCartIconAccessibility() {
                        const e = document.querySelector("#cart-icon-bubble");
                        e &&
                            location.pathname !== window.routes.cart_url &&
                            (e.setAttribute("role", "button"),
                            e.setAttribute("aria-haspopup", "dialog"),
                            e.addEventListener("click", (t) => {
                                t.preventDefault(), this.open(e);
                            }),
                            e.addEventListener("keydown", (t) => {
                                "code" in t && "string" === t.code && "SPACE" === t.code.toUpperCase() && (t.preventDefault(), this.open(e));
                            }));
                    }
                    open(e = null) {
                        this.setActiveElement(e),
                            this.setAttribute("open", ""),
                            this.addEventListener(
                                "transitionend",
                                () => {
                                    const e = document.getElementById("CartDrawer"),
                                        t = this.querySelector('button[aria-label="Close"]');
                                    (0, s.trapFocus)(e, t);
                                },
                                { once: !0 }
                            ),
                            document.body.classList.add("overflow-hidden");
                    }
                    close() {
                        this.removeAttribute("open"), (0, s.removeTrapFocus)(this.activeElement), document.body.classList.remove("overflow-hidden");
                    }
                    setSummaryAccessibility(e) {
                        var t, i;
                        e.setAttribute("role", "button"),
                            e.setAttribute("aria-expanded", "false"),
                            (null === (t = e.nextElementSibling) || void 0 === t ? void 0 : t.getAttribute("id")) && e.setAttribute("aria-controls", e.nextElementSibling.id),
                            e.addEventListener("click", (e) => {
                                var t;
                                const i = e.currentTarget,
                                    s = !(null === (t = null == i ? void 0 : i.closest("details")) || void 0 === t ? void 0 : t.hasAttribute("open"));
                                null == i || i.setAttribute("aria-expanded", s.toString());
                            }),
                            null === (i = e.parentElement) || void 0 === i || i.addEventListener("keyup", r.onKeyUpEscape);
                    }
                    renderContents(e) {
                        (this.productId = e.id),
                            this.getSectionsToRender().forEach((t) => {
                                const i = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
                                i && (i.innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector));
                            }),
                            setTimeout(() => {
                                var e;
                                null === (e = this.querySelector("#CartDrawer-Overlay")) || void 0 === e || e.addEventListener("click", this.close.bind(this)), this.open();
                            });
                    }
                    getSectionInnerHTML(e, t = ".shopify-section") {
                        var i;
                        return (null === (i = new DOMParser().parseFromString(e, "text/html").querySelector(t)) || void 0 === i ? void 0 : i.innerHTML) || "";
                    }
                    getSectionsToRender() {
                        return [
                            { id: "cart-drawer", selector: "#CartDrawer" },
                            { id: "cart-icon-bubble", selector: "cart-icon-bubble" },
                        ];
                    }
                    getSectionDOM(e, t = ".shopify-section") {
                        return new DOMParser().parseFromString(e, "text/html").querySelector(t);
                    }
                    setActiveElement(e) {
                        this.activeElement = e;
                    }
                }
                //customElements.define("cart-drawer", a);
                class o extends n.CartItems {
                    getSectionsToRender() {
                        return [
                            { id: "CartDrawer", section: "cart-drawer", selector: "#CartDrawer" },
                            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
                            { id: "cart-bubble", section: "cart-bubble", selector: ".shopify-section" },
                        ];
                    }
                }
               // customElements.define("cart-drawer-items", o);
            },
            2120: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(), (this.closeIcon = null);
                    }
                    connectedCallback() {
                        "true" !== this.getCookie("hideCartOffer")
                            ? ((this.closeIcon = this.querySelector(".icon-close")), this.closeIcon ? this.closeIcon.addEventListener("click", () => this.handleClose()) : console.error("No close icon found in cart-offer element."))
                            : this.remove();
                    }
                    handleClose() {
                        this.setCookie("hideCartOffer", "true", 7), this.remove();
                    }
                    setCookie(e, t, i) {
                        const s = new Date();
                        s.setTime(s.getTime() + 24 * i * 60 * 60 * 1e3);
                        const r = "expires=" + s.toUTCString();
                        document.cookie = e + "=" + t + ";" + r + ";path=/";
                    }
                    getCookie(e) {
                        const t = e + "=",
                            i = document.cookie.split(";");
                        for (let e = 0; e < i.length; e++) {
                            let s = i[e];
                            for (; " " == s.charAt(0); ) s = s.substring(1, s.length);
                            if (0 == s.indexOf(t)) return s.substring(t.length, s.length);
                        }
                        return null;
                    }
                }
                customElements.define("cart-offer", e);
            },
            5056: function (e, t, i) {
                "use strict";
                var s =
                        (this && this.__createBinding) ||
                        (Object.create
                            ? function (e, t, i, s) {
                                  void 0 === s && (s = i);
                                  var r = Object.getOwnPropertyDescriptor(t, i);
                                  (r && !("get" in r ? !t.__esModule : r.writable || r.configurable)) ||
                                      (r = {
                                          enumerable: !0,
                                          get: function () {
                                              return t[i];
                                          },
                                      }),
                                      Object.defineProperty(e, s, r);
                              }
                            : function (e, t, i, s) {
                                  void 0 === s && (s = i), (e[s] = t[i]);
                              }),
                    r =
                        (this && this.__setModuleDefault) ||
                        (Object.create
                            ? function (e, t) {
                                  Object.defineProperty(e, "default", { enumerable: !0, value: t });
                              }
                            : function (e, t) {
                                  e.default = t;
                              }),
                    n =
                        (this && this.__importStar) ||
                        function (e) {
                            if (e && e.__esModule) return e;
                            var t = {};
                            if (null != e) for (var i in e) "default" !== i && Object.prototype.hasOwnProperty.call(e, i) && s(t, e, i);
                            return r(t, e), t;
                        },
                    a =
                        (this && this.__importDefault) ||
                        function (e) {
                            return e && e.__esModule ? e : { default: e };
                        };
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.CartItems = void 0);
                const o = n(i(8592)),
                    l = a(i(7916)),
                    d = i(852),
                    c = i(4292);
                class u extends HTMLElement {
                    constructor() {
                        super(), (this.selectElement = null);
                    }
                    connectedCallback() {
                        (this.selectElement = this.querySelector("select")),
                            this.selectElement ? this.selectElement.addEventListener("change", this.onSelectChange.bind(this)) : console.error("Select or input element not found in quantity-select component.");
                    }
                    disconnectedCallback() {
                        this.selectElement && this.selectElement.removeEventListener("change", this.onSelectChange.bind(this));
                    }
                    onSelectChange(e) {
                        const t = e.target;
                        if (t) {
                            if ("0" === t.value) {
                                const t = window.cartStrings.thisItem;
                                if (!window.confirm(window.cartStrings.confirmRemove.replace("[product]", t))) {
                                    e.stopPropagation(), e.preventDefault();
                                    const t = this.getAttribute("data-selected-value");
                                    this.selectElement && t && (this.selectElement.value = t);
                                }
                            }
                            this.setAttribute("data-selected-value", t.value);
                        }
                    }
                }
               // customElements.define("quantity-select", u);
                class p extends HTMLElement {
                    constructor() {
                        super(),
                            this.addEventListener("click", (e) => {
                                e.preventDefault();
                                const t = e.currentTarget.dataset.productTitle;
                                if (!window.confirm(window.cartStrings.confirmRemove.replace("[product]", t || "this item"))) return;
                                const i = this.closest("cart-items") || this.closest("cart-drawer-items"),
                                    s = this.dataset.index;
                                s && (null == i || i.updateLineItem(s, { quantity: 0 }));
                            });
                    }
                }
               // customElements.define("cart-remove-button", p);
                class h extends HTMLElement {
                    constructor() {
                        super(), (this.lineItemStatusElement = null), (this.sellingPlanInput = null), (this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status")), this.initCartEventListeners();
                    }
                    connectedCallback() {
                        this.cartUpdateUnsubscriber = (0, c.subscribe)(c.PUB_SUB_EVENTS.cartUpdate, (e) => {
                            this.onCartUpdate();
                        });
                    }
                    disconnectedCallback() {
                        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
                    }
                    initCartEventListeners() {
                        const e = (0, o.default)((e) => {
                            this.onChange(e);
                        }, o.ON_CHANGE_DEBOUNCE_TIMER);
                        this.addEventListener("change", e.bind(this));
                    }
                    onChange(e) {
                        var t, i;
                        const s = null === (t = e.target.closest("[data-index]")) || void 0 === t ? void 0 : t.dataset.index;
                        if (!s) return;
                        const r = {};
                        "quantity" === e.target.name && (r.quantity = e.target.value),
                            "selling_plan" === e.target.name && (r.selling_plan = e.target.value),
                            this.updateLineItem(s, r, null === (i = document.activeElement) || void 0 === i ? void 0 : i.getAttribute("name"), e.target.dataset.quantityVariantId);
                    }
                    onCartUpdate() {
                        const e = "CART-DRAWER-ITEMS" === this.tagName ? "cart-drawer" : "main-cart-items";
                        fetch(`${window.routes.cart_url}?section_id=${e}`)
                            .then((e) => e.text())
                            .then((e) => {
                                const t = new DOMParser().parseFromString(e, "text/html").querySelector("cart-items");
                                this.innerHTML = (null == t ? void 0 : t.innerHTML) || "";
                            })
                            .catch((e) => {
                                console.error(e);
                            });
                    }
                    getSectionsToRender() {
                        var e, t;
                        return [
                            { id: "main-cart-items", section: null === (e = document.getElementById("main-cart-items")) || void 0 === e ? void 0 : e.dataset.id, selector: "#main-cart-items" },
                            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
                            { id: "cart-bubble", section: "cart-bubble", selector: ".shopify-section" },
                            { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
                            { id: "main-cart-footer", section: null === (t = document.getElementById("main-cart-footer")) || void 0 === t ? void 0 : t.dataset.id, selector: "#main-cart-footer" },
                        ];
                    }
                    updateLineItem(e, t, i, s) {
                        this.enableLoading(e), this.classList.remove("has-error");
                        const r = JSON.stringify(Object.assign(Object.assign({ line: e }, t), { sections: this.getSectionsToRender().map((e) => e.section), sections_url: window.location.pathname })),
                            n = parseInt(String(e), 10);
                        fetch(`${window.routes.cart_change_url}`, Object.assign(Object.assign({}, (0, l.default)()), { body: r }))
                            .then((e) => e.text())
                            .then((t) => {
                                const r = JSON.parse(t),
                                    a = document.getElementById(`Quantity-${e}`),
                                    o = document.querySelectorAll(".cart-item");
                                if (r.errors) {
                                    const t = null == a ? void 0 : a.getAttribute("value");
                                    return a && null != t && (a.value = t), void this.updateLiveRegions(e, r.errors);
                                }
                                const l = document.querySelector("cart-drawer"),
                                    u = document.getElementById("main-cart-footer");
                                u && u.classList.toggle("is-empty", 0 === r.item_count),
                                    l && l.classList.toggle("is-empty", 0 === r.item_count),
                                    this.getSectionsToRender().forEach((e) => {
                                        var t;
                                        const i = (null === (t = document.getElementById(e.id)) || void 0 === t ? void 0 : t.querySelector(e.selector)) || document.getElementById(e.id);
                                        i && (i.innerHTML = this.getSectionInnerHTML(r.sections[e.section], e.selector));
                                    });
                                const p = r.items[n - 1] ? r.items[n - 1].quantity : void 0,
                                    h = o.length !== r.items.length,
                                    m = p !== parseInt(String(a.value), 10);
                                let v = "";
                                !h && m && (v = void 0 === p ? window.cartStrings.error : window.cartStrings.quantityError.replace("{{ quantity }}", p)), this.updateLiveRegions(e, v);
                                const g = document.getElementById(`CartItem-${e}`) || document.getElementById(`CartDrawerItem-${e}`),
                                    f = null == g ? void 0 : g.querySelector(`[name="${i}"]`);
                                g && f
                                    ? l
                                        ? (0, d.trapFocus)(l, f)
                                        : f.focus()
                                    : 0 === r.item_count && l
                                    ? (0, d.trapFocus)(l, l.querySelector("a"))
                                    : document.querySelector(".cart-item") && l && (0, d.trapFocus)(l, this.querySelector("[data-line-item-title]")),
                                    (0, c.publish)(c.PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: r, variantId: s });
                            })
                            .catch(() => {
                                this.querySelectorAll(".is-loading").forEach((e) => e.classList.remove("is-loading")), this.classList.add("has-error");
                                const e = document.getElementById("cart-errors");
                                if (e) {
                                    const t = e.querySelector("small");
                                    t && (t.textContent = window.cartStrings.error);
                                }
                            })
                            .finally(() => {
                                this.disableLoading();
                            });
                    }
                    updateLiveRegions(e, t) {
                        var i;
                        const s = document.getElementById(`CartItem-${e}`),
                            r = document.getElementById(`CartItem-error-${e}`),
                            n = null == r ? void 0 : r.querySelector("small");
                        s && n && ((n.innerHTML = t), null == s || s.classList.toggle("has-error", (null == t ? void 0 : t.length) > 0)), null === (i = this.lineItemStatusElement) || void 0 === i || i.setAttribute("aria-hidden", "true");
                        const a = document.getElementById("cart-live-region-text");
                        null == a || a.setAttribute("aria-hidden", "false"),
                            setTimeout(() => {
                                null == a || a.setAttribute("aria-hidden", "true");
                            }, 1e3);
                    }
                    getSectionInnerHTML(e, t) {
                        var i;
                        return (null === (i = new DOMParser().parseFromString(e, "text/html").querySelector(t)) || void 0 === i ? void 0 : i.innerHTML) || "";
                    }
                    enableLoading(e) {
                        var t;
                        const i = this.querySelector(`#CartItem-${e}`);
                        null == i || i.classList.add("is-loading"), document.activeElement.blur(), null === (t = this.lineItemStatusElement) || void 0 === t || t.setAttribute("aria-hidden", "false");
                    }
                    disableLoading(e) {
                        var t;
                        null != e ? null === (t = this.querySelector(`#CartItem-${e}`)) || void 0 === t || t.classList.remove("is-loading") : this.querySelectorAll(".is-loading").forEach((e) => e.classList.remove("is-loading"));
                    }
                }
                (t.CartItems = h)//, customElements.define("cart-items", h);
            },
            8524: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.CustomSelect = void 0);
                const s = i(3948);
                class r extends HTMLElement {
                    constructor() {
                        super(), (this.nativeOptions = []), (this.customOptions = []), (this.emptyLabel = ""), (this.props = {});
                    }
                    connectedCallback() {
                        this.init();
                    }
                    init() {
                        var e, t, i;
                        if (((this.nativeSelect = this.querySelector("select")), (this.nativeOptions = Array.from(this.querySelectorAll("option"))), !this.nativeSelect)) return;
                        this.nativeSelect.classList.add("peer", "hidden"), (this.emptyLabel = this.getAttribute("empty-label") || "");
                        const s = null === (t = null === (e = this.nativeSelect) || void 0 === e ? void 0 : e.querySelector("option[selected]")) || void 0 === t ? void 0 : t.innerHTML,
                            r = null === (i = this.nativeOptions[0]) || void 0 === i ? void 0 : i.innerHTML;
                        (this.props = {
                            initialSelectedValue: s,
                            initialValue: s || this.emptyLabel || r,
                            initialLabel: this.getAttribute("initial-label") || "",
                            selectLabelClass: this.getAttribute("select-label-class") || "",
                            selectLabelIconClass: this.getAttribute("select-label-icon-class") || "",
                            optionsListClass: this.getAttribute("options-list-class") || "",
                            optionClass: this.getAttribute("option-class") || "",
                            theme: this.getAttribute("theme") || void 0,
                            shouldEventBubble: "true" === this.getAttribute("should-event-bubble"),
                            detailTextDelimiter: this.getAttribute("detail-text-delimiter") || "",
                            useOptionValueForLabel: "true" === this.getAttribute("use-option-value-for-label"),
                            labelPrefix: this.getAttribute("label-prefix") || "",
                            showCountryFlags: "true" === this.getAttribute("show-country-flags"),
                        }),
                            this.renderCustomSelect(),
                            this.classList.add("group/wrapper"),
                            this.customSelect && this.dialogElement && ((this.nativeSelect.tabIndex = -1), this.customButton || (this.customSelect.tabIndex = 0), this.initEventListeners());
                    }
                    renderSelectLabel() {
                        const { selectLabelClass: e, selectLabelIconClass: t, initialValue: i, theme: r, detailTextDelimiter: n, initialLabel: a, labelPrefix: o } = this.props,
                            l = this.querySelector("button");
                        if (l) return (this.customButton = l.cloneNode(!0)), this.customButton.setAttribute("data-custom-select-label", ""), l.remove(), this.customButton.outerHTML;
                        const d = (0, s.cn)("flex gap-2 items-center justify-between w-full cursor-pointer", { "px-4 py-2 min-h-11 rounded-sm border border-border-primary font-body-sm": null != r }, e),
                            c = (0, s.cn)({ "text-regular text-text-supporting": null != r }),
                            u = (0, s.cn)("w-5 h-5 transform shrink-0 group-open/wrapper:rotate-180", t);
                        let p = a || i,
                            h = "";
                        if (p && n) {
                            const e = p.split(n);
                            (p = e[0] || ""), (h = e[1] || "");
                        }
                        return `\n      <div class="${d}" data-custom-select-label>\n        <div class="flex gap-1.5">\n          <span class="truncate" data-select-value>${o}${p}</span>\n          <span class="${c}" data-select-detail-text>${h}</span>\n        </div>\n\n        <svg class="${u}" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n          <path d="M17.0288 7.06279L9.90373 14.1876L2.77881 7.06279" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>\n        </svg>\n      </div>\n    `;
                    }
                    renderSelectOptions() {
                        const { optionsListClass: e, optionClass: t, initialSelectedValue: i, theme: r, detailTextDelimiter: n, showCountryFlags: a } = this.props,
                            o = (0, s.cn)("relative full overflow-y-auto max-h-64", { "bg-surface-primary text-text-headline px-1.5 pt-1.5 pb-1 shadow-lg border border-border-disabled my-2 rounded-sm": null != r, dark: "dark" === r }, e),
                            l = (0, s.cn)(
                                "group flex items-center justify-between gap-2 whitespace-nowrap transition-colors cursor-pointer",
                                {
                                    "px-2 py-2.5 mb-0.5 font-body-sm font-medium rounded-sm focus:outline-none border border-transparent": null != r,
                                    "data-[selected=true]:bg-surface-salt-medium hover:bg-surface-salt-medium focus:border-border-primary": "dark" === r,
                                    "data-[selected=true]:bg-surface-salt-light hover:bg-surface-salt-light focus:border-surface-salt-medium": "light" === r,
                                },
                                t
                            ),
                            d = (0, s.cn)({ "text-regular text-text-supporting": null != r });
                        return `\n      <ul class="${o}" role="presentation" data-custom-select-options>\n        ${this.nativeOptions
                            .map((e, t) => {
                                const s = (i ? e.innerHTML === i : 0 === e.index) ? 'data-selected="true" aria-selected="true"' : "";
                                let r = e.innerHTML,
                                    o = "";
                                if (n) {
                                    const t = e.innerHTML.split(n);
                                    (r = t[0] || ""), (o = t[1] || "");
                                }
                                return `\n              <li ${s} class="${l}" role="option" tabindex="0" data-index="${t}" data-value="${e.value}" data-label="${
                                    e.label
                                }">\n                <div class="flex gap-3 items-center">\n                  ${
                                    a ? `<img src="${e.getAttribute("data-flag-src")}" class="w-5 h-5 block" />` : ""
                                }\n\n                  <div class="flex gap-2">\n                    <span>${r}</span>\n                    <span class="${d}">${o}</span>\n                  </div>\n                </div>\n\n                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-icon-secondary shrink-0 opacity-0 group-data-[selected=true]:opacity-100">\n                  <path d="M2 9.24979L7.50066 14.7498L17 5.25049" stroke="currentColor" stroke-width="1.25"/>\n                </svg>\n              </li>\n            `;
                            })
                            .join("")}\n      </ul>\n    `;
                    }
                    renderCustomSelect() {
                        var e;
                        const t = this.querySelector("[data-custom-select]");
                        t && this.removeChild(t);
                        const i = this.getAttribute("select-class") || "",
                            r = (0, s.cn)("m-0 backdrop:opacity-0 backdrop:cursor-default overflow-visible bg-transparent", "", i),
                            n = `\n      <div\n        class="${(0, s.cn)(
                                "flex relative shrink-0 peer-disabled:opacity-60 peer-disabled:pointer-events-none transition-opacity duration-300",
                                "",
                                i
                            )}"\n        data-custom-select\n      >\n        ${this.renderSelectLabel()}\n\n        <dialog class="${r}">\n          ${this.renderSelectOptions()}\n        </dialog>\n      </div>\n    `;
                        this.insertAdjacentHTML("beforeend", n),
                            (this.customSelect = this.querySelector("[data-custom-select]")),
                            (this.customOptions = Array.from((null === (e = this.customSelect) || void 0 === e ? void 0 : e.querySelectorAll("li")) || [])),
                            (this.dialogElement = this.querySelector("dialog"));
                    }
                    refresh() {
                        this.removeEventListeners(), this.renderCustomSelect(), this.initEventListeners();
                    }
                    showOptions() {
                        if (!this.customSelect || !this.dialogElement) return;
                        this.dialogElement.showModal();
                        const e = this.customOptions.find((e) => "true" === e.getAttribute("data-selected"));
                        null == e || e.focus(), this.setAttribute("open", ""), this.positionDialog(), this.setDialogOverflow();
                    }
                    hideOptions() {
                        this.customSelect && this.dialogElement && (this.removeAttribute("open"), this.dialogElement.close(), this.removeDialogOverflow());
                    }
                    toggleOptions() {
                        this.dialogElement && !this.dialogElement.hasAttribute("open") ? this.showOptions() : this.hideOptions();
                    }
                    highlightIndex(e) {
                        var t;
                        null === (t = this.customOptions[e]) || void 0 === t || t.focus();
                    }
                    updateValue(e) {
                        var t, i;
                        if (!this.nativeSelect || !this.customSelect) return;
                        const { useOptionValueForLabel: s, detailTextDelimiter: r, shouldEventBubble: n, labelPrefix: a } = this.props,
                            o = this.customOptions[e],
                            l = this.customSelect.querySelectorAll("[data-select-value]"),
                            d = this.customSelect.querySelectorAll("[data-select-detail-text]"),
                            c = o.getAttribute("data-value"),
                            u = o.getAttribute("data-label");
                        this.customOptions.forEach((e) => {
                            e.setAttribute("aria-selected", "false"), e.setAttribute("data-selected", "false");
                        }),
                            this.customOptions[e].setAttribute("aria-selected", "true"),
                            this.customOptions[e].setAttribute("data-selected", "true");
                        const p = null === (t = this.nativeOptions[e]) || void 0 === t ? void 0 : t.value,
                            h = null != p && "" !== p;
                        if (
                            ((this.nativeSelect.selectedIndex = e),
                            (this.nativeSelect.value = p),
                            null === (i = this.nativeSelect.querySelector("option[selected]")) || void 0 === i || i.removeAttribute("selected"),
                            this.nativeSelect.querySelectorAll("option")[e].setAttribute("selected", "selected"),
                            this.nativeSelect.dispatchEvent(new Event("change", { bubbles: n })),
                            this.nativeSelect.dispatchEvent(new Event("input", { bubbles: n })),
                            (null == l ? void 0 : l.length) && c)
                        ) {
                            let e = (s ? c : u) || c;
                            !h && this.emptyLabel && (e = this.emptyLabel);
                            let t = "";
                            if (u && r && u.includes(r)) {
                                const i = u.split(r);
                                (e = i[0]), (t = i[1]);
                            }
                            a && (e = `${a}${e}`), l.forEach((t) => (t.innerHTML = e)), d.forEach((e) => (e.innerHTML = t));
                        }
                    }
                    getCurrentIndex() {
                        var e;
                        return null === (e = this.nativeSelect) || void 0 === e ? void 0 : e.selectedIndex;
                    }
                    setDialogOverflow() {
                        const e = window.innerWidth - document.documentElement.clientWidth;
                        (document.body.style.overflowY = "hidden"), (document.body.style.paddingRight = `${e}px`);
                    }
                    removeDialogOverflow() {
                        document.body.style.removeProperty("overflow-y"), document.body.style.removeProperty("padding-right");
                    }
                    positionDialog() {
                        if (!this.customSelect || !this.dialogElement) return;
                        const e = this.customSelect.getBoundingClientRect(),
                            t = this.dialogElement.getBoundingClientRect(),
                            i = "true" === this.getAttribute("match-parent-width"),
                            s = this.customSelect.querySelector("[data-custom-select-label]"),
                            r = (null == s || s.getBoundingClientRect().height, this.customSelect.querySelector("[data-custom-select-options]"));
                        (this.dialogElement.style.left = `${e.left}px`),
                            (this.dialogElement.style.height = "fit-content"),
                            (this.dialogElement.style.width = i ? `${e.width}px` : "fit-content"),
                            r && (window.innerHeight - e.bottom < t.height ? (this.dialogElement.style.top = e.top - t.height + "px") : (this.dialogElement.style.top = `${e.bottom}px`));
                    }
                    handleWindowResize() {
                        this.dialogElement && this.dialogElement.hasAttribute("open") && this.hideOptions();
                    }
                    handleCustomOptionMouseOver(e, t) {
                        this.highlightIndex(t);
                    }
                    handleCustomOptionMouseDown(e, t) {
                        e.stopPropagation(), this.updateValue(t), this.hideOptions();
                    }
                    handleCustomSelectKeyup(e) {
                        var t, i, s;
                        const r = null === (t = this.dialogElement) || void 0 === t ? void 0 : t.hasAttribute("open");
                        if (null === (i = this.nativeSelect) || void 0 === i ? void 0 : i.hasAttribute("disabled")) return e.preventDefault(), !1;
                        const n = this.customOptions.find((e) => e === document.activeElement),
                            a = n ? this.customOptions.indexOf(n) : 0;
                        let o = !1;
                        if ("Escape" === e.code || "Enter" === e.code) {
                            if (!r) return e.preventDefault(), !1;
                            null === (s = this.customSelect) || void 0 === s || s.blur(), this.hideOptions(), (o = !0);
                        }
                        return (
                            "Enter" === e.code && this.updateValue(a),
                            "Space" === e.code && (r && this.updateValue(a), this.toggleOptions(), (o = !0)),
                            "ArrowDown" === e.code && a < this.customOptions.length - 1 && (this.highlightIndex(a + 1), (o = !0)),
                            "ArrowUp" === e.code && a > 0 && (this.highlightIndex(a - 1), (o = !0)),
                            o ? (e.preventDefault(), e.stopPropagation(), !1) : void 0
                        );
                    }
                    handleCustomSelectMouseDown(e) {
                        var t;
                        if (null === (t = this.nativeSelect) || void 0 === t ? void 0 : t.hasAttribute("disabled")) return e.preventDefault(), e.stopPropagation(), !1;
                        this.toggleOptions();
                    }
                    handleCustomSelectFocus(e) {
                        window.addEventListener("keydown", this.preventAccidentalScroll, !0);
                    }
                    handleCustomSelectBlur(e) {
                        window.removeEventListener("keydown", this.preventAccidentalScroll, !0);
                    }
                    handleDialogElementKeydown(e) {
                        var t;
                        if (this.dialogElement && !this.dialogElement.hasAttribute("open")) return "Tab" === e.code ? (null === (t = this.customSelect) || void 0 === t || t.focus(), e.preventDefault(), !1) : void 0;
                    }
                    handleDialogElementBlur(e) {
                        this.dialogElement && !this.dialogElement.hasAttribute("open") && this.hideOptions();
                    }
                    initEventListeners() {
                        var e, t;
                        this.customSelect &&
                            this.nativeSelect &&
                            (window.addEventListener("resize", this.handleWindowResize.bind(this)),
                            this.customOptions.forEach((e, t) => {
                                e.addEventListener("mouseover", (e) => this.handleCustomOptionMouseOver(e, t)), e.addEventListener("mousedown", (e) => this.handleCustomOptionMouseDown(e, t));
                            }),
                            this.customSelect.addEventListener("focus", this.handleCustomSelectFocus.bind(this)),
                            this.customSelect.addEventListener("blur", this.handleCustomSelectBlur.bind(this)),
                            this.customSelect.addEventListener("mousedown", this.handleCustomSelectMouseDown.bind(this)),
                            this.customSelect.addEventListener("keyup", this.handleCustomSelectKeyup.bind(this)),
                            null === (e = this.dialogElement) || void 0 === e || e.addEventListener("blur", this.handleDialogElementBlur.bind(this)),
                            null === (t = this.dialogElement) || void 0 === t || t.addEventListener("keydown", this.handleDialogElementKeydown.bind(this)));
                    }
                    removeEventListeners() {
                        var e, t, i, s, r, n;
                        window.removeEventListener("resize", this.handleWindowResize.bind(this)),
                            this.customOptions.forEach((e, t) => {
                                e.removeEventListener("mouseover", (e) => this.handleCustomOptionMouseOver(e, t)), e.removeEventListener("mousedown", (e) => this.handleCustomOptionMouseDown(e, t));
                            }),
                            null === (e = this.customSelect) || void 0 === e || e.removeEventListener("focus", this.handleCustomSelectFocus.bind(this)),
                            null === (t = this.customSelect) || void 0 === t || t.removeEventListener("blur", this.handleCustomSelectBlur.bind(this)),
                            null === (i = this.customSelect) || void 0 === i || i.removeEventListener("mousedown", this.handleCustomSelectMouseDown.bind(this)),
                            null === (s = this.customSelect) || void 0 === s || s.removeEventListener("keyup", this.handleCustomSelectKeyup.bind(this)),
                            null === (r = this.dialogElement) || void 0 === r || r.removeEventListener("blur", this.handleDialogElementBlur.bind(this)),
                            null === (n = this.dialogElement) || void 0 === n || n.removeEventListener("keydown", this.handleDialogElementKeydown.bind(this));
                    }
                    preventAccidentalScroll(e) {
                        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.code)) return e.preventDefault(), !1;
                    }
                    setDisabled(e) {
                        if (this.customSelect && this.nativeSelect) {
                            if (e) return this.nativeSelect.setAttribute("disabled", ""), void this.customSelect.setAttribute("tabindex", "-1");
                            this.nativeSelect.removeAttribute("disabled"), this.customSelect.setAttribute("tabindex", "0");
                        }
                    }
                }
                (t.CustomSelect = r), customElements.define("custom-select", r);
            },
            8808: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(6108);
                class r extends HTMLElement {
                    constructor() {
                        super(),
                            (this.buttonAddNewAddress = null),
                            (this.buttonsEditAddress = []),
                            (this.buttonsDeleteAddress = []),
                            (this.countrySelects = []),
                            (this.addressForms = []),
                            (this.buttonAddNewAddress = this.querySelector("[data-add-new-address-button]")),
                            (this.buttonsEditAddress = [...this.querySelectorAll("[data-edit-address-button]")]),
                            (this.buttonsDeleteAddress = [...this.querySelectorAll("[data-delete-address-button]")]),
                            (this.countrySelects = [...this.querySelectorAll("[data-address-country-select]")]),
                            (this.addressForms = [...this.querySelectorAll("[data-address]")]),
                            this.initCountries(),
                            this.initAddressFormEventListeners();
                    }
                    initCountries() {
                        new s.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                            this.countrySelects.forEach((e) => {
                                const t = e.dataset.formId;
                                new s.CountryProvinceSelector(`AddressCountry_${t}`, `AddressProvince_${t}`, { hideElement: `AddressProvinceContainer_${t}` });
                            });
                    }
                    initAddressFormEventListeners() {
                        this.addressForms.forEach((e) => {
                            const t = e.querySelector("[data-cancel-button]");
                            t && t.addEventListener("click", (t) => this.onFormCancel(t, e));
                        }),
                            this.buttonsEditAddress.forEach((e) => {
                                var t;
                                const i = null === (t = e.closest("[data-edit-container]")) || void 0 === t ? void 0 : t.querySelector("[data-address]");
                                i && e.addEventListener("click", (e) => this.onToggleFormView(e, i));
                            }),
                            this.buttonsDeleteAddress.forEach((e) => {
                                e.addEventListener("click", (e) => this.onDeleteAddress(e));
                            }),
                            this.buttonAddNewAddress && this.buttonAddNewAddress.addEventListener("click", (e) => this.onToggleFormView(e, this.addressForms[0]));
                    }
                    onToggleFormView(e, t) {
                        if (t) return t.classList.toggle("hidden");
                    }
                    onFormCancel(e, t) {
                        if (t) return t.classList.add("hidden");
                    }
                    onDeleteAddress(e) {
                        const t = e.target;
                        t.dataset.target && (0, s.postLink)(t.dataset.target, { parameters: { _method: "delete" } });
                    }
                }
                customElements.define("customer-addresses", r);
            },
            640: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.DetailsDisclosure = void 0);
                class i extends HTMLElement {
                    constructor() {
                        var e, t, i, s;
                        super(),
                            (this.mainDetailsToggle = this.querySelector("details")),
                            (this.content = null === (t = null === (e = this.mainDetailsToggle) || void 0 === e ? void 0 : e.querySelector("summary")) || void 0 === t ? void 0 : t.nextElementSibling),
                            null === (i = this.mainDetailsToggle) || void 0 === i || i.addEventListener("focusout", this.onFocusOut.bind(this)),
                            null === (s = this.mainDetailsToggle) || void 0 === s || s.addEventListener("toggle", this.onToggle.bind(this));
                    }
                    onFocusOut() {
                        setTimeout(() => {
                            this.contains(document.activeElement) || this.close();
                        });
                    }
                    onToggle() {
                        var e, t, i, s;
                        this.animations || (this.animations = null === (e = this.content) || void 0 === e ? void 0 : e.getAnimations()),
                            (null === (t = this.mainDetailsToggle) || void 0 === t ? void 0 : t.hasAttribute("open"))
                                ? null === (i = this.animations) || void 0 === i || i.forEach((e) => e.play())
                                : null === (s = this.animations) || void 0 === s || s.forEach((e) => e.cancel());
                    }
                    close() {
                        var e;
                        this.mainDetailsToggle &&
                            ((this.mainDetailsToggle.open = !1), this.mainDetailsToggle.removeAttribute("open"), null === (e = this.mainDetailsToggle.querySelector("summary")) || void 0 === e || e.setAttribute("aria-expanded", "false"));
                    }
                    openDisclosure() {
                        var e;
                        this.mainDetailsToggle &&
                            ((this.mainDetailsToggle.open = !0), this.mainDetailsToggle.setAttribute("open", ""), null === (e = this.mainDetailsToggle.querySelector("summary")) || void 0 === e || e.setAttribute("aria-expanded", "true"));
                    }
                }
                (t.DetailsDisclosure = i), customElements.define("details-disclosure", i);
            },
            7624: function (e, t, i) {
                "use strict";
                var s =
                    (this && this.__importDefault) ||
                    function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, "__esModule", { value: !0 });
                const r = s(i(8592)),
                    n = i(932);
                class a extends HTMLElement {
                    constructor() {
                        super(),
                            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
                            (this.debouncedOnSubmit = (0, r.default)((e) => {
                                this.onSubmitHandler(e);
                            }, 500));
                        const e = this.querySelector("form");
                        null == e || e.addEventListener("input", this.debouncedOnSubmit.bind(this));
                        const t = this.querySelector("#FacetsWrapperDesktop");
                        t && t.addEventListener("keyup", n.onKeyUpEscape);
                    }
                    static setListeners() {
                        window.addEventListener("popstate", (e) => {
                            const t = e.state ? e.state.searchParams : a.searchParamsInitial;
                            t !== a.searchParamsPrev && a.renderPage(t, null, !1);
                        });
                    }
                    static toggleActiveFacets(e = !0) {
                        document.querySelectorAll(".js-facet-remove").forEach((t) => {
                            t.classList.toggle("disabled", e);
                        });
                    }
                    static renderPage(e, t, i = !0) {
                        var s;
                        a.searchParamsPrev = e;
                        const r = a.getSections(),
                            n = document.getElementById("ProductCount"),
                            o = document.getElementById("ProductCountDesktop");
                        document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach((e) => e.classList.remove("hidden")),
                            null === (s = document.getElementById("ProductGrid")) || void 0 === s || s.classList.add("loading"),
                            n && n.classList.add("loading"),
                            o && o.classList.add("loading"),
                            r.forEach((i) => {
                                const s = `${window.location.pathname}?section_id=${i.section}&${e}`,
                                    r = (e) => e.url === s;
                                a.filterData.some(r) ? a.renderSectionFromCache(r, t) : a.renderSectionFromFetch(s, t);
                            }),
                            i && a.updateURLHash(e);
                    }
                    static renderSectionFromFetch(e, t) {
                        fetch(e)
                            .then((e) => e.text())
                            .then((i) => {
                                const s = i;
                                (a.filterData = [...a.filterData, { html: s, url: e }]), a.renderFilters(s, t), a.renderProductGridContainer(s), a.renderProductCount(s);
                            });
                    }
                    static renderSectionFromCache(e, t) {
                        const i = a.filterData.find(e).html;
                        a.renderFilters(i, t), a.renderProductGridContainer(i), a.renderProductCount(i);
                    }
                    static renderProductGridContainer(e) {
                        var t, i;
                        const s = document.getElementById("ProductGrid"),
                            r = document.getElementById("ProductGridContainer"),
                            n = null === (t = new DOMParser().parseFromString(e, "text/html").getElementById("ProductGridContainer")) || void 0 === t ? void 0 : t.innerHTML;
                        r && n && (r.innerHTML = n),
                            null == s || s.classList.remove("loading"),
                            null === (i = document.getElementById("ProductGridContainer")) ||
                                void 0 === i ||
                                i.querySelectorAll(".scroll-trigger").forEach((e) => {
                                    e.classList.add("scroll-trigger--cancel");
                                });
                    }
                    static renderProductCount(e) {
                        var t;
                        const i = null === (t = new DOMParser().parseFromString(e, "text/html").getElementById("ProductCount")) || void 0 === t ? void 0 : t.innerHTML,
                            s = document.getElementById("ProductCount"),
                            r = document.getElementById("ProductCountDesktop");
                        s && i && (s.innerHTML = i),
                            null == s || s.classList.remove("loading"),
                            r && i && ((r.innerHTML = i), r.classList.remove("loading")),
                            document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach((e) => e.classList.add("hidden"));
                    }
                    static renderFilters(e, t) {
                        var i;
                        const s = new DOMParser().parseFromString(e, "text/html"),
                            r = s.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),
                            n = document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
                        Array.from(n).forEach((e) => {
                            Array.from(r).some(({ id: t }) => e.id === t) || e.remove();
                        });
                        const o = (e) => {
                                var i;
                                const s = t ? (null === (i = t.target) || void 0 === i ? void 0 : i.closest(".js-filter")) : void 0;
                                return !!s && e.id === s.id;
                            },
                            l = Array.from(r).filter((e) => !o(e)),
                            d = Array.from(r).find(o);
                        l.forEach((e, t) => {
                            var i, s;
                            const r = document.getElementById(e.id);
                            if (r) r.innerHTML = e.innerHTML;
                            else {
                                if (t > 0) {
                                    const { className: s, id: r } = l[t - 1];
                                    if (e.className === s) return void (null === (i = document.getElementById(r)) || void 0 === i || i.after(e));
                                }
                                e.parentElement && (null === (s = document.querySelector(`#${e.parentElement.id} .js-filter`)) || void 0 === s || s.before(e));
                            }
                        }),
                            a.renderActiveFacets(s),
                            a.renderAdditionalElements(s);
                        const c = null == t ? void 0 : t.target;
                        if (d && c) {
                            const e = null === (i = c.closest(".js-filter")) || void 0 === i ? void 0 : i.id;
                            if (e) {
                                a.renderCounts(d, c.closest(".js-filter")), a.renderMobileCounts(d, document.getElementById(e));
                                const t = document.getElementById(e),
                                    i = (null == t ? void 0 : t.classList.contains("mobile-facets__details")) ? ".mobile-facets__close-button" : ".facets__summary",
                                    s = null == t ? void 0 : t.querySelector(i);
                                null == s || s.focus();
                            }
                        }
                    }
                    static renderActiveFacets(e) {
                        [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
                            const i = e.querySelector(t),
                                s = document.querySelector(t);
                            i && s && (s.innerHTML = i.innerHTML);
                        }),
                            a.toggleActiveFacets(!1);
                    }
                    static renderAdditionalElements(e) {
                        var t, i;
                        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t) => {
                            const i = e.querySelector(t),
                                s = document.querySelector(t);
                            i && s && (s.innerHTML = i.innerHTML);
                        }),
                            null === (i = null === (t = document.getElementById("FacetFiltersFormMobile")) || void 0 === t ? void 0 : t.closest("menu-drawer")) || void 0 === i || i.bindEvents();
                    }
                    static renderCounts(e, t) {
                        if (!t) return;
                        const i = t.querySelector(".facets__summary"),
                            s = e.querySelector(".facets__summary");
                        s && i && (i.outerHTML = s.outerHTML);
                        const r = t.querySelector(".facets__header"),
                            n = e.querySelector(".facets__header");
                        n && r && (r.outerHTML = n.outerHTML);
                        const a = t.querySelector(".facets-wrap"),
                            o = e.querySelector(".facets-wrap");
                        o &&
                            a &&
                            (Boolean(t.querySelector("show-more-button .label-show-more.hidden")) && o.querySelectorAll(".facets__item.hidden").forEach((e) => e.classList.replace("hidden", "show-more-item")), (a.outerHTML = o.outerHTML));
                    }
                    static renderMobileCounts(e, t) {
                        if (!t) return;
                        const i = t.querySelector(".mobile-facets__list"),
                            s = e.querySelector(".mobile-facets__list");
                        s && i && (i.outerHTML = s.outerHTML);
                    }
                    static updateURLHash(e) {
                        history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
                    }
                    static getSections() {
                        var e;
                        return [{ section: null === (e = document.getElementById("product-grid")) || void 0 === e ? void 0 : e.dataset.id }];
                    }
                    createSearchParams(e) {
                        var t;
                        if (!e) return;
                        const i = new FormData(e);
                        return null === (t = new URLSearchParams(i)) || void 0 === t ? void 0 : t.toString();
                    }
                    onSubmitForm(e, t) {
                        a.renderPage(e, t);
                    }
                    onSubmitHandler(e) {
                        var t, i, s;
                        e.preventDefault();
                        const r = e.target,
                            n = document.querySelectorAll("facet-filters-form form");
                        if (null === (i = null === (t = e.srcElement) || void 0 === t ? void 0 : t.className) || void 0 === i ? void 0 : i.includes("mobile-facets__checkbox")) {
                            const t = this.createSearchParams(null == r ? void 0 : r.closest("form"));
                            t && this.onSubmitForm(t, e);
                        } else {
                            const t = [],
                                i = "FacetFiltersFormMobile" === (null === (s = null == r ? void 0 : r.closest("form")) || void 0 === s ? void 0 : s.id);
                            n.forEach((e) => {
                                if (i) {
                                    if ("FacetFiltersFormMobile" === e.id) {
                                        const i = this.createSearchParams(e);
                                        i && t.push(i);
                                    }
                                } else if ("FacetSortForm" === e.id || "FacetsSortFormSticky" == e.id || "FacetFiltersForm" === e.id || "FacetSortDrawerForm" === e.id) {
                                    document.querySelectorAll(".no-js-list").forEach((e) => e.remove());
                                    const i = this.createSearchParams(e);
                                    i && t.push(i);
                                }
                            }),
                                this.onSubmitForm(t.join("&"), e);
                        }
                    }
                    onActiveFilterClick(e) {
                        e.preventDefault();
                        const t = e.currentTarget;
                        a.toggleActiveFacets();
                        const i = -1 == t.href.indexOf("?") ? "" : t.href.slice(t.href.indexOf("?") + 1);
                        a.renderPage(i);
                    }
                }
                (a.filterData = []), (a.searchParamsInitial = window.location.search.slice(1)), (a.searchParamsPrev = window.location.search.slice(1)), customElements.define("facet-filters-form", a), a.setListeners();
                class o extends HTMLElement {
                    constructor() {
                        super();
                        const e = this.querySelector("a");
                        null == e || e.setAttribute("role", "button"),
                            null == e || e.addEventListener("click", this.closeFilter.bind(this)),
                            null == e ||
                                e.addEventListener("keyup", (e) => {
                                    e.preventDefault(), "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
                                });
                    }
                    closeFilter(e) {
                        e.preventDefault();
                        const t = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
                        null == t || t.onActiveFilterClick(e);
                    }
                }
                customElements.define("facet-remove", o);
            },
            8340: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(), (this.input = null), (this.label = null), (this.input = this.querySelector("input")), (this.label = this.querySelector("label")), this.initClassLists(), this.initEventListeners();
                    }
                    initClassLists() {
                        this.input && this.label && (this.input.classList.add("peer"), this.label.classList.add("peer-focus:-top-4", "peer-[.active]:-top-4", "peer-[:-webkit-autofill]:-top-4"));
                    }
                    initEventListeners() {
                        if (!this.input) return this.destroy();
                        this.input.addEventListener("focus", () => this.checkActive()), this.input.addEventListener("change", () => this.checkActive()), setTimeout(() => this.checkActive(), 500);
                    }
                    checkActive() {
                        var e;
                        return this.input ? ((null === (e = this.input) || void 0 === e ? void 0 : e.value) ? this.input.classList.add("active") : this.input.classList.remove("active")) : this.destroy();
                    }
                    destroy() {
                        this.input && (this.input.removeEventListener("focus", this.checkActive), this.input.removeEventListener("change", this.checkActive), (this.input = null), this.label && (this.label = null));
                    }
                }
                customElements.define("form-field", e);
            },
            6040: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(),
                            (this.form = null),
                            (this.submitButton = null),
                            (this.spinner = null),
                            (this.handleFormSubmit = (e) => {
                                this.submitButton &&
                                    this.spinner &&
                                    ((this.style.width = this.offsetWidth + "px"),
                                    (this.style.width = this.offsetWidth + "px"),
                                    (this.submitButton.disabled = !0),
                                    (this.submitButton.value = ""),
                                    (this.submitButton.innerText = ""),
                                    this.submitButton.classList.add("gap-0"),
                                    this.spinner.classList.remove("hidden"));
                            });
                    }
                    connectedCallback() {
                        this.initializeElements(), this.addEventListeners();
                    }
                    disconnectedCallback() {
                        this.removeEventListeners();
                    }
                    initializeElements() {
                        (this.form = this.closest("form")),
                            this.form
                                ? ((this.submitButton = this.querySelector('[type="submit"]')),
                                  (this.spinner = this.querySelector(".loading-spinner")),
                                  (this.submitButton && this.spinner) || console.error("No submit input or spinner element found inside form-submit-button"))
                                : console.error("No form element found near form-submit-button");
                    }
                    addEventListeners() {
                        var e;
                        null === (e = this.form) || void 0 === e || e.addEventListener("submit", this.handleFormSubmit);
                    }
                    removeEventListeners() {
                        var e;
                        null === (e = this.form) || void 0 === e || e.removeEventListener("submit", this.handleFormSubmit);
                    }
                }
                customElements.define("form-submit-button", e);
            },
            2724: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(9012);
                class r extends s.MenuDrawer {
                    constructor() {
                        super(),
                            (this.header = null),
                            (this.borderOffset = 1),
                            (this.onResize = () => {
                                this.header && document.documentElement.style.setProperty("--header-bottom-position", this.header.getBoundingClientRect().bottom - this.borderOffset + "px"),
                                    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
                            });
                    }
                    connectedCallback() {
                        window.addEventListener("resize", this.onResize);
                    }
                    disconnectedCallback() {
                        window.removeEventListener("resize", this.onResize);
                    }
                    openMenuDrawer(e) {
                        var t;
                        this.header = this.header || document.querySelector(".section-header");
                        const i = ((null === (t = this.header) || void 0 === t ? void 0 : t.getBoundingClientRect().bottom) || 0) - this.borderOffset;
                        document.documentElement.style.setProperty("--header-bottom-position", `${i}px`), super.openMenuDrawer(e);
                    }
                    closeMenuDrawer(e, t) {
                        super.closeMenuDrawer(e, t);
                    }
                }
                customElements.define("header-drawer", r);
            },
            3864: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(640);
                class r extends s.DetailsDisclosure {
                    constructor() {
                        super(), (this.header = null), (this.openButton = null), (this.header = document.querySelector(".header")), (this.openButton = this.querySelector("summary")), this.init();
                    }
                    init() {
                        var e, t;
                        const i = document.querySelector("#MainContent"),
                            s = document.querySelector("#footer"),
                            r = null === (e = this.header) || void 0 === e ? void 0 : e.querySelectorAll(".header-item");
                        window.addEventListener("scroll", this.onScrollWindow.bind(this), !0),
                            null == i || i.addEventListener("mouseenter", this.close.bind(this)),
                            null == s || s.addEventListener("mouseenter", this.close.bind(this)),
                            null === (t = this.openButton) || void 0 === t || t.addEventListener("mouseenter", this.onHoverOpenButton.bind(this)),
                            null == r ||
                                r.forEach((e) => {
                                    e.addEventListener("mouseenter", this.onHoverMenuItem.bind(this));
                                });
                    }
                    onHoverOpenButton() {
                        this.mainDetailsToggle && !this.mainDetailsToggle.open && this.openDisclosure();
                    }
                    onHoverMenuItem(e) {
                        var t;
                        if (!this.mainDetailsToggle || !this.mainDetailsToggle.open) return;
                        const i = null === (t = this.openButton) || void 0 === t ? void 0 : t.querySelector(".header-item");
                        e.currentTarget != i && this.close();
                    }
                    onScrollWindow() {
                        this.mainDetailsToggle && this.mainDetailsToggle.open && this.close();
                    }
                    onToggle() {
                        var e;
                        this.header &&
                            ("preventHide" in this.header && (this.header.preventHide = null === (e = this.mainDetailsToggle) || void 0 === e ? void 0 : e.open),
                            "" === document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") &&
                                document.documentElement.style.setProperty("--header-bottom-position-desktop", `${Math.floor(this.header.getBoundingClientRect().bottom)}px`));
                    }
                }
                customElements.define("header-menu", r);
            },
            5272: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(),
                            (this.elements = { input: this.querySelector('[name="locale_code"], [name="country_code"]'), button: this.querySelector("button"), panel: this.querySelector("ul"), form: this.querySelector("form") }),
                            this.elements.button.addEventListener("click", this.openSelector.bind(this)),
                            this.elements.button.addEventListener("focusout", this.closeSelector.bind(this)),
                            this.elements.input.addEventListener("change", this.handleChange.bind(this)),
                            this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
                            this.querySelectorAll("a").forEach((e) => e.addEventListener("click", this.onItemClick.bind(this)));
                    }
                    hidePanel() {
                        this.elements.button.setAttribute("aria-expanded", "false"), this.elements.panel.setAttribute("hidden", "true");
                    }
                    onContainerKeyUp(e) {
                        "ESCAPE" === e.code.toUpperCase() && "false" != this.elements.button.getAttribute("aria-expanded") && (this.hidePanel(), e.stopPropagation(), this.elements.button.focus());
                    }
                    onItemClick(e) {
                        e.preventDefault();
                        const t = e.currentTarget;
                        t.dataset.value && ((this.elements.input.value = t.dataset.value), this.elements.form && this.elements.form.submit());
                    }
                    handleChange() {
                        this.elements.form && this.elements.form.submit();
                    }
                    openSelector() {
                        this.elements.button.focus(), this.elements.panel.toggleAttribute("hidden"), this.elements.button.setAttribute("aria-expanded", ("false" === this.elements.button.getAttribute("aria-expanded")).toString());
                    }
                    closeSelector(e) {
                        const t = e.relatedTarget,
                            i = this.elements.panel.contains(t) || this.elements.button.contains(t);
                        (e.relatedTarget && i) || this.hidePanel();
                    }
                }
                customElements.define("localization-form", e);
            },
            2972: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(), (this.countryLanguageSelects = this.querySelector("[data-country-languages]")), (this.countrySelect = this.querySelector('select[name="country_code"]')), this.bindEvents(), this.updateLanguageOptions();
                    }
                    bindEvents() {
                        var e;
                        null === (e = this.countrySelect) || void 0 === e || e.addEventListener("change", this.onCountryChange.bind(this));
                    }
                    onCountryChange() {
                        this.updateLanguageOptions();
                    }
                    updateLanguageOptions() {
                        var e, t;
                        const i = null === (e = this.countrySelect) || void 0 === e ? void 0 : e.value;
                        if (!i) return;
                        const s = null === (t = this.countryLanguageSelects) || void 0 === t ? void 0 : t.querySelector("[data-all-languages-select]"),
                            r = this.querySelector("[data-current-language-select]");
                        let n = this.getLanguageSelectByCountryCode(i) || s;
                        n && ((n = n.cloneNode(!0)), n.setAttribute("data-current-language-select", ""), null == r || r.insertAdjacentElement("afterend", n), null == r || r.remove());
                    }
                    getLanguageSelectByCountryCode(e) {
                        var t;
                        return null === (t = this.countryLanguageSelects) || void 0 === t ? void 0 : t.querySelector(`[data-country-code="${e}"]`);
                    }
                }
                customElements.define("localization-modal", e);
            },
            9012: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.MenuDrawer = void 0);
                const s = i(852);
                class r extends HTMLElement {
                    constructor() {
                        var e, t, i;
                        super(),
                            (this.isClickingCustomSelect = !1),
                            (this.incompatibleMenuDrawers = []),
                            (this.incompatibleStickyElements = []),
                            (this.hideElementsWhenOpen = []),
                            (this.mainDetailsToggle = this.querySelector("details")),
                            (this.incompatibleMenuDrawers = (null === (e = this.getAttribute("incompatible-menu-drawers")) || void 0 === e ? void 0 : e.split(",")) || []),
                            (this.incompatibleStickyElements = (null === (t = this.getAttribute("incompatible-sticky-elements")) || void 0 === t ? void 0 : t.split(",")) || []),
                            (this.hideElementsWhenOpen = (null === (i = this.getAttribute("hide-elements-when-open")) || void 0 === i ? void 0 : i.split(",")) || []),
                            this.addEventListener("keyup", this.onKeyUp.bind(this)),
                            this.addEventListener("focusout", this.onFocusOut.bind(this)),
                            this.bindEvents();
                    }
                    bindEvents() {
                        this.querySelectorAll("summary").forEach((e) => {
                            "false" !== e.getAttribute("data-menu") && e.addEventListener("click", (e) => this.onSummaryClick(e));
                        }),
                            this.querySelectorAll("[data-close-menu-button]").forEach((e) => {
                                e.addEventListener("click", (e) => this.onCloseMenuButtonClick());
                            }),
                            this.querySelectorAll("[data-close-submenu-button]").forEach((e) => {
                                e.addEventListener("click", (e) => this.onCloseSubMenuButtonClick(e));
                            });
                    }
                    onKeyUp(e) {
                        var t;
                        if ("ESCAPE" !== e.code.toUpperCase() || !e.target) return;
                        const i = e.target.closest("details[open]");
                        i && (i === this.mainDetailsToggle ? this.closeMenuDrawer(e, null === (t = this.mainDetailsToggle) || void 0 === t ? void 0 : t.querySelector("summary")) : this.closeSubmenu(i));
                    }
                    onSummaryClick(e) {
                        var t, i;
                        const r = e.currentTarget,
                            n = r.parentNode,
                            a = n.hasAttribute("open"),
                            o = window.matchMedia("(prefers-reduced-motion: reduce)");
                        function l() {
                            const e = r.nextElementSibling;
                            (0, s.trapFocus)(e, n.querySelector("button")), e.removeEventListener("transitionend", l);
                        }
                        if ((a && e.preventDefault(), n === this.mainDetailsToggle))
                            return a ? this.closeMenuDrawer(e, r) : this.openMenuDrawer(r), void document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
                        if (a) return void this.closeSubmenu(n);
                        const d = null === (i = null === (t = n.parentNode) || void 0 === t ? void 0 : t.closest("details")) || void 0 === i ? void 0 : i.querySelector("[data-menu-drawer-content]");
                        null == d || d.style.setProperty("overflow-y", "hidden"),
                            setTimeout(() => {
                                var e;
                                n.classList.add("menu-opening"), null == r || r.setAttribute("aria-expanded", "true"), !o || o.matches ? l() : null === (e = r.nextElementSibling) || void 0 === e || e.addEventListener("transitionend", l);
                            }),
                            setTimeout(() => {
                                null == n || n.classList.add("menu-opened"),
                                    requestAnimationFrame(() => {
                                        const e = this.querySelector("[data-menu-drawer-autofocus]");
                                        e && e.focus();
                                    });
                            }, 400);
                    }
                    openMenuDrawer(e) {
                        this.mainDetailsToggle &&
                            (this.incompatibleMenuDrawers.length > 0 &&
                                this.incompatibleMenuDrawers.forEach((e) => {
                                    var t;
                                    const i = document.querySelector(e);
                                    null === (t = null == i ? void 0 : i.closeMenuDrawer) || void 0 === t || t.call(i);
                                }),
                            this.incompatibleStickyElements.length > 0 &&
                                this.incompatibleStickyElements.forEach((e) => {
                                    var t;
                                    const i = document.querySelector(e);
                                    null === (t = null == i ? void 0 : i.hide) || void 0 === t || t.call(i);
                                }),
                            this.incompatibleStickyElements.length > 0 &&
                                this.incompatibleStickyElements.forEach((e) => {
                                    var t;
                                    const i = document.querySelector(e);
                                    null === (t = null == i ? void 0 : i.hide) || void 0 === t || t.call(i);
                                }),
                            this.hideElementsWhenOpen.length > 0 &&
                                this.hideElementsWhenOpen.forEach((e) => {
                                    const t = document.querySelector(e);
                                    null == t || t.style.setProperty("opacity", "0"), null == t || t.style.setProperty("visibility", "hidden");
                                }),
                            setTimeout(() => {
                                var t, i;
                                null === (t = this.mainDetailsToggle) || void 0 === t || t.classList.add("menu-opening"),
                                    null === (i = this.mainDetailsToggle) || void 0 === i || i.setAttribute("open", "true"),
                                    e.setAttribute("aria-expanded", "true"),
                                    (0, s.trapFocus)(this.mainDetailsToggle, e);
                                const r = window.innerWidth - document.documentElement.clientWidth;
                                r > 0 && (document.body.style.paddingRight = `${r}px`), document.body.classList.add("overflow-hidden");
                            }),
                            setTimeout(() => {
                                var e;
                                null === (e = this.mainDetailsToggle) || void 0 === e || e.classList.add("menu-opened"),
                                    requestAnimationFrame(() => {
                                        const e = this.querySelector("[data-menu-drawer-autofocus]");
                                        e && e.focus();
                                    });
                            }, 400));
                    }
                    closeMenuDrawer(e, t) {
                        this.mainDetailsToggle &&
                            (this.mainDetailsToggle.classList.remove("menu-opening"),
                            this.mainDetailsToggle.classList.remove("menu-opened"),
                            this.mainDetailsToggle.querySelectorAll('details[data-submenu="true"]').forEach((e) => {
                                setTimeout(() => {
                                    e.removeAttribute("open"), e.classList.remove("menu-opening"), e.classList.remove("menu-opened");
                                });
                            }),
                            this.hideElementsWhenOpen.length > 0 &&
                                this.hideElementsWhenOpen.forEach((e) => {
                                    const t = document.querySelector(e);
                                    null == t || t.style.removeProperty("opacity"), null == t || t.style.removeProperty("visibility");
                                }),
                            document.body.style.removeProperty("padding-right"),
                            document.body.classList.remove("overflow-hidden"),
                            this.closeAnimation(this.mainDetailsToggle),
                            e instanceof KeyboardEvent && (null == t || t.setAttribute("aria-expanded", "false")));
                    }
                    onFocusOut(e) {
                        const t = e.currentTarget,
                            i = e.relatedTarget;
                        i &&
                            (t.contains(i) ||
                                i.closest("custom-select") ||
                                setTimeout(() => {
                                    var e;
                                    (null === (e = this.mainDetailsToggle) || void 0 === e ? void 0 : e.hasAttribute("open")) && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
                                }));
                    }
                    onCloseMenuButtonClick() {
                        this.closeMenuDrawer();
                    }
                    onCloseSubMenuButtonClick(e) {
                        const t = e.currentTarget.closest("details");
                        t && this.closeSubmenu(t);
                    }
                    closeSubmenu(e) {
                        var t, i, r;
                        e.classList.remove("menu-opening"),
                            e.classList.remove("menu-opened"),
                            null === (t = e.querySelector("summary")) || void 0 === t || t.setAttribute("aria-expanded", "false"),
                            (0, s.removeTrapFocus)(e.querySelector("summary")),
                            this.closeAnimation(e);
                        const n = null === (r = null === (i = e.parentNode) || void 0 === i ? void 0 : i.closest("details")) || void 0 === r ? void 0 : r.querySelector("[data-menu-drawer-content]");
                        null == n || n.style.removeProperty("overflow-y");
                    }
                    closeAnimation(e) {
                        let t;
                        e.classList.add("menu-closing");
                        const i = (r) => {
                            if ((void 0 === t && (t = r), r - t < 400)) window.requestAnimationFrame(i);
                            else {
                                e.removeAttribute("open"), e.classList.remove("menu-closing");
                                const t = e.closest("details[open]");
                                t && (0, s.trapFocus)(t, e.querySelector("summary"));
                            }
                        };
                        window.requestAnimationFrame(i);
                    }
                }
                (t.MenuDrawer = r), customElements.define("menu-drawer", r);
                class n extends HTMLElement {
                    constructor() {
                        super(), (this.observer = void 0), (this.sentinel = null);
                    }
                    connectedCallback() {
                        (this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: [1] })),
                            (this.sentinel = document.querySelector("menu-drawer-sticky-bar-sentinel")),
                            this.sentinel ? this.observer.observe(this.sentinel) : this.observer.observe(this);
                    }
                    disconnectedCallback() {
                        var e;
                        null === (e = this.observer) || void 0 === e || e.disconnect();
                    }
                    handleIntersection(e) {
                        const t = e[0].intersectionRatio < 1;
                        this.classList.toggle("is-sticky", t);
                    }
                }
                customElements.define("menu-drawer-sticky-bar", n);
            },
            2504: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super();
                    }
                    connectedCallback() {
                        this.checkForAlreadySubscribed();
                    }
                    checkForAlreadySubscribed() {
                        const e = window.location.href.includes("form_type=customer"),
                            t = this.querySelector('input[type="email"]');
                        e && (null == t ? void 0 : t.value.length) > 0 && this.setError(window.newsletterStrings.alreadySubscribed);
                    }
                    setError(e) {
                        const t = this.querySelector("[data-form-error-message]");
                        t && (t.classList.remove("hidden"), (t.innerText = e));
                    }
                }
                customElements.define("newsletter-form", e);
            },
            6036: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(), (this.toggleQuizButtons = []), (this.quizWrapper = null);
                    }
                    connectedCallback() {
                        var e;
                        (this.toggleQuizButtons = Array.from(this.querySelectorAll("[data-toggle-quiz]"))),
                            (this.quizWrapper = this.querySelector("dialog")),
                            this.toggleQuizButtons.forEach((e) => {
                                e.addEventListener("click", this.onButtonClick.bind(this));
                            }),
                            null === (e = this.quizWrapper) || void 0 === e || e.addEventListener("close", this.handleDialogClose.bind(this));
                    }
                    disconnectedCallback() {
                        this.toggleQuizButtons.forEach((e) => {
                            e.removeEventListener("click", this.onButtonClick.bind(this));
                        });
                    }
                    onButtonClick() {
                        var e, t, i;
                        (null === (e = this.quizWrapper) || void 0 === e ? void 0 : e.open)
                            ? null === (t = this.quizWrapper) || void 0 === t || t.close()
                            : (this.setDialogOverflow(), null === (i = this.quizWrapper) || void 0 === i || i.showModal());
                    }
                    handleDialogClose() {
                        this.removeDialogOverflow();
                    }
                    setDialogOverflow() {
                        const e = window.innerWidth - document.documentElement.clientWidth;
                        (document.body.style.overflowY = "hidden"), (document.body.style.paddingRight = `${e}px`);
                    }
                    removeDialogOverflow() {
                        document.body.style.removeProperty("overflow-y"), document.body.style.removeProperty("padding-right");
                    }
                }
                customElements.define("open-quiz-button", e);
            },
            420: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(7296);
                class r extends s.SearchForm {
                    constructor() {
                        super(),
                            (this.statusElement = null),
                            (this.resultsMaxHeight = !1),
                            (this.loadingText = null),
                            (this.cachedResults = {}),
                            (this.predictiveSearchResults = this.querySelector("[data-predictive-search]")),
                            (this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search")),
                            (this.isOpen = !1),
                            (this.abortController = new AbortController()),
                            (this.searchTerm = ""),
                            this.setupEventListeners();
                    }
                    setupEventListeners() {
                        var e, t, i;
                        null === (t = null === (e = this.input) || void 0 === e ? void 0 : e.form) || void 0 === t || t.addEventListener("submit", this.onFormSubmit.bind(this)),
                            null === (i = this.input) || void 0 === i || i.addEventListener("focus", this.onFocus.bind(this)),
                            this.addEventListener("focusout", this.onFocusOut.bind(this)),
                            this.addEventListener("keyup", this.onKeyup.bind(this)),
                            this.addEventListener("keydown", this.onKeydown.bind(this));
                    }
                    getQuery() {
                        var e;
                        return (null === (e = this.input) || void 0 === e ? void 0 : e.value.trim()) || "";
                    }
                    onChange() {
                        var e;
                        super.onChange();
                        const t = this.getQuery();
                        (this.searchTerm && (null == t ? void 0 : t.startsWith(this.searchTerm))) || null === (e = this.querySelector("#predictive-search-results-groups-wrapper")) || void 0 === e || e.remove(),
                            this.updateSearchForTerm(this.searchTerm, t),
                            (this.searchTerm = t),
                            this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.close(!0);
                    }
                    onFormSubmit(e) {
                        (this.getQuery().length && !this.querySelector('[aria-selected="true"] a')) || e.preventDefault();
                    }
                    onFormReset(e) {
                        super.onFormReset(e), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
                    }
                    onFocus() {
                        const e = this.getQuery();
                        e.length && (this.searchTerm !== e ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
                    }
                    onFocusOut() {
                        setTimeout(() => {
                            this.contains(document.activeElement) || this.close();
                        });
                    }
                    onKeyup(e) {
                        switch ((this.getQuery().length || this.close(!0), e.preventDefault(), e.code)) {
                            case "ArrowUp":
                                this.switchOption("up");
                                break;
                            case "ArrowDown":
                                this.switchOption("down");
                                break;
                            case "Enter":
                                this.selectOption();
                        }
                    }
                    onKeydown(e) {
                        ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
                    }
                    updateSearchForTerm(e, t) {
                        const i = this.querySelector("[data-predictive-search-search-for-text]"),
                            s = null == i ? void 0 : i.innerText;
                        if (s) {
                            const r = s.match(new RegExp(e, "g"));
                            if (r && r.length > 1) return;
                            const n = s.replace(e, t);
                            i.innerText = n;
                        }
                    }
                    switchOption(e) {
                        var t;
                        if (!this.getAttribute("open")) return;
                        const i = "up" === e,
                            s = this.querySelector('[aria-selected="true"]'),
                            r = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter((e) => null !== e.offsetParent);
                        let n = 0;
                        if (i && !s) return;
                        let a = -1,
                            o = 0;
                        for (; -1 === a && o <= r.length; ) r[o] === s && (a = o), o++;
                        if ((this.statusElement && (this.statusElement.textContent = ""), !i && s ? (n = a === r.length - 1 ? 0 : a + 1) : i && (n = 0 === a ? r.length - 1 : a - 1), n === a)) return;
                        const l = r[n];
                        l.setAttribute("aria-selected", "true"), s && s.setAttribute("aria-selected", "false"), null === (t = this.input) || void 0 === t || t.setAttribute("aria-activedescendant", l.id);
                    }
                    selectOption() {
                        const e = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
                        e && e.click();
                    }
                    getSearchResults(e) {
                        const t = e.replace(" ", "-").toLowerCase();
                        this.setLiveRegionLoadingState(),
                            this.cachedResults[t]
                                ? this.renderSearchResults(this.cachedResults[t])
                                : fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`, { signal: this.abortController.signal })
                                      .then((e) => {
                                          var t;
                                          if (!e.ok) {
                                              var i = new Error(null === (t = e.status) || void 0 === t ? void 0 : t.toString());
                                              throw (this.close(), i);
                                          }
                                          return e.text();
                                      })
                                      .then((e) => {
                                          var i;
                                          const s = null === (i = new DOMParser().parseFromString(e, "text/html").querySelector("#shopify-section-predictive-search")) || void 0 === i ? void 0 : i.innerHTML;
                                          this.allPredictiveSearchInstances.forEach((e) => {
                                              e.cachedResults[t] = s;
                                          }),
                                              s && this.renderSearchResults(s);
                                      })
                                      .catch((e) => {
                                          if (20 !== (null == e ? void 0 : e.code)) throw (this.close(), e);
                                      });
                    }
                    setLiveRegionLoadingState() {
                        (this.statusElement = this.statusElement || this.querySelector(".predictive-search-status")),
                            (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
                            this.setLiveRegionText(this.loadingText || ""),
                            this.setAttribute("data-loading", "true");
                    }
                    setLiveRegionText(e) {
                        this.statusElement && (this.statusElement.setAttribute("aria-hidden", "false"), (this.statusElement.textContent = e)),
                            setTimeout(() => {
                                var e;
                                null === (e = this.statusElement) || void 0 === e || e.setAttribute("aria-hidden", "true");
                            }, 1e3);
                    }
                    renderSearchResults(e) {
                        this.predictiveSearchResults && (this.predictiveSearchResults.innerHTML = e), this.setAttribute("results", "true"), this.setLiveRegionResults(), this.open();
                    }
                    setLiveRegionResults() {
                        var e;
                        this.removeAttribute("data-loading");
                        const t = null === (e = this.querySelector(".predictive-search-status")) || void 0 === e ? void 0 : e.textContent;
                        t && this.setLiveRegionText(t);
                    }
                    getResultsMaxHeight() {
                        var e;
                        const t = (null === (e = document.querySelector(".section-header")) || void 0 === e ? void 0 : e.getBoundingClientRect().bottom) || 0;
                        return (this.resultsMaxHeight = window.innerHeight - t), this.resultsMaxHeight;
                    }
                    open() {
                        var e;
                        this.predictiveSearchResults && (this.predictiveSearchResults.style.maxHeight = "number" == typeof this.resultsMaxHeight ? this.resultsMaxHeight.toString() : `${this.getResultsMaxHeight()}px`),
                            this.setAttribute("open", "true"),
                            null === (e = this.input) || void 0 === e || e.setAttribute("aria-expanded", "true"),
                            (this.isOpen = !0);
                    }
                    close(e = !1) {
                        this.closeResults(e), (this.isOpen = !1);
                    }
                    closeResults(e = !1) {
                        var t, i, s;
                        e && this.input && ((this.input.value = ""), this.removeAttribute("results"));
                        const r = this.querySelector('[aria-selected="true"]');
                        r && r.setAttribute("aria-selected", "false"),
                            null === (t = this.input) || void 0 === t || t.setAttribute("aria-activedescendant", ""),
                            this.removeAttribute("data-loading"),
                            this.removeAttribute("open"),
                            null === (i = this.input) || void 0 === i || i.setAttribute("aria-expanded", "false"),
                            (this.resultsMaxHeight = !1),
                            null === (s = this.predictiveSearchResults) || void 0 === s || s.removeAttribute("style");
                    }
                }
                customElements.define("predictive-search", r);
            },
            4576: function (e, t, i) {
                "use strict";
                var s =
                    (this && this.__importDefault) ||
                    function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, "__esModule", { value: !0 });
                const r = s(i(7916)),
                    n = i(4292);
                class a extends HTMLElement {
                    constructor() {
                        super(), (this.form = null), (this.cart = null), (this.cartMenu = null), (this.submitButton = null), (this.hideErrors = !1), (this.error = !1), (this.errorMessageWrapper = null), (this.errorMessage = null);
                    }
                    connectedCallback() {
                        var e;
                        if (((this.form = this.querySelector("form")), !this.form)) return;
                        const t = this.form.querySelector('[name="id"]');
                        t && (t.disabled = !1),
                            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                            (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
                            (this.cartMenu = document.querySelector("menu-drawer.cart-menu-drawer")),
                            (this.submitButton = this.querySelector('[type="submit"]')),
                            document.querySelector("cart-drawer") && (null === (e = this.submitButton) || void 0 === e || e.setAttribute("aria-haspopup", "dialog")),
                            (this.hideErrors = "true" === this.dataset.hideErrors);
                    }
                    onSubmitHandler(e) {
                        var t, i, s, a;
                        if ((e.preventDefault(), !this.form)) return;
                        if ("true" === (null === (t = this.submitButton) || void 0 === t ? void 0 : t.getAttribute("aria-disabled"))) return;
                        this.handleErrorMessage(),
                            null === (i = this.submitButton) || void 0 === i || i.setAttribute("aria-disabled", "true"),
                            null === (s = this.submitButton) || void 0 === s || s.classList.add("loading"),
                            null === (a = this.querySelector(".loading__spinner")) || void 0 === a || a.classList.remove("hidden"),
                            this.submitButton && (this.submitButton.setAttribute("disabled", "disabled"), (this.submitButton.textContent = window.accessibilityStrings.loadingText));
                        const o = (0, r.default)("javascript");
                        (o.headers["X-Requested-With"] = "XMLHttpRequest"), delete o.headers["Content-Type"];
                        const l = new FormData(this.form);
                        if (this.cart) {
                            const e = this.cart.getSectionsToRender().map((e) => e.id);
                            l.append("sections", e.toString()),
                                l.append("sections_url", window.location.pathname),
                                "setActiveElement" in this.cart && "function" == typeof this.cart.setActiveElement && this.cart.setActiveElement(document.activeElement);
                        }
                        (o.body = l),
                            fetch(`${window.routes.cart_add_url}`, o)
                                .then((e) => e.json())
                                .then((e) => {
                                    var t, i, s, r, a;
                                    if (e.status) {
                                        (0, n.publish)(n.PUB_SUB_EVENTS.cartError, { source: "product-form", productVariantId: l.get("id"), errors: e.errors || e.description, message: e.message }), this.handleErrorMessage(e.description);
                                        const a = null === (t = this.submitButton) || void 0 === t ? void 0 : t.querySelector(".sold-out-message");
                                        if (!a) return;
                                        return (
                                            null === (i = this.submitButton) || void 0 === i || i.setAttribute("aria-disabled", "true"),
                                            null === (r = null === (s = this.submitButton) || void 0 === s ? void 0 : s.querySelector("span")) || void 0 === r || r.classList.add("hidden"),
                                            a.classList.remove("hidden"),
                                            void (this.error = !0)
                                        );
                                    }
                                    this.cart
                                        ? (this.error || (0, n.publish)(n.PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: l.get("id"), cartData: e }),
                                          (this.error = !1),
                                          null === (a = this.cartMenu) || void 0 === a || a.openMenuDrawer(this.submitButton),
                                          "renderContents" in this.cart && "function" == typeof this.cart.renderContents && this.cart.renderContents(e))
                                        : (window.location = window.routes.cart_url);
                                })
                                .catch((e) => {
                                    console.error(e);
                                })
                                .finally(() => {
                                    var e, t, i;
                                    null === (e = this.submitButton) || void 0 === e || e.classList.remove("loading"),
                                        this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
                                        this.error || null === (t = this.submitButton) || void 0 === t || t.removeAttribute("aria-disabled"),
                                        null === (i = this.querySelector(".loading__spinner")) || void 0 === i || i.classList.add("hidden"),
                                        this.submitButton && (this.submitButton.removeAttribute("disabled"), (this.submitButton.textContent = window.variantStrings.addToCart));
                                });
                    }
                    handleErrorMessage(e = !1) {
                        this.hideErrors ||
                            ((this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
                            this.errorMessageWrapper &&
                                ((this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
                                this.errorMessageWrapper.toggleAttribute("hidden", !e),
                                e && this.errorMessage && "string" == typeof e && (this.errorMessage.textContent = e)));
                    }
                }
                customElements.get("product-form") || customElements.define("product-form", a);
            },
            6620: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super();
                    }
                    connectedCallback() {
                        new IntersectionObserver(
                            ((e, t) => {
                                if (!e[0].isIntersecting) return;
                                t.unobserve(this);
                                const i = this.dataset.url;
                                fetch(i)
                                    .then((e) => e.text())
                                    .then((e) => {
                                        const t = document.createElement("div");
                                        t.innerHTML = e;
                                        const i = t.querySelector("product-recommendations");
                                        i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), t.querySelector(".card-product") ? this.setAttribute("data-loaded", "true") : this.classList.add("hidden");
                                    })
                                    .catch((e) => {
                                        console.error(e);
                                    });
                            }).bind(this),
                            { rootMargin: "0px 0px 400px 0px" }
                        ).observe(this);
                    }
                }
                customElements.define("product-recommendations", e);
            },
            6188: () => {
                "use strict";
                const e = /[^\d]/,
                    t = ["Backspace", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Tab"];
                class i extends HTMLElement {
                    constructor() {
                        super(), (this.input = null), (this.changeEvent = null), (this.quantityElem = null), (this.changeEvent = new Event("change", { bubbles: !0 })), this.init();
                    }
                    init() {
                        this.input && this.destroy(),
                            (this.input = this.querySelector("input")),
                            this.input &&
                                (this.input.addEventListener("change", this.onInputChange.bind(this)),
                                this.input.addEventListener("keydown", this.onInputKeydown.bind(this)),
                                this.input.addEventListener("blur", this.onInputBlur.bind(this)),
                                this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this))));
                    }
                    destroy() {
                        this.input &&
                            (this.input.removeEventListener("change", this.onInputChange.bind(this)),
                            this.input.removeEventListener("keydown", this.onInputKeydown.bind(this)),
                            this.input.removeEventListener("blur", this.onInputBlur.bind(this)),
                            this.querySelectorAll("button").forEach((e) => e.removeEventListener("click", this.onButtonClick.bind(this))));
                    }
                    onInputChange() {
                        this.validateQtyRules();
                    }
                    onInputKeydown(i) {
                        var s;
                        if (("Enter" === i.key && (null === (s = this.input) || void 0 === s || s.blur()), e.test(i.key) && !t.includes(i.key))) return i.preventDefault(), !1;
                    }
                    onInputBlur() {
                        var e;
                        "" === (null === (e = this.input) || void 0 === e ? void 0 : e.value) && (this.input.value = "1");
                    }
                    onButtonClick(e) {
                        if (!this.input) return;
                        e.preventDefault();
                        const t = this.input.value,
                            i = e.currentTarget;
                        "plus" === (null == i ? void 0 : i.name) ? this.input.stepUp() : this.input.stepDown(), this.changeEvent && t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
                    }
                    validateQtyRules() {
                        if (!this.input) return;
                        const e = parseInt(this.input.value, 10);
                        if (((this.input.style.width = `${Math.max(e.toString().length, 2)}ch`), this.input.min)) {
                            const t = parseInt(this.input.min),
                                i = this.querySelector("button[name='minus']");
                            i && (e <= t ? i.setAttribute("disabled", "") : i.removeAttribute("disabled"));
                        }
                        if (this.input.max) {
                            const t = parseInt(this.input.max),
                                i = this.querySelector("button[name='plus']");
                            i && (e >= t ? i.setAttribute("disabled", "") : i.removeAttribute("disabled"));
                        }
                    }
                }
                customElements.define("quantity-input", i);
            },
            9044: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(9124);
                class r extends HTMLElement {
                    constructor() {
                        super(), (0, s.replaceSuperscript)(this);
                    }
                }
                customElements.define("replace-superscript", r);
            },
            7296: function (e, t, i) {
                "use strict";
                var s =
                    (this && this.__importDefault) ||
                    function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.SearchForm = void 0);
                const r = s(i(8592));
                class n extends HTMLElement {
                    constructor() {
                        var e, t;
                        super(),
                            (this.input = this.querySelector('input[type="search"]')),
                            (this.resetButton = this.querySelector('button[type="reset"]')),
                            this.input &&
                                (null === (t = null === (e = this.input) || void 0 === e ? void 0 : e.form) || void 0 === t || t.addEventListener("reset", this.onFormReset.bind(this)),
                                this.input.addEventListener(
                                    "input",
                                    (0, r.default)(() => {
                                        this.onChange();
                                    }, 300).bind(this)
                                ));
                    }
                    toggleResetButton() {
                        var e, t, i;
                        const s = null === (e = this.resetButton) || void 0 === e ? void 0 : e.classList.contains("hidden");
                        this.input && this.input.value.length > 0 && s
                            ? null === (t = this.resetButton) || void 0 === t || t.classList.remove("hidden")
                            : this.input && 0 === this.input.value.length && !s && (null === (i = this.resetButton) || void 0 === i || i.classList.add("hidden"));
                    }
                    onChange() {
                        if ((this.toggleResetButton(), this.input && 0 == this.input.value.length)) {
                            const e = this.querySelector("[data-empty-text]");
                            null == e || e.remove();
                        }
                    }
                    shouldResetForm() {
                        return !document.querySelector('[aria-selected="true"] a');
                    }
                    onFormReset(e) {
                        e.preventDefault(), this.input && this.shouldResetForm() && ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
                    }
                }
                (t.SearchForm = n), customElements.define("search-form", n);
            },
            7012: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super();
                    }
                    connectedCallback() {
                        var e;
                        null === (e = this.querySelector("button")) || void 0 === e || e.addEventListener("click", this.onButtonClick.bind(this));
                    }
                    disconnectedCallback() {
                        var e;
                        null === (e = this.querySelector("button")) || void 0 === e || e.removeEventListener("click", this.onButtonClick.bind(this));
                    }
                    onButtonClick() {
                        const e = this.getAttribute("target"),
                            t = this.getAttribute("hide-after-show");
                        if (!e) return;
                        const i = document.querySelector(e);
                        null == i || i.classList.toggle("!hidden"), "true" === t && this.remove();
                    }
                }
                customElements.define("show-more-button", e);
            },
            2200: () => {
                "use strict";
                const e = "down";
                class t extends HTMLElement {
                    constructor() {
                        super(),
                            (this.wrapperSelector = null),
                            (this.scrollDirection = e),
                            (this.onlyShowIfScrolledPastSelector = null),
                            (this.scrolledPastBuffer = null),
                            (this.stickyElement = this),
                            (this.onlyShowIfScrolledPastElement = null),
                            (this.hasScrolledPastElement = !1),
                            (this.isSticky = !1),
                            (this.isAlwaysSticky = !1),
                            (this.elementBounds = {}),
                            (this.currentScrollTop = 0),
                            (this.preventReveal = !1),
                            (this.preventHide = !1),
                            (this.onScrollHandler = null);
                    }
                    connectedCallback() {
                        (this.wrapperSelector = this.getAttribute("wrapper-selector")),
                            (this.scrollDirection = this.getAttribute("scroll-direction") || e),
                            (this.onlyShowIfScrolledPastSelector = this.getAttribute("only-show-if-scrolled-past-selector")),
                            (this.scrolledPastBuffer = this.getAttribute("scrolled-past-buffer")),
                            this.wrapperSelector && (this.stickyElement = document.querySelector(this.wrapperSelector) || this),
                            this.onlyShowIfScrolledPastSelector && (this.onlyShowIfScrolledPastElement = document.querySelector(this.onlyShowIfScrolledPastSelector)),
                            this.stickyElement &&
                                ((this.isAlwaysSticky = "always" === this.getAttribute("data-sticky-type") || "reduce-logo-size" === this.getAttribute("data-sticky-type")),
                                (this.elementBounds = {}),
                                this.setElementHeight(),
                                window.matchMedia("(max-width: 990px)").addEventListener("change", this.setElementHeight.bind(this)),
                                this.isAlwaysSticky && this.stickyElement.setAttribute("data-sticky", "true"),
                                (this.currentScrollTop = 0),
                                (this.preventReveal = !1),
                                (this.onScrollHandler = this.onScroll.bind(this)),
                                (this.hideElementOnScrollUp = () => (this.preventReveal = !0)),
                                this.addEventListener("preventHeaderReveal", this.hideElementOnScrollUp),
                                window.addEventListener("scroll", this.onScrollHandler, !1),
                                this.initObservers());
                    }
                    setElementHeight() {
                        var e;
                        this.stickyElement.style.setProperty("--sticky-element-height", `${(null === (e = this.stickyElement) || void 0 === e ? void 0 : e.offsetHeight) || 0}px`);
                    }
                    disconnectedCallback() {
                        this.removeEventListener("preventHeaderReveal", this.hideElementOnScrollUp), this.onScrollHandler && window.removeEventListener("scroll", this.onScrollHandler);
                    }
                    initObservers() {
                        this.createStickyElementObserver(),
                            this.onlyShowIfScrolledPastElement &&
                                new IntersectionObserver((e, t) => {
                                    this.hasScrolledPastElement = e[0].boundingClientRect.bottom < 0;
                                }).observe(this.onlyShowIfScrolledPastElement);
                    }
                    createStickyElementObserver() {
                        this.stickyElement &&
                            new IntersectionObserver((e, t) => {
                                (this.elementBounds = e[0].intersectionRect), t.disconnect();
                            }).observe(this.stickyElement);
                    }
                    onScroll() {
                        if (!this.stickyElement) return;
                        const e = window.pageYOffset || document.documentElement.scrollTop;
                        if (this.onlyShowIfScrolledPastElement && !this.hasScrolledPastElement) requestAnimationFrame(this.hide.bind(this));
                        else if (e > this.currentScrollTop && e > this.elementBounds.bottom) {
                            if (this.preventHide) return;
                            "up" === this.scrollDirection && requestAnimationFrame(this.hide.bind(this)), "down" === this.scrollDirection && this.revealSafe();
                        } else
                            e < this.currentScrollTop && e > this.elementBounds.bottom
                                ? ("up" === this.scrollDirection && this.revealSafe(), "down" === this.scrollDirection && requestAnimationFrame(this.hide.bind(this)))
                                : e <= this.elementBounds.top && requestAnimationFrame(this.reset.bind(this));
                        this.currentScrollTop = e;
                    }
                    revealSafe() {
                        this.preventReveal
                            ? (window.clearTimeout(this.isScrolling),
                              (this.isScrolling = setTimeout(() => {
                                  this.preventReveal = !1;
                              }, 66)),
                              requestAnimationFrame(this.hide.bind(this)))
                            : requestAnimationFrame(this.reveal.bind(this));
                    }
                    hide() {
                        !this.isAlwaysSticky && this.stickyElement && (this.stickyElement.removeAttribute("data-sticky"), this.stickyElement.setAttribute("data-hidden", "true"), (this.isSticky = !1), this.closeMenuDisclosure());
                    }
                    reveal() {
                        !this.isAlwaysSticky && this.stickyElement && (this.stickyElement.setAttribute("data-sticky", "true"), this.stickyElement.removeAttribute("data-hidden"), (this.isSticky = !0));
                    }
                    reset() {
                        !this.isAlwaysSticky && this.stickyElement && (this.stickyElement.removeAttribute("data-sticky"), this.stickyElement.removeAttribute("data-hidden"), (this.isSticky = !1));
                    }
                    closeMenuDisclosure() {}
                }
                customElements.define("sticky-element", t);
            },
            9224: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(9216);
                class r extends s.VariantHandler {
                    constructor() {
                        super(),
                            (this.variantData = []),
                            (this.radioElements = null),
                            (this.sellingPlansDataElement = null),
                            (this.variantSelects = null),
                            (this.variantRadios = null),
                            (this.sellingPlansSelectParent = null),
                            (this.sellingPlansSelectElement = null),
                            (this.discountTagElement = null),
                            (this.subscriptionPriceElement = null),
                            (this.sellingPlanId = ""),
                            (this.sellingPlanSelectWrapperElement = null),
                            this.init();
                    }
                    init() {
                        var e, t;
                        (null === (e = this.radioElements) || void 0 === e ? void 0 : e.length) && this.destroy(),
                            (this.radioElements = Array.from(this.querySelectorAll(".radio-element"))),
                            (this.discountTagElement = this.querySelector(".discount-tag")),
                            (this.subscriptionPriceElement = this.querySelector("[data-subscription-price]")),
                            (this.variantSelects = document.querySelector("variant-selects")),
                            (this.variantRadios = document.querySelector("variant-radios")),
                            (this.sellingPlansDataElement = this.querySelector(".selling-plans")),
                            (this.sellingPlansSelectParent = this.querySelector("#selling_plan_select")),
                            (this.sellingPlansSelectElement = this.querySelector("[name='selling_plan']")),
                            (this.sellingPlanSelectWrapperElement = this.querySelector(".selling-plan-select-wrapper")),
                            (this.sellingPlanId = null === (t = this.sellingPlansSelectElement) || void 0 === t ? void 0 : t.value),
                            // this.updateMasterId(),
                            this.updateDiscount(),
                            this.initEventListeners();
                    }
                    initEventListeners() {
                        var e;
                        return (null === (e = this.radioElements) || void 0 === e ? void 0 : e.length)
                            ? (this.radioElements.forEach((e) => e.addEventListener("change", (e) => this.onRadioUpdate(e))),
                              this.sellingPlansSelectElement ? void this.sellingPlansSelectElement.addEventListener("change", () => this.onSelectUpdate()) : this.destroy())
                            : this.destroy();
                    }
                    getDiscount() {
                        var e, t, i, s, r, n;
                        return {
                            discount:
                                (null ===
                                    (i =
                                        null === (e = this.sellingPlansDataElement) || void 0 === e
                                            ? void 0
                                            : e.querySelector(`[data-selling-plan-id="${null === (t = this.sellingPlansSelectElement) || void 0 === t ? void 0 : t.value}"]`)) || void 0 === i
                                    ? void 0
                                    : i.dataset.discount) || "",
                            discountType:
                                (null ===
                                    (n =
                                        null === (s = this.sellingPlansDataElement) || void 0 === s
                                            ? void 0
                                            : s.querySelector(`[data-selling-plan-id="${null === (r = this.sellingPlansSelectElement) || void 0 === r ? void 0 : r.value}"]`)) || void 0 === n
                                    ? void 0
                                    : n.dataset.discountType) || "",
                        };
                    }
                    addSellingPlan() {
                        var e;
                        this.sellingPlansSelectElement &&
                            this.sellingPlanId &&
                            (null === (e = this.radioElements) || void 0 === e ? void 0 : e.length) &&
                            this.sellingPlanSelectWrapperElement &&
                            (this.radioElements[1].removeAttribute("checked"),
                            this.radioElements[0].setAttribute("checked", ""),
                            (this.sellingPlansSelectElement.disabled = !1),
                            this.sellingPlansSelectElement.removeAttribute("disabled"),
                            (this.sellingPlansSelectElement.value = this.sellingPlanId),
                            this.sellingPlanSelectWrapperElement.classList.remove("hidden"));
                    }
                    removeSellingPlan() {
                        var e;
                        this.sellingPlansSelectElement &&
                            (null === (e = this.radioElements) || void 0 === e ? void 0 : e.length) &&
                            this.sellingPlanSelectWrapperElement &&
                            ((this.sellingPlanId = this.sellingPlansSelectElement.value),
                            this.radioElements[0].removeAttribute("checked"),
                            this.radioElements[1].setAttribute("checked", ""),
                            (this.sellingPlansSelectElement.disabled = !0),
                            this.sellingPlansSelectElement.setAttribute("disabled", ""),
                            (this.sellingPlansSelectElement.value = ""),
                            this.sellingPlanSelectWrapperElement.classList.add("hidden"));
                    }
                    onRadioUpdate(e) {
                        const t = e.target;
                        t.value && ("buy_once" === t.value && this.removeSellingPlan(), "subscription" === t.value && this.addSellingPlan(), this.triggerVariantChange());
                    }
                    onSelectUpdate() {
                        this.updateDiscount(), this.triggerVariantChange();
                    }
                    updateDiscount() {
                        var e, t;
                        const i = this.getDiscount();
                        this.setDiscount(i), null === (e = this.variantRadios) || void 0 === e || e.setDiscount(i), null === (t = this.variantSelects) || void 0 === t || t.setDiscount(i);
                    }
                    triggerVariantChange() {
                        var e, t;
                        // rama comment this line
                        // this.onVariantChange(), null === (e = this.variantRadios) || void 0 === e || e.onVariantChange(), null === (t = this.variantSelects) || void 0 === t || t.onVariantChange();
                    }
                    destroy() {
                        this.radioElements && this.radioElements.forEach((e) => e.removeEventListener("change", this.onRadioUpdate)),
                            this.sellingPlansSelectElement && this.sellingPlansSelectElement.removeEventListener("change", this.onSelectUpdate),
                            (this.radioElements = []),
                            (this.sellingPlansDataElement = null),
                            (this.sellingPlansSelectElement = null),
                            (this.discountTagElement = null),
                            (this.subscriptionPriceElement = null),
                            (this.variantRadios = null),
                            (this.variantSelects = null),
                            (this.sellingPlanId = void 0);
                    }
                }
                customElements.define("subscription-product", r);
            },
            5460: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(6436);
                class r extends HTMLElement {
                    constructor() {
                        super(),
                            (this.swiperContainer = null),
                            (this.breakpointAliases = ["sm", "md", "lg", "xl", "2xl"]),
                            (this.breakpoints = {}),
                            (this.params = {}),
                            (this.paginationElement = null),
                            (this.paginationElementSpan = null),
                            (0, s.register)(),
                            this.init();
                    }
                    init() {
    this.swiperContainer = this.querySelector("swiper-container");

    if (!this.swiperContainer) {
        console.error("Swiper container not found");
        return;
    }

    // Ensure Swiper Web Component is ready
    this.swiperContainer.addEventListener('swiperInitialized', () => {
        console.log("Swiper is ready, attaching event listeners");
        this.handleOnSlideUpdate();
    });

    // Call other initialization functions
    this.initEventListeners();
    this.initBreakpoints();
    this.initPagination();
}

handleOnSlideUpdate() {
    if (!this.swiperContainer) {
        console.error("Swiper container not available");
        return;
    }

    // Listen for slide change events directly if supported
    this.swiperContainer.addEventListener('slideChange', (e) => {
        this.handleSlideChange(e);
    });
}

                    initEventListeners() {
                        if (!this.swiperContainer) return this.destroy();
                        window.addEventListener("resize", () => this.updateParams()), this.swiperContainer.addEventListener("swiperupdate", () => this.onUpdate());
                    }
                    initBreakpoints() {
                        if (!this.swiperContainer) return this.destroy();
                        this.breakpointAliases.forEach((e) => {
                            var t;
                            const i = this.getBreakpointValue(e),
                                s = null === (t = this.swiperContainer) || void 0 === t ? void 0 : t.getAttribute(`:${e}`);
                            i &&
                                s &&
                                s.split(",").forEach((e) => {
                                    const { key: t, value: s } = this.getParamKeyValuePair(e);
                                    t && void 0 !== s && (this.breakpoints[i] = Object.assign(Object.assign({}, this.breakpoints[i]), { [t]: s }));
                                });
                        }),
                            (this.params.breakpoints = this.breakpoints),
                            this.updateParams();
                    }
                    getBreakpointValue(e) {
                        return getComputedStyle(document.documentElement).getPropertyValue(`--screen-${e}`);
                    }
                    getParamKeyValuePair(e) {
                        const [t, i] = e.split(":");
                        if (t.includes("autoplay")) return this.getAutoplayObject(t, i);
                        const s = t.replace(/-([a-z])/g, (e) => e[1].toUpperCase()).trim(),
                            r = i.trim();
                        return "true" === r ? { key: s, value: !0 } : "false" === r ? { key: s, value: !1 } : { key: s, value: r };
                    }
                    getAutoplayObject(e, t) {
                        return { key: "autoplay", value: { [e.replace(/autoplay-/g, "").trim()]: t.trim() } };
                    }
                    updateParams() {
                        this.swiperContainer && Object.assign(this.swiperContainer, this.params);
                    }
                    onUpdate() {
                        this.swiperContainer && this.classList.add("initialized");
                    }
                    destroy() {
                        window.removeEventListener("resize", this.updateParams),
                            (this.breakpoints = {}),
                            (this.params = {}),
                            this.swiperContainer && (this.swiperContainer.removeEventListener("swiperupdate", this.onUpdate), (this.swiperContainer = null));
                    }
                    initPagination() {
                        var e;
                        (this.paginationElement = document.querySelector(`slider-pagination#${this.dataset.paginationId}`) || this.querySelector("slider-pagination")),
                            this.paginationElement && "progressbar" === (null === (e = this.paginationElement.dataset) || void 0 === e ? void 0 : e.paginationType) && this.initProgressBar();
                    }
                    handleSlideChange(e) {
                        this.initPagination();
                    }
                    initProgressBar() {
                        var e, t, i, s, r, n, a, o;
                        if (!this.paginationElement) return;
                        this.paginationElement.setAttribute("data-pagination-type", "progressbar"),
                            (this.paginationElementSpan = this.paginationElement.querySelector("span")),
                            this.paginationElementSpan || ((this.paginationElementSpan = document.createElement("span")), this.paginationElement.appendChild(this.paginationElementSpan));
                        const l = "true" === (null === (t = null === (e = null == this ? void 0 : this.paginationElement) || void 0 === e ? void 0 : e.dataset) || void 0 === t ? void 0 : t.ignoreSlidesPerView),
                            d = (null === (r = null === (s = null === (i = this.swiperContainer) || void 0 === i ? void 0 : i.swiper) || void 0 === s ? void 0 : s.slides) || void 0 === r ? void 0 : r.length) || 0,
                            c = (null === (a = null === (n = this.swiperContainer) || void 0 === n ? void 0 : n.swiper) || void 0 === a ? void 0 : a.activeIndex) || 0;
                        let u = (null === (o = this.params) || void 0 === o ? void 0 : o.slidesPerView) || 1,
                            p = "string" == typeof u && parseFloat(u);
                        (!p || isNaN(p) || l) && (p = 1), (this.paginationElementSpan.style.left = (c / d) * 100 + "%"), (this.paginationElementSpan.style.width = (p / d) * 100 + "%");
                    }
                }
                (t.default = r), customElements.define("swiper-component", r);
            },
            1736: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(), (this.tabButtons = []);
                    }
                    connectedCallback() {
                        (this.tabButtons = Array.from(this.querySelectorAll("[data-tab-button]"))),
                            this.tabButtons.forEach((e) => {
                                e.addEventListener("click", this.onTabButtonClick.bind(this));
                            });
                    }
                    disconnectedCallback() {
                        this.tabButtons.forEach((e) => {
                            e.removeEventListener("click", this.onTabButtonClick.bind(this));
                        });
                    }
                    onTabButtonClick(e) {
                        const t = e.target,
                            i = t.dataset.tabButton;
                        i &&
                            (this.tabButtons.forEach((e) => {
                                e.removeAttribute("data-active"), e.setAttribute("aria-selected", "false");
                            }),
                            t.setAttribute("data-active", ""),
                            t.setAttribute("aria-selected", "true"),
                            this.showTab(i));
                    }
                    showTab(e) {
                        const t = this.querySelector(e);
                        t &&
                            (this.querySelectorAll("[data-tab-content]").forEach((e) => {
                                e.classList.add("!hidden");
                            }),
                            t.classList.remove("!hidden"));
                    }
                }
                customElements.define("tabs-wrapper", e);
            },
            9216: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.VariantHandler = void 0);
                const s = i(3632),
                    r = i(4292);
                class n extends HTMLElement {
                    constructor() {
                        super(),
                            (this.variantData = []),
                            (this.options = []),
                            (this.renderProductInfo = ({ url: e, variant: t, sectionId: i, originalSection: n, section: a, discount: o }) => {
                                fetch(`${e}?variant=${t.id}&section_id=${n || a}`)
                                    .then((e) => e.text())
                                    .then((e) => {
                                        var l;
                                        const d = new DOMParser().parseFromString(e, "text/html"),
                                            c = null === (l = d.querySelector("[data-buy-once-price]")) || void 0 === l ? void 0 : l.querySelector(".price-amount"),
                                            u = null == c ? void 0 : c.getAttribute("data-price"),
                                            p = u && o && (0, s.getDiscount)(u, o),
                                            h = u && o && (0, s.getDiscountTag)(u, o),
                                            m = document.getElementById(`price-${a}`),
                                            v = d.getElementById(`price-${n || a}`),
                                          
                                            g = document.getElementById(`price-${a}-subscription`),
                                            f = d.getElementById(`price-${n || a}-subscription`),
                                            b = document.getElementById(`price-${a}-discount`),
                                            w = d.getElementById(`price-${n || a}-discount`),
                                            y = document.getElementById(`price-${a}-discount-tag`),
                                            E = d.getElementById(`price-${n || a}-discount-tag`),
                                            S = document.getElementById(`price-sticky-${a}`),
                                            x = d.getElementById(`price-sticky-${n || a}`),
                                            C = d.getElementById(`Sku-${n || a}`),
                                            T = document.getElementById(`Sku-${a}`),
                                            M = d.getElementById(`ProductSubmitButton-${i}`);
                                        v && m && (m.innerHTML = v.innerHTML),
                                            f && g && (g.innerHTML = f.innerHTML),
                                            w && b && p && (b.innerHTML = p),
                                            E && y && h && (y.innerHTML = h),
                                            x && S && ((S.innerHTML = x.innerHTML), x.classList.remove("hidden")),
                                            C && T && ((T.innerHTML = C.innerHTML), T.classList.toggle("hidden", C.classList.contains("hidden"))),
                                            M && this.toggleAddButton(!M || M.hasAttribute("disabled"), window.variantStrings.soldOut, i),
                                            (0, r.publish)(r.PUB_SUB_EVENTS.variantChange, { data: { sectionId: i, html: d, variant: t } });

                                      console.log(f);
                                      console.log(p);
                                      console.log(u);
                                      console.log(c);
                                    });
                            }),
                            // this.addEventListener("change", this.onVariantChange);
                           // rama updated this code
                          this.addEventListener("change", function(event) {
                              if (this.tagName !== "SUBSCRIPTION-PRODUCT") {
                                this.onVariantChange();
                              }
                          });
                    }
                    onVariantChange() {
                     
                      console.log(this);
                      
                        this.updateOptions(),
                            this.updateMasterId(),
                            this.toggleAddButton(!0, window.accessibilityStrings.loadingText),
                            this.removeErrorMessage(),
                            this.updateVariantStatuses(),
                            this.currentVariant ? (this.updateProductInfo(), this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.updateShareUrl()) : (this.toggleAddButton(!0, ""), this.setUnavailable());
                          //rama added this code
                          if(!this.currentVariant)
                          {
                            this.toggleAddButton(!0, window.variantStrings.unavailable);
                          }
                    }
                    setDiscount(e) 
                    {
                        this.discount = e;
                    }
                     updateOptions() 
                    {
                      if (this.tagName === "VARIANT-SELECTS") {
                          this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);   
                        }
                    }
                    updateMasterId() 
                    {                      
                        console.log("rama check please updateMasterId");
                        const variantData = this.getVariantData();
                      
                        if (!variantData || variantData.length === 0) {
                          console.warn("No variant data found.");
                          return;
                        }

                        if (variantData.length === 1) 
                        {
                          return this.currentVariant = variantData[0];
                        } 
                        else if(this.options && this.options.length>0)
                        {
                            let currentForm = document.querySelector(`#product-form-${this.dataset.section}`);
                            let getOptionLength = parseInt(currentForm.querySelector(".total-option-size").dataset.optionSize);
  
                            if(getOptionLength>1)
                            {
                              const activeVariant = currentForm.querySelector('variant-selects select');
                              const activeSize = currentForm.querySelector('variant-radios input[type="radio"]:checked');
                            
                              if (activeVariant && activeVariant.value && activeSize && activeSize.value) 
                              {
                                this.currentVariant = variantData.find(variant =>
                                  variant.options.includes(activeVariant.value) && variant.options.includes(activeSize.value)
                                );
                              } 
                            }// if closed
                            else
                            {
                              this.currentVariant = variantData.find(variant =>
                                    variant.options.every((option, index) => this.options[index] === option)
                                ) || null;
                            }//inner else closed
                          
                            console.log("if Selected Variant:", this.currentVariant);
                        }
                        else
                        {
                          let currentForm = document.querySelector(`#product-form-${this.dataset.section}`);
                          let getvariantId = currentForm.querySelector(".product-variant-id").value;
                        
                          this.currentVariant = variantData.find(variant => variant.id == getvariantId) || null;
                          console.log("else me Selected Variant:", this.currentVariant);
                          
                        }//else closed
                      
                        // Get the add-to-cart button
                        const addToCartButton = document.querySelector(`#ProductSubmitButton-${this.dataset.section}`);

                        if (this.currentVariant) 
                        {
                          if (this.currentVariant.available) 
                          {
                            addToCartButton.textContent = "Add to Cart";
                            addToCartButton.removeAttribute("disabled");
                          } 
                          else 
                          {
                            addToCartButton.textContent = "Sold Out";
                            addToCartButton.setAttribute("disabled", "true");
                          }
                        } 
                        else 
                        {
                          addToCartButton.textContent = "Unavailable";
                          addToCartButton.setAttribute("disabled", "true");
                        }
                  }
                  updateMedia() 
                  {
                      const variants = window.productData; // Get the product data from the window object
                      const selectedVariantId = this.currentVariant.id;
                      const selectedVariant = this.currentVariant;

                      // Retrieve the discount value from the hidden input field
                      const onetimediscountElement = document.querySelector(".onetimediscount");
                      const onetimediscount = onetimediscountElement ? parseFloat(onetimediscountElement.value) : 0;
                      
                      // Assuming you have the selectedVariantprice from a variant object or from the page
                      const selectedVariantprice = this.currentVariant ? this.currentVariant.price : 0;
                      
                      // Calculate the discount price (assuming the discount is a percentage)
                      const discountPercentage = onetimediscount / 100;
                      const discountPrice = selectedVariantprice * (1 - discountPercentage);
                      
                      // Format prices as currency, ensuring 2 decimal places, like $44.50
                      const formattedOriginalPrice = `$${(selectedVariantprice / 100).toFixed(2)}`;
                      const formattedDiscountPrice = `$${(discountPrice / 100).toFixed(2)}`;
                      
                      // Update the original price in the <del> element
                      const originalPriceElement = document.querySelector(".price.original-price-strikethrough");
                      if (originalPriceElement) {
                        originalPriceElement.textContent = formattedOriginalPrice;
                      }
                      
                      // Update the content of the <span> with the discounted price
                      const discountedPriceElement = document.querySelector(".discounted-price.discounted-price6991785525430");
                      if (discountedPriceElement) {
                        discountedPriceElement.textContent = formattedDiscountPrice;
                      }
                      

                   
                        if (selectedVariant && selectedVariant.featured_media) 
                        {
                          const mediaId = parseInt(selectedVariant.featured_media.id);
                          // console.log(mediaId);
                          
                          const swiperInstance = document.querySelector('.mySwiper').swiper;
                          if (swiperInstance) {
                            // Access the slides directly from the Swiper instance
                            const swiperSlides = swiperInstance.slides;
                            // console.log(swiperSlides); // Logs the list of Swiper slides
                            // Find the corresponding slide in Swiper by data attribute
                            const targetSlideIndex = Array.from(swiperSlides).findIndex(slide => 
                              slide.getAttribute('data-media-id') == String(mediaId)
                            );
                            if (targetSlideIndex !== -1) {
                              swiperInstance.slideTo(targetSlideIndex);
                            }

                          }
                        }
                      console.log("updatingmedia...at line 3254 in theme.js");
                        this.currentVariant && this.currentVariant.featured_media && document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
                    }
                    updateURL() {
                        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
                    }
                    updateShareUrl() {}
                    updateVariantInput() {
                        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((e) => {
                            var t, i;
                            const s = e.querySelector('input[name="id"]');
                            s && ((s.value = (null === (i = null === (t = this.currentVariant) || void 0 === t ? void 0 : t.id) || void 0 === i ? void 0 : i.toString()) || ""), s.dispatchEvent(new Event("change", { bubbles: !0 })));
                        });
                    }
                    updateVariantStatuses() {
                        const e = this.variantData.filter((e) => {
                                var t;
                                return (null === (t = this.querySelector(":checked")) || void 0 === t ? void 0 : t.value) === e.option1;
                            }),
                            t = [...this.querySelectorAll(".product-form__input")];
                        t.forEach((i, s) => {
                            var r;
                            if (0 === s) return;
                            const n = [...i.querySelectorAll('input[type="radio"], option')],
                                a = null === (r = t[s - 1].querySelector(":checked")) || void 0 === r ? void 0 : r.value,
                                o = e.filter((e) => e.available && e[`option${s}`] === a).map((e) => e[`option${s + 1}`]);
                            this.setInputAvailability(n, o);
                        });
                    }
                    setInputAvailability(e, t) {
                        e.forEach((e) => {
                            if (!e) return;
                            const i = e.getAttribute("value") || "";
                            t.includes(i) ? (e.innerText = i) : (e.innerText = window.variantStrings.unavailable_with_option.replace("[value]", i));
                        });
                    }
                    removeErrorMessage() {
                        const e = this.closest("section");
                        if (!e) return;
                        const t = e.querySelector("product-form");
                        t && t.handleErrorMessage();
                    }
                    updateProductInfo() {
                        const e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
                        this.dataset.url &&
                            this.currentVariant &&
                            e &&
                            this.renderProductInfo({ url: this.dataset.url, variant: this.currentVariant, sectionId: e, originalSection: this.dataset.originalSection, section: this.dataset.section, discount: this.discount });
                    }
                   toggleAddButton(e = !0, t, i) {
    // console.log("Disable true:", e);
    // console.log("Disable text:", t);
    // console.log("Disable :", i);

    // const sectionId = i || this.dataset.section;
    // const s = document.getElementById(`product-form-${sectionId}`);
    // const pdpform = document.getElementById(`ProductSubmitButton-${sectionId}`);
    // console.log("pdpform Button:", pdpform);

    // const r = s?.querySelector('[name="add"]');
    // const n = document.querySelector(`#ProductFormStickyBar-${sectionId} [name="add"]`);
    // const d = window.variantStrings?.addToCart || "Add to Cart";

    //  [r, n].forEach(b => {
    //     if (b) {
    //         if (e) {
    //             b.setAttribute("disabled", "disabled");
    //             b.textContent = t !== undefined ? t : "Unavailable"; // Use "Unavailable" if `t` is undefined
    //         } else {
    //             b.removeAttribute("disabled");
    //             b.textContent = d; // Reset text to default
    //         }
    //     }
    // });
}

                    setUnavailable() {
                        const e = document.getElementById(`product-form-${this.dataset.section}`),
                            t = null == e ? void 0 : e.querySelector('[name="add"]'),
                            i = null == e ? void 0 : e.querySelector('[name="add"] > span'),
                            s = document.getElementById(`Inventory-${this.dataset.section}`),
                            r = document.getElementById(`Sku-${this.dataset.section}`),
                            n = document.getElementById(`Price-Per-Item-${this.dataset.section}`),
                            a = document.getElementById(`Volume-Note-${this.dataset.section}`),
                            o = document.getElementById(`Volume-${this.dataset.section}`),
                            l = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
                        t &&
                            (i && (i.textContent = window.variantStrings.unavailable),
                            s && s.classList.add("hidden"),
                            r && r.classList.add("hidden"),
                            n && n.classList.add("hidden"),
                            a && a.classList.add("hidden"),
                            o && o.classList.add("hidden"),
                            l && l.classList.add("hidden"));
                    }
                    getVariantData() {
                        var e;
                        const t = null === (e = this.querySelector('[type="application/json"]')) || void 0 === e ? void 0 : e.textContent;
                        return t ? ((this.variantData = JSON.parse(t)), this.variantData) : this.variantData;
                    }
                }
                t.VariantHandler = n;
            },
            3384: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(9216);
                class r extends s.VariantHandler {
                    constructor() {
                        super();
                    }
                    setInputAvailability(e, t) {
                        e.forEach((e) => {
                            t.includes(e.getAttribute("value") || "") ? e.classList.remove("disabled") : e.classList.add("disabled");
                        });
                    }
                    updateOptions() {
                        const e = Array.from(this.querySelectorAll("fieldset"))
                            .map((e) => {
                                var t;
                                return null === (t = Array.from(e.querySelectorAll("input")).find((e) => e.checked)) || void 0 === t ? void 0 : t.value;
                            })
                            .filter((e) => null != e && "string" == typeof e);
                        this.options = e;
                    }
                }
                customElements.define("variant-radios", r);
            },
            5563: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                const s = i(9216);
                class r extends s.VariantHandler {
                    constructor() {
                        super();
                    }
                }
               customElements.define("variant-selects", r);
            },
            3288: () => {
                "use strict";
                class e extends HTMLElement {
                    constructor() {
                        super(), (this.video = null), (this.playPauseButton = null), (this.playIcon = null), (this.pauseIcon = null);
                    }
                    connectedCallback() {
                        this.initializeElements(), this.addEventListeners(), this.updatePlayPauseButtonState();
                    }
                    disconnectedCallback() {
                        this.removeEventListeners();
                    }
                    initializeElements() {
                        (this.video = this.querySelector("video")),
                            this.video
                                ? ((this.playPauseButton = this.querySelector("video-controls-play-pause")),
                                  this.playPauseButton && ((this.playPauseButton.tabIndex = 0), (this.playIcon = this.playPauseButton.querySelector(".icon-play")), (this.pauseIcon = this.playPauseButton.querySelector(".icon-pause"))),
                                  matchMedia("(prefers-reduced-motion: reduce)").matches && (this.video.removeAttribute("autoplay"), this.video.removeAttribute("loop")))
                                : console.error("No video element found inside video-controls");
                    }
                    addEventListeners() {
                        this.video &&
                            (this.playPauseButton && (this.playPauseButton.addEventListener("click", () => this.togglePlayPause()), this.playPauseButton.addEventListener("keydown", (e) => this.handlePlayPauseKeydown(e))),
                            this.video.addEventListener("click", () => this.handleVideoClick()),
                            this.video.addEventListener("play", () => this.updatePlayPauseButtonState()),
                            this.video.addEventListener("pause", () => this.updatePlayPauseButtonState()));
                    }
                    removeEventListeners() {
                        this.video &&
                            (this.playPauseButton && (this.playPauseButton.removeEventListener("click", this.togglePlayPause), this.playPauseButton.removeEventListener("keydown", this.handlePlayPauseKeydown)),
                            this.video.removeEventListener("click", this.handleVideoClick),
                            this.video.removeEventListener("play", this.updatePlayPauseButtonState),
                            this.video.removeEventListener("pause", this.updatePlayPauseButtonState));
                    }
                    togglePlayPause() {
                        this.video && (this.video.paused ? this.video.play() : this.video.pause());
                    }
                    handleVideoClick() {
                        var e;
                        this.togglePlayPause(), null === (e = this.playPauseButton) || void 0 === e || e.focus();
                    }
                    handlePlayPauseKeydown(e) {
                        "Space" === e.code && (e.preventDefault(), this.togglePlayPause());
                    }
                    updatePlayPauseButtonState() {
                        this.video &&
                            this.playIcon &&
                            this.pauseIcon &&
                            (this.video.paused ? (this.playIcon.classList.remove("hidden"), this.pauseIcon.classList.add("hidden")) : (this.playIcon.classList.add("hidden"), this.pauseIcon.classList.remove("hidden")));
                    }
                }
                customElements.define("video-controls", e);
            },
            6516: function (e, t, i) {
                "use strict";
                var s =
                    (this && this.__importDefault) ||
                    function (e) {
                        return e && e.__esModule ? e : { default: e };
                    };
                Object.defineProperty(t, "__esModule", { value: !0 });
                const r = s(i(2464));
                class n extends HTMLElement {
                    constructor() {
                        super(), (this.videoElement = null), (this.videoPlayButton = null), (this.videoThumbnail = null), this.init();
                    }
                    init() {
                        (this.videoId = this.dataset.videoId),
                            (this.videoElement = this.querySelector("[data-video-element]")),
                            (this.videoPlayButton = this.querySelector("[data-video-play-button]")),
                            (this.videoThumbnail = this.querySelector("[data-video-thumbnail]")),
                            this.initYouTubePlayer(),
                            this.initEventListeners();
                    }
                    initYouTubePlayer() {
                        if (this.player) return this.destroy();
                        this.videoId &&
                            this.videoElement &&
                            ((this.player = (0, r.default)(this.videoElement, {
                                videoId: this.videoId,
                                playerVars: { playsinline: 1, controls: "true" === this.dataset.controls ? 1 : 0, autoplay: "true" === this.dataset.autoplay ? 1 : 0 },
                            })),
                            this.player.on("stateChange", ({ data: e }) => {
                                2 === e && this.pauseVideo();
                            }));
                    }
                    initEventListeners() {
                        this.videoPlayButton && this.videoPlayButton.addEventListener("click", () => this.playVideo());
                    }
                    onPlayerStateChange({ data: e }) {
                        2 === e && this.pauseVideo();
                    }
                    playVideo() {
                        var e, t, i, s, r, n, a, o;
                        null === (t = null === (e = this.videoThumbnail) || void 0 === e ? void 0 : e.classList) || void 0 === t || t.toggle("animation-fade-out"),
                            null === (s = null === (i = this.videoThumbnail) || void 0 === i ? void 0 : i.classList) || void 0 === s || s.remove("animation-fade-in"),
                            null === (n = null === (r = this.videoPlayButton) || void 0 === r ? void 0 : r.classList) || void 0 === n || n.add("animation-fade-out"),
                            null === (o = null === (a = this.videoPlayButton) || void 0 === a ? void 0 : a.classList) || void 0 === o || o.remove("animation-fade-in"),
                            this.player && this.player.playVideo();
                    }
                    pauseVideo() {
                        var e, t, i, s, r, n, a, o;
                        null === (t = null === (e = this.videoThumbnail) || void 0 === e ? void 0 : e.classList) || void 0 === t || t.add("animation-fade-in"),
                            null === (s = null === (i = this.videoThumbnail) || void 0 === i ? void 0 : i.classList) || void 0 === s || s.remove("animation-fade-out"),
                            null === (n = null === (r = this.videoPlayButton) || void 0 === r ? void 0 : r.classList) || void 0 === n || n.add("animation-fade-in"),
                            null === (o = null === (a = this.videoPlayButton) || void 0 === a ? void 0 : a.classList) || void 0 === o || o.remove("animation-fade-out"),
                            setTimeout(() => {
                                this.player && this.player.stopVideo();
                            }, 300);
                    }
                    destroy() {
                        this.player && this.player.destroy(),
                            this.videoPlayButton && this.videoPlayButton.removeEventListener("click", this.playVideo),
                            (this.videoId = void 0),
                            (this.videoElement = null),
                            (this.videoPlayButton = null),
                            (this.videoThumbnail = null);
                    }
                }
                customElements.define("youtube-player", n);
            },
            3948: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.cn = void 0);
                const s = i(6864),
                    r = i(2312);
                t.cn = function (...e) {
                    return (0, s.twMerge)((0, r.clsx)(e));
                };
            },
            8592: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.ON_CHANGE_DEBOUNCE_TIMER = void 0),
                    (t.ON_CHANGE_DEBOUNCE_TIMER = 300),
                    (t.default = function (e, t) {
                        let i;
                        return (...s) => {
                            clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
                        };
                    });
            },
            3632: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.getDiscount = t.getDiscountTag = t.moneyWithoutTrailingZeros = t.money = void 0),
                    (t.money = (e) => new Intl.NumberFormat(window.Shopify.locale || "en-US", { style: "currency", currency: window.Shopify.currency.active || "USD" }).format(e)),
                    (t.moneyWithoutTrailingZeros = (e) => (0, t.money)(e).replace(/\.00/g, "")),
                    (t.getDiscountTag = (e, { discount: i, discountType: s }) => {
                        const r = parseInt(e) / 100,
                            n = parseInt(i) / 100;
                        if ("percentage" === s) return `${i}%`;
                        if ("price" === s) {
                            const e = r - n;
                            return (0, t.moneyWithoutTrailingZeros)(e);
                        }
                        return (0, t.moneyWithoutTrailingZeros)(n);
                    }),
                    (t.getDiscount = (e, { discount: i, discountType: s }) => {
                        const r = parseInt(e) / 100,
                            n = parseInt(i) / 100;
                        if ("price" === s) return (0, t.money)(n);
                        if ("fixed_amount" === s) {
                            const e = r - n;
                            return (0, t.money)(e);
                        }
                        const a = parseInt(e) - parseInt(e) * n;
                        return !a || isNaN(a) ? "" : (0, t.money)(a / 100);
                    });
            },
            7916: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.default = function (e = "json") {
                        return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
                    });
            },
            852: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.removeTrapFocus = t.trapFocus = void 0);
                const i = {};
                function s(e) {
                    document.removeEventListener("focusin", i.focusin), document.removeEventListener("focusout", i.focusout), document.removeEventListener("keydown", i.keydown), e && e.focus();
                }
                (t.trapFocus = function (e, t = e) {
                    if (e) {
                        var r = (function (e) {
                                return Array.from(
                                    e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe")
                                );
                            })(e),
                            n = r[0],
                            a = r[r.length - 1];
                        s(),
                            (i.focusin = (t) => {
                                (t.target !== e && t.target !== a && t.target !== n) || document.addEventListener("keydown", i.keydown);
                            }),
                            (i.focusout = function () {
                                document.removeEventListener("keydown", i.keydown);
                            }),
                            (i.keydown = function (t) {
                                "TAB" === t.code.toUpperCase() && (t.target !== a || t.shiftKey || (t.preventDefault(), null == n || n.focus()), (t.target !== e && t.target !== n) || !t.shiftKey || (t.preventDefault(), a.focus()));
                            }),
                            document.addEventListener("focusout", i.focusout),
                            document.addEventListener("focusin", i.focusin),
                            null == t || t.focus(),
                            "INPUT" === (null == t ? void 0 : t.tagName) && t instanceof HTMLInputElement && ["search", "text", "email", "url"].includes(t.type) && "value" in t && t.setSelectionRange(0, t.value.length);
                    }
                }),
                    (t.removeTrapFocus = s);
            },
            932: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.onKeyUpEscape = void 0),
                    (t.onKeyUpEscape = function (e) {
                        var t, i;
                        if ("ESCAPE" !== (null === (t = e.code) || void 0 === t ? void 0 : t.toUpperCase())) return;
                        const s = null === (i = e.target) || void 0 === i ? void 0 : i.closest("details[open]");
                        if (!s) return;
                        const r = s.querySelector("summary");
                        s.removeAttribute("open"), null == r || r.setAttribute("aria-expanded", "false"), null == r || r.focus();
                    });
            },
            4292: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.publish = t.subscribe = t.PUB_SUB_EVENTS = void 0),
                    (t.PUB_SUB_EVENTS = { cartUpdate: "cart-update", quantityUpdate: "quantity-update", variantChange: "variant-change", cartError: "cart-error" });
                let i = { [t.PUB_SUB_EVENTS.cartUpdate]: [], [t.PUB_SUB_EVENTS.quantityUpdate]: [], [t.PUB_SUB_EVENTS.variantChange]: [], [t.PUB_SUB_EVENTS.cartError]: [] };
                (t.subscribe = function (e, t) {
                    return (
                        void 0 === i[e] && (i[e] = []),
                        (i[e] = [...i[e], t]),
                        function () {
                            i[e] = i[e].filter((e) => e !== t);
                        }
                    );
                }),
                    (t.publish = function (e, t) {
                        i[e] &&
                            i[e].forEach((e) => {
                                e(t);
                            });
                    });
            },
            9124: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.replaceSuperscript = void 0),
                    (t.replaceSuperscript = (e) => {
                        const t = e.querySelectorAll("*");
                        if (!(null == t ? void 0 : t.length) && 1 === e.nodeType) return i(e);
                        for (const e of t) for (const t of e.childNodes) t.nodeType === Node.TEXT_NODE && i(t, e);
                    });
                const i = (e, t) => {
                        var i;
                        if (!(null === (i = e.textContent) || void 0 === i ? void 0 : i.includes("®"))) return;
                        const r = document.createElement("span");
                        (r.innerHTML = e.textContent.replace(/®/g, '<sup class="-top-[5%] align-super text-1/2">®</sup>')), s(e, r, t);
                    },
                    s = (e, t, i) => {
                        if (!i) return (e.textContent = ""), e.appendChild(t);
                        i.insertBefore(t, e), i.removeChild(e);
                    };
                (0, t.replaceSuperscript)(document.body);
            },
            6108: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.CountryProvinceSelector = t.postLink = void 0),
                    (t.postLink = (e, t) => {
                        const i = (t = t || {}).method || "post",
                            s = t.parameters || {},
                            r = document.createElement("form");
                        r.setAttribute("method", i), r.setAttribute("action", e);
                        for (const e in s) {
                            const t = document.createElement("input");
                            t.setAttribute("type", "hidden"), t.setAttribute("name", e), t.setAttribute("value", s[e]), r.appendChild(t);
                        }
                        document.body.appendChild(r), r.submit(), document.body.removeChild(r);
                    }),
                    (t.CountryProvinceSelector = class {
                        constructor(e, t, i) {
                            (this.countryEl = document.getElementById(e)),
                                (this.provinceEl = document.getElementById(t)),
                                (this.provinceContainer = document.getElementById(i.hideElement || t)),
                                this.countryEl && (this.countryEl.addEventListener("change", this.countryHandler.bind(this)), this.initCountry(), this.initProvince());
                        }
                        initCountry() {
                            if (!this.countryEl) return;
                            const e = this.countryEl.getAttribute("data-default");
                            this.setSelectorByValue(this.countryEl, e), this.countryHandler();
                        }
                        initProvince() {
                            var e;
                            if (!this.provinceEl) return;
                            const t = this.provinceEl.getAttribute("data-default");
                            t && (null === (e = this.provinceEl) || void 0 === e ? void 0 : e.options.length) > 0 && this.setSelectorByValue(this.provinceEl, t);
                        }
                        countryHandler() {
                            if (!this.countryEl || !this.provinceEl || !this.provinceContainer) return;
                            const e = this.countryEl.options[this.countryEl.selectedIndex].getAttribute("data-provinces") || "",
                                t = JSON.parse(e);
                            this.clearOptions(this.provinceEl), t && 0 == t.length ? (this.provinceContainer.style.display = "none") : (this.setOptions(this.provinceEl, t), (this.provinceContainer.style.display = ""));
                        }
                        clearOptions(e) {
                            for (; e.firstChild; ) e.removeChild(e.firstChild);
                        }
                        setSelectorByValue(e, t) {
                            for (let i = 0, s = e.options.length; i < s; i++) {
                                const s = e.options[i];
                                if (t == s.value || t == s.innerHTML) return (e.selectedIndex = i), i;
                            }
                        }
                        setOptions(e, t) {
                            let i = 0;
                            for (t.length; i < t.length; i++) {
                                const s = document.createElement("option");
                                (s.value = t[i][0]), (s.innerHTML = t[i][1]), e.appendChild(s);
                            }
                        }
                    });
            },
            8308: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var s,
                    r = (s = i(2880)) && s.__esModule ? s : { default: s };
                (t.default = {
                    pauseVideo: { acceptableStates: [r.default.ENDED, r.default.PAUSED], stateChangeRequired: !1 },
                    playVideo: { acceptableStates: [r.default.ENDED, r.default.PLAYING], stateChangeRequired: !1 },
                    seekTo: { acceptableStates: [r.default.ENDED, r.default.PLAYING, r.default.PAUSED], stateChangeRequired: !0, timeout: 3e3 },
                }),
                    (e.exports = t.default);
            },
            3240: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var s = o(i(6580)),
                    r = o(i(8308)),
                    n = o(i(1960)),
                    a = o(i(2308));
                function o(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                const l = (0, s.default)("youtube-player"),
                    d = {
                        proxyEvents: (e) => {
                            const t = {};
                            for (const i of n.default) {
                                const s = "on" + i.slice(0, 1).toUpperCase() + i.slice(1);
                                t[s] = (t) => {
                                    l('event "%s"', s, t), e.trigger(i, t);
                                };
                            }
                            return t;
                        },
                        promisifyPlayer: (e, t = !1) => {
                            const i = {};
                            for (const s of a.default)
                                t && r.default[s]
                                    ? (i[s] = (...t) =>
                                          e.then((e) => {
                                              const i = r.default[s],
                                                  n = e.getPlayerState(),
                                                  a = e[s].apply(e, t);
                                              return i.stateChangeRequired || (Array.isArray(i.acceptableStates) && !i.acceptableStates.includes(n))
                                                  ? new Promise((t) => {
                                                        const s = () => {
                                                            const r = e.getPlayerState();
                                                            let n;
                                                            "number" == typeof i.timeout &&
                                                                (n = setTimeout(() => {
                                                                    e.removeEventListener("onStateChange", s), t();
                                                                }, i.timeout)),
                                                                Array.isArray(i.acceptableStates) && i.acceptableStates.includes(r) && (e.removeEventListener("onStateChange", s), clearTimeout(n), t());
                                                        };
                                                        e.addEventListener("onStateChange", s);
                                                    }).then(() => a)
                                                  : a;
                                          }))
                                    : (i[s] = (...t) => e.then((e) => e[s].apply(e, t)));
                            return i;
                        },
                    };
                (t.default = d), (e.exports = t.default);
            },
            2880: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = { BUFFERING: 3, ENDED: 0, PAUSED: 2, PLAYING: 1, UNSTARTED: -1, VIDEO_CUED: 5 }), (e.exports = t.default);
            },
            1960: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }), (t.default = ["ready", "stateChange", "playbackQualityChange", "playbackRateChange", "error", "apiChange", "volumeChange"]), (e.exports = t.default);
            },
            2308: (e, t) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.default = [
                        "cueVideoById",
                        "loadVideoById",
                        "cueVideoByUrl",
                        "loadVideoByUrl",
                        "playVideo",
                        "pauseVideo",
                        "stopVideo",
                        "getVideoLoadedFraction",
                        "cuePlaylist",
                        "loadPlaylist",
                        "nextVideo",
                        "previousVideo",
                        "playVideoAt",
                        "setShuffle",
                        "setLoop",
                        "getPlaylist",
                        "getPlaylistIndex",
                        "setOption",
                        "mute",
                        "unMute",
                        "isMuted",
                        "setVolume",
                        "getVolume",
                        "seekTo",
                        "getPlayerState",
                        "getPlaybackRate",
                        "setPlaybackRate",
                        "getAvailablePlaybackRates",
                        "getPlaybackQuality",
                        "setPlaybackQuality",
                        "getAvailableQualityLevels",
                        "getCurrentTime",
                        "getDuration",
                        "removeEventListener",
                        "getVideoUrl",
                        "getVideoEmbedCode",
                        "getOptions",
                        "getOption",
                        "addEventListener",
                        "destroy",
                        "setSize",
                        "getIframe",
                        "getSphericalProperties",
                        "setSphericalProperties",
                    ]),
                    (e.exports = t.default);
            },
            2464: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var s = a(i(320)),
                    r = a(i(3240)),
                    n = a(i(7656));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                let o;
                (t.default = (e, t = {}, i = !1) => {
                    const a = (0, s.default)();
                    if ((o || (o = (0, n.default)(a)), t.events)) throw new Error("Event handlers cannot be overwritten.");
                    if ("string" == typeof e && !document.getElementById(e)) throw new Error('Element "' + e + '" does not exist.');
                    t.events = r.default.proxyEvents(a);
                    const l = new Promise((i) => {
                            "object" == typeof e && e.playVideo instanceof Function
                                ? i(e)
                                : o.then((s) => {
                                      const r = new s.Player(e, t);
                                      return (
                                          a.on("ready", () => {
                                              i(r);
                                          }),
                                          null
                                      );
                                  });
                        }),
                        d = r.default.promisifyPlayer(l, i);
                    return (d.on = a.on), (d.off = a.off), d;
                }),
                    (e.exports = t.default);
            },
            7656: (e, t, i) => {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var s,
                    r = (s = i(3008)) && s.__esModule ? s : { default: s };
                (t.default = (e) =>
                    new Promise((t) => {
                        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) return void t(window.YT);
                        {
                            const t = "http:" === window.location.protocol ? "http:" : "https:";
                            (0, r.default)(t + "//www.youtube.com/iframe_api", (t) => {
                                t && e.trigger("error", t);
                            });
                        }
                        const i = window.onYouTubeIframeAPIReady;
                        window.onYouTubeIframeAPIReady = () => {
                            i && i(), t(window.YT);
                        };
                    })),
                    (e.exports = t.default);
            },
            6580: (e, t, i) => {
                (t.formatArgs = function (t) {
                    if (((t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff)), !this.useColors)) return;
                    const i = "color: " + this.color;
                    t.splice(1, 0, i, "color: inherit");
                    let s = 0,
                        r = 0;
                    t[0].replace(/%[a-zA-Z%]/g, (e) => {
                        "%%" !== e && (s++, "%c" === e && (r = s));
                    }),
                        t.splice(r, 0, i);
                }),
                    (t.save = function (e) {
                        try {
                            e ? t.storage.setItem("debug", e) : t.storage.removeItem("debug");
                        } catch (e) {}
                    }),
                    (t.load = function () {
                        let e;
                        try {
                            e = t.storage.getItem("debug");
                        } catch (e) {}
                        return !e && "undefined" != typeof process && "env" in process && (e = process.env.DEBUG), e;
                    }),
                    (t.useColors = function () {
                        return (
                            !("undefined" == typeof window || !window.process || ("renderer" !== window.process.type && !window.process.__nwjs)) ||
                            (("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) &&
                                (("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
                                    ("undefined" != typeof window && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
                                    ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
                                    ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))))
                        );
                    }),
                    (t.storage = (function () {
                        try {
                            return localStorage;
                        } catch (e) {}
                    })()),
                    (t.destroy = (() => {
                        let e = !1;
                        return () => {
                            e || ((e = !0), console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
                        };
                    })()),
                    (t.colors = [
                        "#0000CC",
                        "#0000FF",
                        "#0033CC",
                        "#0033FF",
                        "#0066CC",
                        "#0066FF",
                        "#0099CC",
                        "#0099FF",
                        "#00CC00",
                        "#00CC33",
                        "#00CC66",
                        "#00CC99",
                        "#00CCCC",
                        "#00CCFF",
                        "#3300CC",
                        "#3300FF",
                        "#3333CC",
                        "#3333FF",
                        "#3366CC",
                        "#3366FF",
                        "#3399CC",
                        "#3399FF",
                        "#33CC00",
                        "#33CC33",
                        "#33CC66",
                        "#33CC99",
                        "#33CCCC",
                        "#33CCFF",
                        "#6600CC",
                        "#6600FF",
                        "#6633CC",
                        "#6633FF",
                        "#66CC00",
                        "#66CC33",
                        "#9900CC",
                        "#9900FF",
                        "#9933CC",
                        "#9933FF",
                        "#99CC00",
                        "#99CC33",
                        "#CC0000",
                        "#CC0033",
                        "#CC0066",
                        "#CC0099",
                        "#CC00CC",
                        "#CC00FF",
                        "#CC3300",
                        "#CC3333",
                        "#CC3366",
                        "#CC3399",
                        "#CC33CC",
                        "#CC33FF",
                        "#CC6600",
                        "#CC6633",
                        "#CC9900",
                        "#CC9933",
                        "#CCCC00",
                        "#CCCC33",
                        "#FF0000",
                        "#FF0033",
                        "#FF0066",
                        "#FF0099",
                        "#FF00CC",
                        "#FF00FF",
                        "#FF3300",
                        "#FF3333",
                        "#FF3366",
                        "#FF3399",
                        "#FF33CC",
                        "#FF33FF",
                        "#FF6600",
                        "#FF6633",
                        "#FF9900",
                        "#FF9933",
                        "#FFCC00",
                        "#FFCC33",
                    ]),
                    (t.log = console.debug || console.log || (() => {})),
                    (e.exports = i(4716)(t));
                const { formatters: s } = e.exports;
                s.j = function (e) {
                    try {
                        return JSON.stringify(e);
                    } catch (e) {
                        return "[UnexpectedJSONParseError]: " + e.message;
                    }
                };
            },
            4716: (e, t, i) => {
                e.exports = function (e) {
                    function t(e) {
                        let i,
                            r,
                            n,
                            a = null;
                        function o(...e) {
                            if (!o.enabled) return;
                            const s = o,
                                r = Number(new Date()),
                                n = r - (i || r);
                            (s.diff = n), (s.prev = i), (s.curr = r), (i = r), (e[0] = t.coerce(e[0])), "string" != typeof e[0] && e.unshift("%O");
                            let a = 0;
                            (e[0] = e[0].replace(/%([a-zA-Z%])/g, (i, r) => {
                                if ("%%" === i) return "%";
                                a++;
                                const n = t.formatters[r];
                                if ("function" == typeof n) {
                                    const t = e[a];
                                    (i = n.call(s, t)), e.splice(a, 1), a--;
                                }
                                return i;
                            })),
                                t.formatArgs.call(s, e),
                                (s.log || t.log).apply(s, e);
                        }
                        return (
                            (o.namespace = e),
                            (o.useColors = t.useColors()),
                            (o.color = t.selectColor(e)),
                            (o.extend = s),
                            (o.destroy = t.destroy),
                            Object.defineProperty(o, "enabled", {
                                enumerable: !0,
                                configurable: !1,
                                get: () => (null !== a ? a : (r !== t.namespaces && ((r = t.namespaces), (n = t.enabled(e))), n)),
                                set: (e) => {
                                    a = e;
                                },
                            }),
                            "function" == typeof t.init && t.init(o),
                            o
                        );
                    }
                    function s(e, i) {
                        const s = t(this.namespace + (void 0 === i ? ":" : i) + e);
                        return (s.log = this.log), s;
                    }
                    function r(e) {
                        return e
                            .toString()
                            .substring(2, e.toString().length - 2)
                            .replace(/\.\*\?$/, "*");
                    }
                    return (
                        (t.debug = t),
                        (t.default = t),
                        (t.coerce = function (e) {
                            return e instanceof Error ? e.stack || e.message : e;
                        }),
                        (t.disable = function () {
                            const e = [...t.names.map(r), ...t.skips.map(r).map((e) => "-" + e)].join(",");
                            return t.enable(""), e;
                        }),
                        (t.enable = function (e) {
                            let i;
                            t.save(e), (t.namespaces = e), (t.names = []), (t.skips = []);
                            const s = ("string" == typeof e ? e : "").split(/[\s,]+/),
                                r = s.length;
                            for (i = 0; i < r; i++) s[i] && ("-" === (e = s[i].replace(/\*/g, ".*?"))[0] ? t.skips.push(new RegExp("^" + e.slice(1) + "$")) : t.names.push(new RegExp("^" + e + "$")));
                        }),
                        (t.enabled = function (e) {
                            if ("*" === e[e.length - 1]) return !0;
                            let i, s;
                            for (i = 0, s = t.skips.length; i < s; i++) if (t.skips[i].test(e)) return !1;
                            for (i = 0, s = t.names.length; i < s; i++) if (t.names[i].test(e)) return !0;
                            return !1;
                        }),
                        (t.humanize = i(6520)),
                        (t.destroy = function () {
                            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
                        }),
                        Object.keys(e).forEach((i) => {
                            t[i] = e[i];
                        }),
                        (t.names = []),
                        (t.skips = []),
                        (t.formatters = {}),
                        (t.selectColor = function (e) {
                            let i = 0;
                            for (let t = 0; t < e.length; t++) (i = (i << 5) - i + e.charCodeAt(t)), (i |= 0);
                            return t.colors[Math.abs(i) % t.colors.length];
                        }),
                        t.enable(t.load()),
                        t
                    );
                };
            },
            6520: (e) => {
                var t = 1e3,
                    i = 60 * t,
                    s = 60 * i,
                    r = 24 * s;
                function n(e, t, i, s) {
                    var r = t >= 1.5 * i;
                    return Math.round(e / i) + " " + s + (r ? "s" : "");
                }
                e.exports = function (e, a) {
                    a = a || {};
                    var o,
                        l,
                        d = typeof e;
                    if ("string" === d && e.length > 0)
                        return (function (e) {
                            if (!((e = String(e)).length > 100)) {
                                var n = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e);
                                if (n) {
                                    var a = parseFloat(n[1]);
                                    switch ((n[2] || "ms").toLowerCase()) {
                                        case "years":
                                        case "year":
                                        case "yrs":
                                        case "yr":
                                        case "y":
                                            return 315576e5 * a;
                                        case "weeks":
                                        case "week":
                                        case "w":
                                            return 6048e5 * a;
                                        case "days":
                                        case "day":
                                        case "d":
                                            return a * r;
                                        case "hours":
                                        case "hour":
                                        case "hrs":
                                        case "hr":
                                        case "h":
                                            return a * s;
                                        case "minutes":
                                        case "minute":
                                        case "mins":
                                        case "min":
                                        case "m":
                                            return a * i;
                                        case "seconds":
                                        case "second":
                                        case "secs":
                                        case "sec":
                                        case "s":
                                            return a * t;
                                        case "milliseconds":
                                        case "millisecond":
                                        case "msecs":
                                        case "msec":
                                        case "ms":
                                            return a;
                                        default:
                                            return;
                                    }
                                }
                            }
                        })(e);
                    if ("number" === d && isFinite(e))
                        return a.long
                            ? ((o = e), (l = Math.abs(o)) >= r ? n(o, l, r, "day") : l >= s ? n(o, l, s, "hour") : l >= i ? n(o, l, i, "minute") : l >= t ? n(o, l, t, "second") : o + " ms")
                            : (function (e) {
                                  var n = Math.abs(e);
                                  return n >= r ? Math.round(e / r) + "d" : n >= s ? Math.round(e / s) + "h" : n >= i ? Math.round(e / i) + "m" : n >= t ? Math.round(e / t) + "s" : e + "ms";
                              })(e);
                    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
                };
            },
            6436: (e, t, i) => {
                "use strict";
                function s(e) {
                    return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
                }
                function r(e, t) {
                    void 0 === e && (e = {}),
                        void 0 === t && (t = {}),
                        Object.keys(t).forEach((i) => {
                            void 0 === e[i] ? (e[i] = t[i]) : s(t[i]) && s(e[i]) && Object.keys(t[i]).length > 0 && r(e[i], t[i]);
                        });
                }
                i.r(t), i.d(t, { SwiperContainer: () => Ce, SwiperSlide: () => Te, register: () => Me });
                const n = {
                    body: {},
                    addEventListener() {},
                    removeEventListener() {},
                    activeElement: { blur() {}, nodeName: "" },
                    querySelector: () => null,
                    querySelectorAll: () => [],
                    getElementById: () => null,
                    createEvent: () => ({ initEvent() {} }),
                    createElement: () => ({ children: [], childNodes: [], style: {}, setAttribute() {}, getElementsByTagName: () => [] }),
                    createElementNS: () => ({}),
                    importNode: () => null,
                    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
                };
                function a() {
                    const e = "undefined" != typeof document ? document : {};
                    return r(e, n), e;
                }
                const o = {
                    document: n,
                    navigator: { userAgent: "" },
                    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
                    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
                    CustomEvent: function () {
                        return this;
                    },
                    addEventListener() {},
                    removeEventListener() {},
                    getComputedStyle: () => ({ getPropertyValue: () => "" }),
                    Image() {},
                    Date() {},
                    screen: {},
                    setTimeout() {},
                    clearTimeout() {},
                    matchMedia: () => ({}),
                    requestAnimationFrame: (e) => ("undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)),
                    cancelAnimationFrame(e) {
                        "undefined" != typeof setTimeout && clearTimeout(e);
                    },
                };
                function l() {
                    const e = "undefined" != typeof window ? window : {};
                    return r(e, o), e;
                }
                function d(e) {
                    return (
                        void 0 === e && (e = ""),
                        e
                            .trim()
                            .split(" ")
                            .filter((e) => !!e.trim())
                    );
                }
                function c(e, t) {
                    return void 0 === t && (t = 0), setTimeout(e, t);
                }
                function u() {
                    return Date.now();
                }
                function p(e, t) {
                    void 0 === t && (t = "x");
                    const i = l();
                    let s, r, n;
                    const a = (function (e) {
                        const t = l();
                        let i;
                        return t.getComputedStyle && (i = t.getComputedStyle(e, null)), !i && e.currentStyle && (i = e.currentStyle), i || (i = e.style), i;
                    })(e);
                    return (
                        i.WebKitCSSMatrix
                            ? ((r = a.transform || a.webkitTransform),
                              r.split(",").length > 6 &&
                                  (r = r
                                      .split(", ")
                                      .map((e) => e.replace(",", "."))
                                      .join(", ")),
                              (n = new i.WebKitCSSMatrix("none" === r ? "" : r)))
                            : ((n = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")), (s = n.toString().split(","))),
                        "x" === t && (r = i.WebKitCSSMatrix ? n.m41 : 16 === s.length ? parseFloat(s[12]) : parseFloat(s[4])),
                        "y" === t && (r = i.WebKitCSSMatrix ? n.m42 : 16 === s.length ? parseFloat(s[13]) : parseFloat(s[5])),
                        r || 0
                    );
                }
                function h(e) {
                    return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
                }
                function m() {
                    const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
                        t = ["__proto__", "constructor", "prototype"];
                    for (let s = 1; s < arguments.length; s += 1) {
                        const r = s < 0 || arguments.length <= s ? void 0 : arguments[s];
                        if (null != r && ((i = r), !("undefined" != typeof window && void 0 !== window.HTMLElement ? i instanceof HTMLElement : i && (1 === i.nodeType || 11 === i.nodeType)))) {
                            const i = Object.keys(Object(r)).filter((e) => t.indexOf(e) < 0);
                            for (let t = 0, s = i.length; t < s; t += 1) {
                                const s = i[t],
                                    n = Object.getOwnPropertyDescriptor(r, s);
                                void 0 !== n && n.enumerable && (h(e[s]) && h(r[s]) ? (r[s].__swiper__ ? (e[s] = r[s]) : m(e[s], r[s])) : !h(e[s]) && h(r[s]) ? ((e[s] = {}), r[s].__swiper__ ? (e[s] = r[s]) : m(e[s], r[s])) : (e[s] = r[s]));
                            }
                        }
                    }
                    var i;
                    return e;
                }
                function v(e, t, i) {
                    e.style.setProperty(t, i);
                }
                function g(e) {
                    let { swiper: t, targetPosition: i, side: s } = e;
                    const r = l(),
                        n = -t.translate;
                    let a,
                        o = null;
                    const d = t.params.speed;
                    (t.wrapperEl.style.scrollSnapType = "none"), r.cancelAnimationFrame(t.cssModeFrameID);
                    const c = i > n ? "next" : "prev",
                        u = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
                        p = () => {
                            (a = new Date().getTime()), null === o && (o = a);
                            const e = Math.max(Math.min((a - o) / d, 1), 0),
                                l = 0.5 - Math.cos(e * Math.PI) / 2;
                            let c = n + l * (i - n);
                            if ((u(c, i) && (c = i), t.wrapperEl.scrollTo({ [s]: c }), u(c, i)))
                                return (
                                    (t.wrapperEl.style.overflow = "hidden"),
                                    (t.wrapperEl.style.scrollSnapType = ""),
                                    setTimeout(() => {
                                        (t.wrapperEl.style.overflow = ""), t.wrapperEl.scrollTo({ [s]: c });
                                    }),
                                    void r.cancelAnimationFrame(t.cssModeFrameID)
                                );
                            t.cssModeFrameID = r.requestAnimationFrame(p);
                        };
                    p();
                }
                function f(e) {
                    return e.querySelector(".swiper-slide-transform") || (e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform")) || e;
                }
                function b(e, t) {
                    return void 0 === t && (t = ""), [...e.children].filter((e) => e.matches(t));
                }
                function w(e) {
                    try {
                        return void console.warn(e);
                    } catch (e) {}
                }
                function y(e, t) {
                    void 0 === t && (t = []);
                    const i = document.createElement(e);
                    return i.classList.add(...(Array.isArray(t) ? t : d(t))), i;
                }
                function E(e) {
                    const t = l(),
                        i = a(),
                        s = e.getBoundingClientRect(),
                        r = i.body,
                        n = e.clientTop || r.clientTop || 0,
                        o = e.clientLeft || r.clientLeft || 0,
                        d = e === t ? t.scrollY : e.scrollTop,
                        c = e === t ? t.scrollX : e.scrollLeft;
                    return { top: s.top + d - n, left: s.left + c - o };
                }
                function S(e, t) {
                    return l().getComputedStyle(e, null).getPropertyValue(t);
                }
                function x(e) {
                    let t,
                        i = e;
                    if (i) {
                        for (t = 0; null !== (i = i.previousSibling); ) 1 === i.nodeType && (t += 1);
                        return t;
                    }
                }
                function C(e, t) {
                    const i = [];
                    let s = e.parentElement;
                    for (; s; ) t ? s.matches(t) && i.push(s) : i.push(s), (s = s.parentElement);
                    return i;
                }
                function T(e, t) {
                    t &&
                        e.addEventListener("transitionend", function i(s) {
                            s.target === e && (t.call(e, s), e.removeEventListener("transitionend", i));
                        });
                }
                function M(e, t, i) {
                    const s = l();
                    return i
                        ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
                              parseFloat(s.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) +
                              parseFloat(s.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom"))
                        : e.offsetWidth;
                }
                let L, P, A;
                function k() {
                    return (
                        L ||
                            (L = (function () {
                                const e = l(),
                                    t = a();
                                return { smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style, touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)) };
                            })()),
                        L
                    );
                }
                var I = {
                    on(e, t, i) {
                        const s = this;
                        if (!s.eventsListeners || s.destroyed) return s;
                        if ("function" != typeof t) return s;
                        const r = i ? "unshift" : "push";
                        return (
                            e.split(" ").forEach((e) => {
                                s.eventsListeners[e] || (s.eventsListeners[e] = []), s.eventsListeners[e][r](t);
                            }),
                            s
                        );
                    },
                    once(e, t, i) {
                        const s = this;
                        if (!s.eventsListeners || s.destroyed) return s;
                        if ("function" != typeof t) return s;
                        function r() {
                            s.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
                            for (var i = arguments.length, n = new Array(i), a = 0; a < i; a++) n[a] = arguments[a];
                            t.apply(s, n);
                        }
                        return (r.__emitterProxy = t), s.on(e, r, i);
                    },
                    onAny(e, t) {
                        const i = this;
                        if (!i.eventsListeners || i.destroyed) return i;
                        if ("function" != typeof e) return i;
                        const s = t ? "unshift" : "push";
                        return i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[s](e), i;
                    },
                    offAny(e) {
                        const t = this;
                        if (!t.eventsListeners || t.destroyed) return t;
                        if (!t.eventsAnyListeners) return t;
                        const i = t.eventsAnyListeners.indexOf(e);
                        return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
                    },
                    off(e, t) {
                        const i = this;
                        return !i.eventsListeners || i.destroyed
                            ? i
                            : i.eventsListeners
                            ? (e.split(" ").forEach((e) => {
                                  void 0 === t
                                      ? (i.eventsListeners[e] = [])
                                      : i.eventsListeners[e] &&
                                        i.eventsListeners[e].forEach((s, r) => {
                                            (s === t || (s.__emitterProxy && s.__emitterProxy === t)) && i.eventsListeners[e].splice(r, 1);
                                        });
                              }),
                              i)
                            : i;
                    },
                    emit() {
                        const e = this;
                        if (!e.eventsListeners || e.destroyed) return e;
                        if (!e.eventsListeners) return e;
                        let t, i, s;
                        for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) n[a] = arguments[a];
                        return (
                            "string" == typeof n[0] || Array.isArray(n[0]) ? ((t = n[0]), (i = n.slice(1, n.length)), (s = e)) : ((t = n[0].events), (i = n[0].data), (s = n[0].context || e)),
                            i.unshift(s),
                            (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
                                e.eventsAnyListeners &&
                                    e.eventsAnyListeners.length &&
                                    e.eventsAnyListeners.forEach((e) => {
                                        e.apply(s, [t, ...i]);
                                    }),
                                    e.eventsListeners &&
                                        e.eventsListeners[t] &&
                                        e.eventsListeners[t].forEach((e) => {
                                            e.apply(s, i);
                                        });
                            }),
                            e
                        );
                    },
                };
                const O = (e, t) => {
                        if (!e || e.destroyed || !e.params) return;
                        const i = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
                        if (i) {
                            let t = i.querySelector(`.${e.params.lazyPreloaderClass}`);
                            !t &&
                                e.isElement &&
                                (i.shadowRoot
                                    ? (t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`))
                                    : requestAnimationFrame(() => {
                                          i.shadowRoot && ((t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`)), t && t.remove());
                                      })),
                                t && t.remove();
                        }
                    },
                    D = (e, t) => {
                        if (!e.slides[t]) return;
                        const i = e.slides[t].querySelector('[loading="lazy"]');
                        i && i.removeAttribute("loading");
                    },
                    z = (e) => {
                        if (!e || e.destroyed || !e.params) return;
                        let t = e.params.lazyPreloadPrevNext;
                        const i = e.slides.length;
                        if (!i || !t || t < 0) return;
                        t = Math.min(t, i);
                        const s = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
                            r = e.activeIndex;
                        if (e.params.grid && e.params.grid.rows > 1) {
                            const i = r,
                                n = [i - t];
                            return (
                                n.push(...Array.from({ length: t }).map((e, t) => i + s + t)),
                                void e.slides.forEach((t, i) => {
                                    n.includes(t.column) && D(e, i);
                                })
                            );
                        }
                        const n = r + s - 1;
                        if (e.params.rewind || e.params.loop)
                            for (let s = r - t; s <= n + t; s += 1) {
                                const t = ((s % i) + i) % i;
                                (t < r || t > n) && D(e, t);
                            }
                        else for (let s = Math.max(r - t, 0); s <= Math.min(n + t, i - 1); s += 1) s !== r && (s > n || s < r) && D(e, s);
                    };
                var _ = {
                    updateSize: function () {
                        const e = this;
                        let t, i;
                        const s = e.el;
                        (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : s.clientWidth),
                            (i = void 0 !== e.params.height && null !== e.params.height ? e.params.height : s.clientHeight),
                            (0 === t && e.isHorizontal()) ||
                                (0 === i && e.isVertical()) ||
                                ((t = t - parseInt(S(s, "padding-left") || 0, 10) - parseInt(S(s, "padding-right") || 0, 10)),
                                (i = i - parseInt(S(s, "padding-top") || 0, 10) - parseInt(S(s, "padding-bottom") || 0, 10)),
                                Number.isNaN(t) && (t = 0),
                                Number.isNaN(i) && (i = 0),
                                Object.assign(e, { width: t, height: i, size: e.isHorizontal() ? t : i }));
                    },
                    updateSlides: function () {
                        const e = this;
                        function t(t, i) {
                            return parseFloat(t.getPropertyValue(e.getDirectionLabel(i)) || 0);
                        }
                        const i = e.params,
                            { wrapperEl: s, slidesEl: r, size: n, rtlTranslate: a, wrongRTL: o } = e,
                            l = e.virtual && i.virtual.enabled,
                            d = l ? e.virtual.slides.length : e.slides.length,
                            c = b(r, `.${e.params.slideClass}, swiper-slide`),
                            u = l ? e.virtual.slides.length : c.length;
                        let p = [];
                        const h = [],
                            m = [];
                        let g = i.slidesOffsetBefore;
                        "function" == typeof g && (g = i.slidesOffsetBefore.call(e));
                        let f = i.slidesOffsetAfter;
                        "function" == typeof f && (f = i.slidesOffsetAfter.call(e));
                        const w = e.snapGrid.length,
                            y = e.slidesGrid.length;
                        let E = i.spaceBetween,
                            x = -g,
                            C = 0,
                            T = 0;
                        if (void 0 === n) return;
                        "string" == typeof E && E.indexOf("%") >= 0 ? (E = (parseFloat(E.replace("%", "")) / 100) * n) : "string" == typeof E && (E = parseFloat(E)),
                            (e.virtualSize = -E),
                            c.forEach((e) => {
                                a ? (e.style.marginLeft = "") : (e.style.marginRight = ""), (e.style.marginBottom = ""), (e.style.marginTop = "");
                            }),
                            i.centeredSlides && i.cssMode && (v(s, "--swiper-centered-offset-before", ""), v(s, "--swiper-centered-offset-after", ""));
                        const L = i.grid && i.grid.rows > 1 && e.grid;
                        let P;
                        L ? e.grid.initSlides(c) : e.grid && e.grid.unsetSlides();
                        const A = "auto" === i.slidesPerView && i.breakpoints && Object.keys(i.breakpoints).filter((e) => void 0 !== i.breakpoints[e].slidesPerView).length > 0;
                        for (let s = 0; s < u; s += 1) {
                            let r;
                            if (((P = 0), c[s] && (r = c[s]), L && e.grid.updateSlide(s, r, c), !c[s] || "none" !== S(r, "display"))) {
                                if ("auto" === i.slidesPerView) {
                                    A && (c[s].style[e.getDirectionLabel("width")] = "");
                                    const n = getComputedStyle(r),
                                        a = r.style.transform,
                                        o = r.style.webkitTransform;
                                    if ((a && (r.style.transform = "none"), o && (r.style.webkitTransform = "none"), i.roundLengths)) P = e.isHorizontal() ? M(r, "width", !0) : M(r, "height", !0);
                                    else {
                                        const e = t(n, "width"),
                                            i = t(n, "padding-left"),
                                            s = t(n, "padding-right"),
                                            a = t(n, "margin-left"),
                                            o = t(n, "margin-right"),
                                            l = n.getPropertyValue("box-sizing");
                                        if (l && "border-box" === l) P = e + a + o;
                                        else {
                                            const { clientWidth: t, offsetWidth: n } = r;
                                            P = e + i + s + a + o + (n - t);
                                        }
                                    }
                                    a && (r.style.transform = a), o && (r.style.webkitTransform = o), i.roundLengths && (P = Math.floor(P));
                                } else (P = (n - (i.slidesPerView - 1) * E) / i.slidesPerView), i.roundLengths && (P = Math.floor(P)), c[s] && (c[s].style[e.getDirectionLabel("width")] = `${P}px`);
                                c[s] && (c[s].swiperSlideSize = P),
                                    m.push(P),
                                    i.centeredSlides
                                        ? ((x = x + P / 2 + C / 2 + E),
                                          0 === C && 0 !== s && (x = x - n / 2 - E),
                                          0 === s && (x = x - n / 2 - E),
                                          Math.abs(x) < 0.001 && (x = 0),
                                          i.roundLengths && (x = Math.floor(x)),
                                          T % i.slidesPerGroup == 0 && p.push(x),
                                          h.push(x))
                                        : (i.roundLengths && (x = Math.floor(x)), (T - Math.min(e.params.slidesPerGroupSkip, T)) % e.params.slidesPerGroup == 0 && p.push(x), h.push(x), (x = x + P + E)),
                                    (e.virtualSize += P + E),
                                    (C = P),
                                    (T += 1);
                            }
                        }
                        if (
                            ((e.virtualSize = Math.max(e.virtualSize, n) + f),
                            a && o && ("slide" === i.effect || "coverflow" === i.effect) && (s.style.width = `${e.virtualSize + E}px`),
                            i.setWrapperSize && (s.style[e.getDirectionLabel("width")] = `${e.virtualSize + E}px`),
                            L && e.grid.updateWrapperSize(P, p),
                            !i.centeredSlides)
                        ) {
                            const t = [];
                            for (let s = 0; s < p.length; s += 1) {
                                let r = p[s];
                                i.roundLengths && (r = Math.floor(r)), p[s] <= e.virtualSize - n && t.push(r);
                            }
                            (p = t), Math.floor(e.virtualSize - n) - Math.floor(p[p.length - 1]) > 1 && p.push(e.virtualSize - n);
                        }
                        if (l && i.loop) {
                            const t = m[0] + E;
                            if (i.slidesPerGroup > 1) {
                                const s = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup),
                                    r = t * i.slidesPerGroup;
                                for (let e = 0; e < s; e += 1) p.push(p[p.length - 1] + r);
                            }
                            for (let s = 0; s < e.virtual.slidesBefore + e.virtual.slidesAfter; s += 1) 1 === i.slidesPerGroup && p.push(p[p.length - 1] + t), h.push(h[h.length - 1] + t), (e.virtualSize += t);
                        }
                        if ((0 === p.length && (p = [0]), 0 !== E)) {
                            const t = e.isHorizontal() && a ? "marginLeft" : e.getDirectionLabel("marginRight");
                            c.filter((e, t) => !(i.cssMode && !i.loop) || t !== c.length - 1).forEach((e) => {
                                e.style[t] = `${E}px`;
                            });
                        }
                        if (i.centeredSlides && i.centeredSlidesBounds) {
                            let e = 0;
                            m.forEach((t) => {
                                e += t + (E || 0);
                            }),
                                (e -= E);
                            const t = e - n;
                            p = p.map((e) => (e <= 0 ? -g : e > t ? t + f : e));
                        }
                        if (i.centerInsufficientSlides) {
                            let e = 0;
                            if (
                                (m.forEach((t) => {
                                    e += t + (E || 0);
                                }),
                                (e -= E),
                                e < n)
                            ) {
                                const t = (n - e) / 2;
                                p.forEach((e, i) => {
                                    p[i] = e - t;
                                }),
                                    h.forEach((e, i) => {
                                        h[i] = e + t;
                                    });
                            }
                        }
                        if ((Object.assign(e, { slides: c, snapGrid: p, slidesGrid: h, slidesSizesGrid: m }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)) {
                            v(s, "--swiper-centered-offset-before", -p[0] + "px"), v(s, "--swiper-centered-offset-after", e.size / 2 - m[m.length - 1] / 2 + "px");
                            const t = -e.snapGrid[0],
                                i = -e.slidesGrid[0];
                            (e.snapGrid = e.snapGrid.map((e) => e + t)), (e.slidesGrid = e.slidesGrid.map((e) => e + i));
                        }
                        if (
                            (u !== d && e.emit("slidesLengthChange"),
                            p.length !== w && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                            h.length !== y && e.emit("slidesGridLengthChange"),
                            i.watchSlidesProgress && e.updateSlidesOffset(),
                            e.emit("slidesUpdated"),
                            !(l || i.cssMode || ("slide" !== i.effect && "fade" !== i.effect)))
                        ) {
                            const t = `${i.containerModifierClass}backface-hidden`,
                                s = e.el.classList.contains(t);
                            u <= i.maxBackfaceHiddenSlides ? s || e.el.classList.add(t) : s && e.el.classList.remove(t);
                        }
                    },
                    updateAutoHeight: function (e) {
                        const t = this,
                            i = [],
                            s = t.virtual && t.params.virtual.enabled;
                        let r,
                            n = 0;
                        "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
                        const a = (e) => (s ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
                        if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                            if (t.params.centeredSlides)
                                (t.visibleSlides || []).forEach((e) => {
                                    i.push(e);
                                });
                            else
                                for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
                                    const e = t.activeIndex + r;
                                    if (e > t.slides.length && !s) break;
                                    i.push(a(e));
                                }
                        else i.push(a(t.activeIndex));
                        for (r = 0; r < i.length; r += 1)
                            if (void 0 !== i[r]) {
                                const e = i[r].offsetHeight;
                                n = e > n ? e : n;
                            }
                        (n || 0 === n) && (t.wrapperEl.style.height = `${n}px`);
                    },
                    updateSlidesOffset: function () {
                        const e = this,
                            t = e.slides,
                            i = e.isElement ? (e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop) : 0;
                        for (let s = 0; s < t.length; s += 1) t[s].swiperSlideOffset = (e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop) - i - e.cssOverflowAdjustment();
                    },
                    updateSlidesProgress: function (e) {
                        void 0 === e && (e = (this && this.translate) || 0);
                        const t = this,
                            i = t.params,
                            { slides: s, rtlTranslate: r, snapGrid: n } = t;
                        if (0 === s.length) return;
                        void 0 === s[0].swiperSlideOffset && t.updateSlidesOffset();
                        let a = -e;
                        r && (a = e),
                            s.forEach((e) => {
                                e.classList.remove(i.slideVisibleClass, i.slideFullyVisibleClass);
                            }),
                            (t.visibleSlidesIndexes = []),
                            (t.visibleSlides = []);
                        let o = i.spaceBetween;
                        "string" == typeof o && o.indexOf("%") >= 0 ? (o = (parseFloat(o.replace("%", "")) / 100) * t.size) : "string" == typeof o && (o = parseFloat(o));
                        for (let e = 0; e < s.length; e += 1) {
                            const l = s[e];
                            let d = l.swiperSlideOffset;
                            i.cssMode && i.centeredSlides && (d -= s[0].swiperSlideOffset);
                            const c = (a + (i.centeredSlides ? t.minTranslate() : 0) - d) / (l.swiperSlideSize + o),
                                u = (a - n[0] + (i.centeredSlides ? t.minTranslate() : 0) - d) / (l.swiperSlideSize + o),
                                p = -(a - d),
                                h = p + t.slidesSizesGrid[e],
                                m = p >= 0 && p <= t.size - t.slidesSizesGrid[e];
                            ((p >= 0 && p < t.size - 1) || (h > 1 && h <= t.size) || (p <= 0 && h >= t.size)) && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(e), s[e].classList.add(i.slideVisibleClass)),
                                m && s[e].classList.add(i.slideFullyVisibleClass),
                                (l.progress = r ? -c : c),
                                (l.originalProgress = r ? -u : u);
                        }
                    },
                    updateProgress: function (e) {
                        const t = this;
                        if (void 0 === e) {
                            const i = t.rtlTranslate ? -1 : 1;
                            e = (t && t.translate && t.translate * i) || 0;
                        }
                        const i = t.params,
                            s = t.maxTranslate() - t.minTranslate();
                        let { progress: r, isBeginning: n, isEnd: a, progressLoop: o } = t;
                        const l = n,
                            d = a;
                        if (0 === s) (r = 0), (n = !0), (a = !0);
                        else {
                            r = (e - t.minTranslate()) / s;
                            const i = Math.abs(e - t.minTranslate()) < 1,
                                o = Math.abs(e - t.maxTranslate()) < 1;
                            (n = i || r <= 0), (a = o || r >= 1), i && (r = 0), o && (r = 1);
                        }
                        if (i.loop) {
                            const i = t.getSlideIndexByData(0),
                                s = t.getSlideIndexByData(t.slides.length - 1),
                                r = t.slidesGrid[i],
                                n = t.slidesGrid[s],
                                a = t.slidesGrid[t.slidesGrid.length - 1],
                                l = Math.abs(e);
                            (o = l >= r ? (l - r) / a : (l + a - n) / a), o > 1 && (o -= 1);
                        }
                        Object.assign(t, { progress: r, progressLoop: o, isBeginning: n, isEnd: a }),
                            (i.watchSlidesProgress || (i.centeredSlides && i.autoHeight)) && t.updateSlidesProgress(e),
                            n && !l && t.emit("reachBeginning toEdge"),
                            a && !d && t.emit("reachEnd toEdge"),
                            ((l && !n) || (d && !a)) && t.emit("fromEdge"),
                            t.emit("progress", r);
                    },
                    updateSlidesClasses: function () {
                        const e = this,
                            { slides: t, params: i, slidesEl: s, activeIndex: r } = e,
                            n = e.virtual && i.virtual.enabled,
                            a = e.grid && i.grid && i.grid.rows > 1,
                            o = (e) => b(s, `.${i.slideClass}${e}, swiper-slide${e}`)[0];
                        let l, d, c;
                        if (
                            (t.forEach((e) => {
                                e.classList.remove(i.slideActiveClass, i.slideNextClass, i.slidePrevClass);
                            }),
                            n)
                        )
                            if (i.loop) {
                                let t = r - e.virtual.slidesBefore;
                                t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), (l = o(`[data-swiper-slide-index="${t}"]`));
                            } else l = o(`[data-swiper-slide-index="${r}"]`);
                        else a ? ((l = t.filter((e) => e.column === r)[0]), (c = t.filter((e) => e.column === r + 1)[0]), (d = t.filter((e) => e.column === r - 1)[0])) : (l = t[r]);
                        l &&
                            (l.classList.add(i.slideActiveClass),
                            a
                                ? (c && c.classList.add(i.slideNextClass), d && d.classList.add(i.slidePrevClass))
                                : ((c = (function (e, t) {
                                      const i = [];
                                      for (; e.nextElementSibling; ) {
                                          const s = e.nextElementSibling;
                                          t ? s.matches(t) && i.push(s) : i.push(s), (e = s);
                                      }
                                      return i;
                                  })(l, `.${i.slideClass}, swiper-slide`)[0]),
                                  i.loop && !c && (c = t[0]),
                                  c && c.classList.add(i.slideNextClass),
                                  (d = (function (e, t) {
                                      const i = [];
                                      for (; e.previousElementSibling; ) {
                                          const s = e.previousElementSibling;
                                          t ? s.matches(t) && i.push(s) : i.push(s), (e = s);
                                      }
                                      return i;
                                  })(l, `.${i.slideClass}, swiper-slide`)[0]),
                                  i.loop && 0 === !d && (d = t[t.length - 1]),
                                  d && d.classList.add(i.slidePrevClass))),
                            e.emitSlidesClasses();
                    },
                    updateActiveIndex: function (e) {
                        const t = this,
                            i = t.rtlTranslate ? t.translate : -t.translate,
                            { snapGrid: s, params: r, activeIndex: n, realIndex: a, snapIndex: o } = t;
                        let l,
                            d = e;
                        const c = (e) => {
                            let i = e - t.virtual.slidesBefore;
                            return i < 0 && (i = t.virtual.slides.length + i), i >= t.virtual.slides.length && (i -= t.virtual.slides.length), i;
                        };
                        if (
                            (void 0 === d &&
                                (d = (function (e) {
                                    const { slidesGrid: t, params: i } = e,
                                        s = e.rtlTranslate ? e.translate : -e.translate;
                                    let r;
                                    for (let e = 0; e < t.length; e += 1) void 0 !== t[e + 1] ? (s >= t[e] && s < t[e + 1] - (t[e + 1] - t[e]) / 2 ? (r = e) : s >= t[e] && s < t[e + 1] && (r = e + 1)) : s >= t[e] && (r = e);
                                    return i.normalizeSlideIndex && (r < 0 || void 0 === r) && (r = 0), r;
                                })(t)),
                            s.indexOf(i) >= 0)
                        )
                            l = s.indexOf(i);
                        else {
                            const e = Math.min(r.slidesPerGroupSkip, d);
                            l = e + Math.floor((d - e) / r.slidesPerGroup);
                        }
                        if ((l >= s.length && (l = s.length - 1), d === n && !t.params.loop)) return void (l !== o && ((t.snapIndex = l), t.emit("snapIndexChange")));
                        if (d === n && t.params.loop && t.virtual && t.params.virtual.enabled) return void (t.realIndex = c(d));
                        const u = t.grid && r.grid && r.grid.rows > 1;
                        let p;
                        if (t.virtual && r.virtual.enabled && r.loop) p = c(d);
                        else if (u) {
                            const e = t.slides.filter((e) => e.column === d)[0];
                            let i = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
                            Number.isNaN(i) && (i = Math.max(t.slides.indexOf(e), 0)), (p = Math.floor(i / r.grid.rows));
                        } else if (t.slides[d]) {
                            const e = t.slides[d].getAttribute("data-swiper-slide-index");
                            p = e ? parseInt(e, 10) : d;
                        } else p = d;
                        Object.assign(t, { previousSnapIndex: o, snapIndex: l, previousRealIndex: a, realIndex: p, previousIndex: n, activeIndex: d }),
                            t.initialized && z(t),
                            t.emit("activeIndexChange"),
                            t.emit("snapIndexChange"),
                            (t.initialized || t.params.runCallbacksOnInit) && (a !== p && t.emit("realIndexChange"), t.emit("slideChange"));
                    },
                    updateClickedSlide: function (e, t) {
                        const i = this,
                            s = i.params;
                        let r = e.closest(`.${s.slideClass}, swiper-slide`);
                        !r &&
                            i.isElement &&
                            t &&
                            t.length > 1 &&
                            t.includes(e) &&
                            [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
                                !r && e.matches && e.matches(`.${s.slideClass}, swiper-slide`) && (r = e);
                            });
                        let n,
                            a = !1;
                        if (r)
                            for (let e = 0; e < i.slides.length; e += 1)
                                if (i.slides[e] === r) {
                                    (a = !0), (n = e);
                                    break;
                                }
                        if (!r || !a) return (i.clickedSlide = void 0), void (i.clickedIndex = void 0);
                        (i.clickedSlide = r),
                            i.virtual && i.params.virtual.enabled ? (i.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10)) : (i.clickedIndex = n),
                            s.slideToClickedSlide && void 0 !== i.clickedIndex && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
                    },
                };
                function $(e) {
                    let { swiper: t, runCallbacks: i, direction: s, step: r } = e;
                    const { activeIndex: n, previousIndex: a } = t;
                    let o = s;
                    if ((o || (o = n > a ? "next" : n < a ? "prev" : "reset"), t.emit(`transition${r}`), i && n !== a)) {
                        if ("reset" === o) return void t.emit(`slideResetTransition${r}`);
                        t.emit(`slideChangeTransition${r}`), "next" === o ? t.emit(`slideNextTransition${r}`) : t.emit(`slidePrevTransition${r}`);
                    }
                }
                var B = {
                        slideTo: function (e, t, i, s, r) {
                            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
                            const n = this;
                            let a = e;
                            a < 0 && (a = 0);
                            const { params: o, snapGrid: l, slidesGrid: d, previousIndex: c, activeIndex: u, rtlTranslate: p, wrapperEl: h, enabled: m } = n;
                            if ((n.animating && o.preventInteractionOnTransition) || (!m && !s && !r)) return !1;
                            const v = Math.min(n.params.slidesPerGroupSkip, a);
                            let f = v + Math.floor((a - v) / n.params.slidesPerGroup);
                            f >= l.length && (f = l.length - 1);
                            const b = -l[f];
                            if (o.normalizeSlideIndex)
                                for (let e = 0; e < d.length; e += 1) {
                                    const t = -Math.floor(100 * b),
                                        i = Math.floor(100 * d[e]),
                                        s = Math.floor(100 * d[e + 1]);
                                    void 0 !== d[e + 1] ? (t >= i && t < s - (s - i) / 2 ? (a = e) : t >= i && t < s && (a = e + 1)) : t >= i && (a = e);
                                }
                            if (n.initialized && a !== u) {
                                if (!n.allowSlideNext && (p ? b > n.translate && b > n.minTranslate() : b < n.translate && b < n.minTranslate())) return !1;
                                if (!n.allowSlidePrev && b > n.translate && b > n.maxTranslate() && (u || 0) !== a) return !1;
                            }
                            let w;
                            if ((a !== (c || 0) && i && n.emit("beforeSlideChangeStart"), n.updateProgress(b), (w = a > u ? "next" : a < u ? "prev" : "reset"), (p && -b === n.translate) || (!p && b === n.translate)))
                                return n.updateActiveIndex(a), o.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), "slide" !== o.effect && n.setTranslate(b), "reset" !== w && (n.transitionStart(i, w), n.transitionEnd(i, w)), !1;
                            if (o.cssMode) {
                                const e = n.isHorizontal(),
                                    i = p ? b : -b;
                                if (0 === t) {
                                    const t = n.virtual && n.params.virtual.enabled;
                                    t && ((n.wrapperEl.style.scrollSnapType = "none"), (n._immediateVirtual = !0)),
                                        t && !n._cssModeVirtualInitialSet && n.params.initialSlide > 0
                                            ? ((n._cssModeVirtualInitialSet = !0),
                                              requestAnimationFrame(() => {
                                                  h[e ? "scrollLeft" : "scrollTop"] = i;
                                              }))
                                            : (h[e ? "scrollLeft" : "scrollTop"] = i),
                                        t &&
                                            requestAnimationFrame(() => {
                                                (n.wrapperEl.style.scrollSnapType = ""), (n._immediateVirtual = !1);
                                            });
                                } else {
                                    if (!n.support.smoothScroll) return g({ swiper: n, targetPosition: i, side: e ? "left" : "top" }), !0;
                                    h.scrollTo({ [e ? "left" : "top"]: i, behavior: "smooth" });
                                }
                                return !0;
                            }
                            return (
                                n.setTransition(t),
                                n.setTranslate(b),
                                n.updateActiveIndex(a),
                                n.updateSlidesClasses(),
                                n.emit("beforeTransitionStart", t, s),
                                n.transitionStart(i, w),
                                0 === t
                                    ? n.transitionEnd(i, w)
                                    : n.animating ||
                                      ((n.animating = !0),
                                      n.onSlideToWrapperTransitionEnd ||
                                          (n.onSlideToWrapperTransitionEnd = function (e) {
                                              n &&
                                                  !n.destroyed &&
                                                  e.target === this &&
                                                  (n.wrapperEl.removeEventListener("transitionend", n.onSlideToWrapperTransitionEnd), (n.onSlideToWrapperTransitionEnd = null), delete n.onSlideToWrapperTransitionEnd, n.transitionEnd(i, w));
                                          }),
                                      n.wrapperEl.addEventListener("transitionend", n.onSlideToWrapperTransitionEnd)),
                                !0
                            );
                        },
                        slideToLoop: function (e, t, i, s) {
                            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
                            const r = this,
                                n = r.grid && r.params.grid && r.params.grid.rows > 1;
                            let a = e;
                            if (r.params.loop)
                                if (r.virtual && r.params.virtual.enabled) a += r.virtual.slidesBefore;
                                else {
                                    let e;
                                    if (n) {
                                        const t = a * r.params.grid.rows;
                                        e = r.slides.filter((e) => 1 * e.getAttribute("data-swiper-slide-index") === t)[0].column;
                                    } else e = r.getSlideIndexByData(a);
                                    const t = n ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length,
                                        { centeredSlides: i } = r.params;
                                    let s = r.params.slidesPerView;
                                    "auto" === s ? (s = r.slidesPerViewDynamic()) : ((s = Math.ceil(parseFloat(r.params.slidesPerView, 10))), i && s % 2 == 0 && (s += 1));
                                    let o = t - e < s;
                                    if ((i && (o = o || e < Math.ceil(s / 2)), o)) {
                                        const s = i ? (e < r.activeIndex ? "prev" : "next") : e - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
                                        r.loopFix({ direction: s, slideTo: !0, activeSlideIndex: "next" === s ? e + 1 : e - t + 1, slideRealIndex: "next" === s ? r.realIndex : void 0 });
                                    }
                                    if (n) {
                                        const e = a * r.params.grid.rows;
                                        a = r.slides.filter((t) => 1 * t.getAttribute("data-swiper-slide-index") === e)[0].column;
                                    } else a = r.getSlideIndexByData(a);
                                }
                            return (
                                requestAnimationFrame(() => {
                                    r.slideTo(a, t, i, s);
                                }),
                                r
                            );
                        },
                        slideNext: function (e, t, i) {
                            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                            const s = this,
                                { enabled: r, params: n, animating: a } = s;
                            if (!r) return s;
                            let o = n.slidesPerGroup;
                            "auto" === n.slidesPerView && 1 === n.slidesPerGroup && n.slidesPerGroupAuto && (o = Math.max(s.slidesPerViewDynamic("current", !0), 1));
                            const l = s.activeIndex < n.slidesPerGroupSkip ? 1 : o,
                                d = s.virtual && n.virtual.enabled;
                            if (n.loop) {
                                if (a && !d && n.loopPreventsSliding) return !1;
                                if ((s.loopFix({ direction: "next" }), (s._clientLeft = s.wrapperEl.clientLeft), s.activeIndex === s.slides.length - 1 && n.cssMode))
                                    return (
                                        requestAnimationFrame(() => {
                                            s.slideTo(s.activeIndex + l, e, t, i);
                                        }),
                                        !0
                                    );
                            }
                            return n.rewind && s.isEnd ? s.slideTo(0, e, t, i) : s.slideTo(s.activeIndex + l, e, t, i);
                        },
                        slidePrev: function (e, t, i) {
                            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                            const s = this,
                                { params: r, snapGrid: n, slidesGrid: a, rtlTranslate: o, enabled: l, animating: d } = s;
                            if (!l) return s;
                            const c = s.virtual && r.virtual.enabled;
                            if (r.loop) {
                                if (d && !c && r.loopPreventsSliding) return !1;
                                s.loopFix({ direction: "prev" }), (s._clientLeft = s.wrapperEl.clientLeft);
                            }
                            function u(e) {
                                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
                            }
                            const p = u(o ? s.translate : -s.translate),
                                h = n.map((e) => u(e));
                            let m = n[h.indexOf(p) - 1];
                            if (void 0 === m && r.cssMode) {
                                let e;
                                n.forEach((t, i) => {
                                    p >= t && (e = i);
                                }),
                                    void 0 !== e && (m = n[e > 0 ? e - 1 : e]);
                            }
                            let v = 0;
                            if (
                                (void 0 !== m &&
                                    ((v = a.indexOf(m)),
                                    v < 0 && (v = s.activeIndex - 1),
                                    "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && ((v = v - s.slidesPerViewDynamic("previous", !0) + 1), (v = Math.max(v, 0)))),
                                r.rewind && s.isBeginning)
                            ) {
                                const r = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
                                return s.slideTo(r, e, t, i);
                            }
                            return r.loop && 0 === s.activeIndex && r.cssMode
                                ? (requestAnimationFrame(() => {
                                      s.slideTo(v, e, t, i);
                                  }),
                                  !0)
                                : s.slideTo(v, e, t, i);
                        },
                        slideReset: function (e, t, i) {
                            return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, i);
                        },
                        slideToClosest: function (e, t, i, s) {
                            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === s && (s = 0.5);
                            const r = this;
                            let n = r.activeIndex;
                            const a = Math.min(r.params.slidesPerGroupSkip, n),
                                o = a + Math.floor((n - a) / r.params.slidesPerGroup),
                                l = r.rtlTranslate ? r.translate : -r.translate;
                            if (l >= r.snapGrid[o]) {
                                const e = r.snapGrid[o];
                                l - e > (r.snapGrid[o + 1] - e) * s && (n += r.params.slidesPerGroup);
                            } else {
                                const e = r.snapGrid[o - 1];
                                l - e <= (r.snapGrid[o] - e) * s && (n -= r.params.slidesPerGroup);
                            }
                            return (n = Math.max(n, 0)), (n = Math.min(n, r.slidesGrid.length - 1)), r.slideTo(n, e, t, i);
                        },
                        slideToClickedSlide: function () {
                            const e = this,
                                { params: t, slidesEl: i } = e,
                                s = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                            let r,
                                n = e.clickedIndex;
                            const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
                            if (t.loop) {
                                if (e.animating) return;
                                (r = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
                                    t.centeredSlides
                                        ? n < e.loopedSlides - s / 2 || n > e.slides.length - e.loopedSlides + s / 2
                                            ? (e.loopFix(),
                                              (n = e.getSlideIndex(b(i, `${a}[data-swiper-slide-index="${r}"]`)[0])),
                                              c(() => {
                                                  e.slideTo(n);
                                              }))
                                            : e.slideTo(n)
                                        : n > e.slides.length - s
                                        ? (e.loopFix(),
                                          (n = e.getSlideIndex(b(i, `${a}[data-swiper-slide-index="${r}"]`)[0])),
                                          c(() => {
                                              e.slideTo(n);
                                          }))
                                        : e.slideTo(n);
                            } else e.slideTo(n);
                        },
                    },
                    q = {
                        loopCreate: function (e) {
                            const t = this,
                                { params: i, slidesEl: s } = t;
                            if (!i.loop || (t.virtual && t.params.virtual.enabled)) return;
                            const r = () => {
                                    b(s, `.${i.slideClass}, swiper-slide`).forEach((e, t) => {
                                        e.setAttribute("data-swiper-slide-index", t);
                                    });
                                },
                                n = t.grid && i.grid && i.grid.rows > 1,
                                a = i.slidesPerGroup * (n ? i.grid.rows : 1),
                                o = t.slides.length % a != 0,
                                l = n && t.slides.length % i.grid.rows != 0,
                                d = (e) => {
                                    for (let s = 0; s < e; s += 1) {
                                        const e = t.isElement ? y("swiper-slide", [i.slideBlankClass]) : y("div", [i.slideClass, i.slideBlankClass]);
                                        t.slidesEl.append(e);
                                    }
                                };
                            o
                                ? (i.loopAddBlankSlides
                                      ? (d(a - (t.slides.length % a)), t.recalcSlides(), t.updateSlides())
                                      : w("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"),
                                  r())
                                : l
                                ? (i.loopAddBlankSlides
                                      ? (d(i.grid.rows - (t.slides.length % i.grid.rows)), t.recalcSlides(), t.updateSlides())
                                      : w("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"),
                                  r())
                                : r(),
                                t.loopFix({ slideRealIndex: e, direction: i.centeredSlides ? void 0 : "next" });
                        },
                        loopFix: function (e) {
                            let { slideRealIndex: t, slideTo: i = !0, direction: s, setTranslate: r, activeSlideIndex: n, byController: a, byMousewheel: o } = void 0 === e ? {} : e;
                            const l = this;
                            if (!l.params.loop) return;
                            l.emit("beforeLoopFix");
                            const { slides: d, allowSlidePrev: c, allowSlideNext: u, slidesEl: p, params: h } = l,
                                { centeredSlides: m } = h;
                            if (((l.allowSlidePrev = !0), (l.allowSlideNext = !0), l.virtual && h.virtual.enabled))
                                return (
                                    i &&
                                        (h.centeredSlides || 0 !== l.snapIndex
                                            ? h.centeredSlides && l.snapIndex < h.slidesPerView
                                                ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0)
                                                : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)
                                            : l.slideTo(l.virtual.slides.length, 0, !1, !0)),
                                    (l.allowSlidePrev = c),
                                    (l.allowSlideNext = u),
                                    void l.emit("loopFix")
                                );
                            let v = h.slidesPerView;
                            "auto" === v ? (v = l.slidesPerViewDynamic()) : ((v = Math.ceil(parseFloat(h.slidesPerView, 10))), m && v % 2 == 0 && (v += 1));
                            const g = h.slidesPerGroupAuto ? v : h.slidesPerGroup;
                            let f = g;
                            f % g != 0 && (f += g - (f % g)), (f += h.loopAdditionalSlides), (l.loopedSlides = f);
                            const b = l.grid && h.grid && h.grid.rows > 1;
                            d.length < v + f
                                ? w(
                                      "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"
                                  )
                                : b && "row" === h.grid.fill && w("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
                            const y = [],
                                E = [];
                            let S = l.activeIndex;
                            void 0 === n ? (n = l.getSlideIndex(d.filter((e) => e.classList.contains(h.slideActiveClass))[0])) : (S = n);
                            const x = "next" === s || !s,
                                C = "prev" === s || !s;
                            let T = 0,
                                M = 0;
                            const L = b ? Math.ceil(d.length / h.grid.rows) : d.length,
                                P = (b ? d[n].column : n) + (m && void 0 === r ? -v / 2 + 0.5 : 0);
                            if (P < f) {
                                T = Math.max(f - P, g);
                                for (let e = 0; e < f - P; e += 1) {
                                    const t = e - Math.floor(e / L) * L;
                                    if (b) {
                                        const e = L - t - 1;
                                        for (let t = d.length - 1; t >= 0; t -= 1) d[t].column === e && y.push(t);
                                    } else y.push(L - t - 1);
                                }
                            } else if (P + v > L - f) {
                                M = Math.max(P - (L - 2 * f), g);
                                for (let e = 0; e < M; e += 1) {
                                    const t = e - Math.floor(e / L) * L;
                                    b
                                        ? d.forEach((e, i) => {
                                              e.column === t && E.push(i);
                                          })
                                        : E.push(t);
                                }
                            }
                            if (
                                ((l.__preventObserver__ = !0),
                                requestAnimationFrame(() => {
                                    l.__preventObserver__ = !1;
                                }),
                                C &&
                                    y.forEach((e) => {
                                        (d[e].swiperLoopMoveDOM = !0), p.prepend(d[e]), (d[e].swiperLoopMoveDOM = !1);
                                    }),
                                x &&
                                    E.forEach((e) => {
                                        (d[e].swiperLoopMoveDOM = !0), p.append(d[e]), (d[e].swiperLoopMoveDOM = !1);
                                    }),
                                l.recalcSlides(),
                                "auto" === h.slidesPerView
                                    ? l.updateSlides()
                                    : b &&
                                      ((y.length > 0 && C) || (E.length > 0 && x)) &&
                                      l.slides.forEach((e, t) => {
                                          l.grid.updateSlide(t, e, l.slides);
                                      }),
                                h.watchSlidesProgress && l.updateSlidesOffset(),
                                i)
                            )
                                if (y.length > 0 && C) {
                                    if (void 0 === t) {
                                        const e = l.slidesGrid[S],
                                            t = l.slidesGrid[S + T] - e;
                                        o
                                            ? l.setTranslate(l.translate - t)
                                            : (l.slideTo(S + T, 0, !1, !0), r && ((l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - t), (l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - t)));
                                    } else if (r) {
                                        const e = b ? y.length / h.grid.rows : y.length;
                                        l.slideTo(l.activeIndex + e, 0, !1, !0), (l.touchEventsData.currentTranslate = l.translate);
                                    }
                                } else if (E.length > 0 && x)
                                    if (void 0 === t) {
                                        const e = l.slidesGrid[S],
                                            t = l.slidesGrid[S - M] - e;
                                        o
                                            ? l.setTranslate(l.translate - t)
                                            : (l.slideTo(S - M, 0, !1, !0), r && ((l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - t), (l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - t)));
                                    } else {
                                        const e = b ? E.length / h.grid.rows : E.length;
                                        l.slideTo(l.activeIndex - e, 0, !1, !0);
                                    }
                            if (((l.allowSlidePrev = c), (l.allowSlideNext = u), l.controller && l.controller.control && !a)) {
                                const e = { slideRealIndex: t, direction: s, setTranslate: r, activeSlideIndex: n, byController: !0 };
                                Array.isArray(l.controller.control)
                                    ? l.controller.control.forEach((t) => {
                                          !t.destroyed && t.params.loop && t.loopFix({ ...e, slideTo: t.params.slidesPerView === h.slidesPerView && i });
                                      })
                                    : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({ ...e, slideTo: l.controller.control.params.slidesPerView === h.slidesPerView && i });
                            }
                            l.emit("loopFix");
                        },
                        loopDestroy: function () {
                            const e = this,
                                { params: t, slidesEl: i } = e;
                            if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
                            e.recalcSlides();
                            const s = [];
                            e.slides.forEach((e) => {
                                const t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
                                s[t] = e;
                            }),
                                e.slides.forEach((e) => {
                                    e.removeAttribute("data-swiper-slide-index");
                                }),
                                s.forEach((e) => {
                                    i.append(e);
                                }),
                                e.recalcSlides(),
                                e.slideTo(e.realIndex, 0);
                        },
                    };
                function F(e, t, i) {
                    const s = l(),
                        { params: r } = e,
                        n = r.edgeSwipeDetection,
                        a = r.edgeSwipeThreshold;
                    return !n || !(i <= a || i >= s.innerWidth - a) || ("prevent" === n && (t.preventDefault(), !0));
                }
                function H(e) {
                    const t = this,
                        i = a();
                    let s = e;
                    s.originalEvent && (s = s.originalEvent);
                    const r = t.touchEventsData;
                    if ("pointerdown" === s.type) {
                        if (null !== r.pointerId && r.pointerId !== s.pointerId) return;
                        r.pointerId = s.pointerId;
                    } else "touchstart" === s.type && 1 === s.targetTouches.length && (r.touchId = s.targetTouches[0].identifier);
                    if ("touchstart" === s.type) return void F(t, s, s.targetTouches[0].pageX);
                    const { params: n, touches: o, enabled: d } = t;
                    if (!d) return;
                    if (!n.simulateTouch && "mouse" === s.pointerType) return;
                    if (t.animating && n.preventInteractionOnTransition) return;
                    !t.animating && n.cssMode && n.loop && t.loopFix();
                    let c = s.target;
                    if ("wrapper" === n.touchEventsTarget && !t.wrapperEl.contains(c)) return;
                    if ("which" in s && 3 === s.which) return;
                    if ("button" in s && s.button > 0) return;
                    if (r.isTouched && r.isMoved) return;
                    const p = !!n.noSwipingClass && "" !== n.noSwipingClass,
                        h = s.composedPath ? s.composedPath() : s.path;
                    p && s.target && s.target.shadowRoot && h && (c = h[0]);
                    const m = n.noSwipingSelector ? n.noSwipingSelector : `.${n.noSwipingClass}`,
                        v = !(!s.target || !s.target.shadowRoot);
                    if (
                        n.noSwiping &&
                        (v
                            ? (function (e, t) {
                                  return (
                                      void 0 === t && (t = this),
                                      (function t(i) {
                                          if (!i || i === a() || i === l()) return null;
                                          i.assignedSlot && (i = i.assignedSlot);
                                          const s = i.closest(e);
                                          return s || i.getRootNode ? s || t(i.getRootNode().host) : null;
                                      })(t)
                                  );
                              })(m, c)
                            : c.closest(m))
                    )
                        return void (t.allowClick = !0);
                    if (n.swipeHandler && !c.closest(n.swipeHandler)) return;
                    (o.currentX = s.pageX), (o.currentY = s.pageY);
                    const g = o.currentX,
                        f = o.currentY;
                    if (!F(t, s, g)) return;
                    Object.assign(r, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
                        (o.startX = g),
                        (o.startY = f),
                        (r.touchStartTime = u()),
                        (t.allowClick = !0),
                        t.updateSize(),
                        (t.swipeDirection = void 0),
                        n.threshold > 0 && (r.allowThresholdMove = !1);
                    let b = !0;
                    c.matches(r.focusableElements) && ((b = !1), "SELECT" === c.nodeName && (r.isTouched = !1)), i.activeElement && i.activeElement.matches(r.focusableElements) && i.activeElement !== c && i.activeElement.blur();
                    const w = b && t.allowTouchMove && n.touchStartPreventDefault;
                    (!n.touchStartForcePreventDefault && !w) || c.isContentEditable || s.preventDefault(), n.freeMode && n.freeMode.enabled && t.freeMode && t.animating && !n.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", s);
                }
                function R(e) {
                    const t = a(),
                        i = this,
                        s = i.touchEventsData,
                        { params: r, touches: n, rtlTranslate: o, enabled: l } = i;
                    if (!l) return;
                    if (!r.simulateTouch && "mouse" === e.pointerType) return;
                    let d,
                        c = e;
                    if ((c.originalEvent && (c = c.originalEvent), "pointermove" === c.type)) {
                        if (null !== s.touchId) return;
                        if (c.pointerId !== s.pointerId) return;
                    }
                    if ("touchmove" === c.type) {
                        if (((d = [...c.changedTouches].filter((e) => e.identifier === s.touchId)[0]), !d || d.identifier !== s.touchId)) return;
                    } else d = c;
                    if (!s.isTouched) return void (s.startMoving && s.isScrolling && i.emit("touchMoveOpposite", c));
                    const p = d.pageX,
                        h = d.pageY;
                    if (c.preventedByNestedSwiper) return (n.startX = p), void (n.startY = h);
                    if (!i.allowTouchMove) return c.target.matches(s.focusableElements) || (i.allowClick = !1), void (s.isTouched && (Object.assign(n, { startX: p, startY: h, currentX: p, currentY: h }), (s.touchStartTime = u())));
                    if (r.touchReleaseOnEdges && !r.loop)
                        if (i.isVertical()) {
                            if ((h < n.startY && i.translate <= i.maxTranslate()) || (h > n.startY && i.translate >= i.minTranslate())) return (s.isTouched = !1), void (s.isMoved = !1);
                        } else if ((p < n.startX && i.translate <= i.maxTranslate()) || (p > n.startX && i.translate >= i.minTranslate())) return;
                    if (t.activeElement && c.target === t.activeElement && c.target.matches(s.focusableElements)) return (s.isMoved = !0), void (i.allowClick = !1);
                    s.allowTouchCallbacks && i.emit("touchMove", c), (n.previousX = n.currentX), (n.previousY = n.currentY), (n.currentX = p), (n.currentY = h);
                    const m = n.currentX - n.startX,
                        v = n.currentY - n.startY;
                    if (i.params.threshold && Math.sqrt(m ** 2 + v ** 2) < i.params.threshold) return;
                    if (void 0 === s.isScrolling) {
                        let e;
                        (i.isHorizontal() && n.currentY === n.startY) || (i.isVertical() && n.currentX === n.startX)
                            ? (s.isScrolling = !1)
                            : m * m + v * v >= 25 && ((e = (180 * Math.atan2(Math.abs(v), Math.abs(m))) / Math.PI), (s.isScrolling = i.isHorizontal() ? e > r.touchAngle : 90 - e > r.touchAngle));
                    }
                    if ((s.isScrolling && i.emit("touchMoveOpposite", c), void 0 === s.startMoving && ((n.currentX === n.startX && n.currentY === n.startY) || (s.startMoving = !0)), s.isScrolling)) return void (s.isTouched = !1);
                    if (!s.startMoving) return;
                    (i.allowClick = !1), !r.cssMode && c.cancelable && c.preventDefault(), r.touchMoveStopPropagation && !r.nested && c.stopPropagation();
                    let g = i.isHorizontal() ? m : v,
                        f = i.isHorizontal() ? n.currentX - n.previousX : n.currentY - n.previousY;
                    r.oneWayMovement && ((g = Math.abs(g) * (o ? 1 : -1)), (f = Math.abs(f) * (o ? 1 : -1))), (n.diff = g), (g *= r.touchRatio), o && ((g = -g), (f = -f));
                    const b = i.touchesDirection;
                    (i.swipeDirection = g > 0 ? "prev" : "next"), (i.touchesDirection = f > 0 ? "prev" : "next");
                    const w = i.params.loop && !r.cssMode,
                        y = ("next" === i.touchesDirection && i.allowSlideNext) || ("prev" === i.touchesDirection && i.allowSlidePrev);
                    if (!s.isMoved) {
                        if ((w && y && i.loopFix({ direction: i.swipeDirection }), (s.startTranslate = i.getTranslate()), i.setTransition(0), i.animating)) {
                            const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                            i.wrapperEl.dispatchEvent(e);
                        }
                        (s.allowMomentumBounce = !1), !r.grabCursor || (!0 !== i.allowSlideNext && !0 !== i.allowSlidePrev) || i.setGrabCursor(!0), i.emit("sliderFirstMove", c);
                    }
                    if ((new Date().getTime(), s.isMoved && s.allowThresholdMove && b !== i.touchesDirection && w && y && Math.abs(g) >= 1))
                        return Object.assign(n, { startX: p, startY: h, currentX: p, currentY: h, startTranslate: s.currentTranslate }), (s.loopSwapReset = !0), void (s.startTranslate = s.currentTranslate);
                    i.emit("sliderMove", c), (s.isMoved = !0), (s.currentTranslate = g + s.startTranslate);
                    let E = !0,
                        S = r.resistanceRatio;
                    if (
                        (r.touchReleaseOnEdges && (S = 0),
                        g > 0
                            ? (w &&
                                  y &&
                                  s.allowThresholdMove &&
                                  s.currentTranslate > (r.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] : i.minTranslate()) &&
                                  i.loopFix({ direction: "prev", setTranslate: !0, activeSlideIndex: 0 }),
                              s.currentTranslate > i.minTranslate() && ((E = !1), r.resistance && (s.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + s.startTranslate + g) ** S)))
                            : g < 0 &&
                              (w &&
                                  y &&
                                  s.allowThresholdMove &&
                                  s.currentTranslate < (r.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] : i.maxTranslate()) &&
                                  i.loopFix({ direction: "next", setTranslate: !0, activeSlideIndex: i.slides.length - ("auto" === r.slidesPerView ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10))) }),
                              s.currentTranslate < i.maxTranslate() && ((E = !1), r.resistance && (s.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - s.startTranslate - g) ** S))),
                        E && (c.preventedByNestedSwiper = !0),
                        !i.allowSlideNext && "next" === i.swipeDirection && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate),
                        !i.allowSlidePrev && "prev" === i.swipeDirection && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate),
                        i.allowSlidePrev || i.allowSlideNext || (s.currentTranslate = s.startTranslate),
                        r.threshold > 0)
                    ) {
                        if (!(Math.abs(g) > r.threshold || s.allowThresholdMove)) return void (s.currentTranslate = s.startTranslate);
                        if (!s.allowThresholdMove)
                            return (s.allowThresholdMove = !0), (n.startX = n.currentX), (n.startY = n.currentY), (s.currentTranslate = s.startTranslate), void (n.diff = i.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY);
                    }
                    r.followFinger &&
                        !r.cssMode &&
                        (((r.freeMode && r.freeMode.enabled && i.freeMode) || r.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()),
                        r.freeMode && r.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(),
                        i.updateProgress(s.currentTranslate),
                        i.setTranslate(s.currentTranslate));
                }
                function j(e) {
                    const t = this,
                        i = t.touchEventsData;
                    let s,
                        r = e;
                    if ((r.originalEvent && (r = r.originalEvent), "touchend" === r.type || "touchcancel" === r.type)) {
                        if (((s = [...r.changedTouches].filter((e) => e.identifier === i.touchId)[0]), !s || s.identifier !== i.touchId)) return;
                    } else {
                        if (null !== i.touchId) return;
                        if (r.pointerId !== i.pointerId) return;
                        s = r;
                    }
                    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(r.type) && (!["pointercancel", "contextmenu"].includes(r.type) || (!t.browser.isSafari && !t.browser.isWebView))) return;
                    (i.pointerId = null), (i.touchId = null);
                    const { params: n, touches: a, rtlTranslate: o, slidesGrid: l, enabled: d } = t;
                    if (!d) return;
                    if (!n.simulateTouch && "mouse" === r.pointerType) return;
                    if ((i.allowTouchCallbacks && t.emit("touchEnd", r), (i.allowTouchCallbacks = !1), !i.isTouched)) return i.isMoved && n.grabCursor && t.setGrabCursor(!1), (i.isMoved = !1), void (i.startMoving = !1);
                    n.grabCursor && i.isMoved && i.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
                    const p = u(),
                        h = p - i.touchStartTime;
                    if (t.allowClick) {
                        const e = r.path || (r.composedPath && r.composedPath());
                        t.updateClickedSlide((e && e[0]) || r.target, e), t.emit("tap click", r), h < 300 && p - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", r);
                    }
                    if (
                        ((i.lastClickTime = u()),
                        c(() => {
                            t.destroyed || (t.allowClick = !0);
                        }),
                        !i.isTouched || !i.isMoved || !t.swipeDirection || (0 === a.diff && !i.loopSwapReset) || (i.currentTranslate === i.startTranslate && !i.loopSwapReset))
                    )
                        return (i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1);
                    let m;
                    if (((i.isTouched = !1), (i.isMoved = !1), (i.startMoving = !1), (m = n.followFinger ? (o ? t.translate : -t.translate) : -i.currentTranslate), n.cssMode)) return;
                    if (n.freeMode && n.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: m });
                    const v = m >= -t.maxTranslate() && !t.params.loop;
                    let g = 0,
                        f = t.slidesSizesGrid[0];
                    for (let e = 0; e < l.length; e += e < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup) {
                        const t = e < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
                        void 0 !== l[e + t] ? (v || (m >= l[e] && m < l[e + t])) && ((g = e), (f = l[e + t] - l[e])) : (v || m >= l[e]) && ((g = e), (f = l[l.length - 1] - l[l.length - 2]));
                    }
                    let b = null,
                        w = null;
                    n.rewind && (t.isBeginning ? (w = n.virtual && n.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1) : t.isEnd && (b = 0));
                    const y = (m - l[g]) / f,
                        E = g < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
                    if (h > n.longSwipesMs) {
                        if (!n.longSwipes) return void t.slideTo(t.activeIndex);
                        "next" === t.swipeDirection && (y >= n.longSwipesRatio ? t.slideTo(n.rewind && t.isEnd ? b : g + E) : t.slideTo(g)),
                            "prev" === t.swipeDirection && (y > 1 - n.longSwipesRatio ? t.slideTo(g + E) : null !== w && y < 0 && Math.abs(y) > n.longSwipesRatio ? t.slideTo(w) : t.slideTo(g));
                    } else {
                        if (!n.shortSwipes) return void t.slideTo(t.activeIndex);
                        !t.navigation || (r.target !== t.navigation.nextEl && r.target !== t.navigation.prevEl)
                            ? ("next" === t.swipeDirection && t.slideTo(null !== b ? b : g + E), "prev" === t.swipeDirection && t.slideTo(null !== w ? w : g))
                            : r.target === t.navigation.nextEl
                            ? t.slideTo(g + E)
                            : t.slideTo(g);
                    }
                }
                function N() {
                    const e = this,
                        { params: t, el: i } = e;
                    if (i && 0 === i.offsetWidth) return;
                    t.breakpoints && e.setBreakpoint();
                    const { allowSlideNext: s, allowSlidePrev: r, snapGrid: n } = e,
                        a = e.virtual && e.params.virtual.enabled;
                    (e.allowSlideNext = !0), (e.allowSlidePrev = !0), e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
                    const o = a && t.loop;
                    !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || o
                        ? e.params.loop && !a
                            ? e.slideToLoop(e.realIndex, 0, !1, !0)
                            : e.slideTo(e.activeIndex, 0, !1, !0)
                        : e.slideTo(e.slides.length - 1, 0, !1, !0),
                        e.autoplay &&
                            e.autoplay.running &&
                            e.autoplay.paused &&
                            (clearTimeout(e.autoplay.resizeTimeout),
                            (e.autoplay.resizeTimeout = setTimeout(() => {
                                e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
                            }, 500))),
                        (e.allowSlidePrev = r),
                        (e.allowSlideNext = s),
                        e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow();
                }
                function V(e) {
                    const t = this;
                    t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
                }
                function G() {
                    const e = this,
                        { wrapperEl: t, rtlTranslate: i, enabled: s } = e;
                    if (!s) return;
                    let r;
                    (e.previousTranslate = e.translate), e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop), 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
                    const n = e.maxTranslate() - e.minTranslate();
                    (r = 0 === n ? 0 : (e.translate - e.minTranslate()) / n), r !== e.progress && e.updateProgress(i ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
                }
                function W(e) {
                    const t = this;
                    O(t, e.target), t.params.cssMode || ("auto" !== t.params.slidesPerView && !t.params.autoHeight) || t.update();
                }
                function Y() {
                    const e = this;
                    e.documentTouchHandlerProceeded || ((e.documentTouchHandlerProceeded = !0), e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
                }
                const U = (e, t) => {
                        const i = a(),
                            { params: s, el: r, wrapperEl: n, device: o } = e,
                            l = !!s.nested,
                            d = "on" === t ? "addEventListener" : "removeEventListener",
                            c = t;
                        i[d]("touchstart", e.onDocumentTouchStart, { passive: !1, capture: l }),
                            r[d]("touchstart", e.onTouchStart, { passive: !1 }),
                            r[d]("pointerdown", e.onTouchStart, { passive: !1 }),
                            i[d]("touchmove", e.onTouchMove, { passive: !1, capture: l }),
                            i[d]("pointermove", e.onTouchMove, { passive: !1, capture: l }),
                            i[d]("touchend", e.onTouchEnd, { passive: !0 }),
                            i[d]("pointerup", e.onTouchEnd, { passive: !0 }),
                            i[d]("pointercancel", e.onTouchEnd, { passive: !0 }),
                            i[d]("touchcancel", e.onTouchEnd, { passive: !0 }),
                            i[d]("pointerout", e.onTouchEnd, { passive: !0 }),
                            i[d]("pointerleave", e.onTouchEnd, { passive: !0 }),
                            i[d]("contextmenu", e.onTouchEnd, { passive: !0 }),
                            (s.preventClicks || s.preventClicksPropagation) && r[d]("click", e.onClick, !0),
                            s.cssMode && n[d]("scroll", e.onScroll),
                            s.updateOnWindowResize ? e[c](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", N, !0) : e[c]("observerUpdate", N, !0),
                            r[d]("load", e.onLoad, { capture: !0 });
                    },
                    X = (e, t) => e.grid && t.grid && t.grid.rows > 1;
                var K = {
                    init: !0,
                    direction: "horizontal",
                    oneWayMovement: !1,
                    touchEventsTarget: "wrapper",
                    initialSlide: 0,
                    speed: 300,
                    cssMode: !1,
                    updateOnWindowResize: !0,
                    resizeObserver: !0,
                    nested: !1,
                    createElements: !1,
                    eventsPrefix: "swiper",
                    enabled: !0,
                    focusableElements: "input, select, option, textarea, button, video, label",
                    width: null,
                    height: null,
                    preventInteractionOnTransition: !1,
                    userAgent: null,
                    url: null,
                    edgeSwipeDetection: !1,
                    edgeSwipeThreshold: 20,
                    autoHeight: !1,
                    setWrapperSize: !1,
                    virtualTranslate: !1,
                    effect: "slide",
                    breakpoints: void 0,
                    breakpointsBase: "window",
                    spaceBetween: 0,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    slidesPerGroupSkip: 0,
                    slidesPerGroupAuto: !1,
                    centeredSlides: !1,
                    centeredSlidesBounds: !1,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    normalizeSlideIndex: !0,
                    centerInsufficientSlides: !1,
                    watchOverflow: !0,
                    roundLengths: !1,
                    touchRatio: 1,
                    touchAngle: 45,
                    simulateTouch: !0,
                    shortSwipes: !0,
                    longSwipes: !0,
                    longSwipesRatio: 0.5,
                    longSwipesMs: 300,
                    followFinger: !0,
                    allowTouchMove: !0,
                    threshold: 5,
                    touchMoveStopPropagation: !1,
                    touchStartPreventDefault: !0,
                    touchStartForcePreventDefault: !1,
                    touchReleaseOnEdges: !1,
                    uniqueNavElements: !0,
                    resistance: !0,
                    resistanceRatio: 0.85,
                    watchSlidesProgress: !1,
                    grabCursor: !1,
                    preventClicks: !0,
                    preventClicksPropagation: !0,
                    slideToClickedSlide: !1,
                    loop: !1,
                    loopAddBlankSlides: !0,
                    loopAdditionalSlides: 0,
                    loopPreventsSliding: !0,
                    rewind: !1,
                    allowSlidePrev: !0,
                    allowSlideNext: !0,
                    swipeHandler: null,
                    noSwiping: !0,
                    noSwipingClass: "swiper-no-swiping",
                    noSwipingSelector: null,
                    passiveListeners: !0,
                    maxBackfaceHiddenSlides: 10,
                    containerModifierClass: "swiper-",
                    slideClass: "swiper-slide",
                    slideBlankClass: "swiper-slide-blank",
                    slideActiveClass: "swiper-slide-active",
                    slideVisibleClass: "swiper-slide-visible",
                    slideFullyVisibleClass: "swiper-slide-fully-visible",
                    slideNextClass: "swiper-slide-next",
                    slidePrevClass: "swiper-slide-prev",
                    wrapperClass: "swiper-wrapper",
                    lazyPreloaderClass: "swiper-lazy-preloader",
                    lazyPreloadPrevNext: 0,
                    runCallbacksOnInit: !0,
                    _emitClasses: !1,
                };
                function Q(e, t) {
                    return function (i) {
                        void 0 === i && (i = {});
                        const s = Object.keys(i)[0],
                            r = i[s];
                        "object" == typeof r && null !== r
                            ? (!0 === e[s] && (e[s] = { enabled: !0 }),
                              "navigation" === s && e[s] && e[s].enabled && !e[s].prevEl && !e[s].nextEl && (e[s].auto = !0),
                              ["pagination", "scrollbar"].indexOf(s) >= 0 && e[s] && e[s].enabled && !e[s].el && (e[s].auto = !0),
                              s in e && "enabled" in r ? ("object" != typeof e[s] || "enabled" in e[s] || (e[s].enabled = !0), e[s] || (e[s] = { enabled: !1 }), m(t, i)) : m(t, i))
                            : m(t, i);
                    };
                }
                const Z = {
                        eventsEmitter: I,
                        update: _,
                        translate: {
                            getTranslate: function (e) {
                                void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                                const { params: t, rtlTranslate: i, translate: s, wrapperEl: r } = this;
                                if (t.virtualTranslate) return i ? -s : s;
                                if (t.cssMode) return s;
                                let n = p(r, e);
                                return (n += this.cssOverflowAdjustment()), i && (n = -n), n || 0;
                            },
                            setTranslate: function (e, t) {
                                const i = this,
                                    { rtlTranslate: s, params: r, wrapperEl: n, progress: a } = i;
                                let o,
                                    l = 0,
                                    d = 0;
                                i.isHorizontal() ? (l = s ? -e : e) : (d = e),
                                    r.roundLengths && ((l = Math.floor(l)), (d = Math.floor(d))),
                                    (i.previousTranslate = i.translate),
                                    (i.translate = i.isHorizontal() ? l : d),
                                    r.cssMode
                                        ? (n[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -l : -d)
                                        : r.virtualTranslate || (i.isHorizontal() ? (l -= i.cssOverflowAdjustment()) : (d -= i.cssOverflowAdjustment()), (n.style.transform = `translate3d(${l}px, ${d}px, 0px)`));
                                const c = i.maxTranslate() - i.minTranslate();
                                (o = 0 === c ? 0 : (e - i.minTranslate()) / c), o !== a && i.updateProgress(e), i.emit("setTranslate", i.translate, t);
                            },
                            minTranslate: function () {
                                return -this.snapGrid[0];
                            },
                            maxTranslate: function () {
                                return -this.snapGrid[this.snapGrid.length - 1];
                            },
                            translateTo: function (e, t, i, s, r) {
                                void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), void 0 === s && (s = !0);
                                const n = this,
                                    { params: a, wrapperEl: o } = n;
                                if (n.animating && a.preventInteractionOnTransition) return !1;
                                const l = n.minTranslate(),
                                    d = n.maxTranslate();
                                let c;
                                if (((c = s && e > l ? l : s && e < d ? d : e), n.updateProgress(c), a.cssMode)) {
                                    const e = n.isHorizontal();
                                    if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -c;
                                    else {
                                        if (!n.support.smoothScroll) return g({ swiper: n, targetPosition: -c, side: e ? "left" : "top" }), !0;
                                        o.scrollTo({ [e ? "left" : "top"]: -c, behavior: "smooth" });
                                    }
                                    return !0;
                                }
                                return (
                                    0 === t
                                        ? (n.setTransition(0), n.setTranslate(c), i && (n.emit("beforeTransitionStart", t, r), n.emit("transitionEnd")))
                                        : (n.setTransition(t),
                                          n.setTranslate(c),
                                          i && (n.emit("beforeTransitionStart", t, r), n.emit("transitionStart")),
                                          n.animating ||
                                              ((n.animating = !0),
                                              n.onTranslateToWrapperTransitionEnd ||
                                                  (n.onTranslateToWrapperTransitionEnd = function (e) {
                                                      n &&
                                                          !n.destroyed &&
                                                          e.target === this &&
                                                          (n.wrapperEl.removeEventListener("transitionend", n.onTranslateToWrapperTransitionEnd),
                                                          (n.onTranslateToWrapperTransitionEnd = null),
                                                          delete n.onTranslateToWrapperTransitionEnd,
                                                          i && n.emit("transitionEnd"));
                                                  }),
                                              n.wrapperEl.addEventListener("transitionend", n.onTranslateToWrapperTransitionEnd))),
                                    !0
                                );
                            },
                        },
                        transition: {
                            setTransition: function (e, t) {
                                const i = this;
                                i.params.cssMode || ((i.wrapperEl.style.transitionDuration = `${e}ms`), (i.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : "")), i.emit("setTransition", e, t);
                            },
                            transitionStart: function (e, t) {
                                void 0 === e && (e = !0);
                                const i = this,
                                    { params: s } = i;
                                s.cssMode || (s.autoHeight && i.updateAutoHeight(), $({ swiper: i, runCallbacks: e, direction: t, step: "Start" }));
                            },
                            transitionEnd: function (e, t) {
                                void 0 === e && (e = !0);
                                const i = this,
                                    { params: s } = i;
                                (i.animating = !1), s.cssMode || (i.setTransition(0), $({ swiper: i, runCallbacks: e, direction: t, step: "End" }));
                            },
                        },
                        slide: B,
                        loop: q,
                        grabCursor: {
                            setGrabCursor: function (e) {
                                const t = this;
                                if (!t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return;
                                const i = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                                t.isElement && (t.__preventObserver__ = !0),
                                    (i.style.cursor = "move"),
                                    (i.style.cursor = e ? "grabbing" : "grab"),
                                    t.isElement &&
                                        requestAnimationFrame(() => {
                                            t.__preventObserver__ = !1;
                                        });
                            },
                            unsetGrabCursor: function () {
                                const e = this;
                                (e.params.watchOverflow && e.isLocked) ||
                                    e.params.cssMode ||
                                    (e.isElement && (e.__preventObserver__ = !0),
                                    (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = ""),
                                    e.isElement &&
                                        requestAnimationFrame(() => {
                                            e.__preventObserver__ = !1;
                                        }));
                            },
                        },
                        events: {
                            attachEvents: function () {
                                const e = this,
                                    { params: t } = e;
                                (e.onTouchStart = H.bind(e)),
                                    (e.onTouchMove = R.bind(e)),
                                    (e.onTouchEnd = j.bind(e)),
                                    (e.onDocumentTouchStart = Y.bind(e)),
                                    t.cssMode && (e.onScroll = G.bind(e)),
                                    (e.onClick = V.bind(e)),
                                    (e.onLoad = W.bind(e)),
                                    U(e, "on");
                            },
                            detachEvents: function () {
                                U(this, "off");
                            },
                        },
                        breakpoints: {
                            setBreakpoint: function () {
                                const e = this,
                                    { realIndex: t, initialized: i, params: s, el: r } = e,
                                    n = s.breakpoints;
                                if (!n || (n && 0 === Object.keys(n).length)) return;
                                const a = e.getBreakpoint(n, e.params.breakpointsBase, e.el);
                                if (!a || e.currentBreakpoint === a) return;
                                const o = (a in n ? n[a] : void 0) || e.originalParams,
                                    l = X(e, s),
                                    d = X(e, o),
                                    c = s.enabled;
                                l && !d
                                    ? (r.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), e.emitContainerClasses())
                                    : !l &&
                                      d &&
                                      (r.classList.add(`${s.containerModifierClass}grid`),
                                      ((o.grid.fill && "column" === o.grid.fill) || (!o.grid.fill && "column" === s.grid.fill)) && r.classList.add(`${s.containerModifierClass}grid-column`),
                                      e.emitContainerClasses()),
                                    ["navigation", "pagination", "scrollbar"].forEach((t) => {
                                        if (void 0 === o[t]) return;
                                        const i = s[t] && s[t].enabled,
                                            r = o[t] && o[t].enabled;
                                        i && !r && e[t].disable(), !i && r && e[t].enable();
                                    });
                                const u = o.direction && o.direction !== s.direction,
                                    p = s.loop && (o.slidesPerView !== s.slidesPerView || u),
                                    h = s.loop;
                                u && i && e.changeDirection(), m(e.params, o);
                                const v = e.params.enabled,
                                    g = e.params.loop;
                                Object.assign(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }),
                                    c && !v ? e.disable() : !c && v && e.enable(),
                                    (e.currentBreakpoint = a),
                                    e.emit("_beforeBreakpoint", o),
                                    i && (p ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !h && g ? (e.loopCreate(t), e.updateSlides()) : h && !g && e.loopDestroy()),
                                    e.emit("breakpoint", o);
                            },
                            getBreakpoint: function (e, t, i) {
                                if ((void 0 === t && (t = "window"), !e || ("container" === t && !i))) return;
                                let s = !1;
                                const r = l(),
                                    n = "window" === t ? r.innerHeight : i.clientHeight,
                                    a = Object.keys(e).map((e) => {
                                        if ("string" == typeof e && 0 === e.indexOf("@")) {
                                            const t = parseFloat(e.substr(1));
                                            return { value: n * t, point: e };
                                        }
                                        return { value: e, point: e };
                                    });
                                a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                                for (let e = 0; e < a.length; e += 1) {
                                    const { point: n, value: o } = a[e];
                                    "window" === t ? r.matchMedia(`(min-width: ${o}px)`).matches && (s = n) : o <= i.clientWidth && (s = n);
                                }
                                return s || "max";
                            },
                        },
                        checkOverflow: {
                            checkOverflow: function () {
                                const e = this,
                                    { isLocked: t, params: i } = e,
                                    { slidesOffsetBefore: s } = i;
                                if (s) {
                                    const t = e.slides.length - 1,
                                        i = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * s;
                                    e.isLocked = e.size > i;
                                } else e.isLocked = 1 === e.snapGrid.length;
                                !0 === i.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                                    !0 === i.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                                    t && t !== e.isLocked && (e.isEnd = !1),
                                    t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
                            },
                        },
                        classes: {
                            addClasses: function () {
                                const e = this,
                                    { classNames: t, params: i, rtl: s, el: r, device: n } = e,
                                    a = (function (e, t) {
                                        const i = [];
                                        return (
                                            e.forEach((e) => {
                                                "object" == typeof e
                                                    ? Object.keys(e).forEach((s) => {
                                                          e[s] && i.push(t + s);
                                                      })
                                                    : "string" == typeof e && i.push(t + e);
                                            }),
                                            i
                                        );
                                    })(
                                        [
                                            "initialized",
                                            i.direction,
                                            { "free-mode": e.params.freeMode && i.freeMode.enabled },
                                            { autoheight: i.autoHeight },
                                            { rtl: s },
                                            { grid: i.grid && i.grid.rows > 1 },
                                            { "grid-column": i.grid && i.grid.rows > 1 && "column" === i.grid.fill },
                                            { android: n.android },
                                            { ios: n.ios },
                                            { "css-mode": i.cssMode },
                                            { centered: i.cssMode && i.centeredSlides },
                                            { "watch-progress": i.watchSlidesProgress },
                                        ],
                                        i.containerModifierClass
                                    );
                                t.push(...a), r.classList.add(...t), e.emitContainerClasses();
                            },
                            removeClasses: function () {
                                const { el: e, classNames: t } = this;
                                e.classList.remove(...t), this.emitContainerClasses();
                            },
                        },
                    },
                    J = {};
                class ee {
                    constructor() {
                        let e, t;
                        for (var i = arguments.length, s = new Array(i), r = 0; r < i; r++) s[r] = arguments[r];
                        1 === s.length && s[0].constructor && "Object" === Object.prototype.toString.call(s[0]).slice(8, -1) ? (t = s[0]) : ([e, t] = s), t || (t = {}), (t = m({}, t)), e && !t.el && (t.el = e);
                        const n = a();
                        if (t.el && "string" == typeof t.el && n.querySelectorAll(t.el).length > 1) {
                            const e = [];
                            return (
                                n.querySelectorAll(t.el).forEach((i) => {
                                    const s = m({}, t, { el: i });
                                    e.push(new ee(s));
                                }),
                                e
                            );
                        }
                        const o = this;
                        var d;
                        (o.__swiper__ = !0),
                            (o.support = k()),
                            (o.device =
                                (void 0 === (d = { userAgent: t.userAgent }) && (d = {}),
                                P ||
                                    (P = (function (e) {
                                        let { userAgent: t } = void 0 === e ? {} : e;
                                        const i = k(),
                                            s = l(),
                                            r = s.navigator.platform,
                                            n = t || s.navigator.userAgent,
                                            a = { ios: !1, android: !1 },
                                            o = s.screen.width,
                                            d = s.screen.height,
                                            c = n.match(/(Android);?[\s\/]+([\d.]+)?/);
                                        let u = n.match(/(iPad).*OS\s([\d_]+)/);
                                        const p = n.match(/(iPod)(.*OS\s([\d_]+))?/),
                                            h = !u && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                                            m = "Win32" === r;
                                        let v = "MacIntel" === r;
                                        return (
                                            !u &&
                                                v &&
                                                i.touch &&
                                                ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${o}x${d}`) >= 0 &&
                                                ((u = n.match(/(Version)\/([\d.]+)/)), u || (u = [0, 1, "13_0_0"]), (v = !1)),
                                            c && !m && ((a.os = "android"), (a.android = !0)),
                                            (u || h || p) && ((a.os = "ios"), (a.ios = !0)),
                                            a
                                        );
                                    })(d)),
                                P)),
                            (o.browser =
                                (A ||
                                    (A = (function () {
                                        const e = l();
                                        let t = !1;
                                        function i() {
                                            const t = e.navigator.userAgent.toLowerCase();
                                            return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
                                        }
                                        if (i()) {
                                            const i = String(e.navigator.userAgent);
                                            if (i.includes("Version/")) {
                                                const [e, s] = i
                                                    .split("Version/")[1]
                                                    .split(" ")[0]
                                                    .split(".")
                                                    .map((e) => Number(e));
                                                t = e < 16 || (16 === e && s < 2);
                                            }
                                        }
                                        return { isSafari: t || i(), needPerspectiveFix: t, isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent) };
                                    })()),
                                A)),
                            (o.eventsListeners = {}),
                            (o.eventsAnyListeners = []),
                            (o.modules = [...o.__modules__]),
                            t.modules && Array.isArray(t.modules) && o.modules.push(...t.modules);
                        const c = {};
                        o.modules.forEach((e) => {
                            e({ params: t, swiper: o, extendParams: Q(t, c), on: o.on.bind(o), once: o.once.bind(o), off: o.off.bind(o), emit: o.emit.bind(o) });
                        });
                        const u = m({}, K, c);
                        return (
                            (o.params = m({}, u, J, t)),
                            (o.originalParams = m({}, o.params)),
                            (o.passedParams = m({}, t)),
                            o.params &&
                                o.params.on &&
                                Object.keys(o.params.on).forEach((e) => {
                                    o.on(e, o.params.on[e]);
                                }),
                            o.params && o.params.onAny && o.onAny(o.params.onAny),
                            Object.assign(o, {
                                enabled: o.params.enabled,
                                el: e,
                                classNames: [],
                                slides: [],
                                slidesGrid: [],
                                snapGrid: [],
                                slidesSizesGrid: [],
                                isHorizontal: () => "horizontal" === o.params.direction,
                                isVertical: () => "vertical" === o.params.direction,
                                activeIndex: 0,
                                realIndex: 0,
                                isBeginning: !0,
                                isEnd: !1,
                                translate: 0,
                                previousTranslate: 0,
                                progress: 0,
                                velocity: 0,
                                animating: !1,
                                cssOverflowAdjustment() {
                                    return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
                                },
                                allowSlideNext: o.params.allowSlideNext,
                                allowSlidePrev: o.params.allowSlidePrev,
                                touchEventsData: {
                                    isTouched: void 0,
                                    isMoved: void 0,
                                    allowTouchCallbacks: void 0,
                                    touchStartTime: void 0,
                                    isScrolling: void 0,
                                    currentTranslate: void 0,
                                    startTranslate: void 0,
                                    allowThresholdMove: void 0,
                                    focusableElements: o.params.focusableElements,
                                    lastClickTime: 0,
                                    clickTimeout: void 0,
                                    velocities: [],
                                    allowMomentumBounce: void 0,
                                    startMoving: void 0,
                                    pointerId: null,
                                    touchId: null,
                                },
                                allowClick: !0,
                                allowTouchMove: o.params.allowTouchMove,
                                touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                                imagesToLoad: [],
                                imagesLoaded: 0,
                            }),
                            o.emit("_swiper"),
                            o.params.init && o.init(),
                            o
                        );
                    }
                    getDirectionLabel(e) {
                        return this.isHorizontal()
                            ? e
                            : {
                                  width: "height",
                                  "margin-top": "margin-left",
                                  "margin-bottom ": "margin-right",
                                  "margin-left": "margin-top",
                                  "margin-right": "margin-bottom",
                                  "padding-left": "padding-top",
                                  "padding-right": "padding-bottom",
                                  marginRight: "marginBottom",
                              }[e];
                    }
                    getSlideIndex(e) {
                        const { slidesEl: t, params: i } = this,
                            s = x(b(t, `.${i.slideClass}, swiper-slide`)[0]);
                        return x(e) - s;
                    }
                    getSlideIndexByData(e) {
                        return this.getSlideIndex(this.slides.filter((t) => 1 * t.getAttribute("data-swiper-slide-index") === e)[0]);
                    }
                    recalcSlides() {
                        const { slidesEl: e, params: t } = this;
                        this.slides = b(e, `.${t.slideClass}, swiper-slide`);
                    }
                    enable() {
                        const e = this;
                        e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
                    }
                    disable() {
                        const e = this;
                        e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
                    }
                    setProgress(e, t) {
                        const i = this;
                        e = Math.min(Math.max(e, 0), 1);
                        const s = i.minTranslate(),
                            r = (i.maxTranslate() - s) * e + s;
                        i.translateTo(r, void 0 === t ? 0 : t), i.updateActiveIndex(), i.updateSlidesClasses();
                    }
                    emitContainerClasses() {
                        const e = this;
                        if (!e.params._emitClasses || !e.el) return;
                        const t = e.el.className.split(" ").filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
                        e.emit("_containerClasses", t.join(" "));
                    }
                    getSlideClasses(e) {
                        const t = this;
                        return t.destroyed
                            ? ""
                            : e.className
                                  .split(" ")
                                  .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
                                  .join(" ");
                    }
                    emitSlidesClasses() {
                        const e = this;
                        if (!e.params._emitClasses || !e.el) return;
                        const t = [];
                        e.slides.forEach((i) => {
                            const s = e.getSlideClasses(i);
                            t.push({ slideEl: i, classNames: s }), e.emit("_slideClass", i, s);
                        }),
                            e.emit("_slideClasses", t);
                    }
                    slidesPerViewDynamic(e, t) {
                        void 0 === e && (e = "current"), void 0 === t && (t = !1);
                        const { params: i, slides: s, slidesGrid: r, slidesSizesGrid: n, size: a, activeIndex: o } = this;
                        let l = 1;
                        if ("number" == typeof i.slidesPerView) return i.slidesPerView;
                        if (i.centeredSlides) {
                            let e,
                                t = s[o] ? s[o].swiperSlideSize : 0;
                            for (let i = o + 1; i < s.length; i += 1) s[i] && !e && ((t += s[i].swiperSlideSize), (l += 1), t > a && (e = !0));
                            for (let i = o - 1; i >= 0; i -= 1) s[i] && !e && ((t += s[i].swiperSlideSize), (l += 1), t > a && (e = !0));
                        } else if ("current" === e) for (let e = o + 1; e < s.length; e += 1) (t ? r[e] + n[e] - r[o] < a : r[e] - r[o] < a) && (l += 1);
                        else for (let e = o - 1; e >= 0; e -= 1) r[o] - r[e] < a && (l += 1);
                        return l;
                    }
                    update() {
                        const e = this;
                        if (!e || e.destroyed) return;
                        const { snapGrid: t, params: i } = e;
                        function s() {
                            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                                i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                            e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
                        }
                        let r;
                        if (
                            (i.breakpoints && e.setBreakpoint(),
                            [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
                                t.complete && O(e, t);
                            }),
                            e.updateSize(),
                            e.updateSlides(),
                            e.updateProgress(),
                            e.updateSlidesClasses(),
                            i.freeMode && i.freeMode.enabled && !i.cssMode)
                        )
                            s(), i.autoHeight && e.updateAutoHeight();
                        else {
                            if (("auto" === i.slidesPerView || i.slidesPerView > 1) && e.isEnd && !i.centeredSlides) {
                                const t = e.virtual && i.virtual.enabled ? e.virtual.slides : e.slides;
                                r = e.slideTo(t.length - 1, 0, !1, !0);
                            } else r = e.slideTo(e.activeIndex, 0, !1, !0);
                            r || s();
                        }
                        i.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
                    }
                    changeDirection(e, t) {
                        void 0 === t && (t = !0);
                        const i = this,
                            s = i.params.direction;
                        return (
                            e || (e = "horizontal" === s ? "vertical" : "horizontal"),
                            e === s ||
                                ("horizontal" !== e && "vertical" !== e) ||
                                (i.el.classList.remove(`${i.params.containerModifierClass}${s}`),
                                i.el.classList.add(`${i.params.containerModifierClass}${e}`),
                                i.emitContainerClasses(),
                                (i.params.direction = e),
                                i.slides.forEach((t) => {
                                    "vertical" === e ? (t.style.width = "") : (t.style.height = "");
                                }),
                                i.emit("changeDirection"),
                                t && i.update()),
                            i
                        );
                    }
                    changeLanguageDirection(e) {
                        const t = this;
                        (t.rtl && "rtl" === e) ||
                            (!t.rtl && "ltr" === e) ||
                            ((t.rtl = "rtl" === e),
                            (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
                            t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), (t.el.dir = "rtl")) : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), (t.el.dir = "ltr")),
                            t.update());
                    }
                    mount(e) {
                        const t = this;
                        if (t.mounted) return !0;
                        let i = e || t.params.el;
                        if (("string" == typeof i && (i = document.querySelector(i)), !i)) return !1;
                        (i.swiper = t), i.parentNode && i.parentNode.host && "SWIPER-CONTAINER" === i.parentNode.host.nodeName && (t.isElement = !0);
                        const s = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
                        let r = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(s()) : b(i, s())[0];
                        return (
                            !r &&
                                t.params.createElements &&
                                ((r = y("div", t.params.wrapperClass)),
                                i.append(r),
                                b(i, `.${t.params.slideClass}`).forEach((e) => {
                                    r.append(e);
                                })),
                            Object.assign(t, {
                                el: i,
                                wrapperEl: r,
                                slidesEl: t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : r,
                                hostEl: t.isElement ? i.parentNode.host : i,
                                mounted: !0,
                                rtl: "rtl" === i.dir.toLowerCase() || "rtl" === S(i, "direction"),
                                rtlTranslate: "horizontal" === t.params.direction && ("rtl" === i.dir.toLowerCase() || "rtl" === S(i, "direction")),
                                wrongRTL: "-webkit-box" === S(r, "display"),
                            }),
                            !0
                        );
                    }
                    init(e) {
                        const t = this;
                        if (t.initialized) return t;
                        if (!1 === t.mount(e)) return t;
                        t.emit("beforeInit"),
                            t.params.breakpoints && t.setBreakpoint(),
                            t.addClasses(),
                            t.updateSize(),
                            t.updateSlides(),
                            t.params.watchOverflow && t.checkOverflow(),
                            t.params.grabCursor && t.enabled && t.setGrabCursor(),
                            t.params.loop && t.virtual && t.params.virtual.enabled
                                ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0)
                                : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                            t.params.loop && t.loopCreate(),
                            t.attachEvents();
                        const i = [...t.el.querySelectorAll('[loading="lazy"]')];
                        return (
                            t.isElement && i.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
                            i.forEach((e) => {
                                e.complete
                                    ? O(t, e)
                                    : e.addEventListener("load", (e) => {
                                          O(t, e.target);
                                      });
                            }),
                            z(t),
                            (t.initialized = !0),
                            z(t),
                            t.emit("init"),
                            t.emit("afterInit"),
                            t
                        );
                    }
                    destroy(e, t) {
                        void 0 === e && (e = !0), void 0 === t && (t = !0);
                        const i = this,
                            { params: s, el: r, wrapperEl: n, slides: a } = i;
                        return (
                            void 0 === i.params ||
                                i.destroyed ||
                                (i.emit("beforeDestroy"),
                                (i.initialized = !1),
                                i.detachEvents(),
                                s.loop && i.loopDestroy(),
                                t &&
                                    (i.removeClasses(),
                                    r.removeAttribute("style"),
                                    n.removeAttribute("style"),
                                    a &&
                                        a.length &&
                                        a.forEach((e) => {
                                            e.classList.remove(s.slideVisibleClass, s.slideFullyVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
                                        })),
                                i.emit("destroy"),
                                Object.keys(i.eventsListeners).forEach((e) => {
                                    i.off(e);
                                }),
                                !1 !== e &&
                                    ((i.el.swiper = null),
                                    (function (e) {
                                        const t = e;
                                        Object.keys(t).forEach((e) => {
                                            try {
                                                t[e] = null;
                                            } catch (e) {}
                                            try {
                                                delete t[e];
                                            } catch (e) {}
                                        });
                                    })(i)),
                                (i.destroyed = !0)),
                            null
                        );
                    }
                    static extendDefaults(e) {
                        m(J, e);
                    }
                    static get extendedDefaults() {
                        return J;
                    }
                    static get defaults() {
                        return K;
                    }
                    static installModule(e) {
                        ee.prototype.__modules__ || (ee.prototype.__modules__ = []);
                        const t = ee.prototype.__modules__;
                        "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
                    }
                    static use(e) {
                        return Array.isArray(e) ? (e.forEach((e) => ee.installModule(e)), ee) : (ee.installModule(e), ee);
                    }
                }
                function te(e, t, i, s) {
                    return (
                        e.params.createElements &&
                            Object.keys(s).forEach((r) => {
                                if (!i[r] && !0 === i.auto) {
                                    let n = b(e.el, `.${s[r]}`)[0];
                                    n || ((n = y("div", s[r])), (n.className = s[r]), e.el.append(n)), (i[r] = n), (t[r] = n);
                                }
                            }),
                        i
                    );
                }
                function ie(e) {
                    return (
                        void 0 === e && (e = ""),
                        `.${e
                            .trim()
                            .replace(/([\.:!+\/])/g, "\\$1")
                            .replace(/ /g, ".")}`
                    );
                }
                function se(e) {
                    const t = this,
                        { params: i, slidesEl: s } = t;
                    i.loop && t.loopDestroy();
                    const r = (e) => {
                        if ("string" == typeof e) {
                            const t = document.createElement("div");
                            (t.innerHTML = e), s.append(t.children[0]), (t.innerHTML = "");
                        } else s.append(e);
                    };
                    if ("object" == typeof e && "length" in e) for (let t = 0; t < e.length; t += 1) e[t] && r(e[t]);
                    else r(e);
                    t.recalcSlides(), i.loop && t.loopCreate(), (i.observer && !t.isElement) || t.update();
                }
                function re(e) {
                    const t = this,
                        { params: i, activeIndex: s, slidesEl: r } = t;
                    i.loop && t.loopDestroy();
                    let n = s + 1;
                    const a = (e) => {
                        if ("string" == typeof e) {
                            const t = document.createElement("div");
                            (t.innerHTML = e), r.prepend(t.children[0]), (t.innerHTML = "");
                        } else r.prepend(e);
                    };
                    if ("object" == typeof e && "length" in e) {
                        for (let t = 0; t < e.length; t += 1) e[t] && a(e[t]);
                        n = s + e.length;
                    } else a(e);
                    t.recalcSlides(), i.loop && t.loopCreate(), (i.observer && !t.isElement) || t.update(), t.slideTo(n, 0, !1);
                }
                function ne(e, t) {
                    const i = this,
                        { params: s, activeIndex: r, slidesEl: n } = i;
                    let a = r;
                    s.loop && ((a -= i.loopedSlides), i.loopDestroy(), i.recalcSlides());
                    const o = i.slides.length;
                    if (e <= 0) return void i.prependSlide(t);
                    if (e >= o) return void i.appendSlide(t);
                    let l = a > e ? a + 1 : a;
                    const d = [];
                    for (let t = o - 1; t >= e; t -= 1) {
                        const e = i.slides[t];
                        e.remove(), d.unshift(e);
                    }
                    if ("object" == typeof t && "length" in t) {
                        for (let e = 0; e < t.length; e += 1) t[e] && n.append(t[e]);
                        l = a > e ? a + t.length : a;
                    } else n.append(t);
                    for (let e = 0; e < d.length; e += 1) n.append(d[e]);
                    i.recalcSlides(), s.loop && i.loopCreate(), (s.observer && !i.isElement) || i.update(), s.loop ? i.slideTo(l + i.loopedSlides, 0, !1) : i.slideTo(l, 0, !1);
                }
                function ae(e) {
                    const t = this,
                        { params: i, activeIndex: s } = t;
                    let r = s;
                    i.loop && ((r -= t.loopedSlides), t.loopDestroy());
                    let n,
                        a = r;
                    if ("object" == typeof e && "length" in e) {
                        for (let i = 0; i < e.length; i += 1) (n = e[i]), t.slides[n] && t.slides[n].remove(), n < a && (a -= 1);
                        a = Math.max(a, 0);
                    } else (n = e), t.slides[n] && t.slides[n].remove(), n < a && (a -= 1), (a = Math.max(a, 0));
                    t.recalcSlides(), i.loop && t.loopCreate(), (i.observer && !t.isElement) || t.update(), i.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1);
                }
                function oe() {
                    const e = this,
                        t = [];
                    for (let i = 0; i < e.slides.length; i += 1) t.push(i);
                    e.removeSlide(t);
                }
                function le(e) {
                    const { effect: t, swiper: i, on: s, setTranslate: r, setTransition: n, overwriteParams: a, perspective: o, recreateShadows: l, getEffectParams: d } = e;
                    let c;
                    s("beforeInit", () => {
                        if (i.params.effect !== t) return;
                        i.classNames.push(`${i.params.containerModifierClass}${t}`), o && o() && i.classNames.push(`${i.params.containerModifierClass}3d`);
                        const e = a ? a() : {};
                        Object.assign(i.params, e), Object.assign(i.originalParams, e);
                    }),
                        s("setTranslate", () => {
                            i.params.effect === t && r();
                        }),
                        s("setTransition", (e, s) => {
                            i.params.effect === t && n(s);
                        }),
                        s("transitionEnd", () => {
                            if (i.params.effect === t && l) {
                                if (!d || !d().slideShadows) return;
                                i.slides.forEach((e) => {
                                    e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e) => e.remove());
                                }),
                                    l();
                            }
                        }),
                        s("virtualUpdate", () => {
                            i.params.effect === t &&
                                (i.slides.length || (c = !0),
                                requestAnimationFrame(() => {
                                    c && i.slides && i.slides.length && (r(), (c = !1));
                                }));
                        });
                }
                function de(e, t) {
                    const i = f(t);
                    return i !== t && ((i.style.backfaceVisibility = "hidden"), (i.style["-webkit-backface-visibility"] = "hidden")), i;
                }
                function ce(e) {
                    let { swiper: t, duration: i, transformElements: s, allSlides: r } = e;
                    const { activeIndex: n } = t;
                    if (t.params.virtualTranslate && 0 !== i) {
                        let e,
                            i = !1;
                        (e = r
                            ? s
                            : s.filter((e) => {
                                  const i = e.classList.contains("swiper-slide-transform") ? ((e) => (e.parentElement ? e.parentElement : t.slides.filter((t) => t.shadowRoot && t.shadowRoot === e.parentNode)[0]))(e) : e;
                                  return t.getSlideIndex(i) === n;
                              })),
                            e.forEach((e) => {
                                T(e, () => {
                                    if (i) return;
                                    if (!t || t.destroyed) return;
                                    (i = !0), (t.animating = !1);
                                    const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                                    t.wrapperEl.dispatchEvent(e);
                                });
                            });
                    }
                }
                function ue(e, t, i) {
                    const s = `swiper-slide-shadow${i ? `-${i}` : ""}${e ? ` swiper-slide-shadow-${e}` : ""}`,
                        r = f(t);
                    let n = r.querySelector(`.${s.split(" ").join(".")}`);
                    return n || ((n = y("div", s.split(" "))), r.append(n)), n;
                }
                Object.keys(Z).forEach((e) => {
                    Object.keys(Z[e]).forEach((t) => {
                        ee.prototype[t] = Z[e][t];
                    });
                }),
                    ee.use([
                        function (e) {
                            let { swiper: t, on: i, emit: s } = e;
                            const r = l();
                            let n = null,
                                a = null;
                            const o = () => {
                                    t && !t.destroyed && t.initialized && (s("beforeResize"), s("resize"));
                                },
                                d = () => {
                                    t && !t.destroyed && t.initialized && s("orientationchange");
                                };
                            i("init", () => {
                                t.params.resizeObserver && void 0 !== r.ResizeObserver
                                    ? t &&
                                      !t.destroyed &&
                                      t.initialized &&
                                      ((n = new ResizeObserver((e) => {
                                          a = r.requestAnimationFrame(() => {
                                              const { width: i, height: s } = t;
                                              let r = i,
                                                  n = s;
                                              e.forEach((e) => {
                                                  let { contentBoxSize: i, contentRect: s, target: a } = e;
                                                  (a && a !== t.el) || ((r = s ? s.width : (i[0] || i).inlineSize), (n = s ? s.height : (i[0] || i).blockSize));
                                              }),
                                                  (r === i && n === s) || o();
                                          });
                                      })),
                                      n.observe(t.el))
                                    : (r.addEventListener("resize", o), r.addEventListener("orientationchange", d));
                            }),
                                i("destroy", () => {
                                    a && r.cancelAnimationFrame(a), n && n.unobserve && t.el && (n.unobserve(t.el), (n = null)), r.removeEventListener("resize", o), r.removeEventListener("orientationchange", d);
                                });
                        },
                        function (e) {
                            let { swiper: t, extendParams: i, on: s, emit: r } = e;
                            const n = [],
                                a = l(),
                                o = function (e, i) {
                                    void 0 === i && (i = {});
                                    const s = new (a.MutationObserver || a.WebkitMutationObserver)((e) => {
                                        if (t.__preventObserver__) return;
                                        if (1 === e.length) return void r("observerUpdate", e[0]);
                                        const i = function () {
                                            r("observerUpdate", e[0]);
                                        };
                                        a.requestAnimationFrame ? a.requestAnimationFrame(i) : a.setTimeout(i, 0);
                                    });
                                    s.observe(e, { attributes: void 0 === i.attributes || i.attributes, childList: void 0 === i.childList || i.childList, characterData: void 0 === i.characterData || i.characterData }), n.push(s);
                                };
                            i({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
                                s("init", () => {
                                    if (t.params.observer) {
                                        if (t.params.observeParents) {
                                            const e = C(t.hostEl);
                                            for (let t = 0; t < e.length; t += 1) o(e[t]);
                                        }
                                        o(t.hostEl, { childList: t.params.observeSlideChildren }), o(t.wrapperEl, { attributes: !1 });
                                    }
                                }),
                                s("destroy", () => {
                                    n.forEach((e) => {
                                        e.disconnect();
                                    }),
                                        n.splice(0, n.length);
                                });
                        },
                    ]);
                const pe = [
                    function (e) {
                        let t,
                            { swiper: i, extendParams: s, on: r, emit: n } = e;
                        s({ virtual: { enabled: !1, slides: [], cache: !0, renderSlide: null, renderExternal: null, renderExternalUpdate: !0, addSlidesBefore: 0, addSlidesAfter: 0 } });
                        const o = a();
                        i.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
                        const l = o.createElement("div");
                        function d(e, t) {
                            const s = i.params.virtual;
                            if (s.cache && i.virtual.cache[t]) return i.virtual.cache[t];
                            let r;
                            return (
                                s.renderSlide ? ((r = s.renderSlide.call(i, e, t)), "string" == typeof r && ((l.innerHTML = r), (r = l.children[0]))) : (r = i.isElement ? y("swiper-slide") : y("div", i.params.slideClass)),
                                r.setAttribute("data-swiper-slide-index", t),
                                s.renderSlide || (r.innerHTML = e),
                                s.cache && (i.virtual.cache[t] = r),
                                r
                            );
                        }
                        function c(e) {
                            const { slidesPerView: t, slidesPerGroup: s, centeredSlides: r, loop: a } = i.params,
                                { addSlidesBefore: o, addSlidesAfter: l } = i.params.virtual,
                                { from: c, to: u, slides: p, slidesGrid: h, offset: m } = i.virtual;
                            i.params.cssMode || i.updateActiveIndex();
                            const v = i.activeIndex || 0;
                            let g, f, w;
                            (g = i.rtlTranslate ? "right" : i.isHorizontal() ? "left" : "top"), r ? ((f = Math.floor(t / 2) + s + l), (w = Math.floor(t / 2) + s + o)) : ((f = t + (s - 1) + l), (w = (a ? t : s) + o));
                            let y = v - w,
                                E = v + f;
                            a || ((y = Math.max(y, 0)), (E = Math.min(E, p.length - 1)));
                            let S = (i.slidesGrid[y] || 0) - (i.slidesGrid[0] || 0);
                            function x() {
                                i.updateSlides(), i.updateProgress(), i.updateSlidesClasses(), n("virtualUpdate");
                            }
                            if (
                                (a && v >= w ? ((y -= w), r || (S += i.slidesGrid[0])) : a && v < w && ((y = -w), r && (S += i.slidesGrid[0])),
                                Object.assign(i.virtual, { from: y, to: E, offset: S, slidesGrid: i.slidesGrid, slidesBefore: w, slidesAfter: f }),
                                c === y && u === E && !e)
                            )
                                return (
                                    i.slidesGrid !== h &&
                                        S !== m &&
                                        i.slides.forEach((e) => {
                                            e.style[g] = S - Math.abs(i.cssOverflowAdjustment()) + "px";
                                        }),
                                    i.updateProgress(),
                                    void n("virtualUpdate")
                                );
                            if (i.params.virtual.renderExternal)
                                return (
                                    i.params.virtual.renderExternal.call(i, {
                                        offset: S,
                                        from: y,
                                        to: E,
                                        slides: (function () {
                                            const e = [];
                                            for (let t = y; t <= E; t += 1) e.push(p[t]);
                                            return e;
                                        })(),
                                    }),
                                    void (i.params.virtual.renderExternalUpdate ? x() : n("virtualUpdate"))
                                );
                            const C = [],
                                T = [],
                                M = (e) => {
                                    let t = e;
                                    return e < 0 ? (t = p.length + e) : t >= p.length && (t -= p.length), t;
                                };
                            if (e)
                                i.slides
                                    .filter((e) => e.matches(`.${i.params.slideClass}, swiper-slide`))
                                    .forEach((e) => {
                                        e.remove();
                                    });
                            else
                                for (let e = c; e <= u; e += 1)
                                    if (e < y || e > E) {
                                        const t = M(e);
                                        i.slides
                                            .filter((e) => e.matches(`.${i.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`))
                                            .forEach((e) => {
                                                e.remove();
                                            });
                                    }
                            const L = a ? -p.length : 0,
                                P = a ? 2 * p.length : p.length;
                            for (let t = L; t < P; t += 1)
                                if (t >= y && t <= E) {
                                    const i = M(t);
                                    void 0 === u || e ? T.push(i) : (t > u && T.push(i), t < c && C.push(i));
                                }
                            if (
                                (T.forEach((e) => {
                                    i.slidesEl.append(d(p[e], e));
                                }),
                                a)
                            )
                                for (let e = C.length - 1; e >= 0; e -= 1) {
                                    const t = C[e];
                                    i.slidesEl.prepend(d(p[t], t));
                                }
                            else
                                C.sort((e, t) => t - e),
                                    C.forEach((e) => {
                                        i.slidesEl.prepend(d(p[e], e));
                                    });
                            b(i.slidesEl, ".swiper-slide, swiper-slide").forEach((e) => {
                                e.style[g] = S - Math.abs(i.cssOverflowAdjustment()) + "px";
                            }),
                                x();
                        }
                        r("beforeInit", () => {
                            if (!i.params.virtual.enabled) return;
                            let e;
                            if (void 0 === i.passedParams.virtual.slides) {
                                const t = [...i.slidesEl.children].filter((e) => e.matches(`.${i.params.slideClass}, swiper-slide`));
                                t &&
                                    t.length &&
                                    ((i.virtual.slides = [...t]),
                                    (e = !0),
                                    t.forEach((e, t) => {
                                        e.setAttribute("data-swiper-slide-index", t), (i.virtual.cache[t] = e), e.remove();
                                    }));
                            }
                            e || (i.virtual.slides = i.params.virtual.slides), i.classNames.push(`${i.params.containerModifierClass}virtual`), (i.params.watchSlidesProgress = !0), (i.originalParams.watchSlidesProgress = !0), c();
                        }),
                            r("setTranslate", () => {
                                i.params.virtual.enabled &&
                                    (i.params.cssMode && !i._immediateVirtual
                                        ? (clearTimeout(t),
                                          (t = setTimeout(() => {
                                              c();
                                          }, 100)))
                                        : c());
                            }),
                            r("init update resize", () => {
                                i.params.virtual.enabled && i.params.cssMode && v(i.wrapperEl, "--swiper-virtual-size", `${i.virtualSize}px`);
                            }),
                            Object.assign(i.virtual, {
                                appendSlide: function (e) {
                                    if ("object" == typeof e && "length" in e) for (let t = 0; t < e.length; t += 1) e[t] && i.virtual.slides.push(e[t]);
                                    else i.virtual.slides.push(e);
                                    c(!0);
                                },
                                prependSlide: function (e) {
                                    const t = i.activeIndex;
                                    let s = t + 1,
                                        r = 1;
                                    if (Array.isArray(e)) {
                                        for (let t = 0; t < e.length; t += 1) e[t] && i.virtual.slides.unshift(e[t]);
                                        (s = t + e.length), (r = e.length);
                                    } else i.virtual.slides.unshift(e);
                                    if (i.params.virtual.cache) {
                                        const e = i.virtual.cache,
                                            t = {};
                                        Object.keys(e).forEach((i) => {
                                            const s = e[i],
                                                n = s.getAttribute("data-swiper-slide-index");
                                            n && s.setAttribute("data-swiper-slide-index", parseInt(n, 10) + r), (t[parseInt(i, 10) + r] = s);
                                        }),
                                            (i.virtual.cache = t);
                                    }
                                    c(!0), i.slideTo(s, 0);
                                },
                                removeSlide: function (e) {
                                    if (null == e) return;
                                    let t = i.activeIndex;
                                    if (Array.isArray(e))
                                        for (let s = e.length - 1; s >= 0; s -= 1)
                                            i.params.virtual.cache &&
                                                (delete i.virtual.cache[e[s]],
                                                Object.keys(i.virtual.cache).forEach((t) => {
                                                    t > e && ((i.virtual.cache[t - 1] = i.virtual.cache[t]), i.virtual.cache[t - 1].setAttribute("data-swiper-slide-index", t - 1), delete i.virtual.cache[t]);
                                                })),
                                                i.virtual.slides.splice(e[s], 1),
                                                e[s] < t && (t -= 1),
                                                (t = Math.max(t, 0));
                                    else
                                        i.params.virtual.cache &&
                                            (delete i.virtual.cache[e],
                                            Object.keys(i.virtual.cache).forEach((t) => {
                                                t > e && ((i.virtual.cache[t - 1] = i.virtual.cache[t]), i.virtual.cache[t - 1].setAttribute("data-swiper-slide-index", t - 1), delete i.virtual.cache[t]);
                                            })),
                                            i.virtual.slides.splice(e, 1),
                                            e < t && (t -= 1),
                                            (t = Math.max(t, 0));
                                    c(!0), i.slideTo(t, 0);
                                },
                                removeAllSlides: function () {
                                    (i.virtual.slides = []), i.params.virtual.cache && (i.virtual.cache = {}), c(!0), i.slideTo(0, 0);
                                },
                                update: c,
                            });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s, emit: r } = e;
                        const n = a(),
                            o = l();
                        function d(e) {
                            if (!t.enabled) return;
                            const { rtlTranslate: i } = t;
                            let s = e;
                            s.originalEvent && (s = s.originalEvent);
                            const a = s.keyCode || s.charCode,
                                l = t.params.keyboard.pageUpDown,
                                d = l && 33 === a,
                                c = l && 34 === a,
                                u = 37 === a,
                                p = 39 === a,
                                h = 38 === a,
                                m = 40 === a;
                            if (!t.allowSlideNext && ((t.isHorizontal() && p) || (t.isVertical() && m) || c)) return !1;
                            if (!t.allowSlidePrev && ((t.isHorizontal() && u) || (t.isVertical() && h) || d)) return !1;
                            if (
                                !(
                                    s.shiftKey ||
                                    s.altKey ||
                                    s.ctrlKey ||
                                    s.metaKey ||
                                    (n.activeElement && n.activeElement.nodeName && ("input" === n.activeElement.nodeName.toLowerCase() || "textarea" === n.activeElement.nodeName.toLowerCase()))
                                )
                            ) {
                                if (t.params.keyboard.onlyInViewport && (d || c || u || p || h || m)) {
                                    let e = !1;
                                    if (C(t.el, `.${t.params.slideClass}, swiper-slide`).length > 0 && 0 === C(t.el, `.${t.params.slideActiveClass}`).length) return;
                                    const s = t.el,
                                        r = s.clientWidth,
                                        n = s.clientHeight,
                                        a = o.innerWidth,
                                        l = o.innerHeight,
                                        d = E(s);
                                    i && (d.left -= s.scrollLeft);
                                    const c = [
                                        [d.left, d.top],
                                        [d.left + r, d.top],
                                        [d.left, d.top + n],
                                        [d.left + r, d.top + n],
                                    ];
                                    for (let t = 0; t < c.length; t += 1) {
                                        const i = c[t];
                                        if (i[0] >= 0 && i[0] <= a && i[1] >= 0 && i[1] <= l) {
                                            if (0 === i[0] && 0 === i[1]) continue;
                                            e = !0;
                                        }
                                    }
                                    if (!e) return;
                                }
                                t.isHorizontal()
                                    ? ((d || c || u || p) && (s.preventDefault ? s.preventDefault() : (s.returnValue = !1)), (((c || p) && !i) || ((d || u) && i)) && t.slideNext(), (((d || u) && !i) || ((c || p) && i)) && t.slidePrev())
                                    : ((d || c || h || m) && (s.preventDefault ? s.preventDefault() : (s.returnValue = !1)), (c || m) && t.slideNext(), (d || h) && t.slidePrev()),
                                    r("keyPress", a);
                            }
                        }
                        function c() {
                            t.keyboard.enabled || (n.addEventListener("keydown", d), (t.keyboard.enabled = !0));
                        }
                        function u() {
                            t.keyboard.enabled && (n.removeEventListener("keydown", d), (t.keyboard.enabled = !1));
                        }
                        (t.keyboard = { enabled: !1 }),
                            i({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
                            s("init", () => {
                                t.params.keyboard.enabled && c();
                            }),
                            s("destroy", () => {
                                t.keyboard.enabled && u();
                            }),
                            Object.assign(t.keyboard, { enable: c, disable: u });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s, emit: r } = e;
                        const n = l();
                        let a;
                        i({ mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null, noMousewheelClass: "swiper-no-mousewheel" } }),
                            (t.mousewheel = { enabled: !1 });
                        let o,
                            d = u();
                        const p = [];
                        function h() {
                            t.enabled && (t.mouseEntered = !0);
                        }
                        function m() {
                            t.enabled && (t.mouseEntered = !1);
                        }
                        function v(e) {
                            return !(
                                (t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) ||
                                (t.params.mousewheel.thresholdTime && u() - d < t.params.mousewheel.thresholdTime) ||
                                (!(e.delta >= 6 && u() - d < 60) &&
                                    (e.direction < 0 ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), r("scroll", e.raw)) : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), r("scroll", e.raw)),
                                    (d = new n.Date().getTime()),
                                    1))
                            );
                        }
                        function g(e) {
                            let i = e,
                                s = !0;
                            if (!t.enabled) return;
                            if (e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`)) return;
                            const n = t.params.mousewheel;
                            t.params.cssMode && i.preventDefault();
                            let l = t.el;
                            "container" !== t.params.mousewheel.eventsTarget && (l = document.querySelector(t.params.mousewheel.eventsTarget));
                            const d = l && l.contains(i.target);
                            if (!t.mouseEntered && !d && !n.releaseOnEdges) return !0;
                            i.originalEvent && (i = i.originalEvent);
                            let h = 0;
                            const m = t.rtlTranslate ? -1 : 1,
                                g = (function (e) {
                                    let t = 0,
                                        i = 0,
                                        s = 0,
                                        r = 0;
                                    return (
                                        "detail" in e && (i = e.detail),
                                        "wheelDelta" in e && (i = -e.wheelDelta / 120),
                                        "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120),
                                        "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                                        "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = i), (i = 0)),
                                        (s = 10 * t),
                                        (r = 10 * i),
                                        "deltaY" in e && (r = e.deltaY),
                                        "deltaX" in e && (s = e.deltaX),
                                        e.shiftKey && !s && ((s = r), (r = 0)),
                                        (s || r) && e.deltaMode && (1 === e.deltaMode ? ((s *= 40), (r *= 40)) : ((s *= 800), (r *= 800))),
                                        s && !t && (t = s < 1 ? -1 : 1),
                                        r && !i && (i = r < 1 ? -1 : 1),
                                        { spinX: t, spinY: i, pixelX: s, pixelY: r }
                                    );
                                })(i);
                            if (n.forceToAxis)
                                if (t.isHorizontal()) {
                                    if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0;
                                    h = -g.pixelX * m;
                                } else {
                                    if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0;
                                    h = -g.pixelY;
                                }
                            else h = Math.abs(g.pixelX) > Math.abs(g.pixelY) ? -g.pixelX * m : -g.pixelY;
                            if (0 === h) return !0;
                            n.invert && (h = -h);
                            let f = t.getTranslate() + h * n.sensitivity;
                            if (
                                (f >= t.minTranslate() && (f = t.minTranslate()),
                                f <= t.maxTranslate() && (f = t.maxTranslate()),
                                (s = !!t.params.loop || !(f === t.minTranslate() || f === t.maxTranslate())),
                                s && t.params.nested && i.stopPropagation(),
                                t.params.freeMode && t.params.freeMode.enabled)
                            ) {
                                const e = { time: u(), delta: Math.abs(h), direction: Math.sign(h) },
                                    s = o && e.time < o.time + 500 && e.delta <= o.delta && e.direction === o.direction;
                                if (!s) {
                                    o = void 0;
                                    let l = t.getTranslate() + h * n.sensitivity;
                                    const d = t.isBeginning,
                                        u = t.isEnd;
                                    if (
                                        (l >= t.minTranslate() && (l = t.minTranslate()),
                                        l <= t.maxTranslate() && (l = t.maxTranslate()),
                                        t.setTransition(0),
                                        t.setTranslate(l),
                                        t.updateProgress(),
                                        t.updateActiveIndex(),
                                        t.updateSlidesClasses(),
                                        ((!d && t.isBeginning) || (!u && t.isEnd)) && t.updateSlidesClasses(),
                                        t.params.loop && t.loopFix({ direction: e.direction < 0 ? "next" : "prev", byMousewheel: !0 }),
                                        t.params.freeMode.sticky)
                                    ) {
                                        clearTimeout(a), (a = void 0), p.length >= 15 && p.shift();
                                        const i = p.length ? p[p.length - 1] : void 0,
                                            s = p[0];
                                        if ((p.push(e), i && (e.delta > i.delta || e.direction !== i.direction))) p.splice(0);
                                        else if (p.length >= 15 && e.time - s.time < 500 && s.delta - e.delta >= 1 && e.delta <= 6) {
                                            const i = h > 0 ? 0.8 : 0.2;
                                            (o = e),
                                                p.splice(0),
                                                (a = c(() => {
                                                    t.slideToClosest(t.params.speed, !0, void 0, i);
                                                }, 0));
                                        }
                                        a ||
                                            (a = c(() => {
                                                (o = e), p.splice(0), t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                                            }, 500));
                                    }
                                    if ((s || r("scroll", i), t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(), n.releaseOnEdges && (l === t.minTranslate() || l === t.maxTranslate()))) return !0;
                                }
                            } else {
                                const i = { time: u(), delta: Math.abs(h), direction: Math.sign(h), raw: e };
                                p.length >= 2 && p.shift();
                                const s = p.length ? p[p.length - 1] : void 0;
                                if (
                                    (p.push(i),
                                    s ? (i.direction !== s.direction || i.delta > s.delta || i.time > s.time + 150) && v(i) : v(i),
                                    (function (e) {
                                        const i = t.params.mousewheel;
                                        if (e.direction < 0) {
                                            if (t.isEnd && !t.params.loop && i.releaseOnEdges) return !0;
                                        } else if (t.isBeginning && !t.params.loop && i.releaseOnEdges) return !0;
                                        return !1;
                                    })(i))
                                )
                                    return !0;
                            }
                            return i.preventDefault ? i.preventDefault() : (i.returnValue = !1), !1;
                        }
                        function f(e) {
                            let i = t.el;
                            "container" !== t.params.mousewheel.eventsTarget && (i = document.querySelector(t.params.mousewheel.eventsTarget)), i[e]("mouseenter", h), i[e]("mouseleave", m), i[e]("wheel", g);
                        }
                        function b() {
                            return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", g), !0) : !t.mousewheel.enabled && (f("addEventListener"), (t.mousewheel.enabled = !0), !0);
                        }
                        function w() {
                            return t.params.cssMode ? (t.wrapperEl.addEventListener(event, g), !0) : !!t.mousewheel.enabled && (f("removeEventListener"), (t.mousewheel.enabled = !1), !0);
                        }
                        s("init", () => {
                            !t.params.mousewheel.enabled && t.params.cssMode && w(), t.params.mousewheel.enabled && b();
                        }),
                            s("destroy", () => {
                                t.params.cssMode && b(), t.mousewheel.enabled && w();
                            }),
                            Object.assign(t.mousewheel, { enable: b, disable: w });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s, emit: r } = e;
                        i({
                            navigation: {
                                nextEl: null,
                                prevEl: null,
                                hideOnClick: !1,
                                disabledClass: "swiper-button-disabled",
                                hiddenClass: "swiper-button-hidden",
                                lockClass: "swiper-button-lock",
                                navigationDisabledClass: "swiper-navigation-disabled",
                            },
                        }),
                            (t.navigation = { nextEl: null, prevEl: null });
                        const n = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e);
                        function a(e) {
                            let i;
                            return e && "string" == typeof e && t.isElement && ((i = t.el.querySelector(e)), i)
                                ? i
                                : (e &&
                                      ("string" == typeof e && (i = [...document.querySelectorAll(e)]),
                                      t.params.uniqueNavElements && "string" == typeof e && i.length > 1 && 1 === t.el.querySelectorAll(e).length && (i = t.el.querySelector(e))),
                                  e && !i ? e : i);
                        }
                        function o(e, i) {
                            const s = t.params.navigation;
                            (e = n(e)).forEach((e) => {
                                e &&
                                    (e.classList[i ? "add" : "remove"](...s.disabledClass.split(" ")),
                                    "BUTTON" === e.tagName && (e.disabled = i),
                                    t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](s.lockClass));
                            });
                        }
                        function l() {
                            const { nextEl: e, prevEl: i } = t.navigation;
                            if (t.params.loop) return o(i, !1), void o(e, !1);
                            o(i, t.isBeginning && !t.params.rewind), o(e, t.isEnd && !t.params.rewind);
                        }
                        function d(e) {
                            e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), r("navigationPrev"));
                        }
                        function c(e) {
                            e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), r("navigationNext"));
                        }
                        function u() {
                            const e = t.params.navigation;
                            if (((t.params.navigation = te(t, t.originalParams.navigation, t.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" })), !e.nextEl && !e.prevEl)) return;
                            let i = a(e.nextEl),
                                s = a(e.prevEl);
                            Object.assign(t.navigation, { nextEl: i, prevEl: s }), (i = n(i)), (s = n(s));
                            const r = (i, s) => {
                                i && i.addEventListener("click", "next" === s ? c : d), !t.enabled && i && i.classList.add(...e.lockClass.split(" "));
                            };
                            i.forEach((e) => r(e, "next")), s.forEach((e) => r(e, "prev"));
                        }
                        function p() {
                            let { nextEl: e, prevEl: i } = t.navigation;
                            (e = n(e)), (i = n(i));
                            const s = (e, i) => {
                                e.removeEventListener("click", "next" === i ? c : d), e.classList.remove(...t.params.navigation.disabledClass.split(" "));
                            };
                            e.forEach((e) => s(e, "next")), i.forEach((e) => s(e, "prev"));
                        }
                        s("init", () => {
                            !1 === t.params.navigation.enabled ? h() : (u(), l());
                        }),
                            s("toEdge fromEdge lock unlock", () => {
                                l();
                            }),
                            s("destroy", () => {
                                p();
                            }),
                            s("enable disable", () => {
                                let { nextEl: e, prevEl: i } = t.navigation;
                                (e = n(e)), (i = n(i)), t.enabled ? l() : [...e, ...i].filter((e) => !!e).forEach((e) => e.classList.add(t.params.navigation.lockClass));
                            }),
                            s("click", (e, i) => {
                                let { nextEl: s, prevEl: a } = t.navigation;
                                (s = n(s)), (a = n(a));
                                const o = i.target;
                                if (t.params.navigation.hideOnClick && !a.includes(o) && !s.includes(o)) {
                                    if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === o || t.pagination.el.contains(o))) return;
                                    let e;
                                    s.length ? (e = s[0].classList.contains(t.params.navigation.hiddenClass)) : a.length && (e = a[0].classList.contains(t.params.navigation.hiddenClass)),
                                        r(!0 === e ? "navigationShow" : "navigationHide"),
                                        [...s, ...a].filter((e) => !!e).forEach((e) => e.classList.toggle(t.params.navigation.hiddenClass));
                                }
                            });
                        const h = () => {
                            t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), p();
                        };
                        Object.assign(t.navigation, {
                            enable: () => {
                                t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), u(), l();
                            },
                            disable: h,
                            update: l,
                            init: u,
                            destroy: p,
                        });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s, emit: r } = e;
                        const n = "swiper-pagination";
                        let a;
                        i({
                            pagination: {
                                el: null,
                                bulletElement: "span",
                                clickable: !1,
                                hideOnClick: !1,
                                renderBullet: null,
                                renderProgressbar: null,
                                renderFraction: null,
                                renderCustom: null,
                                progressbarOpposite: !1,
                                type: "bullets",
                                dynamicBullets: !1,
                                dynamicMainBullets: 1,
                                formatFractionCurrent: (e) => e,
                                formatFractionTotal: (e) => e,
                                bulletClass: `${n}-bullet`,
                                bulletActiveClass: `${n}-bullet-active`,
                                modifierClass: `${n}-`,
                                currentClass: `${n}-current`,
                                totalClass: `${n}-total`,
                                hiddenClass: `${n}-hidden`,
                                progressbarFillClass: `${n}-progressbar-fill`,
                                progressbarOppositeClass: `${n}-progressbar-opposite`,
                                clickableClass: `${n}-clickable`,
                                lockClass: `${n}-lock`,
                                horizontalClass: `${n}-horizontal`,
                                verticalClass: `${n}-vertical`,
                                paginationDisabledClass: `${n}-disabled`,
                            },
                        }),
                            (t.pagination = { el: null, bullets: [] });
                        let o = 0;
                        const l = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e);
                        function d() {
                            return !t.params.pagination.el || !t.pagination.el || (Array.isArray(t.pagination.el) && 0 === t.pagination.el.length);
                        }
                        function c(e, i) {
                            const { bulletActiveClass: s } = t.params.pagination;
                            e && (e = e[("prev" === i ? "previous" : "next") + "ElementSibling"]) && (e.classList.add(`${s}-${i}`), (e = e[("prev" === i ? "previous" : "next") + "ElementSibling"]) && e.classList.add(`${s}-${i}-${i}`));
                        }
                        function u(e) {
                            const i = e.target.closest(ie(t.params.pagination.bulletClass));
                            if (!i) return;
                            e.preventDefault();
                            const s = x(i) * t.params.slidesPerGroup;
                            if (t.params.loop) {
                                if (t.realIndex === s) return;
                                t.slideToLoop(s);
                            } else t.slideTo(s);
                        }
                        function p() {
                            const e = t.rtl,
                                i = t.params.pagination;
                            if (d()) return;
                            let s,
                                n,
                                u = t.pagination.el;
                            u = l(u);
                            const p = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                                h = t.params.loop ? Math.ceil(p / t.params.slidesPerGroup) : t.snapGrid.length;
                            if (
                                (t.params.loop
                                    ? ((n = t.previousRealIndex || 0), (s = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex))
                                    : void 0 !== t.snapIndex
                                    ? ((s = t.snapIndex), (n = t.previousSnapIndex))
                                    : ((n = t.previousIndex || 0), (s = t.activeIndex || 0)),
                                "bullets" === i.type && t.pagination.bullets && t.pagination.bullets.length > 0)
                            ) {
                                const r = t.pagination.bullets;
                                let l, d, p;
                                if (
                                    (i.dynamicBullets &&
                                        ((a = M(r[0], t.isHorizontal() ? "width" : "height", !0)),
                                        u.forEach((e) => {
                                            e.style[t.isHorizontal() ? "width" : "height"] = a * (i.dynamicMainBullets + 4) + "px";
                                        }),
                                        i.dynamicMainBullets > 1 && void 0 !== n && ((o += s - (n || 0)), o > i.dynamicMainBullets - 1 ? (o = i.dynamicMainBullets - 1) : o < 0 && (o = 0)),
                                        (l = Math.max(s - o, 0)),
                                        (d = l + (Math.min(r.length, i.dynamicMainBullets) - 1)),
                                        (p = (d + l) / 2)),
                                    r.forEach((e) => {
                                        const t = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e) => `${i.bulletActiveClass}${e}`)].map((e) => ("string" == typeof e && e.includes(" ") ? e.split(" ") : e)).flat();
                                        e.classList.remove(...t);
                                    }),
                                    u.length > 1)
                                )
                                    r.forEach((e) => {
                                        const r = x(e);
                                        r === s ? e.classList.add(...i.bulletActiveClass.split(" ")) : t.isElement && e.setAttribute("part", "bullet"),
                                            i.dynamicBullets && (r >= l && r <= d && e.classList.add(...`${i.bulletActiveClass}-main`.split(" ")), r === l && c(e, "prev"), r === d && c(e, "next"));
                                    });
                                else {
                                    const e = r[s];
                                    if (
                                        (e && e.classList.add(...i.bulletActiveClass.split(" ")),
                                        t.isElement &&
                                            r.forEach((e, t) => {
                                                e.setAttribute("part", t === s ? "bullet-active" : "bullet");
                                            }),
                                        i.dynamicBullets)
                                    ) {
                                        const e = r[l],
                                            t = r[d];
                                        for (let e = l; e <= d; e += 1) r[e] && r[e].classList.add(...`${i.bulletActiveClass}-main`.split(" "));
                                        c(e, "prev"), c(t, "next");
                                    }
                                }
                                if (i.dynamicBullets) {
                                    const s = Math.min(r.length, i.dynamicMainBullets + 4),
                                        n = (a * s - a) / 2 - p * a,
                                        o = e ? "right" : "left";
                                    r.forEach((e) => {
                                        e.style[t.isHorizontal() ? o : "top"] = `${n}px`;
                                    });
                                }
                            }
                            u.forEach((e, n) => {
                                if (
                                    ("fraction" === i.type &&
                                        (e.querySelectorAll(ie(i.currentClass)).forEach((e) => {
                                            e.textContent = i.formatFractionCurrent(s + 1);
                                        }),
                                        e.querySelectorAll(ie(i.totalClass)).forEach((e) => {
                                            e.textContent = i.formatFractionTotal(h);
                                        })),
                                    "progressbar" === i.type)
                                ) {
                                    let r;
                                    r = i.progressbarOpposite ? (t.isHorizontal() ? "vertical" : "horizontal") : t.isHorizontal() ? "horizontal" : "vertical";
                                    const n = (s + 1) / h;
                                    let a = 1,
                                        o = 1;
                                    "horizontal" === r ? (a = n) : (o = n),
                                        e.querySelectorAll(ie(i.progressbarFillClass)).forEach((e) => {
                                            (e.style.transform = `translate3d(0,0,0) scaleX(${a}) scaleY(${o})`), (e.style.transitionDuration = `${t.params.speed}ms`);
                                        });
                                }
                                "custom" === i.type && i.renderCustom ? ((e.innerHTML = i.renderCustom(t, s + 1, h)), 0 === n && r("paginationRender", e)) : (0 === n && r("paginationRender", e), r("paginationUpdate", e)),
                                    t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](i.lockClass);
                            });
                        }
                        function h() {
                            const e = t.params.pagination;
                            if (d()) return;
                            const i = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
                            let s = t.pagination.el;
                            s = l(s);
                            let n = "";
                            if ("bullets" === e.type) {
                                let s = t.params.loop ? Math.ceil(i / t.params.slidesPerGroup) : t.snapGrid.length;
                                t.params.freeMode && t.params.freeMode.enabled && s > i && (s = i);
                                for (let i = 0; i < s; i += 1)
                                    e.renderBullet ? (n += e.renderBullet.call(t, i, e.bulletClass)) : (n += `<${e.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${e.bulletClass}"></${e.bulletElement}>`);
                            }
                            "fraction" === e.type && (n = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
                                "progressbar" === e.type && (n = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`),
                                (t.pagination.bullets = []),
                                s.forEach((i) => {
                                    "custom" !== e.type && (i.innerHTML = n || ""), "bullets" === e.type && t.pagination.bullets.push(...i.querySelectorAll(ie(e.bulletClass)));
                                }),
                                "custom" !== e.type && r("paginationRender", s[0]);
                        }
                        function m() {
                            t.params.pagination = te(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" });
                            const e = t.params.pagination;
                            if (!e.el) return;
                            let i;
                            "string" == typeof e.el && t.isElement && (i = t.el.querySelector(e.el)),
                                i || "string" != typeof e.el || (i = [...document.querySelectorAll(e.el)]),
                                i || (i = e.el),
                                i &&
                                    0 !== i.length &&
                                    (t.params.uniqueNavElements &&
                                        "string" == typeof e.el &&
                                        Array.isArray(i) &&
                                        i.length > 1 &&
                                        ((i = [...t.el.querySelectorAll(e.el)]), i.length > 1 && (i = i.filter((e) => C(e, ".swiper")[0] === t.el)[0])),
                                    Array.isArray(i) && 1 === i.length && (i = i[0]),
                                    Object.assign(t.pagination, { el: i }),
                                    (i = l(i)),
                                    i.forEach((i) => {
                                        "bullets" === e.type && e.clickable && i.classList.add(...(e.clickableClass || "").split(" ")),
                                            i.classList.add(e.modifierClass + e.type),
                                            i.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                                            "bullets" === e.type && e.dynamicBullets && (i.classList.add(`${e.modifierClass}${e.type}-dynamic`), (o = 0), e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                                            "progressbar" === e.type && e.progressbarOpposite && i.classList.add(e.progressbarOppositeClass),
                                            e.clickable && i.addEventListener("click", u),
                                            t.enabled || i.classList.add(e.lockClass);
                                    }));
                        }
                        function v() {
                            const e = t.params.pagination;
                            if (d()) return;
                            let i = t.pagination.el;
                            i &&
                                ((i = l(i)),
                                i.forEach((i) => {
                                    i.classList.remove(e.hiddenClass),
                                        i.classList.remove(e.modifierClass + e.type),
                                        i.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                                        e.clickable && (i.classList.remove(...(e.clickableClass || "").split(" ")), i.removeEventListener("click", u));
                                })),
                                t.pagination.bullets && t.pagination.bullets.forEach((t) => t.classList.remove(...e.bulletActiveClass.split(" ")));
                        }
                        s("changeDirection", () => {
                            if (!t.pagination || !t.pagination.el) return;
                            const e = t.params.pagination;
                            let { el: i } = t.pagination;
                            (i = l(i)),
                                i.forEach((i) => {
                                    i.classList.remove(e.horizontalClass, e.verticalClass), i.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
                                });
                        }),
                            s("init", () => {
                                !1 === t.params.pagination.enabled ? g() : (m(), h(), p());
                            }),
                            s("activeIndexChange", () => {
                                void 0 === t.snapIndex && p();
                            }),
                            s("snapIndexChange", () => {
                                p();
                            }),
                            s("snapGridLengthChange", () => {
                                h(), p();
                            }),
                            s("destroy", () => {
                                v();
                            }),
                            s("enable disable", () => {
                                let { el: e } = t.pagination;
                                e && ((e = l(e)), e.forEach((e) => e.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
                            }),
                            s("lock unlock", () => {
                                p();
                            }),
                            s("click", (e, i) => {
                                const s = i.target,
                                    n = l(t.pagination.el);
                                if (t.params.pagination.el && t.params.pagination.hideOnClick && n && n.length > 0 && !s.classList.contains(t.params.pagination.bulletClass)) {
                                    if (t.navigation && ((t.navigation.nextEl && s === t.navigation.nextEl) || (t.navigation.prevEl && s === t.navigation.prevEl))) return;
                                    const e = n[0].classList.contains(t.params.pagination.hiddenClass);
                                    r(!0 === e ? "paginationShow" : "paginationHide"), n.forEach((e) => e.classList.toggle(t.params.pagination.hiddenClass));
                                }
                            });
                        const g = () => {
                            t.el.classList.add(t.params.pagination.paginationDisabledClass);
                            let { el: e } = t.pagination;
                            e && ((e = l(e)), e.forEach((e) => e.classList.add(t.params.pagination.paginationDisabledClass))), v();
                        };
                        Object.assign(t.pagination, {
                            enable: () => {
                                t.el.classList.remove(t.params.pagination.paginationDisabledClass);
                                let { el: e } = t.pagination;
                                e && ((e = l(e)), e.forEach((e) => e.classList.remove(t.params.pagination.paginationDisabledClass))), m(), h(), p();
                            },
                            disable: g,
                            render: h,
                            update: p,
                            init: m,
                            destroy: v,
                        });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s, emit: r } = e;
                        const n = a();
                        let o,
                            l,
                            u,
                            p,
                            h = !1,
                            m = null,
                            v = null;
                        function g() {
                            if (!t.params.scrollbar.el || !t.scrollbar.el) return;
                            const { scrollbar: e, rtlTranslate: i } = t,
                                { dragEl: s, el: r } = e,
                                n = t.params.scrollbar,
                                a = t.params.loop ? t.progressLoop : t.progress;
                            let o = l,
                                d = (u - l) * a;
                            i ? ((d = -d), d > 0 ? ((o = l - d), (d = 0)) : -d + l > u && (o = u + d)) : d < 0 ? ((o = l + d), (d = 0)) : d + l > u && (o = u - d),
                                t.isHorizontal() ? ((s.style.transform = `translate3d(${d}px, 0, 0)`), (s.style.width = `${o}px`)) : ((s.style.transform = `translate3d(0px, ${d}px, 0)`), (s.style.height = `${o}px`)),
                                n.hide &&
                                    (clearTimeout(m),
                                    (r.style.opacity = 1),
                                    (m = setTimeout(() => {
                                        (r.style.opacity = 0), (r.style.transitionDuration = "400ms");
                                    }, 1e3)));
                        }
                        function f() {
                            if (!t.params.scrollbar.el || !t.scrollbar.el) return;
                            const { scrollbar: e } = t,
                                { dragEl: i, el: s } = e;
                            (i.style.width = ""),
                                (i.style.height = ""),
                                (u = t.isHorizontal() ? s.offsetWidth : s.offsetHeight),
                                (p = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0))),
                                (l = "auto" === t.params.scrollbar.dragSize ? u * p : parseInt(t.params.scrollbar.dragSize, 10)),
                                t.isHorizontal() ? (i.style.width = `${l}px`) : (i.style.height = `${l}px`),
                                (s.style.display = p >= 1 ? "none" : ""),
                                t.params.scrollbar.hide && (s.style.opacity = 0),
                                t.params.watchOverflow && t.enabled && e.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass);
                        }
                        function b(e) {
                            return t.isHorizontal() ? e.clientX : e.clientY;
                        }
                        function w(e) {
                            const { scrollbar: i, rtlTranslate: s } = t,
                                { el: r } = i;
                            let n;
                            (n = (b(e) - E(r)[t.isHorizontal() ? "left" : "top"] - (null !== o ? o : l / 2)) / (u - l)), (n = Math.max(Math.min(n, 1), 0)), s && (n = 1 - n);
                            const a = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * n;
                            t.updateProgress(a), t.setTranslate(a), t.updateActiveIndex(), t.updateSlidesClasses();
                        }
                        function S(e) {
                            const i = t.params.scrollbar,
                                { scrollbar: s, wrapperEl: n } = t,
                                { el: a, dragEl: l } = s;
                            (h = !0),
                                (o = e.target === l ? b(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
                                e.preventDefault(),
                                e.stopPropagation(),
                                (n.style.transitionDuration = "100ms"),
                                (l.style.transitionDuration = "100ms"),
                                w(e),
                                clearTimeout(v),
                                (a.style.transitionDuration = "0ms"),
                                i.hide && (a.style.opacity = 1),
                                t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"),
                                r("scrollbarDragStart", e);
                        }
                        function x(e) {
                            const { scrollbar: i, wrapperEl: s } = t,
                                { el: n, dragEl: a } = i;
                            h &&
                                (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
                                w(e),
                                (s.style.transitionDuration = "0ms"),
                                (n.style.transitionDuration = "0ms"),
                                (a.style.transitionDuration = "0ms"),
                                r("scrollbarDragMove", e));
                        }
                        function C(e) {
                            const i = t.params.scrollbar,
                                { scrollbar: s, wrapperEl: n } = t,
                                { el: a } = s;
                            h &&
                                ((h = !1),
                                t.params.cssMode && ((t.wrapperEl.style["scroll-snap-type"] = ""), (n.style.transitionDuration = "")),
                                i.hide &&
                                    (clearTimeout(v),
                                    (v = c(() => {
                                        (a.style.opacity = 0), (a.style.transitionDuration = "400ms");
                                    }, 1e3))),
                                r("scrollbarDragEnd", e),
                                i.snapOnRelease && t.slideToClosest());
                        }
                        function T(e) {
                            const { scrollbar: i, params: s } = t,
                                r = i.el;
                            if (!r) return;
                            const a = r,
                                o = !!s.passiveListeners && { passive: !1, capture: !1 },
                                l = !!s.passiveListeners && { passive: !0, capture: !1 };
                            if (!a) return;
                            const d = "on" === e ? "addEventListener" : "removeEventListener";
                            a[d]("pointerdown", S, o), n[d]("pointermove", x, o), n[d]("pointerup", C, l);
                        }
                        function M() {
                            const { scrollbar: e, el: i } = t;
                            t.params.scrollbar = te(t, t.originalParams.scrollbar, t.params.scrollbar, { el: "swiper-scrollbar" });
                            const s = t.params.scrollbar;
                            if (!s.el) return;
                            let r, a;
                            if (("string" == typeof s.el && t.isElement && (r = t.el.querySelector(s.el)), r || "string" != typeof s.el)) r || (r = s.el);
                            else if (((r = n.querySelectorAll(s.el)), !r.length)) return;
                            t.params.uniqueNavElements && "string" == typeof s.el && r.length > 1 && 1 === i.querySelectorAll(s.el).length && (r = i.querySelector(s.el)),
                                r.length > 0 && (r = r[0]),
                                r.classList.add(t.isHorizontal() ? s.horizontalClass : s.verticalClass),
                                r && ((a = r.querySelector(ie(t.params.scrollbar.dragClass))), a || ((a = y("div", t.params.scrollbar.dragClass)), r.append(a))),
                                Object.assign(e, { el: r, dragEl: a }),
                                s.draggable && t.params.scrollbar.el && t.scrollbar.el && T("on"),
                                r && r.classList[t.enabled ? "remove" : "add"](...d(t.params.scrollbar.lockClass));
                        }
                        function L() {
                            const e = t.params.scrollbar,
                                i = t.scrollbar.el;
                            i && i.classList.remove(...d(t.isHorizontal() ? e.horizontalClass : e.verticalClass)), t.params.scrollbar.el && t.scrollbar.el && T("off");
                        }
                        i({
                            scrollbar: {
                                el: null,
                                dragSize: "auto",
                                hide: !1,
                                draggable: !1,
                                snapOnRelease: !0,
                                lockClass: "swiper-scrollbar-lock",
                                dragClass: "swiper-scrollbar-drag",
                                scrollbarDisabledClass: "swiper-scrollbar-disabled",
                                horizontalClass: "swiper-scrollbar-horizontal",
                                verticalClass: "swiper-scrollbar-vertical",
                            },
                        }),
                            (t.scrollbar = { el: null, dragEl: null }),
                            s("init", () => {
                                !1 === t.params.scrollbar.enabled ? P() : (M(), f(), g());
                            }),
                            s("update resize observerUpdate lock unlock", () => {
                                f();
                            }),
                            s("setTranslate", () => {
                                g();
                            }),
                            s("setTransition", (e, i) => {
                                !(function (e) {
                                    t.params.scrollbar.el && t.scrollbar.el && (t.scrollbar.dragEl.style.transitionDuration = `${e}ms`);
                                })(i);
                            }),
                            s("enable disable", () => {
                                const { el: e } = t.scrollbar;
                                e && e.classList[t.enabled ? "remove" : "add"](...d(t.params.scrollbar.lockClass));
                            }),
                            s("destroy", () => {
                                L();
                            });
                        const P = () => {
                            t.el.classList.add(...d(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.add(...d(t.params.scrollbar.scrollbarDisabledClass)), L();
                        };
                        Object.assign(t.scrollbar, {
                            enable: () => {
                                t.el.classList.remove(...d(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.remove(...d(t.params.scrollbar.scrollbarDisabledClass)), M(), f(), g();
                            },
                            disable: P,
                            updateSize: f,
                            setTranslate: g,
                            init: M,
                            destroy: L,
                        });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ parallax: { enabled: !1 } });
                        const r = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
                            n = (e, i) => {
                                const { rtl: s } = t,
                                    r = s ? -1 : 1,
                                    n = e.getAttribute("data-swiper-parallax") || "0";
                                let a = e.getAttribute("data-swiper-parallax-x"),
                                    o = e.getAttribute("data-swiper-parallax-y");
                                const l = e.getAttribute("data-swiper-parallax-scale"),
                                    d = e.getAttribute("data-swiper-parallax-opacity"),
                                    c = e.getAttribute("data-swiper-parallax-rotate");
                                if (
                                    (a || o ? ((a = a || "0"), (o = o || "0")) : t.isHorizontal() ? ((a = n), (o = "0")) : ((o = n), (a = "0")),
                                    (a = a.indexOf("%") >= 0 ? parseInt(a, 10) * i * r + "%" : a * i * r + "px"),
                                    (o = o.indexOf("%") >= 0 ? parseInt(o, 10) * i + "%" : o * i + "px"),
                                    null != d)
                                ) {
                                    const t = d - (d - 1) * (1 - Math.abs(i));
                                    e.style.opacity = t;
                                }
                                let u = `translate3d(${a}, ${o}, 0px)`;
                                null != l && (u += ` scale(${l - (l - 1) * (1 - Math.abs(i))})`), c && null != c && (u += ` rotate(${c * i * -1}deg)`), (e.style.transform = u);
                            },
                            a = () => {
                                const { el: e, slides: i, progress: s, snapGrid: a, isElement: o } = t,
                                    l = b(e, r);
                                t.isElement && l.push(...b(t.hostEl, r)),
                                    l.forEach((e) => {
                                        n(e, s);
                                    }),
                                    i.forEach((e, i) => {
                                        let o = e.progress;
                                        t.params.slidesPerGroup > 1 && "auto" !== t.params.slidesPerView && (o += Math.ceil(i / 2) - s * (a.length - 1)),
                                            (o = Math.min(Math.max(o, -1), 1)),
                                            e.querySelectorAll(`${r}, [data-swiper-parallax-rotate]`).forEach((e) => {
                                                n(e, o);
                                            });
                                    });
                            };
                        s("beforeInit", () => {
                            t.params.parallax.enabled && ((t.params.watchSlidesProgress = !0), (t.originalParams.watchSlidesProgress = !0));
                        }),
                            s("init", () => {
                                t.params.parallax.enabled && a();
                            }),
                            s("setTranslate", () => {
                                t.params.parallax.enabled && a();
                            }),
                            s("setTransition", (e, i) => {
                                t.params.parallax.enabled &&
                                    (function (e) {
                                        void 0 === e && (e = t.params.speed);
                                        const { el: i, hostEl: s } = t,
                                            n = [...i.querySelectorAll(r)];
                                        t.isElement && n.push(...s.querySelectorAll(r)),
                                            n.forEach((t) => {
                                                let i = parseInt(t.getAttribute("data-swiper-parallax-duration"), 10) || e;
                                                0 === e && (i = 0), (t.style.transitionDuration = `${i}ms`);
                                            });
                                    })(i);
                            });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s, emit: r } = e;
                        const n = l();
                        i({ zoom: { enabled: !1, maxRatio: 3, minRatio: 1, toggle: !0, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }), (t.zoom = { enabled: !1 });
                        let a,
                            o,
                            d = 1,
                            c = !1;
                        const u = [],
                            h = { originX: 0, originY: 0, slideEl: void 0, slideWidth: void 0, slideHeight: void 0, imageEl: void 0, imageWrapEl: void 0, maxRatio: 3 },
                            m = {
                                isTouched: void 0,
                                isMoved: void 0,
                                currentX: void 0,
                                currentY: void 0,
                                minX: void 0,
                                minY: void 0,
                                maxX: void 0,
                                maxY: void 0,
                                width: void 0,
                                height: void 0,
                                startX: void 0,
                                startY: void 0,
                                touchesStart: {},
                                touchesCurrent: {},
                            },
                            v = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
                        let g = 1;
                        function f() {
                            if (u.length < 2) return 1;
                            const e = u[0].pageX,
                                t = u[0].pageY,
                                i = u[1].pageX,
                                s = u[1].pageY;
                            return Math.sqrt((i - e) ** 2 + (s - t) ** 2);
                        }
                        function w(e) {
                            const i = t.isElement ? "swiper-slide" : `.${t.params.slideClass}`;
                            return !!e.target.matches(i) || t.slides.filter((t) => t.contains(e.target)).length > 0;
                        }
                        function y(e) {
                            if (("mouse" === e.pointerType && u.splice(0, u.length), !w(e))) return;
                            const i = t.params.zoom;
                            if (((a = !1), (o = !1), u.push(e), !(u.length < 2))) {
                                if (((a = !0), (h.scaleStart = f()), !h.slideEl)) {
                                    (h.slideEl = e.target.closest(`.${t.params.slideClass}, swiper-slide`)), h.slideEl || (h.slideEl = t.slides[t.activeIndex]);
                                    let s = h.slideEl.querySelector(`.${i.containerClass}`);
                                    if ((s && (s = s.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (h.imageEl = s), (h.imageWrapEl = s ? C(h.imageEl, `.${i.containerClass}`)[0] : void 0), !h.imageWrapEl))
                                        return void (h.imageEl = void 0);
                                    h.maxRatio = h.imageWrapEl.getAttribute("data-swiper-zoom") || i.maxRatio;
                                }
                                if (h.imageEl) {
                                    const [e, t] = (function () {
                                        if (u.length < 2) return { x: null, y: null };
                                        const e = h.imageEl.getBoundingClientRect();
                                        return [(u[0].pageX + (u[1].pageX - u[0].pageX) / 2 - e.x - n.scrollX) / d, (u[0].pageY + (u[1].pageY - u[0].pageY) / 2 - e.y - n.scrollY) / d];
                                    })();
                                    (h.originX = e), (h.originY = t), (h.imageEl.style.transitionDuration = "0ms");
                                }
                                c = !0;
                            }
                        }
                        function S(e) {
                            if (!w(e)) return;
                            const i = t.params.zoom,
                                s = t.zoom,
                                r = u.findIndex((t) => t.pointerId === e.pointerId);
                            r >= 0 && (u[r] = e),
                                u.length < 2 ||
                                    ((o = !0),
                                    (h.scaleMove = f()),
                                    h.imageEl &&
                                        ((s.scale = (h.scaleMove / h.scaleStart) * d),
                                        s.scale > h.maxRatio && (s.scale = h.maxRatio - 1 + (s.scale - h.maxRatio + 1) ** 0.5),
                                        s.scale < i.minRatio && (s.scale = i.minRatio + 1 - (i.minRatio - s.scale + 1) ** 0.5),
                                        (h.imageEl.style.transform = `translate3d(0,0,0) scale(${s.scale})`)));
                        }
                        function x(e) {
                            if (!w(e)) return;
                            if ("mouse" === e.pointerType && "pointerout" === e.type) return;
                            const i = t.params.zoom,
                                s = t.zoom,
                                r = u.findIndex((t) => t.pointerId === e.pointerId);
                            r >= 0 && u.splice(r, 1),
                                a &&
                                    o &&
                                    ((a = !1),
                                    (o = !1),
                                    h.imageEl &&
                                        ((s.scale = Math.max(Math.min(s.scale, h.maxRatio), i.minRatio)),
                                        (h.imageEl.style.transitionDuration = `${t.params.speed}ms`),
                                        (h.imageEl.style.transform = `translate3d(0,0,0) scale(${s.scale})`),
                                        (d = s.scale),
                                        (c = !1),
                                        s.scale > 1 && h.slideEl ? h.slideEl.classList.add(`${i.zoomedSlideClass}`) : s.scale <= 1 && h.slideEl && h.slideEl.classList.remove(`${i.zoomedSlideClass}`),
                                        1 === s.scale && ((h.originX = 0), (h.originY = 0), (h.slideEl = void 0))));
                        }
                        function T(e) {
                            if (
                                !w(e) ||
                                !(function (e) {
                                    const i = `.${t.params.zoom.containerClass}`;
                                    return !!e.target.matches(i) || [...t.hostEl.querySelectorAll(i)].filter((t) => t.contains(e.target)).length > 0;
                                })(e)
                            )
                                return;
                            const i = t.zoom;
                            if (!h.imageEl) return;
                            if (!m.isTouched || !h.slideEl) return;
                            m.isMoved ||
                                ((m.width = h.imageEl.offsetWidth),
                                (m.height = h.imageEl.offsetHeight),
                                (m.startX = p(h.imageWrapEl, "x") || 0),
                                (m.startY = p(h.imageWrapEl, "y") || 0),
                                (h.slideWidth = h.slideEl.offsetWidth),
                                (h.slideHeight = h.slideEl.offsetHeight),
                                (h.imageWrapEl.style.transitionDuration = "0ms"));
                            const s = m.width * i.scale,
                                r = m.height * i.scale;
                            if (s < h.slideWidth && r < h.slideHeight) return;
                            if (
                                ((m.minX = Math.min(h.slideWidth / 2 - s / 2, 0)),
                                (m.maxX = -m.minX),
                                (m.minY = Math.min(h.slideHeight / 2 - r / 2, 0)),
                                (m.maxY = -m.minY),
                                (m.touchesCurrent.x = u.length > 0 ? u[0].pageX : e.pageX),
                                (m.touchesCurrent.y = u.length > 0 ? u[0].pageY : e.pageY),
                                Math.max(Math.abs(m.touchesCurrent.x - m.touchesStart.x), Math.abs(m.touchesCurrent.y - m.touchesStart.y)) > 5 && (t.allowClick = !1),
                                !m.isMoved && !c)
                            ) {
                                if (t.isHorizontal() && ((Math.floor(m.minX) === Math.floor(m.startX) && m.touchesCurrent.x < m.touchesStart.x) || (Math.floor(m.maxX) === Math.floor(m.startX) && m.touchesCurrent.x > m.touchesStart.x)))
                                    return void (m.isTouched = !1);
                                if (!t.isHorizontal() && ((Math.floor(m.minY) === Math.floor(m.startY) && m.touchesCurrent.y < m.touchesStart.y) || (Math.floor(m.maxY) === Math.floor(m.startY) && m.touchesCurrent.y > m.touchesStart.y)))
                                    return void (m.isTouched = !1);
                            }
                            e.cancelable && e.preventDefault(), e.stopPropagation(), (m.isMoved = !0);
                            const n = (i.scale - d) / (h.maxRatio - t.params.zoom.minRatio),
                                { originX: a, originY: o } = h;
                            (m.currentX = m.touchesCurrent.x - m.touchesStart.x + m.startX + n * (m.width - 2 * a)),
                                (m.currentY = m.touchesCurrent.y - m.touchesStart.y + m.startY + n * (m.height - 2 * o)),
                                m.currentX < m.minX && (m.currentX = m.minX + 1 - (m.minX - m.currentX + 1) ** 0.8),
                                m.currentX > m.maxX && (m.currentX = m.maxX - 1 + (m.currentX - m.maxX + 1) ** 0.8),
                                m.currentY < m.minY && (m.currentY = m.minY + 1 - (m.minY - m.currentY + 1) ** 0.8),
                                m.currentY > m.maxY && (m.currentY = m.maxY - 1 + (m.currentY - m.maxY + 1) ** 0.8),
                                v.prevPositionX || (v.prevPositionX = m.touchesCurrent.x),
                                v.prevPositionY || (v.prevPositionY = m.touchesCurrent.y),
                                v.prevTime || (v.prevTime = Date.now()),
                                (v.x = (m.touchesCurrent.x - v.prevPositionX) / (Date.now() - v.prevTime) / 2),
                                (v.y = (m.touchesCurrent.y - v.prevPositionY) / (Date.now() - v.prevTime) / 2),
                                Math.abs(m.touchesCurrent.x - v.prevPositionX) < 2 && (v.x = 0),
                                Math.abs(m.touchesCurrent.y - v.prevPositionY) < 2 && (v.y = 0),
                                (v.prevPositionX = m.touchesCurrent.x),
                                (v.prevPositionY = m.touchesCurrent.y),
                                (v.prevTime = Date.now()),
                                (h.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`);
                        }
                        function M() {
                            const e = t.zoom;
                            h.slideEl &&
                                t.activeIndex !== t.slides.indexOf(h.slideEl) &&
                                (h.imageEl && (h.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
                                h.imageWrapEl && (h.imageWrapEl.style.transform = "translate3d(0,0,0)"),
                                h.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),
                                (e.scale = 1),
                                (d = 1),
                                (h.slideEl = void 0),
                                (h.imageEl = void 0),
                                (h.imageWrapEl = void 0),
                                (h.originX = 0),
                                (h.originY = 0));
                        }
                        function L(e) {
                            const i = t.zoom,
                                s = t.params.zoom;
                            if (!h.slideEl) {
                                e && e.target && (h.slideEl = e.target.closest(`.${t.params.slideClass}, swiper-slide`)),
                                    h.slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? (h.slideEl = b(t.slidesEl, `.${t.params.slideActiveClass}`)[0]) : (h.slideEl = t.slides[t.activeIndex]));
                                let i = h.slideEl.querySelector(`.${s.containerClass}`);
                                i && (i = i.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (h.imageEl = i), (h.imageWrapEl = i ? C(h.imageEl, `.${s.containerClass}`)[0] : void 0);
                            }
                            if (!h.imageEl || !h.imageWrapEl) return;
                            let r, a, o, l, c, u, p, v, g, f, w, y, S, x, T, M, L, P;
                            t.params.cssMode && ((t.wrapperEl.style.overflow = "hidden"), (t.wrapperEl.style.touchAction = "none")),
                                h.slideEl.classList.add(`${s.zoomedSlideClass}`),
                                void 0 === m.touchesStart.x && e ? ((r = e.pageX), (a = e.pageY)) : ((r = m.touchesStart.x), (a = m.touchesStart.y));
                            const A = "number" == typeof e ? e : null;
                            1 === d && A && ((r = void 0), (a = void 0)),
                                (i.scale = A || h.imageWrapEl.getAttribute("data-swiper-zoom") || s.maxRatio),
                                (d = A || h.imageWrapEl.getAttribute("data-swiper-zoom") || s.maxRatio),
                                !e || (1 === d && A)
                                    ? ((p = 0), (v = 0))
                                    : ((L = h.slideEl.offsetWidth),
                                      (P = h.slideEl.offsetHeight),
                                      (o = E(h.slideEl).left + n.scrollX),
                                      (l = E(h.slideEl).top + n.scrollY),
                                      (c = o + L / 2 - r),
                                      (u = l + P / 2 - a),
                                      (g = h.imageEl.offsetWidth),
                                      (f = h.imageEl.offsetHeight),
                                      (w = g * i.scale),
                                      (y = f * i.scale),
                                      (S = Math.min(L / 2 - w / 2, 0)),
                                      (x = Math.min(P / 2 - y / 2, 0)),
                                      (T = -S),
                                      (M = -x),
                                      (p = c * i.scale),
                                      (v = u * i.scale),
                                      p < S && (p = S),
                                      p > T && (p = T),
                                      v < x && (v = x),
                                      v > M && (v = M)),
                                A && 1 === i.scale && ((h.originX = 0), (h.originY = 0)),
                                (h.imageWrapEl.style.transitionDuration = "300ms"),
                                (h.imageWrapEl.style.transform = `translate3d(${p}px, ${v}px,0)`),
                                (h.imageEl.style.transitionDuration = "300ms"),
                                (h.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`);
                        }
                        function P() {
                            const e = t.zoom,
                                i = t.params.zoom;
                            if (!h.slideEl) {
                                t.params.virtual && t.params.virtual.enabled && t.virtual ? (h.slideEl = b(t.slidesEl, `.${t.params.slideActiveClass}`)[0]) : (h.slideEl = t.slides[t.activeIndex]);
                                let e = h.slideEl.querySelector(`.${i.containerClass}`);
                                e && (e = e.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (h.imageEl = e), (h.imageWrapEl = e ? C(h.imageEl, `.${i.containerClass}`)[0] : void 0);
                            }
                            h.imageEl &&
                                h.imageWrapEl &&
                                (t.params.cssMode && ((t.wrapperEl.style.overflow = ""), (t.wrapperEl.style.touchAction = "")),
                                (e.scale = 1),
                                (d = 1),
                                (h.imageWrapEl.style.transitionDuration = "300ms"),
                                (h.imageWrapEl.style.transform = "translate3d(0,0,0)"),
                                (h.imageEl.style.transitionDuration = "300ms"),
                                (h.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
                                h.slideEl.classList.remove(`${i.zoomedSlideClass}`),
                                (h.slideEl = void 0),
                                (h.originX = 0),
                                (h.originY = 0));
                        }
                        function A(e) {
                            const i = t.zoom;
                            i.scale && 1 !== i.scale ? P() : L(e);
                        }
                        function k() {
                            return { passiveListener: !!t.params.passiveListeners && { passive: !0, capture: !1 }, activeListenerWithCapture: !t.params.passiveListeners || { passive: !1, capture: !0 } };
                        }
                        function I() {
                            const e = t.zoom;
                            if (e.enabled) return;
                            e.enabled = !0;
                            const { passiveListener: i, activeListenerWithCapture: s } = k();
                            t.wrapperEl.addEventListener("pointerdown", y, i),
                                t.wrapperEl.addEventListener("pointermove", S, s),
                                ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
                                    t.wrapperEl.addEventListener(e, x, i);
                                }),
                                t.wrapperEl.addEventListener("pointermove", T, s);
                        }
                        function O() {
                            const e = t.zoom;
                            if (!e.enabled) return;
                            e.enabled = !1;
                            const { passiveListener: i, activeListenerWithCapture: s } = k();
                            t.wrapperEl.removeEventListener("pointerdown", y, i),
                                t.wrapperEl.removeEventListener("pointermove", S, s),
                                ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
                                    t.wrapperEl.removeEventListener(e, x, i);
                                }),
                                t.wrapperEl.removeEventListener("pointermove", T, s);
                        }
                        Object.defineProperty(t.zoom, "scale", {
                            get: () => g,
                            set(e) {
                                if (g !== e) {
                                    const t = h.imageEl,
                                        i = h.slideEl;
                                    r("zoomChange", e, t, i);
                                }
                                g = e;
                            },
                        }),
                            s("init", () => {
                                t.params.zoom.enabled && I();
                            }),
                            s("destroy", () => {
                                O();
                            }),
                            s("touchStart", (e, i) => {
                                t.zoom.enabled &&
                                    (function (e) {
                                        const i = t.device;
                                        if (!h.imageEl) return;
                                        if (m.isTouched) return;
                                        i.android && e.cancelable && e.preventDefault(), (m.isTouched = !0);
                                        const s = u.length > 0 ? u[0] : e;
                                        (m.touchesStart.x = s.pageX), (m.touchesStart.y = s.pageY);
                                    })(i);
                            }),
                            s("touchEnd", (e, i) => {
                                t.zoom.enabled &&
                                    (function () {
                                        const e = t.zoom;
                                        if (!h.imageEl) return;
                                        if (!m.isTouched || !m.isMoved) return (m.isTouched = !1), void (m.isMoved = !1);
                                        (m.isTouched = !1), (m.isMoved = !1);
                                        let i = 300,
                                            s = 300;
                                        const r = v.x * i,
                                            n = m.currentX + r,
                                            a = v.y * s,
                                            o = m.currentY + a;
                                        0 !== v.x && (i = Math.abs((n - m.currentX) / v.x)), 0 !== v.y && (s = Math.abs((o - m.currentY) / v.y));
                                        const l = Math.max(i, s);
                                        (m.currentX = n), (m.currentY = o);
                                        const d = m.width * e.scale,
                                            c = m.height * e.scale;
                                        (m.minX = Math.min(h.slideWidth / 2 - d / 2, 0)),
                                            (m.maxX = -m.minX),
                                            (m.minY = Math.min(h.slideHeight / 2 - c / 2, 0)),
                                            (m.maxY = -m.minY),
                                            (m.currentX = Math.max(Math.min(m.currentX, m.maxX), m.minX)),
                                            (m.currentY = Math.max(Math.min(m.currentY, m.maxY), m.minY)),
                                            (h.imageWrapEl.style.transitionDuration = `${l}ms`),
                                            (h.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`);
                                    })();
                            }),
                            s("doubleTap", (e, i) => {
                                !t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && A(i);
                            }),
                            s("transitionEnd", () => {
                                t.zoom.enabled && t.params.zoom.enabled && M();
                            }),
                            s("slideChange", () => {
                                t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && M();
                            }),
                            Object.assign(t.zoom, { enable: I, disable: O, in: L, out: P, toggle: A });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        function r(e, t) {
                            const i = (function () {
                                let e, t, i;
                                return (s, r) => {
                                    for (t = -1, e = s.length; e - t > 1; ) (i = (e + t) >> 1), s[i] <= r ? (t = i) : (e = i);
                                    return e;
                                };
                            })();
                            let s, r;
                            return (
                                (this.x = e),
                                (this.y = t),
                                (this.lastIndex = e.length - 1),
                                (this.interpolate = function (e) {
                                    return e ? ((r = i(this.x, e)), (s = r - 1), ((e - this.x[s]) * (this.y[r] - this.y[s])) / (this.x[r] - this.x[s]) + this.y[s]) : 0;
                                }),
                                this
                            );
                        }
                        function n() {
                            t.controller.control && t.controller.spline && ((t.controller.spline = void 0), delete t.controller.spline);
                        }
                        i({ controller: { control: void 0, inverse: !1, by: "slide" } }),
                            (t.controller = { control: void 0 }),
                            s("beforeInit", () => {
                                if ("undefined" != typeof window && ("string" == typeof t.params.controller.control || t.params.controller.control instanceof HTMLElement)) {
                                    const e = document.querySelector(t.params.controller.control);
                                    if (e && e.swiper) t.controller.control = e.swiper;
                                    else if (e) {
                                        const i = (s) => {
                                            (t.controller.control = s.detail[0]), t.update(), e.removeEventListener("init", i);
                                        };
                                        e.addEventListener("init", i);
                                    }
                                } else t.controller.control = t.params.controller.control;
                            }),
                            s("update", () => {
                                n();
                            }),
                            s("resize", () => {
                                n();
                            }),
                            s("observerUpdate", () => {
                                n();
                            }),
                            s("setTranslate", (e, i, s) => {
                                t.controller.control && !t.controller.control.destroyed && t.controller.setTranslate(i, s);
                            }),
                            s("setTransition", (e, i, s) => {
                                t.controller.control && !t.controller.control.destroyed && t.controller.setTransition(i, s);
                            }),
                            Object.assign(t.controller, {
                                setTranslate: function (e, i) {
                                    const s = t.controller.control;
                                    let n, a;
                                    const o = t.constructor;
                                    function l(e) {
                                        if (e.destroyed) return;
                                        const i = t.rtlTranslate ? -t.translate : t.translate;
                                        "slide" === t.params.controller.by &&
                                            ((function (e) {
                                                t.controller.spline = t.params.loop ? new r(t.slidesGrid, e.slidesGrid) : new r(t.snapGrid, e.snapGrid);
                                            })(e),
                                            (a = -t.controller.spline.interpolate(-i))),
                                            (a && "container" !== t.params.controller.by) ||
                                                ((n = (e.maxTranslate() - e.minTranslate()) / (t.maxTranslate() - t.minTranslate())), (!Number.isNaN(n) && Number.isFinite(n)) || (n = 1), (a = (i - t.minTranslate()) * n + e.minTranslate())),
                                            t.params.controller.inverse && (a = e.maxTranslate() - a),
                                            e.updateProgress(a),
                                            e.setTranslate(a, t),
                                            e.updateActiveIndex(),
                                            e.updateSlidesClasses();
                                    }
                                    if (Array.isArray(s)) for (let e = 0; e < s.length; e += 1) s[e] !== i && s[e] instanceof o && l(s[e]);
                                    else s instanceof o && i !== s && l(s);
                                },
                                setTransition: function (e, i) {
                                    const s = t.constructor,
                                        r = t.controller.control;
                                    let n;
                                    function a(i) {
                                        i.destroyed ||
                                            (i.setTransition(e, t),
                                            0 !== e &&
                                                (i.transitionStart(),
                                                i.params.autoHeight &&
                                                    c(() => {
                                                        i.updateAutoHeight();
                                                    }),
                                                T(i.wrapperEl, () => {
                                                    r && i.transitionEnd();
                                                })));
                                    }
                                    if (Array.isArray(r)) for (n = 0; n < r.length; n += 1) r[n] !== i && r[n] instanceof s && a(r[n]);
                                    else r instanceof s && i !== r && a(r);
                                },
                            });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({
                            a11y: {
                                enabled: !0,
                                notificationClass: "swiper-notification",
                                prevSlideMessage: "Previous slide",
                                nextSlideMessage: "Next slide",
                                firstSlideMessage: "This is the first slide",
                                lastSlideMessage: "This is the last slide",
                                paginationBulletMessage: "Go to slide {{index}}",
                                slideLabelMessage: "{{index}} / {{slidesLength}}",
                                containerMessage: null,
                                containerRoleDescriptionMessage: null,
                                itemRoleDescriptionMessage: null,
                                slideRole: "group",
                                id: null,
                            },
                        }),
                            (t.a11y = { clicked: !1 });
                        let r = null;
                        function n(e) {
                            const t = r;
                            0 !== t.length && ((t.innerHTML = ""), (t.innerHTML = e));
                        }
                        const a = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e);
                        function o(e) {
                            (e = a(e)).forEach((e) => {
                                e.setAttribute("tabIndex", "0");
                            });
                        }
                        function l(e) {
                            (e = a(e)).forEach((e) => {
                                e.setAttribute("tabIndex", "-1");
                            });
                        }
                        function d(e, t) {
                            (e = a(e)).forEach((e) => {
                                e.setAttribute("role", t);
                            });
                        }
                        function c(e, t) {
                            (e = a(e)).forEach((e) => {
                                e.setAttribute("aria-roledescription", t);
                            });
                        }
                        function u(e, t) {
                            (e = a(e)).forEach((e) => {
                                e.setAttribute("aria-label", t);
                            });
                        }
                        function p(e) {
                            (e = a(e)).forEach((e) => {
                                e.setAttribute("aria-disabled", !0);
                            });
                        }
                        function h(e) {
                            (e = a(e)).forEach((e) => {
                                e.setAttribute("aria-disabled", !1);
                            });
                        }
                        function m(e) {
                            if (13 !== e.keyCode && 32 !== e.keyCode) return;
                            const i = t.params.a11y,
                                s = e.target;
                            (t.pagination && t.pagination.el && (s === t.pagination.el || t.pagination.el.contains(e.target)) && !e.target.matches(ie(t.params.pagination.bulletClass))) ||
                                (t.navigation && t.navigation.nextEl && s === t.navigation.nextEl && ((t.isEnd && !t.params.loop) || t.slideNext(), t.isEnd ? n(i.lastSlideMessage) : n(i.nextSlideMessage)),
                                t.navigation && t.navigation.prevEl && s === t.navigation.prevEl && ((t.isBeginning && !t.params.loop) || t.slidePrev(), t.isBeginning ? n(i.firstSlideMessage) : n(i.prevSlideMessage)),
                                t.pagination && s.matches(ie(t.params.pagination.bulletClass)) && s.click());
                        }
                        function v() {
                            return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
                        }
                        function g() {
                            return v() && t.params.pagination.clickable;
                        }
                        const f = (e, t, i) => {
                                o(e),
                                    "BUTTON" !== e.tagName && (d(e, "button"), e.addEventListener("keydown", m)),
                                    u(e, i),
                                    (function (e, t) {
                                        (e = a(e)).forEach((e) => {
                                            e.setAttribute("aria-controls", t);
                                        });
                                    })(e, t);
                            },
                            b = () => {
                                t.a11y.clicked = !0;
                            },
                            w = () => {
                                requestAnimationFrame(() => {
                                    requestAnimationFrame(() => {
                                        t.destroyed || (t.a11y.clicked = !1);
                                    });
                                });
                            },
                            E = (e) => {
                                if (t.a11y.clicked) return;
                                const i = e.target.closest(`.${t.params.slideClass}, swiper-slide`);
                                if (!i || !t.slides.includes(i)) return;
                                const s = t.slides.indexOf(i) === t.activeIndex,
                                    r = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(i);
                                s || r || (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) || (t.isHorizontal() ? (t.el.scrollLeft = 0) : (t.el.scrollTop = 0), t.slideTo(t.slides.indexOf(i), 0));
                            },
                            S = () => {
                                const e = t.params.a11y;
                                e.itemRoleDescriptionMessage && c(t.slides, e.itemRoleDescriptionMessage), e.slideRole && d(t.slides, e.slideRole);
                                const i = t.slides.length;
                                e.slideLabelMessage &&
                                    t.slides.forEach((s, r) => {
                                        const n = t.params.loop ? parseInt(s.getAttribute("data-swiper-slide-index"), 10) : r;
                                        u(s, e.slideLabelMessage.replace(/\{\{index\}\}/, n + 1).replace(/\{\{slidesLength\}\}/, i));
                                    });
                            };
                        s("beforeInit", () => {
                            (r = y("span", t.params.a11y.notificationClass)), r.setAttribute("aria-live", "assertive"), r.setAttribute("aria-atomic", "true");
                        }),
                            s("afterInit", () => {
                                t.params.a11y.enabled &&
                                    (() => {
                                        const e = t.params.a11y;
                                        t.el.append(r);
                                        const i = t.el;
                                        e.containerRoleDescriptionMessage && c(i, e.containerRoleDescriptionMessage), e.containerMessage && u(i, e.containerMessage);
                                        const s = t.wrapperEl,
                                            n = e.id || s.getAttribute("id") || `swiper-wrapper-${((o = 16), void 0 === o && (o = 16), "x".repeat(o).replace(/x/g, () => Math.round(16 * Math.random()).toString(16)))}`;
                                        var o;
                                        const l = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
                                        var d;
                                        (d = n),
                                            a(s).forEach((e) => {
                                                e.setAttribute("id", d);
                                            }),
                                            (function (e, t) {
                                                (e = a(e)).forEach((e) => {
                                                    e.setAttribute("aria-live", t);
                                                });
                                            })(s, l),
                                            S();
                                        let { nextEl: p, prevEl: h } = t.navigation ? t.navigation : {};
                                        (p = a(p)),
                                            (h = a(h)),
                                            p && p.forEach((t) => f(t, n, e.nextSlideMessage)),
                                            h && h.forEach((t) => f(t, n, e.prevSlideMessage)),
                                            g() &&
                                                a(t.pagination.el).forEach((e) => {
                                                    e.addEventListener("keydown", m);
                                                }),
                                            t.el.addEventListener("focus", E, !0),
                                            t.el.addEventListener("pointerdown", b, !0),
                                            t.el.addEventListener("pointerup", w, !0);
                                    })();
                            }),
                            s("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
                                t.params.a11y.enabled && S();
                            }),
                            s("fromEdge toEdge afterInit lock unlock", () => {
                                t.params.a11y.enabled &&
                                    (function () {
                                        if (t.params.loop || t.params.rewind || !t.navigation) return;
                                        const { nextEl: e, prevEl: i } = t.navigation;
                                        i && (t.isBeginning ? (p(i), l(i)) : (h(i), o(i))), e && (t.isEnd ? (p(e), l(e)) : (h(e), o(e)));
                                    })();
                            }),
                            s("paginationUpdate", () => {
                                t.params.a11y.enabled &&
                                    (function () {
                                        const e = t.params.a11y;
                                        v() &&
                                            t.pagination.bullets.forEach((i) => {
                                                t.params.pagination.clickable && (o(i), t.params.pagination.renderBullet || (d(i, "button"), u(i, e.paginationBulletMessage.replace(/\{\{index\}\}/, x(i) + 1)))),
                                                    i.matches(ie(t.params.pagination.bulletActiveClass)) ? i.setAttribute("aria-current", "true") : i.removeAttribute("aria-current");
                                            });
                                    })();
                            }),
                            s("destroy", () => {
                                t.params.a11y.enabled &&
                                    (function () {
                                        r && r.remove();
                                        let { nextEl: e, prevEl: i } = t.navigation ? t.navigation : {};
                                        (e = a(e)),
                                            (i = a(i)),
                                            e && e.forEach((e) => e.removeEventListener("keydown", m)),
                                            i && i.forEach((e) => e.removeEventListener("keydown", m)),
                                            g() &&
                                                a(t.pagination.el).forEach((e) => {
                                                    e.removeEventListener("keydown", m);
                                                }),
                                            t.el.removeEventListener("focus", E, !0),
                                            t.el.removeEventListener("pointerdown", b, !0),
                                            t.el.removeEventListener("pointerup", w, !0);
                                    })();
                            });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ history: { enabled: !1, root: "", replaceState: !1, key: "slides", keepQuery: !1 } });
                        let r = !1,
                            n = {};
                        const a = (e) =>
                                e
                                    .toString()
                                    .replace(/\s+/g, "-")
                                    .replace(/[^\w-]+/g, "")
                                    .replace(/--+/g, "-")
                                    .replace(/^-+/, "")
                                    .replace(/-+$/, ""),
                            o = (e) => {
                                const t = l();
                                let i;
                                i = e ? new URL(e) : t.location;
                                const s = i.pathname
                                        .slice(1)
                                        .split("/")
                                        .filter((e) => "" !== e),
                                    r = s.length;
                                return { key: s[r - 2], value: s[r - 1] };
                            },
                            d = (e, i) => {
                                const s = l();
                                if (!r || !t.params.history.enabled) return;
                                let n;
                                n = t.params.url ? new URL(t.params.url) : s.location;
                                const o = t.slides[i];
                                let d = a(o.getAttribute("data-history"));
                                if (t.params.history.root.length > 0) {
                                    let i = t.params.history.root;
                                    "/" === i[i.length - 1] && (i = i.slice(0, i.length - 1)), (d = `${i}/${e ? `${e}/` : ""}${d}`);
                                } else n.pathname.includes(e) || (d = `${e ? `${e}/` : ""}${d}`);
                                t.params.history.keepQuery && (d += n.search);
                                const c = s.history.state;
                                (c && c.value === d) || (t.params.history.replaceState ? s.history.replaceState({ value: d }, null, d) : s.history.pushState({ value: d }, null, d));
                            },
                            c = (e, i, s) => {
                                if (i)
                                    for (let r = 0, n = t.slides.length; r < n; r += 1) {
                                        const n = t.slides[r];
                                        if (a(n.getAttribute("data-history")) === i) {
                                            const i = t.getSlideIndex(n);
                                            t.slideTo(i, e, s);
                                        }
                                    }
                                else t.slideTo(0, e, s);
                            },
                            u = () => {
                                (n = o(t.params.url)), c(t.params.speed, n.value, !1);
                            };
                        s("init", () => {
                            t.params.history.enabled &&
                                (() => {
                                    const e = l();
                                    if (t.params.history) {
                                        if (!e.history || !e.history.pushState) return (t.params.history.enabled = !1), void (t.params.hashNavigation.enabled = !0);
                                        (r = !0),
                                            (n = o(t.params.url)),
                                            n.key || n.value
                                                ? (c(0, n.value, t.params.runCallbacksOnInit), t.params.history.replaceState || e.addEventListener("popstate", u))
                                                : t.params.history.replaceState || e.addEventListener("popstate", u);
                                    }
                                })();
                        }),
                            s("destroy", () => {
                                t.params.history.enabled &&
                                    (() => {
                                        const e = l();
                                        t.params.history.replaceState || e.removeEventListener("popstate", u);
                                    })();
                            }),
                            s("transitionEnd _freeModeNoMomentumRelease", () => {
                                r && d(t.params.history.key, t.activeIndex);
                            }),
                            s("slideChange", () => {
                                r && t.params.cssMode && d(t.params.history.key, t.activeIndex);
                            });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, emit: s, on: r } = e,
                            n = !1;
                        const o = a(),
                            d = l();
                        i({
                            hashNavigation: {
                                enabled: !1,
                                replaceState: !1,
                                watchState: !1,
                                getSlideIndex(e, i) {
                                    if (t.virtual && t.params.virtual.enabled) {
                                        const e = t.slides.filter((e) => e.getAttribute("data-hash") === i)[0];
                                        return e ? parseInt(e.getAttribute("data-swiper-slide-index"), 10) : 0;
                                    }
                                    return t.getSlideIndex(b(t.slidesEl, `.${t.params.slideClass}[data-hash="${i}"], swiper-slide[data-hash="${i}"]`)[0]);
                                },
                            },
                        });
                        const c = () => {
                                s("hashChange");
                                const e = o.location.hash.replace("#", ""),
                                    i = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`) : t.slides[t.activeIndex];
                                if (e !== (i ? i.getAttribute("data-hash") : "")) {
                                    const i = t.params.hashNavigation.getSlideIndex(t, e);
                                    if (void 0 === i || Number.isNaN(i)) return;
                                    t.slideTo(i);
                                }
                            },
                            u = () => {
                                if (!n || !t.params.hashNavigation.enabled) return;
                                const e = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`) : t.slides[t.activeIndex],
                                    i = e ? e.getAttribute("data-hash") || e.getAttribute("data-history") : "";
                                t.params.hashNavigation.replaceState && d.history && d.history.replaceState ? (d.history.replaceState(null, null, `#${i}` || ""), s("hashSet")) : ((o.location.hash = i || ""), s("hashSet"));
                            };
                        r("init", () => {
                            t.params.hashNavigation.enabled &&
                                (() => {
                                    if (!t.params.hashNavigation.enabled || (t.params.history && t.params.history.enabled)) return;
                                    n = !0;
                                    const e = o.location.hash.replace("#", "");
                                    if (e) {
                                        const i = 0,
                                            s = t.params.hashNavigation.getSlideIndex(t, e);
                                        t.slideTo(s || 0, i, t.params.runCallbacksOnInit, !0);
                                    }
                                    t.params.hashNavigation.watchState && d.addEventListener("hashchange", c);
                                })();
                        }),
                            r("destroy", () => {
                                t.params.hashNavigation.enabled && t.params.hashNavigation.watchState && d.removeEventListener("hashchange", c);
                            }),
                            r("transitionEnd _freeModeNoMomentumRelease", () => {
                                n && u();
                            }),
                            r("slideChange", () => {
                                n && t.params.cssMode && u();
                            });
                    },
                    function (e) {
                        let t,
                            i,
                            { swiper: s, extendParams: r, on: n, emit: o, params: l } = e;
                        (s.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
                            r({ autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !1, stopOnLastSlide: !1, reverseDirection: !1, pauseOnMouseEnter: !1 } });
                        let d,
                            c,
                            u,
                            p,
                            h,
                            m,
                            v,
                            g,
                            f = l && l.autoplay ? l.autoplay.delay : 3e3,
                            b = l && l.autoplay ? l.autoplay.delay : 3e3,
                            w = new Date().getTime();
                        function y(e) {
                            s && !s.destroyed && s.wrapperEl && e.target === s.wrapperEl && (s.wrapperEl.removeEventListener("transitionend", y), g || M());
                        }
                        const E = () => {
                                if (s.destroyed || !s.autoplay.running) return;
                                s.autoplay.paused ? (c = !0) : c && ((b = d), (c = !1));
                                const e = s.autoplay.paused ? d : w + b - new Date().getTime();
                                (s.autoplay.timeLeft = e),
                                    o("autoplayTimeLeft", e, e / f),
                                    (i = requestAnimationFrame(() => {
                                        E();
                                    }));
                            },
                            S = (e) => {
                                if (s.destroyed || !s.autoplay.running) return;
                                cancelAnimationFrame(i), E();
                                let r = void 0 === e ? s.params.autoplay.delay : e;
                                (f = s.params.autoplay.delay), (b = s.params.autoplay.delay);
                                const n = (() => {
                                    let e;
                                    if (((e = s.virtual && s.params.virtual.enabled ? s.slides.filter((e) => e.classList.contains("swiper-slide-active"))[0] : s.slides[s.activeIndex]), e))
                                        return parseInt(e.getAttribute("data-swiper-autoplay"), 10);
                                })();
                                !Number.isNaN(n) && n > 0 && void 0 === e && ((r = n), (f = n), (b = n)), (d = r);
                                const a = s.params.speed,
                                    l = () => {
                                        s &&
                                            !s.destroyed &&
                                            (s.params.autoplay.reverseDirection
                                                ? !s.isBeginning || s.params.loop || s.params.rewind
                                                    ? (s.slidePrev(a, !0, !0), o("autoplay"))
                                                    : s.params.autoplay.stopOnLastSlide || (s.slideTo(s.slides.length - 1, a, !0, !0), o("autoplay"))
                                                : !s.isEnd || s.params.loop || s.params.rewind
                                                ? (s.slideNext(a, !0, !0), o("autoplay"))
                                                : s.params.autoplay.stopOnLastSlide || (s.slideTo(0, a, !0, !0), o("autoplay")),
                                            s.params.cssMode &&
                                                ((w = new Date().getTime()),
                                                requestAnimationFrame(() => {
                                                    S();
                                                })));
                                    };
                                return (
                                    r > 0
                                        ? (clearTimeout(t),
                                          (t = setTimeout(() => {
                                              l();
                                          }, r)))
                                        : requestAnimationFrame(() => {
                                              l();
                                          }),
                                    r
                                );
                            },
                            x = () => {
                                (w = new Date().getTime()), (s.autoplay.running = !0), S(), o("autoplayStart");
                            },
                            C = () => {
                                (s.autoplay.running = !1), clearTimeout(t), cancelAnimationFrame(i), o("autoplayStop");
                            },
                            T = (e, i) => {
                                if (s.destroyed || !s.autoplay.running) return;
                                clearTimeout(t), e || (v = !0);
                                const r = () => {
                                    o("autoplayPause"), s.params.autoplay.waitForTransition ? s.wrapperEl.addEventListener("transitionend", y) : M();
                                };
                                if (((s.autoplay.paused = !0), i)) return m && (d = s.params.autoplay.delay), (m = !1), void r();
                                const n = d || s.params.autoplay.delay;
                                (d = n - (new Date().getTime() - w)), (s.isEnd && d < 0 && !s.params.loop) || (d < 0 && (d = 0), r());
                            },
                            M = () => {
                                (s.isEnd && d < 0 && !s.params.loop) || s.destroyed || !s.autoplay.running || ((w = new Date().getTime()), v ? ((v = !1), S(d)) : S(), (s.autoplay.paused = !1), o("autoplayResume"));
                            },
                            L = () => {
                                if (s.destroyed || !s.autoplay.running) return;
                                const e = a();
                                "hidden" === e.visibilityState && ((v = !0), T(!0)), "visible" === e.visibilityState && M();
                            },
                            P = (e) => {
                                "mouse" === e.pointerType && ((v = !0), (g = !0), s.animating || s.autoplay.paused || T(!0));
                            },
                            A = (e) => {
                                "mouse" === e.pointerType && ((g = !1), s.autoplay.paused && M());
                            };
                        n("init", () => {
                            s.params.autoplay.enabled && (s.params.autoplay.pauseOnMouseEnter && (s.el.addEventListener("pointerenter", P), s.el.addEventListener("pointerleave", A)), a().addEventListener("visibilitychange", L), x());
                        }),
                            n("destroy", () => {
                                s.el.removeEventListener("pointerenter", P), s.el.removeEventListener("pointerleave", A), a().removeEventListener("visibilitychange", L), s.autoplay.running && C();
                            }),
                            n("_freeModeStaticRelease", () => {
                                (p || v) && M();
                            }),
                            n("_freeModeNoMomentumRelease", () => {
                                s.params.autoplay.disableOnInteraction ? C() : T(!0, !0);
                            }),
                            n("beforeTransitionStart", (e, t, i) => {
                                !s.destroyed && s.autoplay.running && (i || !s.params.autoplay.disableOnInteraction ? T(!0, !0) : C());
                            }),
                            n("sliderFirstMove", () => {
                                !s.destroyed &&
                                    s.autoplay.running &&
                                    (s.params.autoplay.disableOnInteraction
                                        ? C()
                                        : ((u = !0),
                                          (p = !1),
                                          (v = !1),
                                          (h = setTimeout(() => {
                                              (v = !0), (p = !0), T(!0);
                                          }, 200))));
                            }),
                            n("touchEnd", () => {
                                if (!s.destroyed && s.autoplay.running && u) {
                                    if ((clearTimeout(h), clearTimeout(t), s.params.autoplay.disableOnInteraction)) return (p = !1), void (u = !1);
                                    p && s.params.cssMode && M(), (p = !1), (u = !1);
                                }
                            }),
                            n("slideChange", () => {
                                !s.destroyed && s.autoplay.running && (m = !0);
                            }),
                            Object.assign(s.autoplay, { start: x, stop: C, pause: T, resume: M });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
                        let r = !1,
                            n = !1;
                        function o() {
                            const e = t.thumbs.swiper;
                            if (!e || e.destroyed) return;
                            const i = e.clickedIndex,
                                s = e.clickedSlide;
                            if (s && s.classList.contains(t.params.thumbs.slideThumbActiveClass)) return;
                            if (null == i) return;
                            let r;
                            (r = e.params.loop ? parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : i), t.params.loop ? t.slideToLoop(r) : t.slideTo(r);
                        }
                        function l() {
                            const { thumbs: e } = t.params;
                            if (r) return !1;
                            r = !0;
                            const i = t.constructor;
                            if (e.swiper instanceof i)
                                (t.thumbs.swiper = e.swiper),
                                    Object.assign(t.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                                    Object.assign(t.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                                    t.thumbs.swiper.update();
                            else if (h(e.swiper)) {
                                const s = Object.assign({}, e.swiper);
                                Object.assign(s, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), (t.thumbs.swiper = new i(s)), (n = !0);
                            }
                            return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", o), !0;
                        }
                        function d(e) {
                            const i = t.thumbs.swiper;
                            if (!i || i.destroyed) return;
                            const s = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView;
                            let r = 1;
                            const n = t.params.thumbs.slideThumbActiveClass;
                            if (
                                (t.params.slidesPerView > 1 && !t.params.centeredSlides && (r = t.params.slidesPerView),
                                t.params.thumbs.multipleActiveThumbs || (r = 1),
                                (r = Math.floor(r)),
                                i.slides.forEach((e) => e.classList.remove(n)),
                                i.params.loop || (i.params.virtual && i.params.virtual.enabled))
                            )
                                for (let e = 0; e < r; e += 1)
                                    b(i.slidesEl, `[data-swiper-slide-index="${t.realIndex + e}"]`).forEach((e) => {
                                        e.classList.add(n);
                                    });
                            else for (let e = 0; e < r; e += 1) i.slides[t.realIndex + e] && i.slides[t.realIndex + e].classList.add(n);
                            const a = t.params.thumbs.autoScrollOffset,
                                o = a && !i.params.loop;
                            if (t.realIndex !== i.realIndex || o) {
                                const r = i.activeIndex;
                                let n, l;
                                if (i.params.loop) {
                                    const e = i.slides.filter((e) => e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`)[0];
                                    (n = i.slides.indexOf(e)), (l = t.activeIndex > t.previousIndex ? "next" : "prev");
                                } else (n = t.realIndex), (l = n > t.previousIndex ? "next" : "prev");
                                o && (n += "next" === l ? a : -1 * a),
                                    i.visibleSlidesIndexes &&
                                        i.visibleSlidesIndexes.indexOf(n) < 0 &&
                                        (i.params.centeredSlides ? (n = n > r ? n - Math.floor(s / 2) + 1 : n + Math.floor(s / 2) - 1) : n > r && i.params.slidesPerGroup, i.slideTo(n, e ? 0 : void 0));
                            }
                        }
                        (t.thumbs = { swiper: null }),
                            s("beforeInit", () => {
                                const { thumbs: e } = t.params;
                                if (e && e.swiper)
                                    if ("string" == typeof e.swiper || e.swiper instanceof HTMLElement) {
                                        const i = a(),
                                            s = () => {
                                                const s = "string" == typeof e.swiper ? i.querySelector(e.swiper) : e.swiper;
                                                if (s && s.swiper) (e.swiper = s.swiper), l(), d(!0);
                                                else if (s) {
                                                    const i = (r) => {
                                                        (e.swiper = r.detail[0]), s.removeEventListener("init", i), l(), d(!0), e.swiper.update(), t.update();
                                                    };
                                                    s.addEventListener("init", i);
                                                }
                                                return s;
                                            },
                                            r = () => {
                                                t.destroyed || s() || requestAnimationFrame(r);
                                            };
                                        requestAnimationFrame(r);
                                    } else l(), d(!0);
                            }),
                            s("slideChange update resize observerUpdate", () => {
                                d();
                            }),
                            s("setTransition", (e, i) => {
                                const s = t.thumbs.swiper;
                                s && !s.destroyed && s.setTransition(i);
                            }),
                            s("beforeDestroy", () => {
                                const e = t.thumbs.swiper;
                                e && !e.destroyed && n && e.destroy();
                            }),
                            Object.assign(t.thumbs, { init: l, update: d });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, emit: s, once: r } = e;
                        i({ freeMode: { enabled: !1, momentum: !0, momentumRatio: 1, momentumBounce: !0, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: !1, minimumVelocity: 0.02 } }),
                            Object.assign(t, {
                                freeMode: {
                                    onTouchStart: function () {
                                        if (t.params.cssMode) return;
                                        const e = t.getTranslate();
                                        t.setTranslate(e), t.setTransition(0), (t.touchEventsData.velocities.length = 0), t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate });
                                    },
                                    onTouchMove: function () {
                                        if (t.params.cssMode) return;
                                        const { touchEventsData: e, touches: i } = t;
                                        0 === e.velocities.length && e.velocities.push({ position: i[t.isHorizontal() ? "startX" : "startY"], time: e.touchStartTime }),
                                            e.velocities.push({ position: i[t.isHorizontal() ? "currentX" : "currentY"], time: u() });
                                    },
                                    onTouchEnd: function (e) {
                                        let { currentPos: i } = e;
                                        if (t.params.cssMode) return;
                                        const { params: n, wrapperEl: a, rtlTranslate: o, snapGrid: l, touchEventsData: d } = t,
                                            c = u() - d.touchStartTime;
                                        if (i < -t.minTranslate()) t.slideTo(t.activeIndex);
                                        else if (i > -t.maxTranslate()) t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1);
                                        else {
                                            if (n.freeMode.momentum) {
                                                if (d.velocities.length > 1) {
                                                    const e = d.velocities.pop(),
                                                        i = d.velocities.pop(),
                                                        s = e.position - i.position,
                                                        r = e.time - i.time;
                                                    (t.velocity = s / r), (t.velocity /= 2), Math.abs(t.velocity) < n.freeMode.minimumVelocity && (t.velocity = 0), (r > 150 || u() - e.time > 300) && (t.velocity = 0);
                                                } else t.velocity = 0;
                                                (t.velocity *= n.freeMode.momentumVelocityRatio), (d.velocities.length = 0);
                                                let e = 1e3 * n.freeMode.momentumRatio;
                                                const i = t.velocity * e;
                                                let c = t.translate + i;
                                                o && (c = -c);
                                                let p,
                                                    h = !1;
                                                const m = 20 * Math.abs(t.velocity) * n.freeMode.momentumBounceRatio;
                                                let v;
                                                if (c < t.maxTranslate())
                                                    n.freeMode.momentumBounce ? (c + t.maxTranslate() < -m && (c = t.maxTranslate() - m), (p = t.maxTranslate()), (h = !0), (d.allowMomentumBounce = !0)) : (c = t.maxTranslate()),
                                                        n.loop && n.centeredSlides && (v = !0);
                                                else if (c > t.minTranslate())
                                                    n.freeMode.momentumBounce ? (c - t.minTranslate() > m && (c = t.minTranslate() + m), (p = t.minTranslate()), (h = !0), (d.allowMomentumBounce = !0)) : (c = t.minTranslate()),
                                                        n.loop && n.centeredSlides && (v = !0);
                                                else if (n.freeMode.sticky) {
                                                    let e;
                                                    for (let t = 0; t < l.length; t += 1)
                                                        if (l[t] > -c) {
                                                            e = t;
                                                            break;
                                                        }
                                                    (c = Math.abs(l[e] - c) < Math.abs(l[e - 1] - c) || "next" === t.swipeDirection ? l[e] : l[e - 1]), (c = -c);
                                                }
                                                if (
                                                    (v &&
                                                        r("transitionEnd", () => {
                                                            t.loopFix();
                                                        }),
                                                    0 !== t.velocity)
                                                ) {
                                                    if (((e = o ? Math.abs((-c - t.translate) / t.velocity) : Math.abs((c - t.translate) / t.velocity)), n.freeMode.sticky)) {
                                                        const i = Math.abs((o ? -c : c) - t.translate),
                                                            s = t.slidesSizesGrid[t.activeIndex];
                                                        e = i < s ? n.speed : i < 2 * s ? 1.5 * n.speed : 2.5 * n.speed;
                                                    }
                                                } else if (n.freeMode.sticky) return void t.slideToClosest();
                                                n.freeMode.momentumBounce && h
                                                    ? (t.updateProgress(p),
                                                      t.setTransition(e),
                                                      t.setTranslate(c),
                                                      t.transitionStart(!0, t.swipeDirection),
                                                      (t.animating = !0),
                                                      T(a, () => {
                                                          t &&
                                                              !t.destroyed &&
                                                              d.allowMomentumBounce &&
                                                              (s("momentumBounce"),
                                                              t.setTransition(n.speed),
                                                              setTimeout(() => {
                                                                  t.setTranslate(p),
                                                                      T(a, () => {
                                                                          t && !t.destroyed && t.transitionEnd();
                                                                      });
                                                              }, 0));
                                                      }))
                                                    : t.velocity
                                                    ? (s("_freeModeNoMomentumRelease"),
                                                      t.updateProgress(c),
                                                      t.setTransition(e),
                                                      t.setTranslate(c),
                                                      t.transitionStart(!0, t.swipeDirection),
                                                      t.animating ||
                                                          ((t.animating = !0),
                                                          T(a, () => {
                                                              t && !t.destroyed && t.transitionEnd();
                                                          })))
                                                    : t.updateProgress(c),
                                                    t.updateActiveIndex(),
                                                    t.updateSlidesClasses();
                                            } else {
                                                if (n.freeMode.sticky) return void t.slideToClosest();
                                                n.freeMode && s("_freeModeNoMomentumRelease");
                                            }
                                            (!n.freeMode.momentum || c >= n.longSwipesMs) && (s("_freeModeStaticRelease"), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                                        }
                                    },
                                },
                            });
                    },
                    function (e) {
                        let t,
                            i,
                            s,
                            r,
                            { swiper: n, extendParams: a, on: o } = e;
                        a({ grid: { rows: 1, fill: "column" } });
                        const l = () => {
                            let e = n.params.spaceBetween;
                            return "string" == typeof e && e.indexOf("%") >= 0 ? (e = (parseFloat(e.replace("%", "")) / 100) * n.size) : "string" == typeof e && (e = parseFloat(e)), e;
                        };
                        o("init", () => {
                            r = n.params.grid && n.params.grid.rows > 1;
                        }),
                            o("update", () => {
                                const { params: e, el: t } = n,
                                    i = e.grid && e.grid.rows > 1;
                                r && !i
                                    ? (t.classList.remove(`${e.containerModifierClass}grid`, `${e.containerModifierClass}grid-column`), (s = 1), n.emitContainerClasses())
                                    : !r && i && (t.classList.add(`${e.containerModifierClass}grid`), "column" === e.grid.fill && t.classList.add(`${e.containerModifierClass}grid-column`), n.emitContainerClasses()),
                                    (r = i);
                            }),
                            (n.grid = {
                                initSlides: (e) => {
                                    const { slidesPerView: r } = n.params,
                                        { rows: a, fill: o } = n.params.grid,
                                        l = n.virtual && n.params.virtual.enabled ? n.virtual.slides.length : e.length;
                                    (s = Math.floor(l / a)), (t = Math.floor(l / a) === l / a ? l : Math.ceil(l / a) * a), "auto" !== r && "row" === o && (t = Math.max(t, r * a)), (i = t / a);
                                },
                                unsetSlides: () => {
                                    n.slides &&
                                        n.slides.forEach((e) => {
                                            e.swiperSlideGridSet && ((e.style.height = ""), (e.style[n.getDirectionLabel("margin-top")] = ""));
                                        });
                                },
                                updateSlide: (e, r, a) => {
                                    const { slidesPerGroup: o } = n.params,
                                        d = l(),
                                        { rows: c, fill: u } = n.params.grid,
                                        p = n.virtual && n.params.virtual.enabled ? n.virtual.slides.length : a.length;
                                    let h, m, v;
                                    if ("row" === u && o > 1) {
                                        const i = Math.floor(e / (o * c)),
                                            s = e - c * o * i,
                                            n = 0 === i ? o : Math.min(Math.ceil((p - i * c * o) / c), o);
                                        (v = Math.floor(s / n)), (m = s - v * n + i * o), (h = m + (v * t) / c), (r.style.order = h);
                                    } else "column" === u ? ((m = Math.floor(e / c)), (v = e - m * c), (m > s || (m === s && v === c - 1)) && ((v += 1), v >= c && ((v = 0), (m += 1)))) : ((v = Math.floor(e / i)), (m = e - v * i));
                                    (r.row = v), (r.column = m), (r.style.height = `calc((100% - ${(c - 1) * d}px) / ${c})`), (r.style[n.getDirectionLabel("margin-top")] = 0 !== v ? d && `${d}px` : ""), (r.swiperSlideGridSet = !0);
                                },
                                updateWrapperSize: (e, i) => {
                                    const { centeredSlides: s, roundLengths: r } = n.params,
                                        a = l(),
                                        { rows: o } = n.params.grid;
                                    if (((n.virtualSize = (e + a) * t), (n.virtualSize = Math.ceil(n.virtualSize / o) - a), n.params.cssMode || (n.wrapperEl.style[n.getDirectionLabel("width")] = `${n.virtualSize + a}px`), s)) {
                                        const e = [];
                                        for (let t = 0; t < i.length; t += 1) {
                                            let s = i[t];
                                            r && (s = Math.floor(s)), i[t] < n.virtualSize + i[0] && e.push(s);
                                        }
                                        i.splice(0, i.length), i.push(...e);
                                    }
                                },
                            });
                    },
                    function (e) {
                        let { swiper: t } = e;
                        Object.assign(t, { appendSlide: se.bind(t), prependSlide: re.bind(t), addSlide: ne.bind(t), removeSlide: ae.bind(t), removeAllSlides: oe.bind(t) });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ fadeEffect: { crossFade: !1 } }),
                            le({
                                effect: "fade",
                                swiper: t,
                                on: s,
                                setTranslate: () => {
                                    const { slides: e } = t;
                                    t.params.fadeEffect;
                                    for (let i = 0; i < e.length; i += 1) {
                                        const e = t.slides[i];
                                        let s = -e.swiperSlideOffset;
                                        t.params.virtualTranslate || (s -= t.translate);
                                        let r = 0;
                                        t.isHorizontal() || ((r = s), (s = 0));
                                        const n = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(e.progress), 0) : 1 + Math.min(Math.max(e.progress, -1), 0),
                                            a = de(0, e);
                                        (a.style.opacity = n), (a.style.transform = `translate3d(${s}px, ${r}px, 0px)`);
                                    }
                                },
                                setTransition: (e) => {
                                    const i = t.slides.map((e) => f(e));
                                    i.forEach((t) => {
                                        t.style.transitionDuration = `${e}ms`;
                                    }),
                                        ce({ swiper: t, duration: e, transformElements: i, allSlides: !0 });
                                },
                                overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !t.params.cssMode }),
                            });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } });
                        const r = (e, t, i) => {
                            let s = i ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
                                r = i ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
                            s || ((s = y("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (i ? "left" : "top")).split(" "))), e.append(s)),
                                r || ((r = y("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (i ? "right" : "bottom")).split(" "))), e.append(r)),
                                s && (s.style.opacity = Math.max(-t, 0)),
                                r && (r.style.opacity = Math.max(t, 0));
                        };
                        le({
                            effect: "cube",
                            swiper: t,
                            on: s,
                            setTranslate: () => {
                                const { el: e, wrapperEl: i, slides: s, width: n, height: a, rtlTranslate: o, size: l, browser: d } = t,
                                    c = t.params.cubeEffect,
                                    u = t.isHorizontal(),
                                    p = t.virtual && t.params.virtual.enabled;
                                let h,
                                    m = 0;
                                c.shadow &&
                                    (u
                                        ? ((h = t.wrapperEl.querySelector(".swiper-cube-shadow")), h || ((h = y("div", "swiper-cube-shadow")), t.wrapperEl.append(h)), (h.style.height = `${n}px`))
                                        : ((h = e.querySelector(".swiper-cube-shadow")), h || ((h = y("div", "swiper-cube-shadow")), e.append(h))));
                                for (let e = 0; e < s.length; e += 1) {
                                    const i = s[e];
                                    let n = e;
                                    p && (n = parseInt(i.getAttribute("data-swiper-slide-index"), 10));
                                    let a = 90 * n,
                                        d = Math.floor(a / 360);
                                    o && ((a = -a), (d = Math.floor(-a / 360)));
                                    const h = Math.max(Math.min(i.progress, 1), -1);
                                    let v = 0,
                                        g = 0,
                                        f = 0;
                                    n % 4 == 0 ? ((v = 4 * -d * l), (f = 0)) : (n - 1) % 4 == 0 ? ((v = 0), (f = 4 * -d * l)) : (n - 2) % 4 == 0 ? ((v = l + 4 * d * l), (f = l)) : (n - 3) % 4 == 0 && ((v = -l), (f = 3 * l + 4 * l * d)),
                                        o && (v = -v),
                                        u || ((g = v), (v = 0));
                                    const b = `rotateX(${u ? 0 : -a}deg) rotateY(${u ? a : 0}deg) translate3d(${v}px, ${g}px, ${f}px)`;
                                    h <= 1 && h > -1 && ((m = 90 * n + 90 * h), o && (m = 90 * -n - 90 * h), t.browser && t.browser.isSafari && (Math.abs(m) / 90) % 2 == 1 && (m += 0.001)),
                                        (i.style.transform = b),
                                        c.slideShadows && r(i, h, u);
                                }
                                if (((i.style.transformOrigin = `50% 50% -${l / 2}px`), (i.style["-webkit-transform-origin"] = `50% 50% -${l / 2}px`), c.shadow))
                                    if (u) h.style.transform = `translate3d(0px, ${n / 2 + c.shadowOffset}px, ${-n / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${c.shadowScale})`;
                                    else {
                                        const e = Math.abs(m) - 90 * Math.floor(Math.abs(m) / 90),
                                            t = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                                            i = c.shadowScale,
                                            s = c.shadowScale / t,
                                            r = c.shadowOffset;
                                        h.style.transform = `scale3d(${i}, 1, ${s}) translate3d(0px, ${a / 2 + r}px, ${-a / 2 / s}px) rotateX(-89.99deg)`;
                                    }
                                const v = (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -l / 2 : 0;
                                (i.style.transform = `translate3d(0px,0,${v}px) rotateX(${t.isHorizontal() ? 0 : m}deg) rotateY(${t.isHorizontal() ? -m : 0}deg)`), i.style.setProperty("--swiper-cube-translate-z", `${v}px`);
                            },
                            setTransition: (e) => {
                                const { el: i, slides: s } = t;
                                if (
                                    (s.forEach((t) => {
                                        (t.style.transitionDuration = `${e}ms`),
                                            t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t) => {
                                                t.style.transitionDuration = `${e}ms`;
                                            });
                                    }),
                                    t.params.cubeEffect.shadow && !t.isHorizontal())
                                ) {
                                    const t = i.querySelector(".swiper-cube-shadow");
                                    t && (t.style.transitionDuration = `${e}ms`);
                                }
                            },
                            recreateShadows: () => {
                                const e = t.isHorizontal();
                                t.slides.forEach((t) => {
                                    const i = Math.max(Math.min(t.progress, 1), -1);
                                    r(t, i, e);
                                });
                            },
                            getEffectParams: () => t.params.cubeEffect,
                            perspective: () => !0,
                            overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, resistanceRatio: 0, spaceBetween: 0, centeredSlides: !1, virtualTranslate: !0 }),
                        });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
                        const r = (e, i) => {
                            let s = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
                                r = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
                            s || (s = ue("flip", e, t.isHorizontal() ? "left" : "top")), r || (r = ue("flip", e, t.isHorizontal() ? "right" : "bottom")), s && (s.style.opacity = Math.max(-i, 0)), r && (r.style.opacity = Math.max(i, 0));
                        };
                        le({
                            effect: "flip",
                            swiper: t,
                            on: s,
                            setTranslate: () => {
                                const { slides: e, rtlTranslate: i } = t,
                                    s = t.params.flipEffect;
                                for (let n = 0; n < e.length; n += 1) {
                                    const a = e[n];
                                    let o = a.progress;
                                    t.params.flipEffect.limitRotation && (o = Math.max(Math.min(a.progress, 1), -1));
                                    const l = a.swiperSlideOffset;
                                    let d = -180 * o,
                                        c = 0,
                                        u = t.params.cssMode ? -l - t.translate : -l,
                                        p = 0;
                                    t.isHorizontal() ? i && (d = -d) : ((p = u), (u = 0), (c = -d), (d = 0)),
                                        t.browser && t.browser.isSafari && ((Math.abs(d) / 90) % 2 == 1 && (d += 0.001), (Math.abs(c) / 90) % 2 == 1 && (c += 0.001)),
                                        (a.style.zIndex = -Math.abs(Math.round(o)) + e.length),
                                        s.slideShadows && r(a, o);
                                    const h = `translate3d(${u}px, ${p}px, 0px) rotateX(${c}deg) rotateY(${d}deg)`;
                                    de(0, a).style.transform = h;
                                }
                            },
                            setTransition: (e) => {
                                const i = t.slides.map((e) => f(e));
                                i.forEach((t) => {
                                    (t.style.transitionDuration = `${e}ms`),
                                        t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t) => {
                                            t.style.transitionDuration = `${e}ms`;
                                        });
                                }),
                                    ce({ swiper: t, duration: e, transformElements: i });
                            },
                            recreateShadows: () => {
                                t.params.flipEffect,
                                    t.slides.forEach((e) => {
                                        let i = e.progress;
                                        t.params.flipEffect.limitRotation && (i = Math.max(Math.min(e.progress, 1), -1)), r(e, i);
                                    });
                            },
                            getEffectParams: () => t.params.flipEffect,
                            perspective: () => !0,
                            overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !t.params.cssMode }),
                        });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 } }),
                            le({
                                effect: "coverflow",
                                swiper: t,
                                on: s,
                                setTranslate: () => {
                                    const { width: e, height: i, slides: s, slidesSizesGrid: r } = t,
                                        n = t.params.coverflowEffect,
                                        a = t.isHorizontal(),
                                        o = t.translate,
                                        l = a ? e / 2 - o : i / 2 - o,
                                        d = a ? n.rotate : -n.rotate,
                                        c = n.depth;
                                    for (let e = 0, i = s.length; e < i; e += 1) {
                                        const i = s[e],
                                            o = r[e],
                                            u = (l - i.swiperSlideOffset - o / 2) / o,
                                            p = "function" == typeof n.modifier ? n.modifier(u) : u * n.modifier;
                                        let h = a ? d * p : 0,
                                            m = a ? 0 : d * p,
                                            v = -c * Math.abs(p),
                                            g = n.stretch;
                                        "string" == typeof g && -1 !== g.indexOf("%") && (g = (parseFloat(n.stretch) / 100) * o);
                                        let f = a ? 0 : g * p,
                                            b = a ? g * p : 0,
                                            w = 1 - (1 - n.scale) * Math.abs(p);
                                        Math.abs(b) < 0.001 && (b = 0),
                                            Math.abs(f) < 0.001 && (f = 0),
                                            Math.abs(v) < 0.001 && (v = 0),
                                            Math.abs(h) < 0.001 && (h = 0),
                                            Math.abs(m) < 0.001 && (m = 0),
                                            Math.abs(w) < 0.001 && (w = 0),
                                            t.browser && t.browser.isSafari && ((Math.abs(h) / 90) % 2 == 1 && (h += 0.001), (Math.abs(m) / 90) % 2 == 1 && (m += 0.001));
                                        const y = `translate3d(${b}px,${f}px,${v}px)  rotateX(${m}deg) rotateY(${h}deg) scale(${w})`;
                                        if (((de(0, i).style.transform = y), (i.style.zIndex = 1 - Math.abs(Math.round(p))), n.slideShadows)) {
                                            let e = a ? i.querySelector(".swiper-slide-shadow-left") : i.querySelector(".swiper-slide-shadow-top"),
                                                t = a ? i.querySelector(".swiper-slide-shadow-right") : i.querySelector(".swiper-slide-shadow-bottom");
                                            e || (e = ue("coverflow", i, a ? "left" : "top")), t || (t = ue("coverflow", i, a ? "right" : "bottom")), e && (e.style.opacity = p > 0 ? p : 0), t && (t.style.opacity = -p > 0 ? -p : 0);
                                        }
                                    }
                                },
                                setTransition: (e) => {
                                    t.slides
                                        .map((e) => f(e))
                                        .forEach((t) => {
                                            (t.style.transitionDuration = `${e}ms`),
                                                t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t) => {
                                                    t.style.transitionDuration = `${e}ms`;
                                                });
                                        });
                                },
                                perspective: () => !0,
                                overwriteParams: () => ({ watchSlidesProgress: !0 }),
                            });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({
                            creativeEffect: {
                                limitProgress: 1,
                                shadowPerProgress: !1,
                                progressMultiplier: 1,
                                perspective: !0,
                                prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                                next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                            },
                        });
                        const r = (e) => ("string" == typeof e ? e : `${e}px`);
                        le({
                            effect: "creative",
                            swiper: t,
                            on: s,
                            setTranslate: () => {
                                const { slides: e, wrapperEl: i, slidesSizesGrid: s } = t,
                                    n = t.params.creativeEffect,
                                    { progressMultiplier: a } = n,
                                    o = t.params.centeredSlides;
                                if (o) {
                                    const e = s[0] / 2 - t.params.slidesOffsetBefore || 0;
                                    i.style.transform = `translateX(calc(50% - ${e}px))`;
                                }
                                for (let i = 0; i < e.length; i += 1) {
                                    const s = e[i],
                                        l = s.progress,
                                        d = Math.min(Math.max(s.progress, -n.limitProgress), n.limitProgress);
                                    let c = d;
                                    o || (c = Math.min(Math.max(s.originalProgress, -n.limitProgress), n.limitProgress));
                                    const u = s.swiperSlideOffset,
                                        p = [t.params.cssMode ? -u - t.translate : -u, 0, 0],
                                        h = [0, 0, 0];
                                    let m = !1;
                                    t.isHorizontal() || ((p[1] = p[0]), (p[0] = 0));
                                    let v = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
                                    d < 0 ? ((v = n.next), (m = !0)) : d > 0 && ((v = n.prev), (m = !0)),
                                        p.forEach((e, t) => {
                                            p[t] = `calc(${e}px + (${r(v.translate[t])} * ${Math.abs(d * a)}))`;
                                        }),
                                        h.forEach((e, i) => {
                                            let s = v.rotate[i] * Math.abs(d * a);
                                            t.browser && t.browser.isSafari && (Math.abs(s) / 90) % 2 == 1 && (s += 0.001), (h[i] = s);
                                        }),
                                        (s.style.zIndex = -Math.abs(Math.round(l)) + e.length);
                                    const g = p.join(", "),
                                        f = `rotateX(${h[0]}deg) rotateY(${h[1]}deg) rotateZ(${h[2]}deg)`,
                                        b = c < 0 ? `scale(${1 + (1 - v.scale) * c * a})` : `scale(${1 - (1 - v.scale) * c * a})`,
                                        w = c < 0 ? 1 + (1 - v.opacity) * c * a : 1 - (1 - v.opacity) * c * a,
                                        y = `translate3d(${g}) ${f} ${b}`;
                                    if ((m && v.shadow) || !m) {
                                        let e = s.querySelector(".swiper-slide-shadow");
                                        if ((!e && v.shadow && (e = ue("creative", s)), e)) {
                                            const t = n.shadowPerProgress ? d * (1 / n.limitProgress) : d;
                                            e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                                        }
                                    }
                                    const E = de(0, s);
                                    (E.style.transform = y), (E.style.opacity = w), v.origin && (E.style.transformOrigin = v.origin);
                                }
                            },
                            setTransition: (e) => {
                                const i = t.slides.map((e) => f(e));
                                i.forEach((t) => {
                                    (t.style.transitionDuration = `${e}ms`),
                                        t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                                            t.style.transitionDuration = `${e}ms`;
                                        });
                                }),
                                    ce({ swiper: t, duration: e, transformElements: i, allSlides: !0 });
                            },
                            perspective: () => t.params.creativeEffect.perspective,
                            overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !t.params.cssMode }),
                        });
                    },
                    function (e) {
                        let { swiper: t, extendParams: i, on: s } = e;
                        i({ cardsEffect: { slideShadows: !0, rotate: !0, perSlideRotate: 2, perSlideOffset: 8 } }),
                            le({
                                effect: "cards",
                                swiper: t,
                                on: s,
                                setTranslate: () => {
                                    const { slides: e, activeIndex: i, rtlTranslate: s } = t,
                                        r = t.params.cardsEffect,
                                        { startTranslate: n, isTouched: a } = t.touchEventsData,
                                        o = s ? -t.translate : t.translate;
                                    for (let l = 0; l < e.length; l += 1) {
                                        const d = e[l],
                                            c = d.progress,
                                            u = Math.min(Math.max(c, -4), 4);
                                        let p = d.swiperSlideOffset;
                                        t.params.centeredSlides && !t.params.cssMode && (t.wrapperEl.style.transform = `translateX(${t.minTranslate()}px)`), t.params.centeredSlides && t.params.cssMode && (p -= e[0].swiperSlideOffset);
                                        let h = t.params.cssMode ? -p - t.translate : -p,
                                            m = 0;
                                        const v = -100 * Math.abs(u);
                                        let g = 1,
                                            f = -r.perSlideRotate * u,
                                            b = r.perSlideOffset - 0.75 * Math.abs(u);
                                        const w = t.virtual && t.params.virtual.enabled ? t.virtual.from + l : l,
                                            y = (w === i || w === i - 1) && u > 0 && u < 1 && (a || t.params.cssMode) && o < n,
                                            E = (w === i || w === i + 1) && u < 0 && u > -1 && (a || t.params.cssMode) && o > n;
                                        if (y || E) {
                                            const e = (1 - Math.abs((Math.abs(u) - 0.5) / 0.5)) ** 0.5;
                                            (f += -28 * u * e), (g += -0.5 * e), (b += 96 * e), (m = -25 * e * Math.abs(u) + "%");
                                        }
                                        if (((h = u < 0 ? `calc(${h}px ${s ? "-" : "+"} (${b * Math.abs(u)}%))` : u > 0 ? `calc(${h}px ${s ? "-" : "+"} (-${b * Math.abs(u)}%))` : `${h}px`), !t.isHorizontal())) {
                                            const e = m;
                                            (m = h), (h = e);
                                        }
                                        const S = u < 0 ? "" + (1 + (1 - g) * u) : "" + (1 - (1 - g) * u),
                                            x = `\n        translate3d(${h}, ${m}, ${v}px)\n        rotateZ(${r.rotate ? (s ? -f : f) : 0}deg)\n        scale(${S})\n      `;
                                        if (r.slideShadows) {
                                            let e = d.querySelector(".swiper-slide-shadow");
                                            e || (e = ue("cards", d)), e && (e.style.opacity = Math.min(Math.max((Math.abs(u) - 0.5) / 0.5, 0), 1));
                                        }
                                        (d.style.zIndex = -Math.abs(Math.round(c)) + e.length), (de(0, d).style.transform = x);
                                    }
                                },
                                setTransition: (e) => {
                                    const i = t.slides.map((e) => f(e));
                                    i.forEach((t) => {
                                        (t.style.transitionDuration = `${e}ms`),
                                            t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                                                t.style.transitionDuration = `${e}ms`;
                                            });
                                    }),
                                        ce({ swiper: t, duration: e, transformElements: i });
                                },
                                perspective: () => !0,
                                overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !t.params.cssMode }),
                            });
                    },
                ];
                ee.use(pe);
                const he = [
                    "eventsPrefix",
                    "injectStyles",
                    "injectStylesUrls",
                    "modules",
                    "init",
                    "_direction",
                    "oneWayMovement",
                    "touchEventsTarget",
                    "initialSlide",
                    "_speed",
                    "cssMode",
                    "updateOnWindowResize",
                    "resizeObserver",
                    "nested",
                    "focusableElements",
                    "_enabled",
                    "_width",
                    "_height",
                    "preventInteractionOnTransition",
                    "userAgent",
                    "url",
                    "_edgeSwipeDetection",
                    "_edgeSwipeThreshold",
                    "_freeMode",
                    "_autoHeight",
                    "setWrapperSize",
                    "virtualTranslate",
                    "_effect",
                    "breakpoints",
                    "breakpointsBase",
                    "_spaceBetween",
                    "_slidesPerView",
                    "maxBackfaceHiddenSlides",
                    "_grid",
                    "_slidesPerGroup",
                    "_slidesPerGroupSkip",
                    "_slidesPerGroupAuto",
                    "_centeredSlides",
                    "_centeredSlidesBounds",
                    "_slidesOffsetBefore",
                    "_slidesOffsetAfter",
                    "normalizeSlideIndex",
                    "_centerInsufficientSlides",
                    "_watchOverflow",
                    "roundLengths",
                    "touchRatio",
                    "touchAngle",
                    "simulateTouch",
                    "_shortSwipes",
                    "_longSwipes",
                    "longSwipesRatio",
                    "longSwipesMs",
                    "_followFinger",
                    "allowTouchMove",
                    "_threshold",
                    "touchMoveStopPropagation",
                    "touchStartPreventDefault",
                    "touchStartForcePreventDefault",
                    "touchReleaseOnEdges",
                    "uniqueNavElements",
                    "_resistance",
                    "_resistanceRatio",
                    "_watchSlidesProgress",
                    "_grabCursor",
                    "preventClicks",
                    "preventClicksPropagation",
                    "_slideToClickedSlide",
                    "_loop",
                    "loopAdditionalSlides",
                    "loopAddBlankSlides",
                    "loopPreventsSliding",
                    "_rewind",
                    "_allowSlidePrev",
                    "_allowSlideNext",
                    "_swipeHandler",
                    "_noSwiping",
                    "noSwipingClass",
                    "noSwipingSelector",
                    "passiveListeners",
                    "containerModifierClass",
                    "slideClass",
                    "slideActiveClass",
                    "slideVisibleClass",
                    "slideFullyVisibleClass",
                    "slideNextClass",
                    "slidePrevClass",
                    "slideBlankClass",
                    "wrapperClass",
                    "lazyPreloaderClass",
                    "lazyPreloadPrevNext",
                    "runCallbacksOnInit",
                    "observer",
                    "observeParents",
                    "observeSlideChildren",
                    "a11y",
                    "_autoplay",
                    "_controller",
                    "coverflowEffect",
                    "cubeEffect",
                    "fadeEffect",
                    "flipEffect",
                    "creativeEffect",
                    "cardsEffect",
                    "hashNavigation",
                    "history",
                    "keyboard",
                    "mousewheel",
                    "_navigation",
                    "_pagination",
                    "parallax",
                    "_scrollbar",
                    "_thumbs",
                    "virtual",
                    "zoom",
                    "control",
                ];
                function me(e) {
                    return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1) && !e.__swiper__;
                }
                function ve(e, t) {
                    const i = ["__proto__", "constructor", "prototype"];
                    Object.keys(t)
                        .filter((e) => i.indexOf(e) < 0)
                        .forEach((i) => {
                            void 0 === e[i] ? (e[i] = t[i]) : me(t[i]) && me(e[i]) && Object.keys(t[i]).length > 0 ? (t[i].__swiper__ ? (e[i] = t[i]) : ve(e[i], t[i])) : (e[i] = t[i]);
                        });
                }
                function ge(e) {
                    return void 0 === e && (e = ""), e.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
                }
                const fe = (e) => {
                        if (parseFloat(e) === Number(e)) return Number(e);
                        if ("true" === e) return !0;
                        if ("" === e) return !0;
                        if ("false" === e) return !1;
                        if ("null" === e) return null;
                        if ("undefined" !== e) {
                            if ("string" == typeof e && e.includes("{") && e.includes("}") && e.includes('"')) {
                                let t;
                                try {
                                    t = JSON.parse(e);
                                } catch (i) {
                                    t = e;
                                }
                                return t;
                            }
                            return e;
                        }
                    },
                    be = [
                        "a11y",
                        "autoplay",
                        "controller",
                        "cards-effect",
                        "coverflow-effect",
                        "creative-effect",
                        "cube-effect",
                        "fade-effect",
                        "flip-effect",
                        "free-mode",
                        "grid",
                        "hash-navigation",
                        "history",
                        "keyboard",
                        "mousewheel",
                        "navigation",
                        "pagination",
                        "parallax",
                        "scrollbar",
                        "thumbs",
                        "virtual",
                        "zoom",
                    ];
                function we(e, t, i) {
                    const s = {},
                        r = {};
                    ve(s, K);
                    const n = [...he, "on"],
                        a = n.map((e) => e.replace(/_/, ""));
                    n.forEach((t) => {
                        (t = t.replace("_", "")), void 0 !== e[t] && (r[t] = e[t]);
                    });
                    const o = [...e.attributes];
                    return (
                        "string" == typeof t && void 0 !== i && o.push({ name: t, value: me(i) ? { ...i } : i }),
                        o.forEach((e) => {
                            const t = be.filter((t) => 0 === e.name.indexOf(`${t}-`))[0];
                            if (t) {
                                const i = ge(t),
                                    s = ge(e.name.split(`${t}-`)[1]);
                                void 0 === r[i] && (r[i] = {}), !0 === r[i] && (r[i] = { enabled: !0 }), (r[i][s] = fe(e.value));
                            } else {
                                const t = ge(e.name);
                                if (!a.includes(t)) return;
                                const i = fe(e.value);
                                r[t] && be.includes(e.name) && !me(i) ? (r[t].constructor !== Object && (r[t] = {}), (r[t].enabled = !!i)) : (r[t] = i);
                            }
                        }),
                        ve(s, r),
                        s.navigation ? (s.navigation = { prevEl: ".swiper-button-prev", nextEl: ".swiper-button-next", ...(!0 !== s.navigation ? s.navigation : {}) }) : !1 === s.navigation && delete s.navigation,
                        s.scrollbar ? (s.scrollbar = { el: ".swiper-scrollbar", ...(!0 !== s.scrollbar ? s.scrollbar : {}) }) : !1 === s.scrollbar && delete s.scrollbar,
                        s.pagination ? (s.pagination = { el: ".swiper-pagination", ...(!0 !== s.pagination ? s.pagination : {}) }) : !1 === s.pagination && delete s.pagination,
                        { params: s, passedParams: r }
                    );
                }
                const ye =
                        ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}",
                    Ee = "undefined" == typeof window || "undefined" == typeof HTMLElement ? class {} : HTMLElement,
                    Se =
                        '<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>\n    ',
                    xe = (e, t) => {
                        if ("undefined" != typeof CSSStyleSheet && e.adoptedStyleSheets) {
                            const i = new CSSStyleSheet();
                            i.replaceSync(t), (e.adoptedStyleSheets = [i]);
                        } else {
                            const i = document.createElement("style");
                            (i.rel = "stylesheet"), (i.textContent = t), e.appendChild(i);
                        }
                    };
                class Ce extends Ee {
                    constructor() {
                        super(), this.attachShadow({ mode: "open" });
                    }
                    static get nextButtonSvg() {
                        return Se;
                    }
                    static get prevButtonSvg() {
                        return Se.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
                    }
                    cssStyles() {
                        return [ye, ...(this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : [])].join("\n");
                    }
                    cssLinks() {
                        return this.injectStylesUrls || [];
                    }
                    calcSlideSlots() {
                        const e = this.slideSlots || 0,
                            t = [...this.querySelectorAll("[slot^=slide-]")].map((e) => parseInt(e.getAttribute("slot").split("slide-")[1], 10));
                        if (((this.slideSlots = t.length ? Math.max(...t) + 1 : 0), this.rendered))
                            if (this.slideSlots > e)
                                for (let t = e; t < this.slideSlots; t += 1) {
                                    const e = document.createElement("swiper-slide");
                                    e.setAttribute("part", `slide slide-${t + 1}`);
                                    const i = document.createElement("slot");
                                    i.setAttribute("name", `slide-${t + 1}`), e.appendChild(i), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(e);
                                }
                            else if (this.slideSlots < e) {
                                const e = this.swiper.slides;
                                for (let t = e.length - 1; t >= 0; t -= 1) t > this.slideSlots && e[t].remove();
                            }
                    }
                    render() {
                        if (this.rendered) return;
                        this.calcSlideSlots();
                        let e = this.cssStyles();
                        this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")),
                            e.length && xe(this.shadowRoot, e),
                            this.cssLinks().forEach((e) => {
                                if (this.shadowRoot.querySelector(`link[href="${e}"]`)) return;
                                const t = document.createElement("link");
                                (t.rel = "stylesheet"), (t.href = e), this.shadowRoot.appendChild(t);
                            });
                        const t = document.createElement("div");
                        var i;
                        t.classList.add("swiper"),
                            (t.part = "container"),
                            (t.innerHTML = `\n      <slot name="container-start"></slot>\n      <div class="swiper-wrapper" part="wrapper">\n        <slot></slot>\n        ${Array.from({ length: this.slideSlots })
                                .map((e, t) => `\n        <swiper-slide part="slide slide-${t}">\n          <slot name="slide-${t}"></slot>\n        </swiper-slide>\n        `)
                                .join("")}\n      </div>\n      <slot name="container-end"></slot>\n      ${
                                ((i = this.passedParams),
                                void 0 === i && (i = {}),
                                i.navigation && void 0 === i.navigation.nextEl && void 0 === i.navigation.prevEl
                                    ? `\n        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>\n        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>\n      `
                                    : "")
                            }\n      ${
                                (function (e) {
                                    return void 0 === e && (e = {}), e.pagination && void 0 === e.pagination.el;
                                })(this.passedParams)
                                    ? '\n        <div part="pagination" class="swiper-pagination"></div>\n      '
                                    : ""
                            }\n      ${
                                (function (e) {
                                    return void 0 === e && (e = {}), e.scrollbar && void 0 === e.scrollbar.el;
                                })(this.passedParams)
                                    ? '\n        <div part="scrollbar" class="swiper-scrollbar"></div>\n      '
                                    : ""
                            }\n    `),
                            this.shadowRoot.appendChild(t),
                            (this.rendered = !0);
                    }
                    initialize() {
                        var e = this;
                        if (this.initialized) return;
                        this.initialized = !0;
                        const { params: t, passedParams: i } = we(this);
                        (this.swiperParams = t),
                            (this.passedParams = i),
                            delete this.swiperParams.init,
                            this.render(),
                            (this.swiper = new ee(this.shadowRoot.querySelector(".swiper"), {
                                ...(t.virtual ? {} : { observer: !0, observeSlideChildren: this.slideSlots > 0 }),
                                ...t,
                                touchEventsTarget: "container",
                                onAny: function (i) {
                                    "observerUpdate" === i && e.calcSlideSlots();
                                    const s = t.eventsPrefix ? `${t.eventsPrefix}${i.toLowerCase()}` : i.toLowerCase();
                                    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) n[a - 1] = arguments[a];
                                    const o = new CustomEvent(s, { detail: n, bubbles: "hashChange" !== i, cancelable: !0 });
                                    e.dispatchEvent(o);
                                },
                            }));
                    }
                    connectedCallback() {
                        (this.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM) || (!1 !== this.init && "false" !== this.getAttribute("init") && this.initialize());
                    }
                    disconnectedCallback() {
                        (this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM) || (this.swiper && this.swiper.destroy && this.swiper.destroy(), (this.initialized = !1));
                    }
                    updateSwiperOnPropChange(e, t) {
                        const { params: i, passedParams: s } = we(this, e, t);
                        (this.passedParams = s),
                            (this.swiperParams = i),
                            (this.swiper && this.swiper.params[e] === t) ||
                                (function (e) {
                                    let { swiper: t, slides: i, passedParams: s, changedParams: r, nextEl: n, prevEl: a, scrollbarEl: o, paginationEl: l } = e;
                                    const d = r.filter((e) => "children" !== e && "direction" !== e && "wrapperClass" !== e),
                                        { params: c, pagination: u, navigation: p, scrollbar: h, virtual: m, thumbs: v } = t;
                                    let g, f, b, w, y, E, S, x;
                                    r.includes("thumbs") && s.thumbs && s.thumbs.swiper && c.thumbs && !c.thumbs.swiper && (g = !0),
                                        r.includes("controller") && s.controller && s.controller.control && c.controller && !c.controller.control && (f = !0),
                                        r.includes("pagination") && s.pagination && (s.pagination.el || l) && (c.pagination || !1 === c.pagination) && u && !u.el && (b = !0),
                                        r.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || o) && (c.scrollbar || !1 === c.scrollbar) && h && !h.el && (w = !0),
                                        r.includes("navigation") && s.navigation && (s.navigation.prevEl || a) && (s.navigation.nextEl || n) && (c.navigation || !1 === c.navigation) && p && !p.prevEl && !p.nextEl && (y = !0);
                                    const C = (e) => {
                                        t[e] &&
                                            (t[e].destroy(),
                                            "navigation" === e
                                                ? (t.isElement && (t[e].prevEl.remove(), t[e].nextEl.remove()), (c[e].prevEl = void 0), (c[e].nextEl = void 0), (t[e].prevEl = void 0), (t[e].nextEl = void 0))
                                                : (t.isElement && t[e].el.remove(), (c[e].el = void 0), (t[e].el = void 0)));
                                    };
                                    r.includes("loop") && t.isElement && (c.loop && !s.loop ? (E = !0) : !c.loop && s.loop ? (S = !0) : (x = !0)),
                                        d.forEach((e) => {
                                            if (me(c[e]) && me(s[e])) Object.assign(c[e], s[e]), ("navigation" !== e && "pagination" !== e && "scrollbar" !== e) || !("enabled" in s[e]) || s[e].enabled || C(e);
                                            else {
                                                const t = s[e];
                                                (!0 !== t && !1 !== t) || ("navigation" !== e && "pagination" !== e && "scrollbar" !== e) ? (c[e] = s[e]) : !1 === t && C(e);
                                            }
                                        }),
                                        d.includes("controller") && !f && t.controller && t.controller.control && c.controller && c.controller.control && (t.controller.control = c.controller.control),
                                        r.includes("children") && i && m && c.virtual.enabled ? ((m.slides = i), m.update(!0)) : r.includes("virtual") && m && c.virtual.enabled && (i && (m.slides = i), m.update(!0)),
                                        r.includes("children") && i && c.loop && (x = !0),
                                        g && v.init() && v.update(!0),
                                        f && (t.controller.control = c.controller.control),
                                        b &&
                                            (!t.isElement || (l && "string" != typeof l) || ((l = document.createElement("div")), l.classList.add("swiper-pagination"), l.part.add("pagination"), t.el.appendChild(l)),
                                            l && (c.pagination.el = l),
                                            u.init(),
                                            u.render(),
                                            u.update()),
                                        w &&
                                            (!t.isElement || (o && "string" != typeof o) || ((o = document.createElement("div")), o.classList.add("swiper-scrollbar"), o.part.add("scrollbar"), t.el.appendChild(o)),
                                            o && (c.scrollbar.el = o),
                                            h.init(),
                                            h.updateSize(),
                                            h.setTranslate()),
                                        y &&
                                            (t.isElement &&
                                                ((n && "string" != typeof n) ||
                                                    ((n = document.createElement("div")), n.classList.add("swiper-button-next"), (n.innerHTML = t.hostEl.constructor.nextButtonSvg), n.part.add("button-next"), t.el.appendChild(n)),
                                                (a && "string" != typeof a) ||
                                                    ((a = document.createElement("div")), a.classList.add("swiper-button-prev"), (a.innerHTML = t.hostEl.constructor.prevButtonSvg), a.part.add("button-prev"), t.el.appendChild(a))),
                                            n && (c.navigation.nextEl = n),
                                            a && (c.navigation.prevEl = a),
                                            p.init(),
                                            p.update()),
                                        r.includes("allowSlideNext") && (t.allowSlideNext = s.allowSlideNext),
                                        r.includes("allowSlidePrev") && (t.allowSlidePrev = s.allowSlidePrev),
                                        r.includes("direction") && t.changeDirection(s.direction, !1),
                                        (E || x) && t.loopDestroy(),
                                        (S || x) && t.loopCreate(),
                                        t.update();
                                })({
                                    swiper: this.swiper,
                                    passedParams: this.passedParams,
                                    changedParams: [ge(e)],
                                    ...("navigation" === e && s[e] ? { prevEl: ".swiper-button-prev", nextEl: ".swiper-button-next" } : {}),
                                    ...("pagination" === e && s[e] ? { paginationEl: ".swiper-pagination" } : {}),
                                    ...("scrollbar" === e && s[e] ? { scrollbarEl: ".swiper-scrollbar" } : {}),
                                });
                    }
                    attributeChangedCallback(e, t, i) {
                        this.initialized && ("true" === t && null === i && (i = !1), this.updateSwiperOnPropChange(e, i));
                    }
                    static get observedAttributes() {
                        return he
                            .filter((e) => e.includes("_"))
                            .map((e) =>
                                e
                                    .replace(/[A-Z]/g, (e) => `-${e}`)
                                    .replace("_", "")
                                    .toLowerCase()
                            );
                    }
                }
                he.forEach((e) => {
                    "init" !== e &&
                        ((e = e.replace("_", "")),
                        Object.defineProperty(Ce.prototype, e, {
                            configurable: !0,
                            get() {
                                return (this.passedParams || {})[e];
                            },
                            set(t) {
                                this.passedParams || (this.passedParams = {}), (this.passedParams[e] = t), this.initialized && this.updateSwiperOnPropChange(e, t);
                            },
                        }));
                });
                class Te extends Ee {
                    constructor() {
                        super(), this.attachShadow({ mode: "open" });
                    }
                    render() {
                        const e = this.lazy || "" === this.getAttribute("lazy") || "true" === this.getAttribute("lazy");
                        if (
                            (xe(
                                this.shadowRoot,
                                "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}"
                            ),
                            this.shadowRoot.appendChild(document.createElement("slot")),
                            e)
                        ) {
                            const e = document.createElement("div");
                            e.classList.add("swiper-lazy-preloader"), e.part.add("preloader"), this.shadowRoot.appendChild(e);
                        }
                    }
                    initialize() {
                        this.render();
                    }
                    connectedCallback() {
                        this.initialize();
                    }
                }
                const Me = () => {
                    "undefined" != typeof window &&
                        (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", Ce), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", Te));
                };
                "undefined" != typeof window &&
                    (window.SwiperElementRegisterParams = (e) => {
                        he.push(...e);
                    });
            },
        },
        t = {};
    function i(s) {
        var r = t[s];
        if (void 0 !== r) return r.exports;
        var n = (t[s] = { exports: {} });
        return e[s].call(n.exports, n, n.exports, i), n.exports;
    }
    (i.d = (e, t) => {
        for (var s in t) i.o(t, s) && !i.o(e, s) && Object.defineProperty(e, s, { enumerable: !0, get: t[s] });
    }),
        (i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
        (i.r = (e) => {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (() => {
            "use strict";
            i(5460),
                i(2200),
                i(2724),
                i(3864),
                i(640),
                i(6516),
                i(3288),
                i(6040),
                i(5056),
                i(3116),
                i(2120),
                i(6188),
                i(4576),
                i(8524),
                i(7624),
                i(5272),
                i(9e3),
                i(6620),
                i(3384),
                i(5563),
                i(9216),
                i(9224),
                i(7012),
                i(7296),
                i(8340),
                i(8808),
                i(420),
                i(1736),
                i(6036),
                i(2504),
                i(9044),
                i(2972);
        })();
})();
